/* tslint:disable */
/* eslint-disable */
/**
 * BreedLogic - Core
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from './base';

/**
 *
 * @export
 * @enum {string}
 */

export const ActionType = {
  Create: 0,
  Edit: 1,
  Update: 1,
  Delete: 2,
  Studbook: 3,
  QuickSearch: 4,
} as const;

export type ActionType = (typeof ActionType)[keyof typeof ActionType];

/**
 *
 * @export
 * @interface AddAddressRequest
 */
export interface AddAddressRequest {
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  unitNumber?: string | null;
  /**
   *
   * @type {AddressType}
   * @memberof AddAddressRequest
   */
  addressType?: AddressType;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  streetAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  state?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  country?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  postCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  latitude?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  longitude?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AddAddressRequest
   */
  isAddressValid?: boolean;
  /**
   *
   * @type {string}
   * @memberof AddAddressRequest
   */
  entityId?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof AddAddressRequest
   */
  entityType?: EntityTypeCode;
}

/**
 *
 * @export
 * @interface AddCustomFieldRequest
 */
export interface AddCustomFieldRequest {
  /**
   *
   * @type {string}
   * @memberof AddCustomFieldRequest
   */
  customFieldEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof AddCustomFieldRequest
   */
  organisationId?: number | null;
  /**
   *
   * @type {number}
   * @memberof AddCustomFieldRequest
   */
  fieldTypeId: number;
  /**
   *
   * @type {string}
   * @memberof AddCustomFieldRequest
   */
  labelText: string;
  /**
   *
   * @type {string}
   * @memberof AddCustomFieldRequest
   */
  fieldName: string;
  /**
   *
   * @type {string}
   * @memberof AddCustomFieldRequest
   */
  fieldDescription: string;
  /**
   *
   * @type {string}
   * @memberof AddCustomFieldRequest
   */
  placeholder?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddCustomFieldRequest
   */
  defaultValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddCustomFieldRequest
   */
  value?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof AddCustomFieldRequest
   */
  options?: Array<string> | null;
  /**
   *
   * @type {ValidationRequest}
   * @memberof AddCustomFieldRequest
   */
  validation?: ValidationRequest;
}
/**
 *
 * @export
 * @interface AddFeesRequest
 */
export interface AddFeesRequest {
  /**
   *
   * @type {Array<FeeDto>}
   * @memberof AddFeesRequest
   */
  items?: Array<FeeDto> | null;
}
/**
 *
 * @export
 * @interface AddMembershipRequest
 */
export interface AddMembershipRequest {
  /**
   *
   * @type {number}
   * @memberof AddMembershipRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof AddMembershipRequest
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof AddMembershipRequest
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof AddMembershipRequest
   */
  isAutoRenewal?: boolean;
  /**
   *
   * @type {string}
   * @memberof AddMembershipRequest
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof AddMembershipRequest
   */
  expiryDate?: string | null;
}
/**
 *
 * @export
 * @interface AddOrganisationRequest
 */
export interface AddOrganisationRequest {
  /**
   *
   * @type {string}
   * @memberof AddOrganisationRequest
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddOrganisationRequest
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddOrganisationRequest
   */
  currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddOrganisationRequest
   */
  country?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AddOrganisationRequest
   */
  isFreeMembership?: boolean;
  /**
   *
   * @type {string}
   * @memberof AddOrganisationRequest
   */
  constitutionUrl?: string | null;
  /**
   *
   * @type {Array<OrganisationServiceOption>}
   * @memberof AddOrganisationRequest
   */
  organisationServiceOptions?: Array<OrganisationServiceOption> | null;
}
/**
 *
 * @export
 * @interface AddRoleRequest
 */
export interface AddRoleRequest {
  /**
   *
   * @type {string}
   * @memberof AddRoleRequest
   */
  roleName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddRoleRequest
   */
  roleDescription?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AddRoleRequest
   */
  isSystemRole?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AddRoleRequest
   */
  isDefaultRole?: boolean;
}
/**
 *
 * @export
 * @interface AddRuleRequest
 */
export interface AddRuleRequest {
  /**
   *
   * @type {string}
   * @memberof AddRuleRequest
   */
  ruleName: string;
  /**
   *
   * @type {string}
   * @memberof AddRuleRequest
   */
  description: string;
  /**
   *
   * @type {number}
   * @memberof AddRuleRequest
   */
  validationId?: number | null;
  /**
   *
   * @type {RuleType}
   * @memberof AddRuleRequest
   */
  ruleType?: RuleType;
  /**
   *
   * @type {string}
   * @memberof AddRuleRequest
   */
  ruleJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddRuleRequest
   */
  triggerConfigJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddRuleRequest
   */
  errorMessage?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddRuleRequest
   */
  ruleEntityId?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof AddRuleRequest
   */
  ruleEntityType?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof AddRuleRequest
   */
  isEnabled?: boolean;
}

/**
 *
 * @export
 * @interface AddValidationRequest
 */
export interface AddValidationRequest {
  /**
   *
   * @type {string}
   * @memberof AddValidationRequest
   */
  validationEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof AddValidationRequest
   */
  validationName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddValidationRequest
   */
  validationDescription?: string | null;
  /**
   *
   * @type {ValidationType}
   * @memberof AddValidationRequest
   */
  validationType?: ValidationType;
  /**
   *
   * @type {ParentEntityType}
   * @memberof AddValidationRequest
   */
  parentEntityType?: ParentEntityType;
  /**
   *
   * @type {string}
   * @memberof AddValidationRequest
   */
  errorMessage?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AddValidationRequest
   */
  isActive?: boolean;
}

/**
 *
 * @export
 * @interface AdditionalInfoDto
 */
export interface AdditionalInfoDto {
  /**
   *
   * @type {string}
   * @memberof AdditionalInfoDto
   */
  entityId?: string;
  /**
   *
   * @type {number}
   * @memberof AdditionalInfoDto
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof AdditionalInfoDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof AdditionalInfoDto
   */
  ident?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AdditionalInfoDto
   */
  isStudbookOptedOut?: boolean;
}
/**
 *
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
  /**
   *
   * @type {number}
   * @memberof AddressDto
   */
  addressId?: number;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  addressEntityId?: string;
  /**
   *
   * @type {AddressType}
   * @memberof AddressDto
   */
  addressType?: AddressType;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  unitNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  streetAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  state?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  country?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  postCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  latitude?: string | null;
  /**
   *
   * @type {string}
   * @memberof AddressDto
   */
  longitude?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AddressDto
   */
  isAddressValid?: boolean;
}

/**
 *
 * @export
 * @enum {string}
 */

export const AddressType = {
  Property: 1,
  Mailing: 2,
  Residential: 3,
  Other: 4,
} as const;

export type AddressType = (typeof AddressType)[keyof typeof AddressType];

/**
 *
 * @export
 * @interface AnimalDetailFilterInput
 */
export interface AnimalDetailFilterInput {
  /**
   *
   * @type {string}
   * @memberof AnimalDetailFilterInput
   */
  detailName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AnimalDetailFilterInput
   */
  value?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof AnimalDetailFilterInput
   */
  type?: EntityDetailType;
  /**
   *
   * @type {ComparisonOperator}
   * @memberof AnimalDetailFilterInput
   */
  operator?: ComparisonOperator;
}

/**
 *
 * @export
 * @interface AnimalSpeciesBreedDto
 */
export interface AnimalSpeciesBreedDto {
  /**
   *
   * @type {number}
   * @memberof AnimalSpeciesBreedDto
   */
  animalSpeciesBreedId?: number;
  /**
   *
   * @type {string}
   * @memberof AnimalSpeciesBreedDto
   */
  animalSpeciesBreedEntityId?: string | null;
  /**
   *
   * @type {number}
   * @memberof AnimalSpeciesBreedDto
   */
  animalSpeciesId?: number;
  /**
   *
   * @type {string}
   * @memberof AnimalSpeciesBreedDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof AnimalSpeciesBreedDto
   */
  description?: string | null;
}
/**
 *
 * @export
 * @interface AnimalSpeciesDto
 */
export interface AnimalSpeciesDto {
  /**
   *
   * @type {number}
   * @memberof AnimalSpeciesDto
   */
  animalSpeciesId?: number;
  /**
   *
   * @type {string}
   * @memberof AnimalSpeciesDto
   */
  animalSpeciesEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof AnimalSpeciesDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof AnimalSpeciesDto
   */
  description?: string | null;
  /**
   *
   * @type {Array<AnimalSpeciesBreedDto>}
   * @memberof AnimalSpeciesDto
   */
  animalSpeciesBreeds?: Array<AnimalSpeciesBreedDto> | null;
}
/**
 *
 * @export
 * @interface AppendWorkOrderItemRequest
 */
export interface AppendWorkOrderItemRequest {
  /**
   *
   * @type {string}
   * @memberof AppendWorkOrderItemRequest
   */
  itemDescription: string;
  /**
   *
   * @type {FeeSection}
   * @memberof AppendWorkOrderItemRequest
   */
  itemType: FeeSection;
  /**
   *
   * @type {number}
   * @memberof AppendWorkOrderItemRequest
   */
  quantity: number;
  /**
   *
   * @type {number}
   * @memberof AppendWorkOrderItemRequest
   */
  feeId: number;
  /**
   *
   * @type {number}
   * @memberof AppendWorkOrderItemRequest
   */
  rate?: number;
  /**
   *
   * @type {string}
   * @memberof AppendWorkOrderItemRequest
   */
  itemTypeEntityId?: string | null;
  /**
   *
   * @type {string}
   * @memberof AppendWorkOrderItemRequest
   */
  itemEntityId?: string | null;
}

/**
 *
 * @export
 * @interface AppendWorkOrderItemsRequest
 */
export interface AppendWorkOrderItemsRequest {
  /**
   *
   * @type {number}
   * @memberof AppendWorkOrderItemsRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof AppendWorkOrderItemsRequest
   */
  organisationId?: number;
  /**
   *
   * @type {Array<AppendWorkOrderItemRequest>}
   * @memberof AppendWorkOrderItemsRequest
   */
  items?: Array<AppendWorkOrderItemRequest> | null;
}
/**
 *
 * @export
 * @interface AuthorisedRepresentativeDto
 */
export interface AuthorisedRepresentativeDto {
  /**
   *
   * @type {number}
   * @memberof AuthorisedRepresentativeDto
   */
  authorisedRepresentativeId?: number;
  /**
   *
   * @type {string}
   * @memberof AuthorisedRepresentativeDto
   */
  authorisedRepresentativeEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof AuthorisedRepresentativeDto
   */
  memberId?: number;
  /**
   *
   * @type {string}
   * @memberof AuthorisedRepresentativeDto
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AuthorisedRepresentativeDto
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AuthorisedRepresentativeDto
   */
  email?: string | null;
}
/**
 *
 * @export
 * @interface AutoCalcInputValue
 */
export interface AutoCalcInputValue {
  /**
   *
   * @type {number}
   * @memberof AutoCalcInputValue
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof AutoCalcInputValue
   */
  value?: string | null;
  /**
   *
   * @type {string}
   * @memberof AutoCalcInputValue
   */
  name?: string | null;
}
/**
 *
 * @export
 * @interface AutoCalcInstruction
 */
export interface AutoCalcInstruction {
  /**
   *
   * @type {InstructionType}
   * @memberof AutoCalcInstruction
   */
  type?: InstructionType;
  /**
   *
   * @type {number}
   * @memberof AutoCalcInstruction
   */
  entityDetailId?: number | null;
  /**
   *
   * @type {string}
   * @memberof AutoCalcInstruction
   */
  value?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof AutoCalcInstruction
   */
  overwriteExisting?: boolean | null;
}

/**
 *
 * @export
 * @interface AutoCalcTriggerRequest
 */
export interface AutoCalcTriggerRequest {
  /**
   *
   * @type {number}
   * @memberof AutoCalcTriggerRequest
   */
  organisationId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof AutoCalcTriggerRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {ActionType}
   * @memberof AutoCalcTriggerRequest
   */
  entityAction?: ActionType;
  /**
   *
   * @type {number}
   * @memberof AutoCalcTriggerRequest
   */
  triggeringDetailId?: number;
  /**
   *
   * @type {Array<AutoCalcInputValue>}
   * @memberof AutoCalcTriggerRequest
   */
  formValues?: Array<AutoCalcInputValue> | null;
}

/**
 *
 * @export
 * @interface AutoCalculateRule
 */
export interface AutoCalculateRule {
  /**
   *
   * @type {string}
   * @memberof AutoCalculateRule
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof AutoCalculateRule
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof AutoCalculateRule
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof AutoCalculateRule
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof AutoCalculateRule
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof AutoCalculateRule
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof AutoCalculateRule
   */
  autoCalculateRuleId?: number;
  /**
   *
   * @type {string}
   * @memberof AutoCalculateRule
   */
  autoCalculateEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof AutoCalculateRule
   */
  organisationId?: number;
  /**
   *
   * @type {number}
   * @memberof AutoCalculateRule
   */
  triggerDetailId: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof AutoCalculateRule
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {ActionType}
   * @memberof AutoCalculateRule
   */
  entityAction?: ActionType;
  /**
   *
   * @type {boolean}
   * @memberof AutoCalculateRule
   */
  isEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof AutoCalculateRule
   */
  priority?: number;
  /**
   *
   * @type {Array<DecisionRule>}
   * @memberof AutoCalculateRule
   */
  decisionRules?: Array<DecisionRule> | null;
  /**
   *
   * @type {string}
   * @memberof AutoCalculateRule
   */
  decisionRulesJson?: string | null;
}

/**
 *
 * @export
 * @interface BillableEvent
 */
export interface BillableEvent {
  /**
   *
   * @type {string}
   * @memberof BillableEvent
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillableEvent
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof BillableEvent
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillableEvent
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof BillableEvent
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof BillableEvent
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof BillableEvent
   */
  billableEventId?: number;
  /**
   *
   * @type {string}
   * @memberof BillableEvent
   */
  billableEventIdent?: string | null;
  /**
   *
   * @type {number}
   * @memberof BillableEvent
   */
  orgId: number;
  /**
   *
   * @type {number}
   * @memberof BillableEvent
   */
  entityId: number;
  /**
   *
   * @type {Entity}
   * @memberof BillableEvent
   */
  entity?: Entity;
  /**
   *
   * @type {number}
   * @memberof BillableEvent
   */
  grossAmount: number;
  /**
   *
   * @type {string}
   * @memberof BillableEvent
   */
  date: string;
  /**
   *
   * @type {number}
   * @memberof BillableEvent
   */
  batchId?: number | null;
  /**
   *
   * @type {BillableEventBatch}
   * @memberof BillableEvent
   */
  batch?: BillableEventBatch;
  /**
   *
   * @type {Array<ItemCode>}
   * @memberof BillableEvent
   */
  itemCodes?: Array<ItemCode> | null;
}
/**
 *
 * @export
 * @interface BillableEventBatch
 */
export interface BillableEventBatch {
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof BillableEventBatch
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof BillableEventBatch
   */
  batchId?: number;
  /**
   *
   * @type {number}
   * @memberof BillableEventBatch
   */
  orgId?: number;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  batchIdent?: string | null;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  status?: string | null;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  dateCreated?: string;
  /**
   *
   * @type {string}
   * @memberof BillableEventBatch
   */
  dateExported?: string | null;
  /**
   *
   * @type {number}
   * @memberof BillableEventBatch
   */
  totalAmount?: number;
  /**
   *
   * @type {Array<BillableEvent>}
   * @memberof BillableEventBatch
   */
  billableEvents?: Array<BillableEvent> | null;
}
/**
 *
 * @export
 * @interface BillableEventDto
 */
export interface BillableEventDto {
  /**
   *
   * @type {string}
   * @memberof BillableEventDto
   */
  billableEventIdent?: string | null;
  /**
   *
   * @type {number}
   * @memberof BillableEventDto
   */
  billableEventId?: number;
  /**
   *
   * @type {number}
   * @memberof BillableEventDto
   */
  orgId?: number;
  /**
   *
   * @type {number}
   * @memberof BillableEventDto
   */
  entityId?: number;
  /**
   *
   * @type {number}
   * @memberof BillableEventDto
   */
  grossAmount?: number;
  /**
   *
   * @type {string}
   * @memberof BillableEventDto
   */
  date?: string;
  /**
   *
   * @type {number}
   * @memberof BillableEventDto
   */
  batchId?: number | null;
  /**
   *
   * @type {Array<ItemCodeDto>}
   * @memberof BillableEventDto
   */
  itemCodes?: Array<ItemCodeDto> | null;
}
/**
 *
 * @export
 * @interface BillableEventDtoPagedResult
 */
export interface BillableEventDtoPagedResult {
  /**
   *
   * @type {Array<BillableEventDto>}
   * @memberof BillableEventDtoPagedResult
   */
  queryable?: Array<BillableEventDto> | null;
  /**
   *
   * @type {number}
   * @memberof BillableEventDtoPagedResult
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof BillableEventDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof BillableEventDtoPagedResult
   */
  pageSize?: number;
  /**
   *
   * @type {number}
   * @memberof BillableEventDtoPagedResult
   */
  rowCount?: number;
}
/**
 *
 * @export
 * @interface BillableEventFilter
 */
export interface BillableEventFilter {
  /**
   *
   * @type {string}
   * @memberof BillableEventFilter
   */
  status?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const BillableEventType = {
  AnimalCreate: 1,
  AnimalTransfer: 2,
  AnimalEdit: 3,
  AnimalDisposalCancel: 4,
  MembershipUpdate: 5,
} as const;

export type BillableEventType =
  (typeof BillableEventType)[keyof typeof BillableEventType];

/**
 *
 * @export
 * @interface BillingEventRule
 */
export interface BillingEventRule {
  /**
   *
   * @type {string}
   * @memberof BillingEventRule
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillingEventRule
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof BillingEventRule
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillingEventRule
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof BillingEventRule
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof BillingEventRule
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof BillingEventRule
   */
  ruleId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof BillingEventRule
   */
  entityType: EntityTypeCode;
  /**
   *
   * @type {BillableEventType}
   * @memberof BillingEventRule
   */
  billableEventTypeCode: BillableEventType;
  /**
   *
   * @type {number}
   * @memberof BillingEventRule
   */
  amount?: number | null;
  /**
   *
   * @type {number}
   * @memberof BillingEventRule
   */
  sequence: number;
  /**
   *
   * @type {Array<BillingEventRuleCriteria>}
   * @memberof BillingEventRule
   */
  criteria?: Array<BillingEventRuleCriteria> | null;
  /**
   *
   * @type {number}
   * @memberof BillingEventRule
   */
  organisationId: number;
  /**
   *
   * @type {Organisation}
   * @memberof BillingEventRule
   */
  organisation?: Organisation;
  /**
   *
   * @type {number}
   * @memberof BillingEventRule
   */
  itemCodeId: number;
  /**
   *
   * @type {ItemCode}
   * @memberof BillingEventRule
   */
  itemCode?: ItemCode;
}

/**
 *
 * @export
 * @interface BillingEventRuleCriteria
 */
export interface BillingEventRuleCriteria {
  /**
   *
   * @type {string}
   * @memberof BillingEventRuleCriteria
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillingEventRuleCriteria
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof BillingEventRuleCriteria
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof BillingEventRuleCriteria
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof BillingEventRuleCriteria
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof BillingEventRuleCriteria
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof BillingEventRuleCriteria
   */
  criteriaId?: number;
  /**
   *
   * @type {string}
   * @memberof BillingEventRuleCriteria
   */
  criteria: string;
  /**
   *
   * @type {number}
   * @memberof BillingEventRuleCriteria
   */
  ruleId: number;
  /**
   *
   * @type {BillingEventRule}
   * @memberof BillingEventRuleCriteria
   */
  rule?: BillingEventRule;
}
/**
 *
 * @export
 * @interface BulkDisposeErrorDto
 */
export interface BulkDisposeErrorDto {
  /**
   *
   * @type {number}
   * @memberof BulkDisposeErrorDto
   */
  animalId?: number;
  /**
   *
   * @type {string}
   * @memberof BulkDisposeErrorDto
   */
  error?: string | null;
}
/**
 *
 * @export
 * @interface BulkDisposeRequest
 */
export interface BulkDisposeRequest {
  /**
   *
   * @type {Array<number>}
   * @memberof BulkDisposeRequest
   */
  animalIds?: Array<number> | null;
  /**
   *
   * @type {DisposalRecord}
   * @memberof BulkDisposeRequest
   */
  disposalRecord?: DisposalRecord;
}
/**
 *
 * @export
 * @interface BulkDisposeResultDto
 */
export interface BulkDisposeResultDto {
  /**
   *
   * @type {Array<BulkDisposeSuccessDto>}
   * @memberof BulkDisposeResultDto
   */
  successResults?: Array<BulkDisposeSuccessDto> | null;
  /**
   *
   * @type {Array<BulkDisposeErrorDto>}
   * @memberof BulkDisposeResultDto
   */
  errors?: Array<BulkDisposeErrorDto> | null;
  /**
   *
   * @type {Array<number>}
   * @memberof BulkDisposeResultDto
   */
  successIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface BulkDisposeSuccessDto
 */
export interface BulkDisposeSuccessDto {
  /**
   *
   * @type {number}
   * @memberof BulkDisposeSuccessDto
   */
  animalId?: number;
  /**
   *
   * @type {DisposalRecord}
   * @memberof BulkDisposeSuccessDto
   */
  disposalRecord?: DisposalRecord;
}
/**
 *
 * @export
 * @interface BulkSuspendEnterpriseRequest
 */
export interface BulkSuspendEnterpriseRequest {
  /**
   *
   * @type {Array<number>}
   * @memberof BulkSuspendEnterpriseRequest
   */
  entityIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface BulkUpdateMembershipStatusCodeRequest
 */
export interface BulkUpdateMembershipStatusCodeRequest {
  /**
   *
   * @type {Array<number>}
   * @memberof BulkUpdateMembershipStatusCodeRequest
   */
  enterpriseIds?: Array<number> | null;
  /**
   *
   * @type {MembershipStatusCode}
   * @memberof BulkUpdateMembershipStatusCodeRequest
   */
  newStatusCode?: MembershipStatusCode;
}

/**
 *
 * @export
 * @interface BulkUploadDocumentRequest
 */
export interface BulkUploadDocumentRequest {
  /**
   *
   * @type {string}
   * @memberof BulkUploadDocumentRequest
   */
  entityId?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof BulkUploadDocumentRequest
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {DocumentTypeCode}
   * @memberof BulkUploadDocumentRequest
   */
  documentType?: DocumentTypeCode;
  /**
   *
   * @type {Array<number>}
   * @memberof BulkUploadDocumentRequest
   */
  documentIds?: Array<number> | null;
}

/**
 *
 * @export
 * @interface CheckPrefixExistsForEnterpriseRequest
 */
export interface CheckPrefixExistsForEnterpriseRequest {
  /**
   *
   * @type {number}
   * @memberof CheckPrefixExistsForEnterpriseRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {PrefixType}
   * @memberof CheckPrefixExistsForEnterpriseRequest
   */
  prefixType?: PrefixType;
  /**
   *
   * @type {string}
   * @memberof CheckPrefixExistsForEnterpriseRequest
   */
  prefix?: string | null;
}

/**
 *
 * @export
 * @interface CheckValidIdentForOrganisationRequest
 */
export interface CheckValidIdentForOrganisationRequest {
  /**
   *
   * @type {string}
   * @memberof CheckValidIdentForOrganisationRequest
   */
  identValue?: string | null;
}
/**
 *
 * @export
 * @interface CheckValidPrefixForOrganisationRequest
 */
export interface CheckValidPrefixForOrganisationRequest {
  /**
   *
   * @type {PrefixType}
   * @memberof CheckValidPrefixForOrganisationRequest
   */
  prefixType?: PrefixType;
  /**
   *
   * @type {string}
   * @memberof CheckValidPrefixForOrganisationRequest
   */
  prefix?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ComparisonOperator = {
  Equals: 0,
  GreaterThan: 1,
  LessThan: 2,
  Contains: 3,
  NotEquals: 4,
  NotNull: 5,
  StartWith: 6,
  EndsWith: 7,
} as const;

export type ComparisonOperator =
  (typeof ComparisonOperator)[keyof typeof ComparisonOperator];

/**
 *
 * @export
 * @interface ContactDetailDto
 */
export interface ContactDetailDto {
  /**
   *
   * @type {number}
   * @memberof ContactDetailDto
   */
  contactDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof ContactDetailDto
   */
  contactDetailEntityId?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof ContactDetailDto
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof ContactDetailDto
   */
  entityId?: string;
  /**
   *
   * @type {ContactType}
   * @memberof ContactDetailDto
   */
  contactType?: ContactType;
  /**
   *
   * @type {string}
   * @memberof ContactDetailDto
   */
  contactValue?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ContactDetailDto
   */
  isPrimary?: boolean;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ContactType = {
  Phone: 2,
  Mobile: 3,
  Fax: 4,
} as const;

export type ContactType = (typeof ContactType)[keyof typeof ContactType];

/**
 *
 * @export
 * @interface CreateCustomFormRequest
 */
export interface CreateCustomFormRequest {
  /**
   *
   * @type {string}
   * @memberof CreateCustomFormRequest
   */
  customFormEntityId: string;
  /**
   *
   * @type {number}
   * @memberof CreateCustomFormRequest
   */
  organisationId: number;
  /**
   *
   * @type {number}
   * @memberof CreateCustomFormRequest
   */
  editableFormId: number;
}
/**
 *
 * @export
 * @interface CustomFieldDto
 */
export interface CustomFieldDto {
  /**
   *
   * @type {number}
   * @memberof CustomFieldDto
   */
  customFieldId?: number;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDto
   */
  customFieldEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof CustomFieldDto
   */
  organisationId?: number | null;
  /**
   *
   * @type {number}
   * @memberof CustomFieldDto
   */
  fieldTypeId: number;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDto
   */
  labelText: string;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDto
   */
  fieldName: string;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDto
   */
  fieldDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDto
   */
  placeholder?: string | null;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDto
   */
  defaultValue?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CustomFieldDto
   */
  options?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof CustomFieldDto
   */
  value?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof CustomFieldDto
   */
  entityType: EntityTypeCode;
  /**
   *
   * @type {ValidationRuleDto}
   * @memberof CustomFieldDto
   */
  validation?: ValidationRuleDto;
}

/**
 *
 * @export
 * @interface CustomFormDto
 */
export interface CustomFormDto {
  /**
   *
   * @type {number}
   * @memberof CustomFormDto
   */
  customFormId?: number;
  /**
   *
   * @type {string}
   * @memberof CustomFormDto
   */
  entityId?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof CustomFormDto
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof CustomFormDto
   */
  formName?: string | null;
  /**
   *
   * @type {string}
   * @memberof CustomFormDto
   */
  formDescription?: string | null;
  /**
   *
   * @type {Array<CustomFieldDto>}
   * @memberof CustomFormDto
   */
  fields?: Array<CustomFieldDto> | null;
}

/**
 *
 * @export
 * @interface DecisionCondition
 */
export interface DecisionCondition {
  /**
   *
   * @type {Array<FieldMatch>}
   * @memberof DecisionCondition
   */
  when?: Array<FieldMatch> | null;
  /**
   *
   * @type {string}
   * @memberof DecisionCondition
   */
  thenValue?: string | null;
}
/**
 *
 * @export
 * @interface DecisionRule
 */
export interface DecisionRule {
  /**
   *
   * @type {number}
   * @memberof DecisionRule
   */
  destinationDetailId?: number;
  /**
   *
   * @type {Array<DecisionCondition>}
   * @memberof DecisionRule
   */
  conditions?: Array<DecisionCondition> | null;
  /**
   *
   * @type {string}
   * @memberof DecisionRule
   */
  defaultValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof DecisionRule
   */
  fallbackMessage?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DecisionRule
   */
  setReadonly?: boolean | null;
}
/**
 *
 * @export
 * @interface DeleteFeesRequest
 */
export interface DeleteFeesRequest {
  /**
   *
   * @type {number}
   * @memberof DeleteFeesRequest
   */
  organisationId?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof DeleteFeesRequest
   */
  itemIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface DeleteWorkOrderItemsRequest
 */
export interface DeleteWorkOrderItemsRequest {
  /**
   *
   * @type {number}
   * @memberof DeleteWorkOrderItemsRequest
   */
  workOrderId?: number;
  /**
   *
   * @type {number}
   * @memberof DeleteWorkOrderItemsRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof DeleteWorkOrderItemsRequest
   */
  itemIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface DisposalRecord
 */
export interface DisposalRecord {
  /**
   *
   * @type {string}
   * @memberof DisposalRecord
   */
  code?: string | null;
  /**
   *
   * @type {string}
   * @memberof DisposalRecord
   */
  date?: string | null;
  /**
   *
   * @type {string}
   * @memberof DisposalRecord
   */
  id?: string | null;
}
/**
 *
 * @export
 * @interface Document
 */
export interface Document {
  /**
   *
   * @type {string}
   * @memberof Document
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Document
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Document
   */
  documentId?: number;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  documentEntityId?: string;
  /**
   *
   * @type {DocumentTypeCode}
   * @memberof Document
   */
  documentType?: DocumentTypeCode;
  /**
   *
   * @type {DocumentSourceType}
   * @memberof Document
   */
  sourceType?: DocumentSourceType;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  entityId: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof Document
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  location: string;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  extension?: string | null;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  contentType?: string | null;
  /**
   *
   * @type {number}
   * @memberof Document
   */
  documentSize?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof Document
   */
  isPrimary?: boolean;
}

/**
 *
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
  /**
   *
   * @type {number}
   * @memberof DocumentDto
   */
  documentId?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  documentEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  entityId?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  documentName?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  documentLocation?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  contentType?: string | null;
  /**
   *
   * @type {DocumentTypeCode}
   * @memberof DocumentDto
   */
  documentType?: DocumentTypeCode;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof DocumentDto
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  documentBytes?: string | null;
  /**
   *
   * @type {number}
   * @memberof DocumentDto
   */
  documentSize?: number | null;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  createdBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof DocumentDto
   */
  createdDate?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DocumentDto
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DocumentDto
   */
  isPrimary?: boolean;
}

/**
 *
 * @export
 * @interface DocumentPagedResult
 */
export interface DocumentPagedResult {
  /**
   *
   * @type {number}
   * @memberof DocumentPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof DocumentPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof DocumentPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<Document>}
   * @memberof DocumentPagedResult
   */
  results?: Array<Document> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const DocumentSourceType = {
  BlobStorage: 0,
  FileShare: 1,
} as const;

export type DocumentSourceType =
  (typeof DocumentSourceType)[keyof typeof DocumentSourceType];

/**
 *
 * @export
 * @enum {string}
 */

export const DocumentTypeCode = {
  Avatar: 1,
  Banner: 2,
  Logo: 3,
  Document: 4,
  Image: 5,
  UploadAnimal: 6,
  Template: 7,
  Certificate: 8,
} as const;

export type DocumentTypeCode =
  (typeof DocumentTypeCode)[keyof typeof DocumentTypeCode];

/**
 *
 * @export
 * @interface DuplicateFormRequest
 */
export interface DuplicateFormRequest {
  /**
   *
   * @type {number}
   * @memberof DuplicateFormRequest
   */
  sourceFormId?: number;
  /**
   *
   * @type {number}
   * @memberof DuplicateFormRequest
   */
  organisationId?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const EditableFormType = {
  MemberAdditionalInfo: 1,
} as const;

export type EditableFormType =
  (typeof EditableFormType)[keyof typeof EditableFormType];

/**
 *
 * @export
 * @enum {string}
 */

export const EnhancerType = {
  Individual: 0,
  ComplementaryPrevious: 1,
  HideIfPreviousEmpty: 2,
} as const;

export type EnhancerType = (typeof EnhancerType)[keyof typeof EnhancerType];

/**
 *
 * @export
 * @interface Enterprise
 */
export interface Enterprise {
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Enterprise
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Enterprise
   */
  enterpriseId?: number;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  enterpriseEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof Enterprise
   */
  organisationId?: number | null;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  dateOfBirth?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof Enterprise
   */
  isConstitutionAccepted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  constitutionAcceptedDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof Enterprise
   */
  enterpriseIdent?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof Enterprise
   */
  isExistingEnterprise?: boolean;
  /**
   *
   * @type {Array<Membership>}
   * @memberof Enterprise
   */
  memberships?: Array<Membership> | null;
  /**
   *
   * @type {Array<EnterprisePrefix>}
   * @memberof Enterprise
   */
  enterprisePrefixes?: Array<EnterprisePrefix> | null;
  /**
   *
   * @type {Array<EnterpriseAction>}
   * @memberof Enterprise
   */
  enterpriseActions?: Array<EnterpriseAction> | null;
  /**
   *
   * @type {Array<EnterpriseAlternateIdentifier>}
   * @memberof Enterprise
   */
  alternateIdentifiers?: Array<EnterpriseAlternateIdentifier> | null;
  /**
   *
   * @type {Array<EnterpriseUser>}
   * @memberof Enterprise
   */
  enterpriseUsers?: Array<EnterpriseUser> | null;
  /**
   *
   * @type {Organisation}
   * @memberof Enterprise
   */
  organisation?: Organisation;
  /**
   *
   * @type {boolean}
   * @memberof Enterprise
   */
  isStudbookOptedOut?: boolean;
}
/**
 *
 * @export
 * @interface EnterpriseAction
 */
export interface EnterpriseAction {
  /**
   *
   * @type {number}
   * @memberof EnterpriseAction
   */
  enterpriseActionId?: number;
  /**
   *
   * @type {number}
   * @memberof EnterpriseAction
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof EnterpriseAction
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof EnterpriseAction
   */
  actionTypeId: number;
  /**
   *
   * @type {EnterpriseActionTypeStatusCode}
   * @memberof EnterpriseAction
   */
  actionTypeStatus: EnterpriseActionTypeStatusCode;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAction
   */
  actionOnDate?: string;
  /**
   *
   * @type {number}
   * @memberof EnterpriseAction
   */
  actionByUserId?: number;
  /**
   *
   * @type {Enterprise}
   * @memberof EnterpriseAction
   */
  enterprise?: Enterprise;
}

/**
 *
 * @export
 * @interface EnterpriseActionDto
 */
export interface EnterpriseActionDto {
  /**
   *
   * @type {number}
   * @memberof EnterpriseActionDto
   */
  enterpriseActionId?: number | null;
  /**
   *
   * @type {number}
   * @memberof EnterpriseActionDto
   */
  enterpriseId?: number;
  /**
   *
   * @type {EnterpriseActionTypeCode}
   * @memberof EnterpriseActionDto
   */
  actionType?: EnterpriseActionTypeCode;
  /**
   *
   * @type {EnterpriseActionTypeStatusCode}
   * @memberof EnterpriseActionDto
   */
  actionTypeStatus?: EnterpriseActionTypeStatusCode;
  /**
   *
   * @type {string}
   * @memberof EnterpriseActionDto
   */
  actionOnDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof EnterpriseActionDto
   */
  actionByUserId?: number | null;
  /**
   *
   * @type {Enterprise}
   * @memberof EnterpriseActionDto
   */
  enterprise?: Enterprise;
}

/**
 *
 * @export
 * @interface EnterpriseActionTypeCode
 */
export interface EnterpriseActionTypeCode {
  /**
   *
   * @type {number}
   * @memberof EnterpriseActionTypeCode
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof EnterpriseActionTypeCode
   */
  name?: string | null;
  /**
   *
   * @type {number}
   * @memberof EnterpriseActionTypeCode
   */
  order?: number | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const EnterpriseActionTypeStatusCode = {
  Incomplete: 1,
  Complete: 2,
} as const;

export type EnterpriseActionTypeStatusCode =
  (typeof EnterpriseActionTypeStatusCode)[keyof typeof EnterpriseActionTypeStatusCode];

/**
 *
 * @export
 * @interface EnterpriseAlternateIdentifier
 */
export interface EnterpriseAlternateIdentifier {
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseAlternateIdentifier
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EnterpriseAlternateIdentifier
   */
  alternateIdentId?: number;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  alternateIdentGuid: string;
  /**
   *
   * @type {number}
   * @memberof EnterpriseAlternateIdentifier
   */
  enterpriseId: number;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  alternateAssociation: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  alternateIdent: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  startDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseAlternateIdentifier
   */
  expiryDate?: string | null;
  /**
   *
   * @type {Enterprise}
   * @memberof EnterpriseAlternateIdentifier
   */
  enterprise?: Enterprise;
}
/**
 *
 * @export
 * @interface EnterpriseDto
 */
export interface EnterpriseDto {
  /**
   *
   * @type {number}
   * @memberof EnterpriseDto
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  enterpriseIdent?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  enterpriseEntityId?: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseDto
   */
  isConstitutionAccepted?: boolean;
  /**
   *
   * @type {number}
   * @memberof EnterpriseDto
   */
  organisationId?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseDto
   */
  isReceiveNotifications?: boolean;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  constitutionAcceptedDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  dateJoined?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDto
   */
  dateOfBirth?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseDto
   */
  isExistingMember?: boolean;
  /**
   *
   * @type {Array<EnterprisePrefixDto>}
   * @memberof EnterpriseDto
   */
  enterprisePrefixes?: Array<EnterprisePrefixDto> | null;
  /**
   *
   * @type {Array<AddressDto>}
   * @memberof EnterpriseDto
   */
  addresses?: Array<AddressDto> | null;
  /**
   *
   * @type {Array<ContactDetailDto>}
   * @memberof EnterpriseDto
   */
  contactDetails?: Array<ContactDetailDto> | null;
  /**
   *
   * @type {Array<EnterpriseUserDto>}
   * @memberof EnterpriseDto
   */
  enterpriseUsers?: Array<EnterpriseUserDto> | null;
  /**
   *
   * @type {MembershipDto}
   * @memberof EnterpriseDto
   */
  membership?: MembershipDto;
  /**
   *
   * @type {MembershipStatusCode}
   * @memberof EnterpriseDto
   */
  lastMembershipStatus?: MembershipStatusCode;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseDto
   */
  isStudbookOptedOut?: boolean;
}

/**
 *
 * @export
 * @interface EnterpriseDtoPagedResult
 */
export interface EnterpriseDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof EnterpriseDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof EnterpriseDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof EnterpriseDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof EnterpriseDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<EnterpriseDto>}
   * @memberof EnterpriseDtoPagedResult
   */
  results?: Array<EnterpriseDto> | null;
}
/**
 *
 * @export
 * @interface EnterpriseDtoResult
 */
export interface EnterpriseDtoResult {
  /**
   *
   * @type {ReturnStatus}
   * @memberof EnterpriseDtoResult
   */
  status?: ReturnStatus;
  /**
   *
   * @type {string}
   * @memberof EnterpriseDtoResult
   */
  message?: string | null;
  /**
   *
   * @type {EnterpriseDto}
   * @memberof EnterpriseDtoResult
   */
  data?: EnterpriseDto;
  /**
   *
   * @type {Array<ErrorDetail>}
   * @memberof EnterpriseDtoResult
   */
  errorDetails?: Array<ErrorDetail> | null;
}

/**
 *
 * @export
 * @interface EnterprisePrefix
 */
export interface EnterprisePrefix {
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefix
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefix
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefix
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefix
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterprisePrefix
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefix
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EnterprisePrefix
   */
  enterprisePrefixId?: number;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefix
   */
  enterprisePrefixEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof EnterprisePrefix
   */
  enterpriseId?: number;
  /**
   *
   * @type {PrefixType}
   * @memberof EnterprisePrefix
   */
  prefixType?: PrefixType;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefix
   */
  prefix: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterprisePrefix
   */
  activePrefix?: boolean;
  /**
   *
   * @type {Enterprise}
   * @memberof EnterprisePrefix
   */
  enterprise?: Enterprise;
}

/**
 *
 * @export
 * @interface EnterprisePrefixDto
 */
export interface EnterprisePrefixDto {
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefixDto
   */
  enterprisePrefixEntityId?: string | null;
  /**
   *
   * @type {number}
   * @memberof EnterprisePrefixDto
   */
  enterpriseId?: number;
  /**
   *
   * @type {PrefixType}
   * @memberof EnterprisePrefixDto
   */
  prefixType: PrefixType;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefixDto
   */
  prefix: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterprisePrefixDto
   */
  activePrefix?: boolean;
  /**
   *
   * @type {number}
   * @memberof EnterprisePrefixDto
   */
  enterprisePrefixId?: number | null;
  /**
   *
   * @type {string}
   * @memberof EnterprisePrefixDto
   */
  labelName?: string | null;
}

/**
 *
 * @export
 * @interface EnterpriseUser
 */
export interface EnterpriseUser {
  /**
   *
   * @type {string}
   * @memberof EnterpriseUser
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUser
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUser
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUser
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseUser
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUser
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EnterpriseUser
   */
  enterpriseUserId?: number;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUser
   */
  enterpriseUserEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof EnterpriseUser
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof EnterpriseUser
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseUser
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUser
   */
  dateOfBirth?: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseUser
   */
  isReceiveNotifications?: boolean;
  /**
   *
   * @type {Enterprise}
   * @memberof EnterpriseUser
   */
  enterprise?: Enterprise;
}
/**
 *
 * @export
 * @interface EnterpriseUserDto
 */
export interface EnterpriseUserDto {
  /**
   *
   * @type {number}
   * @memberof EnterpriseUserDto
   */
  enterpriseUserId?: number;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUserDto
   */
  enterpriseUserEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof EnterpriseUserDto
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseUserDto
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUserDto
   */
  dateOfBirth?: string;
  /**
   *
   * @type {boolean}
   * @memberof EnterpriseUserDto
   */
  isReceiveNotifications?: boolean;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUserDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnterpriseUserDto
   */
  enterpriseName?: string | null;
}
/**
 *
 * @export
 * @interface Entity
 */
export interface Entity {
  /**
   *
   * @type {string}
   * @memberof Entity
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Entity
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Entity
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Entity
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Entity
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Entity
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Entity
   */
  entityId?: number;
  /**
   *
   * @type {string}
   * @memberof Entity
   */
  entityGuid?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof Entity
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {RecordStatus}
   * @memberof Entity
   */
  recordStatus?: RecordStatus;
  /**
   *
   * @type {Array<EntityOrganisationAssociation>}
   * @memberof Entity
   */
  entityOrganisationAssociations?: Array<EntityOrganisationAssociation> | null;
  /**
   *
   * @type {Array<EntityTransfer>}
   * @memberof Entity
   */
  entityTransfers?: Array<EntityTransfer> | null;
  /**
   *
   * @type {Array<EntityDetailValue>}
   * @memberof Entity
   */
  entityDetailValues?: Array<EntityDetailValue> | null;
}

/**
 *
 * @export
 * @interface EntityDetail
 */
export interface EntityDetail {
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetail
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetail
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  entityDetailEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetail
   */
  entityDetailDescription?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof EntityDetail
   */
  entityDetailType?: EntityDetailType;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof EntityDetail
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetail
   */
  isMandatoryEnable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetail
   */
  isDatabaseSearchEnable?: boolean;
  /**
   *
   * @type {Array<EntityDetailConfig>}
   * @memberof EntityDetail
   */
  entityDetailConfigs?: Array<EntityDetailConfig> | null;
  /**
   *
   * @type {Array<EntityDetailValue>}
   * @memberof EntityDetail
   */
  entityDetailValues?: Array<EntityDetailValue> | null;
}

/**
 *
 * @export
 * @interface EntityDetailCategoryAssociationDto
 */
export interface EntityDetailCategoryAssociationDto {
  /**
   *
   * @type {number}
   * @memberof EntityDetailCategoryAssociationDto
   */
  entityDetailCategoryId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailCategoryAssociationDto
   */
  entityDetailId?: number;
}
/**
 *
 * @export
 * @interface EntityDetailCategoryDto
 */
export interface EntityDetailCategoryDto {
  /**
   *
   * @type {number}
   * @memberof EntityDetailCategoryDto
   */
  entityDetailCategoryId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailCategoryDto
   */
  entityDetailCategoryName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailCategoryDto
   */
  entityDetailCategoryDescription?: string | null;
  /**
   *
   * @type {Array<EntityDetailCategoryAssociationDto>}
   * @memberof EntityDetailCategoryDto
   */
  entityDetailCategoryAssociations?: Array<EntityDetailCategoryAssociationDto> | null;
}
/**
 *
 * @export
 * @interface EntityDetailConfig
 */
export interface EntityDetailConfig {
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfig
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfig
   */
  entityDetailConfigId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  entityDetailConfigEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfig
   */
  entityDetailId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfig
   */
  organisationId?: number | null;
  /**
   *
   * @type {EntityDetailUnitOfMeasurement}
   * @memberof EntityDetailConfig
   */
  entityDetailUnitOfMeasurement?: EntityDetailUnitOfMeasurement;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfig
   */
  entityDetailUnitOfMeasureScale?: number | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  labelText: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  detailName: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  detailDescription: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  placeholder?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof EntityDetailConfig
   */
  entityDetailType?: EntityDetailType;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  defaultValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  category?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfig
   */
  order?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfig
   */
  isDefault?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfig
   */
  isEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfig
   */
  custom?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfig
   */
  isVisible?: boolean;
  /**
   *
   * @type {ReactiveEntityValidationRule}
   * @memberof EntityDetailConfig
   */
  validation?: ReactiveEntityValidationRule;
  /**
   *
   * @type {Array<EntityDetailOption>}
   * @memberof EntityDetailConfig
   */
  options?: Array<EntityDetailOption> | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfig
   */
  isAutoCalculatedEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfig
   */
  isDatabaseSearchEnable?: boolean;
  /**
   *
   * @type {EntityDetail}
   * @memberof EntityDetailConfig
   */
  entityDetail?: EntityDetail;
}

/**
 *
 * @export
 * @interface EntityDetailConfigDto
 */
export interface EntityDetailConfigDto {
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfigDto
   */
  entityDetailConfigId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  entityDetailConfigEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfigDto
   */
  entityDetailId?: number;
  /**
   *
   * @type {EntityDetailUnitOfMeasurement}
   * @memberof EntityDetailConfigDto
   */
  entityDetailUnitOfMeasurement?: EntityDetailUnitOfMeasurement;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfigDto
   */
  entityDetailUnitOfMeasureScale?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  labelText: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  detailName: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  detailDescription: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  placeholder?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof EntityDetailConfigDto
   */
  entityDetailType?: EntityDetailType;
  /**
   *
   * @type {Array<EntityDetailOption>}
   * @memberof EntityDetailConfigDto
   */
  options?: Array<EntityDetailOption> | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  defaultValue?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfigDto
   */
  order?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfigDto
   */
  isDefault?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  category?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfigDto
   */
  isEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof EntityDetailConfigDto
   */
  organisationId?: number | null;
  /**
   *
   * @type {ValidationRuleDto}
   * @memberof EntityDetailConfigDto
   */
  validation?: ValidationRuleDto;
  /**
   *
   * @type {string}
   * @memberof EntityDetailConfigDto
   */
  custom?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfigDto
   */
  isVisible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfigDto
   */
  isMandatoryEnable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailConfigDto
   */
  isDatabaseSearchEnable?: boolean;
}

/**
 *
 * @export
 * @interface EntityDetailData
 */
export interface EntityDetailData {
  /**
   *
   * @type {number}
   * @memberof EntityDetailData
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailData
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailData
   */
  isVisible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailData
   */
  isEnabled?: boolean;
  /**
   *
   * @type {EntityDetailConfigDto}
   * @memberof EntityDetailData
   */
  entityDetailConfig?: EntityDetailConfigDto;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailData
   */
  isDatabaseSearchEnable?: boolean;
}
/**
 *
 * @export
 * @interface EntityDetailDto
 */
export interface EntityDetailDto {
  /**
   *
   * @type {number}
   * @memberof EntityDetailDto
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailDto
   */
  entityDetailEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailDto
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailDto
   */
  entityDetailDescription?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof EntityDetailDto
   */
  entityDetailType?: EntityDetailType;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailDto
   */
  isMandatoryEnable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailDto
   */
  isEnhancer?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailDto
   */
  isDatabaseSearchEnable?: boolean;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof EntityDetailDto
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {EntityDetailConfigDto}
   * @memberof EntityDetailDto
   */
  entityDetailConfigs?: EntityDetailConfigDto;
  /**
   *
   * @type {Array<EntityDetailValueDto>}
   * @memberof EntityDetailDto
   */
  entityDetailValues?: Array<EntityDetailValueDto> | null;
  /**
   *
   * @type {Array<EntityDetailCategoryDto>}
   * @memberof EntityDetailDto
   */
  entityDetailCategories?: Array<EntityDetailCategoryDto> | null;
}

/**
 *
 * @export
 * @interface EntityDetailDtoPagedResult
 */
export interface EntityDetailDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof EntityDetailDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<EntityDetailDto>}
   * @memberof EntityDetailDtoPagedResult
   */
  results?: Array<EntityDetailDto> | null;
}
/**
 *
 * @export
 * @interface EntityDetailEnhancerConfiguration
 */
export interface EntityDetailEnhancerConfiguration {
  /**
   *
   * @type {number}
   * @memberof EntityDetailEnhancerConfiguration
   */
  order?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailEnhancerConfiguration
   */
  entityDetailId?: number | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  defaultValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  prefix?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  postfix?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  customRegex?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  customFormat?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  joinCharacters?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  previousJoinCharacters?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof EntityDetailEnhancerConfiguration
   */
  lookupProperties?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof EntityDetailEnhancerConfiguration
   */
  customMapping?: Array<string> | null;
  /**
   *
   * @type {EnhancerType}
   * @memberof EntityDetailEnhancerConfiguration
   */
  type?: EnhancerType;
  /**
   *
   * @type {OutputFormatStyle}
   * @memberof EntityDetailEnhancerConfiguration
   */
  outputFormatStyle?: OutputFormatStyle;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  exampleValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerConfiguration
   */
  conditionalValues?: string | null;
}

/**
 *
 * @export
 * @interface EntityDetailEnhancerDto
 */
export interface EntityDetailEnhancerDto {
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerDto
   */
  name: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnhancerDto
   */
  value: string | null;
}
/**
 *
 * @export
 * @interface EntityDetailEnum
 */
export interface EntityDetailEnum {
  /**
   *
   * @type {number}
   * @memberof EntityDetailEnum
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnum
   */
  guid?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailEnum
   */
  name?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetailEnum
   */
  order?: number | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof EntityDetailEnum
   */
  entityDetailType?: EntityDetailType;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof EntityDetailEnum
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailEnum
   */
  isDatabaseSearchEnable?: boolean;
}

/**
 *
 * @export
 * @interface EntityDetailFilter
 */
export interface EntityDetailFilter {
  /**
   *
   * @type {string}
   * @memberof EntityDetailFilter
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailFilter
   */
  description?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof EntityDetailFilter
   */
  type?: EntityDetailType;
  /**
   *
   * @type {string}
   * @memberof EntityDetailFilter
   */
  group?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailFilter
   */
  category?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetailFilter
   */
  price?: number | null;
}

/**
 *
 * @export
 * @interface EntityDetailFilterInput
 */
export interface EntityDetailFilterInput {
  /**
   *
   * @type {number}
   * @memberof EntityDetailFilterInput
   */
  entityDetailId?: number | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailFilterInput
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailFilterInput
   */
  value?: string | null;
  /**
   *
   * @type {ComparisonOperator}
   * @memberof EntityDetailFilterInput
   */
  operator?: ComparisonOperator;
  /**
   *
   * @type {LogicalOperator}
   * @memberof EntityDetailFilterInput
   */
  logicalOperator?: LogicalOperator;
}

/**
 *
 * @export
 * @interface EntityDetailOption
 */
export interface EntityDetailOption {
  /**
   *
   * @type {string}
   * @memberof EntityDetailOption
   */
  label?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailOption
   */
  value?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailOption
   */
  category?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailOption
   */
  data?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailOption
   */
  isArchived?: boolean;
  /**
   *
   * @type {number}
   * @memberof EntityDetailOption
   */
  sortOrder?: number;
}
/**
 *
 * @export
 * @interface EntityDetailSortInput
 */
export interface EntityDetailSortInput {
  /**
   *
   * @type {number}
   * @memberof EntityDetailSortInput
   */
  entityDetailId?: number | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailSortInput
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {SortDirectionOrder}
   * @memberof EntityDetailSortInput
   */
  sortDirection?: SortDirectionOrder;
}

/**
 *
 * @export
 * @enum {string}
 */

export const EntityDetailType = {
  Enhancer: 0,
  Text: 1,
  Date: 2,
  Dropdown: 3,
  Radio: 4,
  Checkbox: 5,
  Textarea: 6,
  Number: 7,
  Range: 8,
  Select: 9,
  File: 10,
  Image: 11,
  BreedSelector: 12,
  AnimalSelector: 13,
  MemberSelector: 14,
  AnimalIdent: 15,
  EnterpriseIdent: 16,
  Email: 17,
  Phone: 18,
  Address: 19,
  Prefix: 20,
  Membership: 21,
  Acceptor: 22,
  DisposalRecord: 23,
  AlternateIdents: 24,
  MultipleChoiceCheckbox: 25,
  Attachment: 26,
  MemberLinks: 27,
  Syndicate: 28,
  SexCode: 29,
} as const;

export type EntityDetailType =
  (typeof EntityDetailType)[keyof typeof EntityDetailType];

/**
 *
 * @export
 * @enum {string}
 */

export const EntityDetailUnitOfMeasurement = {
  None: 0,
  Kilograms: 1,
  Grams: 2,
  Liters: 3,
  Milliliters: 4,
  Meters: 5,
  Centimeters: 6,
  Millimeters: 7,
  Inches: 8,
  Feet: 9,
  Yards: 10,
  Miles: 11,
  Kilometers: 12,
  Pounds: 13,
  Ounces: 14,
  Gallons: 15,
  Quarts: 16,
  Pints: 17,
  Cups: 18,
  Tablespoons: 19,
  Teaspoons: 20,
  FluidOunces: 21,
  Milligrams: 22,
  Micrograms: 23,
  SquareMeters: 24,
  SquareCentimeters: 25,
  SquareMillimeters: 26,
  SquareInches: 27,
  SquareFeet: 28,
  SquareYards: 29,
  SquareMiles: 30,
  SquareKilometers: 31,
  CubicMeters: 32,
  CubicCentimeters: 33,
  CubicMillimeters: 34,
  CubicInches: 35,
  CubicFeet: 36,
  CubicYards: 37,
  CubicMiles: 38,
  CubicKilometers: 39,
  Degrees: 40,
  Radians: 41,
  Minutes: 42,
  Seconds: 43,
  Hours: 44,
  Days: 45,
  Weeks: 46,
  Months: 47,
  Years: 48,
  Decades: 49,
  Centuries: 50,
  Millenia: 51,
  Kelvin: 52,
  Celsius: 53,
  Fahrenheit: 54,
} as const;

export type EntityDetailUnitOfMeasurement =
  (typeof EntityDetailUnitOfMeasurement)[keyof typeof EntityDetailUnitOfMeasurement];

/**
 *
 * @export
 * @interface EntityDetailValue
 */
export interface EntityDetailValue {
  /**
   *
   * @type {string}
   * @memberof EntityDetailValue
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailValue
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailValue
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityDetailValue
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EntityDetailValue
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityDetailValue
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetailValue
   */
  entityDetailValueId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailValue
   */
  entityId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailValue
   */
  entityDetailId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailValue
   */
  organisationId?: number | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailValue
   */
  value?: string | null;
  /**
   *
   * @type {RecordStatus}
   * @memberof EntityDetailValue
   */
  recordStatus?: RecordStatus;
  /**
   *
   * @type {EntityDetail}
   * @memberof EntityDetailValue
   */
  entityDetail?: EntityDetail;
  /**
   *
   * @type {Entity}
   * @memberof EntityDetailValue
   */
  entity?: Entity;
}

/**
 *
 * @export
 * @interface EntityDetailValueDto
 */
export interface EntityDetailValueDto {
  /**
   *
   * @type {number}
   * @memberof EntityDetailValueDto
   */
  entityDetailValueId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailValueDto
   */
  entityId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDetailValueDto
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailValueDto
   */
  value?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityDetailValueDto
   */
  organisationId?: number | null;
  /**
   *
   * @type {string}
   * @memberof EntityDetailValueDto
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof EntityDetailValueDto
   */
  entityDetailType?: EntityDetailType;
  /**
   *
   * @type {AdditionalInfoDto}
   * @memberof EntityDetailValueDto
   */
  additionalInfo?: AdditionalInfoDto;
}

/**
 *
 * @export
 * @interface EntityDetailsSearchSortFilterRequest
 */
export interface EntityDetailsSearchSortFilterRequest {
  /**
   *
   * @type {number}
   * @memberof EntityDetailsSearchSortFilterRequest
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDetailsSearchSortFilterRequest
   */
  searchPhrase?: string | null;
  /**
   *
   * @type {SortByRequest}
   * @memberof EntityDetailsSearchSortFilterRequest
   */
  sortBySettings?: SortByRequest;
  /**
   *
   * @type {EntityDetailFilter}
   * @memberof EntityDetailsSearchSortFilterRequest
   */
  filter?: EntityDetailFilter;
  /**
   *
   * @type {PagedEntityDetailsRequest}
   * @memberof EntityDetailsSearchSortFilterRequest
   */
  pageSettings?: PagedEntityDetailsRequest;
}
/**
 *
 * @export
 * @interface EntityDto
 */
export interface EntityDto {
  /**
   *
   * @type {number}
   * @memberof EntityDto
   */
  entityId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityDto
   */
  entityGuid?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof EntityDto
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {RecordStatus}
   * @memberof EntityDto
   */
  recordStatus?: RecordStatus;
  /**
   *
   * @type {boolean}
   * @memberof EntityDto
   */
  isTemporary?: boolean;
  /**
   *
   * @type {Array<EntityDetailValueDto>}
   * @memberof EntityDto
   */
  entityDetailValues?: Array<EntityDetailValueDto> | null;
  /**
   *
   * @type {Array<EntityDetailEnhancerDto>}
   * @memberof EntityDto
   */
  entityDetailEnhancers?: Array<EntityDetailEnhancerDto> | null;
  /**
   *
   * @type {Array<DocumentDto>}
   * @memberof EntityDto
   */
  documents?: Array<DocumentDto> | null;
}

/**
 *
 * @export
 * @interface EntityDtoPagedResult
 */
export interface EntityDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof EntityDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof EntityDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof EntityDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof EntityDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<EntityDto>}
   * @memberof EntityDtoPagedResult
   */
  results?: Array<EntityDto> | null;
}
/**
 *
 * @export
 * @interface EntityEnhancerDto
 */
export interface EntityEnhancerDto {
  /**
   *
   * @type {number}
   * @memberof EntityEnhancerDto
   */
  entityDetailEnhancerId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof EntityEnhancerDto
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof EntityEnhancerDto
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityEnhancerDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityEnhancerDto
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityEnhancerDto
   */
  shortDisplayConfiguration?: string | null;
  /**
   *
   * @type {Array<EntityDetailEnhancerConfiguration>}
   * @memberof EntityEnhancerDto
   */
  configurations?: Array<EntityDetailEnhancerConfiguration> | null;
  /**
   *
   * @type {string}
   * @memberof EntityEnhancerDto
   */
  configurationString?: string | null;
}

/**
 *
 * @export
 * @interface EntityFilterByDetailRequest
 */
export interface EntityFilterByDetailRequest {
  /**
   *
   * @type {Pagination}
   * @memberof EntityFilterByDetailRequest
   */
  pagination?: Pagination;
  /**
   *
   * @type {Array<AnimalDetailFilterInput>}
   * @memberof EntityFilterByDetailRequest
   */
  filterInputs?: Array<AnimalDetailFilterInput> | null;
}
/**
 *
 * @export
 * @interface EntityKeyDto
 */
export interface EntityKeyDto {
  /**
   *
   * @type {number}
   * @memberof EntityKeyDto
   */
  entityKeyId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityKeyDto
   */
  entityKeyEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityKeyDto
   */
  entityId?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof EntityKeyDto
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof EntityKeyDto
   */
  externalKey?: string | null;
  /**
   *
   * @type {ExternalSourceType}
   * @memberof EntityKeyDto
   */
  externalKeySource?: ExternalSourceType;
}

/**
 *
 * @export
 * @interface EntityOrganisationAssociation
 */
export interface EntityOrganisationAssociation {
  /**
   *
   * @type {string}
   * @memberof EntityOrganisationAssociation
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityOrganisationAssociation
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EntityOrganisationAssociation
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityOrganisationAssociation
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EntityOrganisationAssociation
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityOrganisationAssociation
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityOrganisationAssociation
   */
  entityId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityOrganisationAssociation
   */
  organisationId?: number;
  /**
   *
   * @type {Entity}
   * @memberof EntityOrganisationAssociation
   */
  entity?: Entity;
  /**
   *
   * @type {Organisation}
   * @memberof EntityOrganisationAssociation
   */
  organisation?: Organisation;
}
/**
 *
 * @export
 * @interface EntityTransfer
 */
export interface EntityTransfer {
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof EntityTransfer
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof EntityTransfer
   */
  entityTransferId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  entityTransferEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof EntityTransfer
   */
  entityId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityTransfer
   */
  transferFromEntityId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityTransfer
   */
  transferToEntityId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  transferFromDate?: string;
  /**
   *
   * @type {string}
   * @memberof EntityTransfer
   */
  transferToDate?: string | null;
  /**
   *
   * @type {TransferType}
   * @memberof EntityTransfer
   */
  transferType?: TransferType;
  /**
   *
   * @type {Entity}
   * @memberof EntityTransfer
   */
  fromEntity?: Entity;
  /**
   *
   * @type {Entity}
   * @memberof EntityTransfer
   */
  toEntity?: Entity;
  /**
   *
   * @type {number}
   * @memberof EntityTransfer
   */
  transferPercent?: number;
  /**
   *
   * @type {Entity}
   * @memberof EntityTransfer
   */
  entity?: Entity;
}

/**
 *
 * @export
 * @interface EntityTransferDto
 */
export interface EntityTransferDto {
  /**
   *
   * @type {number}
   * @memberof EntityTransferDto
   */
  entityTransferId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityTransferDto
   */
  entityTransferEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof EntityTransferDto
   */
  transferFromEnterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityTransferDto
   */
  transferToEnterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof EntityTransferDto
   */
  transferPercent?: number;
  /**
   *
   * @type {string}
   * @memberof EntityTransferDto
   */
  transferFromDate?: string;
  /**
   *
   * @type {string}
   * @memberof EntityTransferDto
   */
  transferToDate?: string | null;
  /**
   *
   * @type {TransferType}
   * @memberof EntityTransferDto
   */
  transferType?: TransferType;
  /**
   *
   * @type {string}
   * @memberof EntityTransferDto
   */
  fromEnterpriseName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityTransferDto
   */
  toEnterpriseName?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityTransferDto
   */
  fromEnterpriseIdent?: string | null;
  /**
   *
   * @type {string}
   * @memberof EntityTransferDto
   */
  toEnterpriseIdent?: string | null;
}

/**
 *
 * @export
 * @interface EntityTransferDtoPagedResult
 */
export interface EntityTransferDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof EntityTransferDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof EntityTransferDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof EntityTransferDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof EntityTransferDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<EntityTransferDto>}
   * @memberof EntityTransferDtoPagedResult
   */
  results?: Array<EntityTransferDto> | null;
}
/**
 *
 * @export
 * @interface EntityTransferSearchRequest
 */
export interface EntityTransferSearchRequest {
  /**
   *
   * @type {number}
   * @memberof EntityTransferSearchRequest
   */
  entityId?: number;
  /**
   *
   * @type {string}
   * @memberof EntityTransferSearchRequest
   */
  sortColumn?: string | null;
  /**
   *
   * @type {SortDirectionOrder}
   * @memberof EntityTransferSearchRequest
   */
  sortDirection?: SortDirectionOrder;
  /**
   *
   * @type {Pagination}
   * @memberof EntityTransferSearchRequest
   */
  pagination?: Pagination;
}

/**
 *
 * @export
 * @enum {string}
 */

export const EntityTypeCode = {
  AnimalGroup: 1,
  UserProfile: 2,
  Organisation: 3,
  OrganisationBrand: 4,
  Enterprise: 5,
  Animal: 6,
  WorkOrder: 7,
  Note: 8,
  Membership: 9,
  MembershipType: 10,
  EnterpriseActionType: 11,
  EnterprisePrefix: 12,
  MembershipBenefit: 13,
  MembershipTypeBenefitAssc: 14,
  MembershipTypeDuration: 15,
  EnterpriseAlternateIdentifier: 16,
  EnterpriseUser: 17,
  Person: 18,
  CertificateTemplate: 19,
  Syndicate: 20,
} as const;

export type EntityTypeCode =
  (typeof EntityTypeCode)[keyof typeof EntityTypeCode];

/**
 *
 * @export
 * @interface ErrorDetail
 */
export interface ErrorDetail {
  /**
   *
   * @type {number}
   * @memberof ErrorDetail
   */
  detailId?: number;
  /**
   *
   * @type {string}
   * @memberof ErrorDetail
   */
  detailName?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ErrorDetail
   */
  errorMessage?: Array<string> | null;
}
/**
 *
 * @export
 * @interface EvaluateJsonRuleRequest
 */
export interface EvaluateJsonRuleRequest {
  /**
   *
   * @type {string}
   * @memberof EvaluateJsonRuleRequest
   */
  ruleJson?: string | null;
  /**
   *
   * @type {Entity}
   * @memberof EvaluateJsonRuleRequest
   */
  testEntity?: Entity;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof EvaluateJsonRuleRequest
   */
  testValues?: { [key: string]: any } | null;
  /**
   *
   * @type {string}
   * @memberof EvaluateJsonRuleRequest
   */
  testStringJson?: string | null;
  /**
   *
   * @type {number}
   * @memberof EvaluateJsonRuleRequest
   */
  organisationId?: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ExternalSourceType = {
  ILRX: 1,
} as const;

export type ExternalSourceType =
  (typeof ExternalSourceType)[keyof typeof ExternalSourceType];

/**
 *
 * @export
 * @interface Fee
 */
export interface Fee {
  /**
   *
   * @type {string}
   * @memberof Fee
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Fee
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Fee
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Fee
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Fee
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Fee
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Fee
   */
  feeId?: number;
  /**
   *
   * @type {number}
   * @memberof Fee
   */
  organisationId: number;
  /**
   *
   * @type {string}
   * @memberof Fee
   */
  itemDescription: string;
  /**
   *
   * @type {FeeSection}
   * @memberof Fee
   */
  itemType: FeeSection;
  /**
   *
   * @type {number}
   * @memberof Fee
   */
  rate: number;
  /**
   *
   * @type {Organisation}
   * @memberof Fee
   */
  organisation?: Organisation;
  /**
   *
   * @type {Array<WorkOrderItem>}
   * @memberof Fee
   */
  workOrderItems?: Array<WorkOrderItem> | null;
}

/**
 *
 * @export
 * @interface FeeDto
 */
export interface FeeDto {
  /**
   *
   * @type {number}
   * @memberof FeeDto
   */
  feeId?: number;
  /**
   *
   * @type {number}
   * @memberof FeeDto
   */
  organisationId: number;
  /**
   *
   * @type {string}
   * @memberof FeeDto
   */
  itemDescription: string;
  /**
   *
   * @type {FeeSection}
   * @memberof FeeDto
   */
  itemType: FeeSection;
  /**
   *
   * @type {number}
   * @memberof FeeDto
   */
  rate: number;
}

/**
 *
 * @export
 * @enum {string}
 */

export const FeeSection = {
  MembershipType: 1,
  Animal: 2,
  FeeOverride: 3,
} as const;

export type FeeSection = (typeof FeeSection)[keyof typeof FeeSection];

/**
 *
 * @export
 * @interface FieldCondition
 */
export interface FieldCondition {
  /**
   *
   * @type {EntityDetailEnum}
   * @memberof FieldCondition
   */
  fieldEnum?: EntityDetailEnum;
  /**
   *
   * @type {LogicalComparisonOperator}
   * @memberof FieldCondition
   */
  operator?: LogicalComparisonOperator;
  /**
   *
   * @type {any}
   * @memberof FieldCondition
   */
  value?: any | null;
  /**
   *
   * @type {EntityDetailEnum}
   * @memberof FieldCondition
   */
  compareToFieldEnum?: EntityDetailEnum;
  /**
   *
   * @type {FieldDataType}
   * @memberof FieldCondition
   */
  dataType?: FieldDataType;
  /**
   *
   * @type {boolean}
   * @memberof FieldCondition
   */
  caseSensitive?: boolean;
  /**
   *
   * @type {string}
   * @memberof FieldCondition
   */
  description?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const FieldDataType = {
  String: 0,
  Integer: 1,
  Decimal: 2,
  Boolean: 3,
  DateTime: 4,
  Date: 5,
  Time: 6,
  Guid: 7,
  Enum: 8,
  Array: 9,
  Object: 10,
} as const;

export type FieldDataType = (typeof FieldDataType)[keyof typeof FieldDataType];

/**
 *
 * @export
 * @interface FieldMatch
 */
export interface FieldMatch {
  /**
   *
   * @type {string}
   * @memberof FieldMatch
   */
  expectedValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof FieldMatch
   */
  fieldName?: string | null;
}
/**
 *
 * @export
 * @interface FinaliseImportBatchRequest
 */
export interface FinaliseImportBatchRequest {
  /**
   *
   * @type {Array<number>}
   * @memberof FinaliseImportBatchRequest
   */
  importedEntityIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface Form
 */
export interface Form {
  /**
   *
   * @type {string}
   * @memberof Form
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Form
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Form
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Form
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Form
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Form
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Form
   */
  formId?: number;
  /**
   *
   * @type {string}
   * @memberof Form
   */
  value: string;
  /**
   *
   * @type {number}
   * @memberof Form
   */
  screenId?: number;
  /**
   *
   * @type {string}
   * @memberof Form
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof Form
   */
  formName?: string | null;
  /**
   *
   * @type {Screen}
   * @memberof Form
   */
  screen?: Screen;
  /**
   *
   * @type {Array<FormActionAssociation>}
   * @memberof Form
   */
  formActionAssociations?: Array<FormActionAssociation> | null;
}
/**
 *
 * @export
 * @interface FormActionAssociation
 */
export interface FormActionAssociation {
  /**
   *
   * @type {string}
   * @memberof FormActionAssociation
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof FormActionAssociation
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof FormActionAssociation
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof FormActionAssociation
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof FormActionAssociation
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof FormActionAssociation
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof FormActionAssociation
   */
  formId: number;
  /**
   *
   * @type {ActionType}
   * @memberof FormActionAssociation
   */
  actionType: ActionType;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof FormActionAssociation
   */
  entityTypeCode: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof FormActionAssociation
   */
  organisationId: number;
  /**
   *
   * @type {Form}
   * @memberof FormActionAssociation
   */
  form?: Form;
  /**
   *
   * @type {Organisation}
   * @memberof FormActionAssociation
   */
  organisation?: Organisation;
}

/**
 *
 * @export
 * @interface FormActionAssociationDto
 */
export interface FormActionAssociationDto {
  /**
   *
   * @type {number}
   * @memberof FormActionAssociationDto
   */
  formId?: number;
  /**
   *
   * @type {ActionType}
   * @memberof FormActionAssociationDto
   */
  actionType?: ActionType;
  /**
   *
   * @type {number}
   * @memberof FormActionAssociationDto
   */
  organisationId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof FormActionAssociationDto
   */
  entityTypeCode?: EntityTypeCode;
}

/**
 *
 * @export
 * @interface FormDto
 */
export interface FormDto {
  /**
   *
   * @type {number}
   * @memberof FormDto
   */
  formId?: number;
  /**
   *
   * @type {number}
   * @memberof FormDto
   */
  screenId?: number;
  /**
   *
   * @type {ActionType}
   * @memberof FormDto
   */
  actionType?: ActionType;
  /**
   *
   * @type {string}
   * @memberof FormDto
   */
  value?: string | null;
  /**
   *
   * @type {string}
   * @memberof FormDto
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof FormDto
   */
  screenName?: string | null;
  /**
   *
   * @type {string}
   * @memberof FormDto
   */
  formName?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof FormDto
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof FormDto
   */
  isEditable?: boolean;
}

/**
 *
 * @export
 * @enum {string}
 */

export const FormType = {
  Animal: 1,
  Member: 2,
  MembershipSetting: 3,
} as const;

export type FormType = (typeof FormType)[keyof typeof FormType];

/**
 *
 * @export
 * @interface GenerateAnimalRequest
 */
export interface GenerateAnimalRequest {
  /**
   *
   * @type {number}
   * @memberof GenerateAnimalRequest
   */
  organisationId?: number;
  /**
   *
   * @type {number}
   * @memberof GenerateAnimalRequest
   */
  number?: number;
  /**
   *
   * @type {number}
   * @memberof GenerateAnimalRequest
   */
  numberOld?: number;
}
/**
 *
 * @export
 * @interface GenerateCertificateRequest
 */
export interface GenerateCertificateRequest {
  /**
   *
   * @type {number}
   * @memberof GenerateCertificateRequest
   */
  entityId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof GenerateCertificateRequest
   */
  entityTypeCode?: EntityTypeCode;
}

/**
 *
 * @export
 * @interface GenerateEnterpriseRequest
 */
export interface GenerateEnterpriseRequest {
  /**
   *
   * @type {number}
   * @memberof GenerateEnterpriseRequest
   */
  organisationId?: number;
  /**
   *
   * @type {number}
   * @memberof GenerateEnterpriseRequest
   */
  number?: number;
}
/**
 *
 * @export
 * @interface GenerateRequest
 */
export interface GenerateRequest {
  /**
   *
   * @type {EntityTypeCode}
   * @memberof GenerateRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof GenerateRequest
   */
  organisationId?: number;
  /**
   *
   * @type {number}
   * @memberof GenerateRequest
   */
  number?: number;
  /**
   *
   * @type {number}
   * @memberof GenerateRequest
   */
  numberOld?: number | null;
}

/**
 *
 * @export
 * @interface GetAnimalProgenyRequest
 */
export interface GetAnimalProgenyRequest {
  /**
   *
   * @type {Pagination}
   * @memberof GetAnimalProgenyRequest
   */
  pagination?: Pagination;
  /**
   *
   * @type {string}
   * @memberof GetAnimalProgenyRequest
   */
  entityGuid?: string;
  /**
   *
   * @type {Array<EntityDetailFilterInput>}
   * @memberof GetAnimalProgenyRequest
   */
  filterInputs?: Array<EntityDetailFilterInput> | null;
  /**
   *
   * @type {EntityDetailSortInput}
   * @memberof GetAnimalProgenyRequest
   */
  sortInput?: EntityDetailSortInput;
  /**
   *
   * @type {RecordStatus}
   * @memberof GetAnimalProgenyRequest
   */
  recordStatus?: RecordStatus;
}

/**
 *
 * @export
 * @interface GetSettingsByOrganisationAndSettingTypesRequest
 */
export interface GetSettingsByOrganisationAndSettingTypesRequest {
  /**
   *
   * @type {number}
   * @memberof GetSettingsByOrganisationAndSettingTypesRequest
   */
  organisationId?: number;
  /**
   *
   * @type {Array<OrganisationSettingTypeCode>}
   * @memberof GetSettingsByOrganisationAndSettingTypesRequest
   */
  settingTypeCodes?: Array<OrganisationSettingTypeCode> | null;
}
/**
 *
 * @export
 * @interface IdentGenerationRule
 */
export interface IdentGenerationRule {
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof IdentGenerationRule
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof IdentGenerationRule
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof IdentGenerationRule
   */
  organisationId?: number;
  /**
   *
   * @type {Organisation}
   * @memberof IdentGenerationRule
   */
  organisation?: Organisation;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  format: string;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  requiredFieldsJson: string;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRule
   */
  gradeAbbreviationMapJson?: string | null;
}
/**
 *
 * @export
 * @interface IdentGenerationRuleDto
 */
export interface IdentGenerationRuleDto {
  /**
   *
   * @type {number}
   * @memberof IdentGenerationRuleDto
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof IdentGenerationRuleDto
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRuleDto
   */
  format?: string | null;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRuleDto
   */
  requiredFieldsJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof IdentGenerationRuleDto
   */
  gradeAbbreviationMapJson?: string | null;
}
/**
 *
 * @export
 * @interface ImportBatchDto
 */
export interface ImportBatchDto {
  /**
   *
   * @type {number}
   * @memberof ImportBatchDto
   */
  importBatchId?: number;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDto
   */
  importBatchGuid?: string;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDto
   */
  importDate?: string;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDto
   */
  documentGuid?: string;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDto
   */
  type?: string | null;
  /**
   *
   * @type {number}
   * @memberof ImportBatchDto
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof ImportBatchDto
   */
  numberOfRecords?: number;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDto
   */
  fileName?: string | null;
  /**
   *
   * @type {ImportBatchStatus}
   * @memberof ImportBatchDto
   */
  status?: ImportBatchStatus;
  /**
   *
   * @type {number}
   * @memberof ImportBatchDto
   */
  documentId?: number | null;
  /**
   *
   * @type {DocumentTypeCode}
   * @memberof ImportBatchDto
   */
  documentType?: DocumentTypeCode;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDto
   */
  documentTypeName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDto
   */
  enterpriseName?: string | null;
}

/**
 *
 * @export
 * @interface ImportBatchDtoPagedResult
 */
export interface ImportBatchDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof ImportBatchDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof ImportBatchDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof ImportBatchDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof ImportBatchDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<ImportBatchDto>}
   * @memberof ImportBatchDtoPagedResult
   */
  results?: Array<ImportBatchDto> | null;
}
/**
 *
 * @export
 * @interface ImportBatchDtoResult
 */
export interface ImportBatchDtoResult {
  /**
   *
   * @type {ReturnStatus}
   * @memberof ImportBatchDtoResult
   */
  status?: ReturnStatus;
  /**
   *
   * @type {string}
   * @memberof ImportBatchDtoResult
   */
  message?: string | null;
  /**
   *
   * @type {ImportBatchDto}
   * @memberof ImportBatchDtoResult
   */
  data?: ImportBatchDto;
  /**
   *
   * @type {Array<ErrorDetail>}
   * @memberof ImportBatchDtoResult
   */
  errorDetails?: Array<ErrorDetail> | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const ImportBatchStatus = {
  Pending: 0,
  Validated: 1,
  Complete: 2,
  Cancelled: 3,
} as const;

export type ImportBatchStatus =
  (typeof ImportBatchStatus)[keyof typeof ImportBatchStatus];

/**
 *
 * @export
 * @enum {string}
 */

export const InstructionType = {
  AutoCalc: 0,
  Message: 1,
  SetReadonly: 2,
  NoAction: 3,
} as const;

export type InstructionType =
  (typeof InstructionType)[keyof typeof InstructionType];

/**
 *
 * @export
 * @interface ItemCode
 */
export interface ItemCode {
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof ItemCode
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof ItemCode
   */
  itemCodeId?: number;
  /**
   *
   * @type {number}
   * @memberof ItemCode
   */
  orgId: number;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  itemCodeValue: string;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  externalId?: string | null;
  /**
   *
   * @type {number}
   * @memberof ItemCode
   */
  grossPrice: number;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  defaultDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof ItemCode
   */
  status?: string | null;
  /**
   *
   * @type {Array<BillingEventRule>}
   * @memberof ItemCode
   */
  billingEventRules?: Array<BillingEventRule> | null;
  /**
   *
   * @type {Array<BillableEvent>}
   * @memberof ItemCode
   */
  billableEvents?: Array<BillableEvent> | null;
}
/**
 *
 * @export
 * @interface ItemCodeDto
 */
export interface ItemCodeDto {
  /**
   *
   * @type {number}
   * @memberof ItemCodeDto
   */
  itemCodeId?: number;
  /**
   *
   * @type {number}
   * @memberof ItemCodeDto
   */
  orgId?: number;
  /**
   *
   * @type {string}
   * @memberof ItemCodeDto
   */
  itemCodeValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof ItemCodeDto
   */
  externalId?: string | null;
  /**
   *
   * @type {number}
   * @memberof ItemCodeDto
   */
  grossPrice?: number;
  /**
   *
   * @type {string}
   * @memberof ItemCodeDto
   */
  defaultDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof ItemCodeDto
   */
  status?: string | null;
}
/**
 *
 * @export
 * @interface LinkOptionData
 */
export interface LinkOptionData {
  /**
   *
   * @type {string}
   * @memberof LinkOptionData
   */
  value?: string | null;
  /**
   *
   * @type {number}
   * @memberof LinkOptionData
   */
  linkedEntityDetailId?: number;
  /**
   *
   * @type {number}
   * @memberof LinkOptionData
   */
  linkedEntityId?: number | null;
}
/**
 *
 * @export
 * @interface LinkOptionsByEntityDetailsRequest
 */
export interface LinkOptionsByEntityDetailsRequest {
  /**
   *
   * @type {number}
   * @memberof LinkOptionsByEntityDetailsRequest
   */
  optionsEntityDetailId?: number;
  /**
   *
   * @type {number}
   * @memberof LinkOptionsByEntityDetailsRequest
   */
  linkedEntityDetailId?: number;
}
/**
 *
 * @export
 * @interface LinkOptionsByEntityDetailsResponse
 */
export interface LinkOptionsByEntityDetailsResponse {
  /**
   *
   * @type {Array<LinkOptionData>}
   * @memberof LinkOptionsByEntityDetailsResponse
   */
  linkOptions?: Array<LinkOptionData> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const LogicalComparisonOperator = {
  Equals: 0,
  NotEquals: 1,
  GreaterThan: 2,
  GreaterThanOrEqual: 3,
  LessThan: 4,
  LessThanOrEqual: 5,
  Contains: 6,
  NotContains: 7,
  StartsWith: 8,
  EndsWith: 9,
  IsNull: 10,
  IsNotNull: 11,
  IsEmpty: 12,
  IsNotEmpty: 13,
  In: 14,
  NotIn: 15,
  Between: 16,
  NotBetween: 17,
  Regex: 18,
  Length: 19,
  DateDifference: 20,
} as const;

export type LogicalComparisonOperator =
  (typeof LogicalComparisonOperator)[keyof typeof LogicalComparisonOperator];

/**
 *
 * @export
 * @enum {string}
 */

export const LogicalOperator = {
  And: 0,
  Or: 1,
} as const;

export type LogicalOperator =
  (typeof LogicalOperator)[keyof typeof LogicalOperator];

/**
 *
 * @export
 * @interface Membership
 */
export interface Membership {
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Membership
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Membership
   */
  membershipId?: number;
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  membershipEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof Membership
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {number}
   * @memberof Membership
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof Membership
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof Membership
   */
  isAutoRenewal?: boolean;
  /**
   *
   * @type {MembershipStatusCode}
   * @memberof Membership
   */
  membershipStatus?: MembershipStatusCode;
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof Membership
   */
  expiryDate?: string | null;
  /**
   *
   * @type {RecordStatus}
   * @memberof Membership
   */
  recordStatus?: RecordStatus;
  /**
   *
   * @type {Enterprise}
   * @memberof Membership
   */
  enterprise?: Enterprise;
  /**
   *
   * @type {MembershipType}
   * @memberof Membership
   */
  membershipType?: MembershipType;
  /**
   *
   * @type {MembershipTypeDuration}
   * @memberof Membership
   */
  membershipTypeDuration?: MembershipTypeDuration;
}

/**
 *
 * @export
 * @interface MembershipBenefitDto
 */
export interface MembershipBenefitDto {
  /**
   *
   * @type {number}
   * @memberof MembershipBenefitDto
   */
  membershipBenefitId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipBenefitDto
   */
  membershipBenefitEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipBenefitDto
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipBenefitDto
   */
  benefitName?: string | null;
  /**
   *
   * @type {number}
   * @memberof MembershipBenefitDto
   */
  order?: number;
  /**
   *
   * @type {Array<MembershipTypeBenefitAsscDto>}
   * @memberof MembershipBenefitDto
   */
  membershipTypeBenefitAsscs?: Array<MembershipTypeBenefitAsscDto> | null;
}
/**
 *
 * @export
 * @interface MembershipBenefitUpsert
 */
export interface MembershipBenefitUpsert {
  /**
   *
   * @type {number}
   * @memberof MembershipBenefitUpsert
   */
  membershipBenefitId?: number | null;
  /**
   *
   * @type {string}
   * @memberof MembershipBenefitUpsert
   */
  benefitName?: string | null;
  /**
   *
   * @type {number}
   * @memberof MembershipBenefitUpsert
   */
  order?: number;
}
/**
 *
 * @export
 * @interface MembershipDto
 */
export interface MembershipDto {
  /**
   *
   * @type {number}
   * @memberof MembershipDto
   */
  membershipId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipDto
   */
  membershipEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipDto
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {number}
   * @memberof MembershipDto
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipDto
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipDto
   */
  isAutoRenewal?: boolean;
  /**
   *
   * @type {MembershipStatusCode}
   * @memberof MembershipDto
   */
  membershipStatus?: MembershipStatusCode;
  /**
   *
   * @type {string}
   * @memberof MembershipDto
   */
  effectiveDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof MembershipDto
   */
  expiryDate?: string | null;
  /**
   *
   * @type {MembershipTypeDto}
   * @memberof MembershipDto
   */
  membershipType?: MembershipTypeDto;
}

/**
 *
 * @export
 * @interface MembershipReturnDto
 */
export interface MembershipReturnDto {
  /**
   *
   * @type {number}
   * @memberof MembershipReturnDto
   */
  membershipId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipReturnDto
   */
  membershipEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipReturnDto
   */
  memberId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipReturnDto
   */
  membershipTypeId?: number;
  /**
   *
   * @type {boolean}
   * @memberof MembershipReturnDto
   */
  isAutoRenewal?: boolean;
  /**
   *
   * @type {MembershipStatusCode}
   * @memberof MembershipReturnDto
   */
  membershipStatus?: MembershipStatusCode;
  /**
   *
   * @type {string}
   * @memberof MembershipReturnDto
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipReturnDto
   */
  expiryDate?: string | null;
  /**
   *
   * @type {MembershipTypeDto}
   * @memberof MembershipReturnDto
   */
  membershipType?: MembershipTypeDto;
  /**
   *
   * @type {MembershipTypeDurationDto}
   * @memberof MembershipReturnDto
   */
  membershipTypeDuration?: MembershipTypeDurationDto;
}

/**
 *
 * @export
 * @enum {string}
 */

export const MembershipStatusCode = {
  Pending: 1,
  Approved: 2,
  Active: 3,
  Inactive: 4,
  Suspended: 5,
  Cancelled: 6,
} as const;

export type MembershipStatusCode =
  (typeof MembershipStatusCode)[keyof typeof MembershipStatusCode];

/**
 *
 * @export
 * @interface MembershipType
 */
export interface MembershipType {
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof MembershipType
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof MembershipType
   */
  membershipTypeId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  membershipTypeEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipType
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof MembershipType
   */
  active?: boolean;
  /**
   *
   * @type {MembershipTypeRecordStatus}
   * @memberof MembershipType
   */
  recordStatus?: MembershipTypeRecordStatus;
  /**
   *
   * @type {number}
   * @memberof MembershipType
   */
  minimumAge?: number | null;
  /**
   *
   * @type {number}
   * @memberof MembershipType
   */
  maximumAge?: number | null;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipType
   */
  expiryDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof MembershipType
   */
  order: number;
  /**
   *
   * @type {Organisation}
   * @memberof MembershipType
   */
  organisation?: Organisation;
  /**
   *
   * @type {Array<Membership>}
   * @memberof MembershipType
   */
  memberships?: Array<Membership> | null;
  /**
   *
   * @type {Array<MembershipTypeDuration>}
   * @memberof MembershipType
   */
  membershipTypeDurations?: Array<MembershipTypeDuration> | null;
}

/**
 *
 * @export
 * @interface MembershipTypeBenefitAsscDto
 */
export interface MembershipTypeBenefitAsscDto {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeBenefitAsscDto
   */
  membershipTypeBenefitAsscId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeBenefitAsscDto
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeBenefitAsscDto
   */
  membershipBenefitId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeBenefitAsscDto
   */
  membershipBenefitValue?: string | null;
}
/**
 *
 * @export
 * @interface MembershipTypeDto
 */
export interface MembershipTypeDto {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDto
   */
  membershipTypeId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDto
   */
  membershipTypeEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDto
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDto
   */
  description?: string | null;
  /**
   *
   * @type {MembershipTypeRecordStatus}
   * @memberof MembershipTypeDto
   */
  recordStatus?: MembershipTypeRecordStatus;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDto
   */
  minimumAge?: number | null;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDto
   */
  maximumAge?: number | null;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDto
   */
  order?: number;
  /**
   *
   * @type {Array<MembershipTypeDurationDto>}
   * @memberof MembershipTypeDto
   */
  membershipTypeDurations?: Array<MembershipTypeDurationDto> | null;
}

/**
 *
 * @export
 * @interface MembershipTypeDuration
 */
export interface MembershipTypeDuration {
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeDuration
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDuration
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  membershipTypeDurationEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDuration
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDuration
   */
  duration?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDuration
   */
  feeId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDuration
   */
  expiryDate?: string | null;
  /**
   *
   * @type {MembershipType}
   * @memberof MembershipTypeDuration
   */
  membershipType?: MembershipType;
  /**
   *
   * @type {Fee}
   * @memberof MembershipTypeDuration
   */
  fee?: Fee;
}
/**
 *
 * @export
 * @interface MembershipTypeDurationDto
 */
export interface MembershipTypeDurationDto {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationDto
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDurationDto
   */
  membershipTypeDurationEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationDto
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationDto
   */
  duration?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationDto
   */
  feeId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDurationDto
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDurationDto
   */
  expiryDate?: string | null;
  /**
   *
   * @type {FeeDto}
   * @memberof MembershipTypeDurationDto
   */
  fee?: FeeDto;
}
/**
 *
 * @export
 * @interface MembershipTypeDurationUpsert
 */
export interface MembershipTypeDurationUpsert {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationUpsert
   */
  membershipTypeDurationId?: number | null;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationUpsert
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationUpsert
   */
  duration?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeDurationUpsert
   */
  feeId?: number;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDurationUpsert
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeDurationUpsert
   */
  expiryDate?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const MembershipTypeRecordStatus = {
  Active: 1,
  Inactive: 2,
} as const;

export type MembershipTypeRecordStatus =
  (typeof MembershipTypeRecordStatus)[keyof typeof MembershipTypeRecordStatus];

/**
 *
 * @export
 * @interface MembershipTypeUpsert
 */
export interface MembershipTypeUpsert {
  /**
   *
   * @type {number}
   * @memberof MembershipTypeUpsert
   */
  membershipTypeId?: number | null;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeUpsert
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof MembershipTypeUpsert
   */
  description?: string | null;
  /**
   *
   * @type {MembershipTypeRecordStatus}
   * @memberof MembershipTypeUpsert
   */
  recordStatus?: MembershipTypeRecordStatus;
  /**
   *
   * @type {boolean}
   * @memberof MembershipTypeUpsert
   */
  isDeleted?: boolean;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeUpsert
   */
  minimumAge?: number | null;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeUpsert
   */
  maximumAge?: number | null;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeUpsert
   */
  order?: number;
  /**
   *
   * @type {number}
   * @memberof MembershipTypeUpsert
   */
  annualPrice?: number;
}

/**
 *
 * @export
 * @interface MergeEntityDetailCategoryAssociationRequest
 */
export interface MergeEntityDetailCategoryAssociationRequest {
  /**
   *
   * @type {number}
   * @memberof MergeEntityDetailCategoryAssociationRequest
   */
  detailId?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof MergeEntityDetailCategoryAssociationRequest
   */
  entityDetailCategoryIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface MergeMembershipTypeBenefitsAsscsRequest
 */
export interface MergeMembershipTypeBenefitsAsscsRequest {
  /**
   *
   * @type {number}
   * @memberof MergeMembershipTypeBenefitsAsscsRequest
   */
  membershipTypeBenefitAsscId?: number | null;
  /**
   *
   * @type {number}
   * @memberof MergeMembershipTypeBenefitsAsscsRequest
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof MergeMembershipTypeBenefitsAsscsRequest
   */
  membershipBenefitId?: number;
  /**
   *
   * @type {string}
   * @memberof MergeMembershipTypeBenefitsAsscsRequest
   */
  membershipBenefitValue?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const MessageLevel = {
  Info: 0,
  Warning: 1,
  Error: 2,
  Success: 3,
} as const;

export type MessageLevel = (typeof MessageLevel)[keyof typeof MessageLevel];

/**
 *
 * @export
 * @interface NoteDto
 */
export interface NoteDto {
  /**
   *
   * @type {number}
   * @memberof NoteDto
   */
  noteId?: number;
  /**
   *
   * @type {string}
   * @memberof NoteDto
   */
  noteEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof NoteDto
   */
  entityGuid?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof NoteDto
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof NoteDto
   */
  isImportant?: boolean;
  /**
   *
   * @type {string}
   * @memberof NoteDto
   */
  category?: string | null;
  /**
   *
   * @type {string}
   * @memberof NoteDto
   */
  subject?: string | null;
  /**
   *
   * @type {string}
   * @memberof NoteDto
   */
  body?: string | null;
  /**
   *
   * @type {number}
   * @memberof NoteDto
   */
  entityId?: number;
  /**
   *
   * @type {number}
   * @memberof NoteDto
   */
  enterpriseId?: number;
  /**
   *
   * @type {string}
   * @memberof NoteDto
   */
  createdBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof NoteDto
   */
  createdDate?: string | null;
  /**
   *
   * @type {Array<DocumentDto>}
   * @memberof NoteDto
   */
  attachments?: Array<DocumentDto> | null;
}

/**
 *
 * @export
 * @interface NoteDtoPagedResult
 */
export interface NoteDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof NoteDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof NoteDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof NoteDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof NoteDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<NoteDto>}
   * @memberof NoteDtoPagedResult
   */
  results?: Array<NoteDto> | null;
}
/**
 *
 * @export
 * @interface NoteFilter
 */
export interface NoteFilter {
  /**
   *
   * @type {string}
   * @memberof NoteFilter
   */
  subject?: string | null;
  /**
   *
   * @type {string}
   * @memberof NoteFilter
   */
  body?: string | null;
}
/**
 *
 * @export
 * @interface NoteSearchSortRequest
 */
export interface NoteSearchSortRequest {
  /**
   *
   * @type {Pagination}
   * @memberof NoteSearchSortRequest
   */
  pagination?: Pagination;
  /**
   *
   * @type {string}
   * @memberof NoteSearchSortRequest
   */
  entityId?: string;
  /**
   *
   * @type {SortByRequest}
   * @memberof NoteSearchSortRequest
   */
  sortBySettings?: SortByRequest;
  /**
   *
   * @type {NoteFilter}
   * @memberof NoteSearchSortRequest
   */
  filter?: NoteFilter;
  /**
   *
   * @type {number}
   * @memberof NoteSearchSortRequest
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof NoteSearchSortRequest
   */
  entityType?: EntityTypeCode;
}

/**
 *
 * @export
 * @interface Organisation
 */
export interface Organisation {
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Organisation
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Organisation
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  organisationEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  country?: string | null;
  /**
   *
   * @type {string}
   * @memberof Organisation
   */
  constitutionUrl?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof Organisation
   */
  isFreeMembership?: boolean;
  /**
   *
   * @type {Array<OrganisationServiceOption>}
   * @memberof Organisation
   */
  organisationServiceOptions?: Array<OrganisationServiceOption> | null;
  /**
   *
   * @type {IdentGenerationRule}
   * @memberof Organisation
   */
  identGenerationRule?: IdentGenerationRule;
  /**
   *
   * @type {Array<MembershipType>}
   * @memberof Organisation
   */
  membershipTypes?: Array<MembershipType> | null;
  /**
   *
   * @type {Array<OrganisationSetting>}
   * @memberof Organisation
   */
  organisationSettings?: Array<OrganisationSetting> | null;
  /**
   *
   * @type {Array<EntityOrganisationAssociation>}
   * @memberof Organisation
   */
  animalOrganisationAssociations?: Array<EntityOrganisationAssociation> | null;
  /**
   *
   * @type {Array<Screen>}
   * @memberof Organisation
   */
  screens?: Array<Screen> | null;
  /**
   *
   * @type {Array<BillingEventRule>}
   * @memberof Organisation
   */
  billingEventRules?: Array<BillingEventRule> | null;
  /**
   *
   * @type {Array<FormActionAssociation>}
   * @memberof Organisation
   */
  formActionAssociations?: Array<FormActionAssociation> | null;
}
/**
 *
 * @export
 * @interface OrganisationDto
 */
export interface OrganisationDto {
  /**
   *
   * @type {number}
   * @memberof OrganisationDto
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof OrganisationDto
   */
  organisationEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof OrganisationDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrganisationDto
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrganisationDto
   */
  currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrganisationDto
   */
  country?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof OrganisationDto
   */
  isFreeMembership?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrganisationDto
   */
  constitutionUrl?: string | null;
  /**
   *
   * @type {Array<MembershipTypeDto>}
   * @memberof OrganisationDto
   */
  membershipTypes?: Array<MembershipTypeDto> | null;
  /**
   *
   * @type {Array<OrganisationSettingDto>}
   * @memberof OrganisationDto
   */
  organisationSettings?: Array<OrganisationSettingDto> | null;
  /**
   *
   * @type {Array<OrganisationServiceOption>}
   * @memberof OrganisationDto
   */
  organisationServiceOptions?: Array<OrganisationServiceOption> | null;
}
/**
 *
 * @export
 * @interface OrganisationGroupedWorkOrders
 */
export interface OrganisationGroupedWorkOrders {
  /**
   *
   * @type {number}
   * @memberof OrganisationGroupedWorkOrders
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof OrganisationGroupedWorkOrders
   */
  organisationName?: string | null;
  /**
   *
   * @type {Array<WorkOrderDto>}
   * @memberof OrganisationGroupedWorkOrders
   */
  workOrders?: Array<WorkOrderDto> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const OrganisationServiceOption = {
  Dairy: 0,
  Beef: 1,
  Sheep: 2,
  Goat: 3,
  Pig: 4,
  Poultry: 5,
  Other: 6,
} as const;

export type OrganisationServiceOption =
  (typeof OrganisationServiceOption)[keyof typeof OrganisationServiceOption];

/**
 *
 * @export
 * @interface OrganisationSetting
 */
export interface OrganisationSetting {
  /**
   *
   * @type {string}
   * @memberof OrganisationSetting
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof OrganisationSetting
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof OrganisationSetting
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof OrganisationSetting
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof OrganisationSetting
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrganisationSetting
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrganisationSetting
   */
  organisationSettingId?: number;
  /**
   *
   * @type {number}
   * @memberof OrganisationSetting
   */
  organisationId?: number;
  /**
   *
   * @type {OrganisationSettingTypeCode}
   * @memberof OrganisationSetting
   */
  settingTypeCode: OrganisationSettingTypeCode;
  /**
   *
   * @type {OrganisationSettingDataType}
   * @memberof OrganisationSetting
   */
  dataType: OrganisationSettingDataType;
  /**
   *
   * @type {string}
   * @memberof OrganisationSetting
   */
  value: string;
  /**
   *
   * @type {number}
   * @memberof OrganisationSetting
   */
  order: number;
  /**
   *
   * @type {number}
   * @memberof OrganisationSetting
   */
  characterLimit?: number | null;
  /**
   *
   * @type {string}
   * @memberof OrganisationSetting
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof OrganisationSetting
   */
  requiredByDefault: boolean;
  /**
   *
   * @type {Organisation}
   * @memberof OrganisationSetting
   */
  organisation?: Organisation;
}

/**
 *
 * @export
 * @enum {string}
 */

export const OrganisationSettingDataType = {
  Int: 0,
  Decimal: 1,
  Bool: 2,
  DateTime: 3,
  String: 4,
} as const;

export type OrganisationSettingDataType =
  (typeof OrganisationSettingDataType)[keyof typeof OrganisationSettingDataType];

/**
 *
 * @export
 * @interface OrganisationSettingDto
 */
export interface OrganisationSettingDto {
  /**
   *
   * @type {number}
   * @memberof OrganisationSettingDto
   */
  organisationSettingId?: number;
  /**
   *
   * @type {number}
   * @memberof OrganisationSettingDto
   */
  organisationId?: number;
  /**
   *
   * @type {OrganisationSettingTypeCode}
   * @memberof OrganisationSettingDto
   */
  settingTypeCode?: OrganisationSettingTypeCode;
  /**
   *
   * @type {string}
   * @memberof OrganisationSettingDto
   */
  settingTypeName?: string | null;
  /**
   *
   * @type {OrganisationSettingDataType}
   * @memberof OrganisationSettingDto
   */
  dataType?: OrganisationSettingDataType;
  /**
   *
   * @type {string}
   * @memberof OrganisationSettingDto
   */
  value?: string | null;
  /**
   *
   * @type {number}
   * @memberof OrganisationSettingDto
   */
  order?: number;
  /**
   *
   * @type {number}
   * @memberof OrganisationSettingDto
   */
  characterLimit?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof OrganisationSettingDto
   */
  requiredByDefault?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrganisationSettingDto
   */
  description?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const OrganisationSettingTypeCode = {
  HerdIdent: 1,
  StudName: 2,
  HerdPrefix: 3,
  MailToAddress: 4,
  FacebookPageLink: 5,
  EnterpriseIdentPrefix: 6,
  EnterpriseIdentSeed: 7,
  EnterpriseIdentAuto: 8,
  MembershipDateSeedDay: 9,
  MembershipDateSeedMonth: 10,
  RenewalPeriod: 11,
  GracePeriod: 12,
  EnterpriseIdentAutoCalcType: 13,
  AnimalForm: 14,
  MemberForm: 15,
  MembershipSettingForm: 16,
  AnimalFormField: 17,
  MemberFormField: 18,
  MembershipSettingFormField: 19,
  AnimalSpecieIds: 20,
  CalvingYearStartMonth: 21,
  CalvingYearEndMonth: 22,
  YearLetterMappings: 23,
  MaxDropNo: 24,
  DamMinAgeAtBirth: 25,
  GestationLength: 26,
  NumberInBirth: 27,
  BirthWeightDecimalPlaces: 28,
  MinBirthWeight: 29,
  MaxBirthWeight: 30,
  SequenceNumber: 31,
  StudbookEnabled: 32,
  DateDisplayFormat: 33,
  BillableEventIdentPrefix: 34,
  MaximumImageOfAnimals: 35,
  EntityIdentSeed: 36,
  MainAnimalSpecieId: 37,
  InvalidRecipDamStatuses: 38,
  InvalidDamStatuses: 39,
  InvalidSireStatuses: 40,
  InvalidFosterDamStatuses: 41,
  InvalidRecipDamRegoStatuses: 42,
  InvalidDamRegoStatuses: 43,
  InvalidSireRegoStatuses: 44,
  InvalidFosterDamRegoStatuses: 45,
  InvalidNumInBirthDamAnimalTypeIgnore: 46,
  BirthWeightFormat: 47,
  MinBirthWeightWarn: 48,
  MaxBirthWeightWarn: 49,
  MaxNameLength: 50,
  MultipleBirthGracePeriod: 51,
  InvalidNameCharacters: 52,
  ParentAnimalTypesExcludedFromStatusChecks: 53,
  YearsTattooReusable: 54,
  InvalidStatusesForRegistration: 55,
  RecipMinAgeBirth: 56,
  RecipMinAgeImplant: 57,
  LateRegoAge: 58,
  InvalidGradesForCommercialAnimal: 59,
  InvalidGradesWhenRegisteredWithCommercialParent: 60,
  CalvingYearAdj: 61,
  InvalidMembershipTypes: 62,
  InvalidMembershipStatuses: 63,
  RegoStatusesConsideredRegistered: 67,
  RegoStatusesConsideredUnRegistered: 68,
  RegoStatusesConsideredCommercial: 69,
  AgeConsideredInactive: 70,
  InvalidDNACaseIdCharacters: 71,
  RidiculouslyOldDate: 72,
  YearLetterBase: 73,
  GestationLengthErrorRange: 74,
  SireMinAgeConception: 75,
  SireMinAgeConceptionAi: 76,
  DamMinAgeConception: 77,
  GestationLengthErrorRangeEt: 78,
  MatingClashRange: 79,
} as const;

export type OrganisationSettingTypeCode =
  (typeof OrganisationSettingTypeCode)[keyof typeof OrganisationSettingTypeCode];

/**
 *
 * @export
 * @interface OrganisationSettingsFormDto
 */
export interface OrganisationSettingsFormDto {
  /**
   *
   * @type {number}
   * @memberof OrganisationSettingsFormDto
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof OrganisationSettingsFormDto
   */
  value: string | null;
  /**
   *
   * @type {FormType}
   * @memberof OrganisationSettingsFormDto
   */
  type?: FormType;
}

/**
 *
 * @export
 * @interface OrgsOptInSetting
 */
export interface OrgsOptInSetting {
  /**
   *
   * @type {number}
   * @memberof OrgsOptInSetting
   */
  orgId?: number;
  /**
   *
   * @type {string}
   * @memberof OrgsOptInSetting
   */
  value?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrgsOptInSetting
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof OrgsOptInSetting
   */
  description?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const OutputFormatStyle = {
  None: 0,
  LowerCase: 1,
  SentenceCase: 2,
  TitleCase: 3,
  UpperCase: 4,
} as const;

export type OutputFormatStyle =
  (typeof OutputFormatStyle)[keyof typeof OutputFormatStyle];

/**
 *
 * @export
 * @interface PagedEntityDetailsRequest
 */
export interface PagedEntityDetailsRequest {
  /**
   *
   * @type {number}
   * @memberof PagedEntityDetailsRequest
   */
  organisationId?: number;
  /**
   *
   * @type {number}
   * @memberof PagedEntityDetailsRequest
   */
  currentPage?: number;
  /**
   *
   * @type {number}
   * @memberof PagedEntityDetailsRequest
   */
  pageSize?: number;
}
/**
 *
 * @export
 * @interface PagedWorkOrderRequest
 */
export interface PagedWorkOrderRequest {
  /**
   *
   * @type {Pagination}
   * @memberof PagedWorkOrderRequest
   */
  pagination?: Pagination;
  /**
   *
   * @type {number}
   * @memberof PagedWorkOrderRequest
   */
  enterpriseId?: number;
}
/**
 *
 * @export
 * @interface Pagination
 */
export interface Pagination {
  /**
   *
   * @type {number}
   * @memberof Pagination
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof Pagination
   */
  pageSize: number;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ParentEntityType = {
  Animal: 1,
  Enterprise: 2,
  Member: 3,
} as const;

export type ParentEntityType =
  (typeof ParentEntityType)[keyof typeof ParentEntityType];

/**
 *
 * @export
 * @enum {string}
 */

export const PaymentStatus = {
  Draft: 1,
  Submitted: 2,
  Paid: 3,
  Expired: 4,
  Cancelled: 5,
  Failed: 6,
} as const;

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

/**
 *
 * @export
 * @interface PedigreeNodeDto
 */
export interface PedigreeNodeDto {
  /**
   *
   * @type {string}
   * @memberof PedigreeNodeDto
   */
  entityGuid?: string;
  /**
   *
   * @type {string}
   * @memberof PedigreeNodeDto
   */
  animalName?: string | null;
  /**
   *
   * @type {string}
   * @memberof PedigreeNodeDto
   */
  ownerName?: string | null;
  /**
   *
   * @type {string}
   * @memberof PedigreeNodeDto
   */
  ownerIdent?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof PedigreeNodeDto
   */
  ownerIsStudbookOptedOut?: boolean;
  /**
   *
   * @type {string}
   * @memberof PedigreeNodeDto
   */
  ownerHerdIdent?: string | null;
  /**
   *
   * @type {string}
   * @memberof PedigreeNodeDto
   */
  ownerHerdPrefix?: string | null;
  /**
   *
   * @type {string}
   * @memberof PedigreeNodeDto
   */
  ownerStudName?: string | null;
  /**
   *
   * @type {PedigreeNodeDto}
   * @memberof PedigreeNodeDto
   */
  sire?: PedigreeNodeDto;
  /**
   *
   * @type {PedigreeNodeDto}
   * @memberof PedigreeNodeDto
   */
  dam?: PedigreeNodeDto;
  /**
   *
   * @type {DocumentDto}
   * @memberof PedigreeNodeDto
   */
  profilePicture?: DocumentDto;
  /**
   *
   * @type {Array<EntityDetailValueDto>}
   * @memberof PedigreeNodeDto
   */
  tags?: Array<EntityDetailValueDto> | null;
  /**
   *
   * @type {Array<EntityDetailEnhancerDto>}
   * @memberof PedigreeNodeDto
   */
  entityDetailEnhancers?: Array<EntityDetailEnhancerDto> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const Permissions = {
  EntityView: 11001,
  EntityModify: 11002,
  AddressView: 12001,
  AddressModify: 12002,
  AnimalSpeciesBreedView: 13001,
  AnimalSpeciesBreedModify: 13002,
  AnimalSpeciesView: 14001,
  AnimalSpeciesModify: 14002,
  EntityDetailCategoryAssociationModify: 15002,
  EntityDetailCategoryView: 16001,
  EntityDetailCategoryModify: 16002,
  EntityDetailConfigView: 17001,
  EntityDetailConfigModify: 17002,
  EntityDetailView: 18001,
  EntityDetailModify: 18002,
  EntityDetailValueView: 19001,
  EntityDetailValueModify: 19002,
  AuthorisedRepresentativeView: 20001,
  AuthorisedRepresentativeModify: 20002,
  CustomFieldView: 21001,
  CustomFieldModify: 21002,
  CustomFormView: 22001,
  CustomFormModify: 22002,
  DocumentView: 23001,
  DocumentModify: 23002,
  EnterpriseView: 24001,
  EnterpriseModify: 24002,
  EnterpriseActionView: 25001,
  EnterpriseActionModify: 25002,
  EnterprisePrefixView: 26001,
  EnterprisePrefixModify: 26002,
  FeeView: 27001,
  FeeModify: 27002,
  InvitationView: 28001,
  InvitationModify: 28002,
  MembershipView: 29001,
  MembershipModify: 29002,
  MembershipApprove: 29003,
  MembershipBenefitView: 30001,
  MembershipBenefitModify: 30002,
  MembershipBenefitAssociationView: 31001,
  MembershipBenefitAssociationModify: 31002,
  MembershipTypeView: 32001,
  MembershipTypeModify: 32002,
  MembershipTypeDurationView: 33001,
  MembershipTypeDurationModify: 33002,
  OrganisationView: 34001,
  OrganisationModify: 34002,
  OrganisationSettingsView: 35001,
  OrganisationSettingsModify: 35002,
  RegistrationView: 36001,
  RegistrationModify: 36002,
  RoleView: 37001,
  RoleModify: 37002,
  RoleUserOrgAssociationView: 38001,
  RoleUserOrgAssociationModify: 38002,
  TimelineView: 39001,
  TimelineModify: 39002,
  UserView: 40001,
  UserModify: 40002,
  WorkOrderView: 41001,
  WorkOrderModify: 41002,
  EntityEnterpriseAssociationView: 42001,
  EntityEnterpriseAssociationModify: 42002,
  EntityDetailEnhancerView: 43001,
  EntityDetailEnhancerModify: 43002,
} as const;

export type Permissions = (typeof Permissions)[keyof typeof Permissions];

/**
 *
 * @export
 * @enum {string}
 */

export const PrefixType = {
  HerdIdent: 1,
  StudName: 2,
  HerdPrefix: 3,
  StudLetters: 4,
} as const;

export type PrefixType = (typeof PrefixType)[keyof typeof PrefixType];

/**
 *
 * @export
 * @interface PreviewValueEntityDetailEnhancerRequest
 */
export interface PreviewValueEntityDetailEnhancerRequest {
  /**
   *
   * @type {string}
   * @memberof PreviewValueEntityDetailEnhancerRequest
   */
  configurationString?: string | null;
  /**
   *
   * @type {number}
   * @memberof PreviewValueEntityDetailEnhancerRequest
   */
  entityDetailEnhancerId?: number | null;
  /**
   *
   * @type {number}
   * @memberof PreviewValueEntityDetailEnhancerRequest
   */
  entityId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof PreviewValueEntityDetailEnhancerRequest
   */
  entityTypeCode?: EntityTypeCode;
}

/**
 *
 * @export
 * @interface ProcessInvitationRequest
 */
export interface ProcessInvitationRequest {
  /**
   *
   * @type {string}
   * @memberof ProcessInvitationRequest
   */
  invitationGuid?: string;
  /**
   *
   * @type {string}
   * @memberof ProcessInvitationRequest
   */
  userEmail?: string | null;
  /**
   *
   * @type {number}
   * @memberof ProcessInvitationRequest
   */
  userId?: number;
}
/**
 *
 * @export
 * @interface QuickSearchRequest
 */
export interface QuickSearchRequest {
  /**
   *
   * @type {Pagination}
   * @memberof QuickSearchRequest
   */
  pagination?: Pagination;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof QuickSearchRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof QuickSearchRequest
   */
  keywords: string | null;
  /**
   *
   * @type {EntityDetailSortInput}
   * @memberof QuickSearchRequest
   */
  sortInput?: EntityDetailSortInput;
}

/**
 *
 * @export
 * @interface ReactiveEntityValidationRule
 */
export interface ReactiveEntityValidationRule {
  /**
   *
   * @type {boolean}
   * @memberof ReactiveEntityValidationRule
   */
  required?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReactiveEntityValidationRule
   */
  min?: number | null;
  /**
   *
   * @type {number}
   * @memberof ReactiveEntityValidationRule
   */
  max?: number | null;
  /**
   *
   * @type {string}
   * @memberof ReactiveEntityValidationRule
   */
  regex?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReactiveEntityValidationRule
   */
  minDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ReactiveEntityValidationRule
   */
  maxDate?: string | null;
}
/**
 *
 * @export
 * @interface ReadCustomFormFieldsJsonRequest
 */
export interface ReadCustomFormFieldsJsonRequest {
  /**
   *
   * @type {string}
   * @memberof ReadCustomFormFieldsJsonRequest
   */
  entityId?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof ReadCustomFormFieldsJsonRequest
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof ReadCustomFormFieldsJsonRequest
   */
  organisationId?: number;
  /**
   *
   * @type {EditableFormType}
   * @memberof ReadCustomFormFieldsJsonRequest
   */
  editableFormType?: EditableFormType;
}

/**
 *
 * @export
 * @enum {string}
 */

export const RecordStatus = {
  Initial: 0,
  Incomplete: 1,
  Unverified: 2,
  Verified: 3,
} as const;

export type RecordStatus = (typeof RecordStatus)[keyof typeof RecordStatus];

/**
 *
 * @export
 * @enum {string}
 */

export const ReturnStatus = {
  OK: 0,
  MultipleRecordsUpdated: 1,
  Error: 2,
  NotFound: 3,
  BadRequest: 4,
  Unauthorized: 5,
  Forbidden: 6,
  MethodNotAllowed: 7,
  Conflict: 8,
} as const;

export type ReturnStatus = (typeof ReturnStatus)[keyof typeof ReturnStatus];

/**
 *
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
  /**
   *
   * @type {number}
   * @memberof RoleDto
   */
  roleId?: number;
  /**
   *
   * @type {string}
   * @memberof RoleDto
   */
  roleEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof RoleDto
   */
  roleName?: string | null;
  /**
   *
   * @type {string}
   * @memberof RoleDto
   */
  roleDescription?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RoleDto
   */
  isSystemRole?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RoleDto
   */
  isDefaultRole?: boolean;
}
/**
 *
 * @export
 * @interface RolePermissionAssociationDto
 */
export interface RolePermissionAssociationDto {
  /**
   *
   * @type {number}
   * @memberof RolePermissionAssociationDto
   */
  roleId?: number;
  /**
   *
   * @type {Permissions}
   * @memberof RolePermissionAssociationDto
   */
  permissionId?: Permissions;
}

/**
 *
 * @export
 * @interface RoleUserOrgAssociationDto
 */
export interface RoleUserOrgAssociationDto {
  /**
   *
   * @type {number}
   * @memberof RoleUserOrgAssociationDto
   */
  roleUserOrgAssociationId?: number;
  /**
   *
   * @type {string}
   * @memberof RoleUserOrgAssociationDto
   */
  roleUserOrgAssociationEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof RoleUserOrgAssociationDto
   */
  roleId?: number;
  /**
   *
   * @type {number}
   * @memberof RoleUserOrgAssociationDto
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof RoleUserOrgAssociationDto
   */
  organisationId?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof RoleUserOrgAssociationDto
   */
  roleNames?: Array<string> | null;
  /**
   *
   * @type {OrganisationDto}
   * @memberof RoleUserOrgAssociationDto
   */
  organisation?: OrganisationDto;
  /**
   *
   * @type {RoleDto}
   * @memberof RoleUserOrgAssociationDto
   */
  role?: RoleDto;
}
/**
 *
 * @export
 * @interface RuleAction
 */
export interface RuleAction {
  /**
   *
   * @type {RuleActionType}
   * @memberof RuleAction
   */
  type?: RuleActionType;
  /**
   *
   * @type {number}
   * @memberof RuleAction
   */
  targetFieldId?: number | null;
  /**
   *
   * @type {string}
   * @memberof RuleAction
   */
  value?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RuleAction
   */
  overwriteExisting?: boolean | null;
  /**
   *
   * @type {MessageLevel}
   * @memberof RuleAction
   */
  level?: MessageLevel;
}

/**
 *
 * @export
 * @interface RuleActionDto
 */
export interface RuleActionDto {
  /**
   *
   * @type {RuleActionType}
   * @memberof RuleActionDto
   */
  type?: RuleActionType;
  /**
   *
   * @type {number}
   * @memberof RuleActionDto
   */
  targetFieldId?: number | null;
  /**
   *
   * @type {string}
   * @memberof RuleActionDto
   */
  targetFieldName?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleActionDto
   */
  value?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RuleActionDto
   */
  overwriteExisting?: boolean | null;
  /**
   *
   * @type {MessageLevel}
   * @memberof RuleActionDto
   */
  level?: MessageLevel;
  /**
   *
   * @type {string}
   * @memberof RuleActionDto
   */
  metadata?: string | null;
}

/**
 *
 * @export
 * @enum {string}
 */

export const RuleActionType = {
  SetValue: 0,
  SetReadonly: 1,
  SetRequired: 2,
  SetVisible: 3,
  ShowMessage: 4,
  ClearValue: 5,
} as const;

export type RuleActionType =
  (typeof RuleActionType)[keyof typeof RuleActionType];

/**
 *
 * @export
 * @interface RuleCondition
 */
export interface RuleCondition {
  /**
   *
   * @type {LogicalOperator}
   * @memberof RuleCondition
   */
  operator?: LogicalOperator;
  /**
   *
   * @type {Array<RuleCondition>}
   * @memberof RuleCondition
   */
  conditionGroups?: Array<RuleCondition> | null;
  /**
   *
   * @type {Array<FieldCondition>}
   * @memberof RuleCondition
   */
  conditions?: Array<FieldCondition> | null;
  /**
   *
   * @type {boolean}
   * @memberof RuleCondition
   */
  negate?: boolean;
  /**
   *
   * @type {string}
   * @memberof RuleCondition
   */
  description?: string | null;
}

/**
 *
 * @export
 * @interface RuleConfigurationDto
 */
export interface RuleConfigurationDto {
  /**
   *
   * @type {number}
   * @memberof RuleConfigurationDto
   */
  ruleConfigurationId?: number;
  /**
   *
   * @type {number}
   * @memberof RuleConfigurationDto
   */
  ruleId?: number;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  ruleName?: string | null;
  /**
   *
   * @type {number}
   * @memberof RuleConfigurationDto
   */
  roleId?: number;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  roleName?: string | null;
  /**
   *
   * @type {number}
   * @memberof RuleConfigurationDto
   */
  organisationId?: number | null;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  organisationName?: string | null;
  /**
   *
   * @type {number}
   * @memberof RuleConfigurationDto
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  entityDetailValue?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RuleConfigurationDto
   */
  enabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RuleConfigurationDto
   */
  canOverride?: boolean;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  message?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  ruleJsonString?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleConfigurationDto
   */
  triggerRuleJsonString?: string | null;
  /**
   *
   * @type {RuleType}
   * @memberof RuleDto
   */
  ruleType?: RuleType;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof RuleDto
   */
  ruleEntityType?: EntityTypeCode;
}
/**
 *
 * @export
 * @interface RuleDefinition
 */
export interface RuleDefinition {
  /**
   *
   * @type {string}
   * @memberof RuleDefinition
   */
  version?: string | null;
  /**
   *
   * @type {RuleCondition}
   * @memberof RuleDefinition
   */
  rootCondition?: RuleCondition;
  /**
   *
   * @type {RuleMetadata}
   * @memberof RuleDefinition
   */
  metadata?: RuleMetadata;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof RuleDefinition
   */
  variables?: { [key: string]: any } | null;
  /**
   *
   * @type {Array<RuleAction>}
   * @memberof RuleDefinition
   */
  actions?: Array<RuleAction> | null;
}
/**
 *
 * @export
 * @interface RuleDto
 */
export interface RuleDto {
  /**
   *
   * @type {number}
   * @memberof RuleDto
   */
  ruleId?: number;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  ruleEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof RuleDto
   */
  validationId?: number;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  ruleName?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  description?: string | null;
  /**
   *
   * @type {RuleType}
   * @memberof RuleDto
   */
  ruleType?: RuleType;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  ruleJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  triggerConfigJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  errorMessage?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof RuleDto
   */
  modifiedDate?: string;
  /**
   *
   * @type {number}
   * @memberof RuleDto
   */
  createdByUserId?: number;
  /**
   *
   * @type {number}
   * @memberof RuleDto
   */
  modifiedByUserId?: number;
  /**
   *
   * @type {ValidationDto}
   * @memberof RuleDto
   */
  validation?: ValidationDto;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof RuleDto
   */
  ruleEntityType?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof RuleDto
   */
  isEnabled?: boolean;
}

/**
 *
 * @export
 * @interface RuleEvaluationResultDto
 */
export interface RuleEvaluationResultDto {
  /**
   *
   * @type {boolean}
   * @memberof RuleEvaluationResultDto
   */
  isValid?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof RuleEvaluationResultDto
   */
  rulePassed?: boolean;
  /**
   *
   * @type {string}
   * @memberof RuleEvaluationResultDto
   */
  errorMessage?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleEvaluationResultDto
   */
  message?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleEvaluationResultDto
   */
  evaluationDetails?: string | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof RuleEvaluationResultDto
   */
  evaluationMetadata?: { [key: string]: any } | null;
}
/**
 *
 * @export
 * @interface RuleExamplesDto
 */
export interface RuleExamplesDto {
  /**
   *
   * @type {string}
   * @memberof RuleExamplesDto
   */
  simpleRule?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleExamplesDto
   */
  complexRule?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleExamplesDto
   */
  fieldComparisonRule?: string | null;
}
/**
 *
 * @export
 * @interface RuleMetadata
 */
export interface RuleMetadata {
  /**
   *
   * @type {string}
   * @memberof RuleMetadata
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleMetadata
   */
  author?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleMetadata
   */
  createdDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleMetadata
   */
  modifiedDate?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof RuleMetadata
   */
  tags?: Array<string> | null;
}
/**
 *
 * @export
 * @interface RuleTestResultDto
 */
export interface RuleTestResultDto {
  /**
   *
   * @type {boolean}
   * @memberof RuleTestResultDto
   */
  isValid?: boolean;
  /**
   *
   * @type {string}
   * @memberof RuleTestResultDto
   */
  errorMessage?: string | null;
  /**
   *
   * @type {string}
   * @memberof RuleTestResultDto
   */
  message?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof RuleTestResultDto
   */
  rulePassed?: boolean;
  /**
   *
   * @type {string}
   * @memberof RuleTestResultDto
   */
  evaluationDetails?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const RuleType = {
  InCode: 0,
  JSON_Simple: 1,
} as const;

export type RuleType = (typeof RuleType)[keyof typeof RuleType];

/**
 *
 * @export
 * @interface Screen
 */
export interface Screen {
  /**
   *
   * @type {string}
   * @memberof Screen
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Screen
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof Screen
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof Screen
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof Screen
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof Screen
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof Screen
   */
  screenId?: number;
  /**
   *
   * @type {string}
   * @memberof Screen
   */
  screenName: string;
  /**
   *
   * @type {string}
   * @memberof Screen
   */
  screenDescription?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof Screen
   */
  entityTypeCode: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof Screen
   */
  organisationId?: number | null;
  /**
   *
   * @type {Organisation}
   * @memberof Screen
   */
  organisation?: Organisation;
  /**
   *
   * @type {Array<Form>}
   * @memberof Screen
   */
  forms?: Array<Form> | null;
}

/**
 *
 * @export
 * @interface ScreenDto
 */
export interface ScreenDto {
  /**
   *
   * @type {number}
   * @memberof ScreenDto
   */
  screenId?: number;
  /**
   *
   * @type {string}
   * @memberof ScreenDto
   */
  screenName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ScreenDto
   */
  screenDescription?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof ScreenDto
   */
  type?: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof ScreenDto
   */
  organisationId?: number;
  /**
   *
   * @type {Array<FormDto>}
   * @memberof ScreenDto
   */
  forms?: Array<FormDto> | null;
}

/**
 *
 * @export
 * @interface SearchBillableEventsByEntityRequest
 */
export interface SearchBillableEventsByEntityRequest {
  /**
   *
   * @type {string}
   * @memberof SearchBillableEventsByEntityRequest
   */
  searchString?: string | null;
  /**
   *
   * @type {number}
   * @memberof SearchBillableEventsByEntityRequest
   */
  organisationId?: number;
  /**
   *
   * @type {number}
   * @memberof SearchBillableEventsByEntityRequest
   */
  entityId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof SearchBillableEventsByEntityRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {SortByRequest}
   * @memberof SearchBillableEventsByEntityRequest
   */
  sortBySettings?: SortByRequest;
  /**
   *
   * @type {BillableEventFilter}
   * @memberof SearchBillableEventsByEntityRequest
   */
  filter?: BillableEventFilter;
  /**
   *
   * @type {Pagination}
   * @memberof SearchBillableEventsByEntityRequest
   */
  pagination?: Pagination;
}

/**
 *
 * @export
 * @interface SearchByOrgIdRequest
 */
export interface SearchByOrgIdRequest {
  /**
   *
   * @type {Pagination}
   * @memberof SearchByOrgIdRequest
   */
  pagination?: Pagination;
  /**
   *
   * @type {number}
   * @memberof SearchByOrgIdRequest
   * @deprecated
   */
  organisationId?: number | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof SearchByOrgIdRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof SearchByOrgIdRequest
   */
  isOnlyActive?: boolean;
  /**
   *
   * @type {Array<EntityDetailFilterInput>}
   * @memberof SearchByOrgIdRequest
   */
  filterInputs?: Array<EntityDetailFilterInput> | null;
  /**
   *
   * @type {EntityDetailSortInput}
   * @memberof SearchByOrgIdRequest
   */
  sortInput?: EntityDetailSortInput;
  /**
   *
   * @type {boolean}
   * @memberof SearchByOrgIdRequest
   */
  isStudBook?: boolean;
  /**
   *
   * @type {Array<DocumentTypeCode>}
   * @memberof SearchByOrgIdRequest
   */
  includeDocumentTypes?: Array<DocumentTypeCode> | null;
}

/**
 *
 * @export
 * @interface SearchEntityByDetailRequest
 */
export interface SearchEntityByDetailRequest {
  /**
   *
   * @type {string}
   * @memberof SearchEntityByDetailRequest
   */
  searchString?: string | null;
  /**
   *
   * @type {number}
   * @memberof SearchEntityByDetailRequest
   */
  organisationId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof SearchEntityByDetailRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {RecordStatus}
   * @memberof SearchEntityByDetailRequest
   */
  recordStatus?: RecordStatus;
  /**
   *
   * @type {SexType}
   * @memberof SearchEntityByDetailRequest
   */
  sexType?: SexType;
  /**
   *
   * @type {Pagination}
   * @memberof SearchEntityByDetailRequest
   */
  pagination?: Pagination;
}

/**
 *
 * @export
 * @interface SearchRuleRequest
 */
export interface SearchRuleRequest {
  /**
   *
   * @type {Pagination}
   * @memberof SearchRuleRequest
   */
  pagination?: Pagination;
  /**
   *
   * @type {TriggerType}
   * @memberof SearchRuleRequest
   */
  triggerType?: TriggerType;
  /**
   *
   * @type {RuleType}
   * @memberof SearchRuleRequest
   */
  ruleType?: RuleType;
  /**
   *
   * @type {string}
   * @memberof SearchRuleRequest
   */
  keyword?: string | null;
}

/**
 *
 * @export
 * @interface SendSocietyInvitationEmailRequest
 */
export interface SendSocietyInvitationEmailRequest {
  /**
   *
   * @type {string}
   * @memberof SendSocietyInvitationEmailRequest
   */
  invitationEmail?: string | null;
  /**
   *
   * @type {number}
   * @memberof SendSocietyInvitationEmailRequest
   */
  organisationId?: number;
}
/**
 *
 * @export
 * @interface SetCustomFormFieldsRequest
 */
export interface SetCustomFormFieldsRequest {
  /**
   *
   * @type {number}
   * @memberof SetCustomFormFieldsRequest
   */
  customFormId?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof SetCustomFormFieldsRequest
   */
  customFieldIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface SetEnterprisePrefixesRequest
 */
export interface SetEnterprisePrefixesRequest {
  /**
   *
   * @type {Array<EnterprisePrefixDto>}
   * @memberof SetEnterprisePrefixesRequest
   */
  enterprisePrefixes?: Array<EnterprisePrefixDto> | null;
}
/**
 *
 * @export
 * @interface SetMembershipTypeStatusRequest
 */
export interface SetMembershipTypeStatusRequest {
  /**
   *
   * @type {number}
   * @memberof SetMembershipTypeStatusRequest
   */
  membershipTypeId?: number;
  /**
   *
   * @type {MembershipTypeRecordStatus}
   * @memberof SetMembershipTypeStatusRequest
   */
  recordStatus?: MembershipTypeRecordStatus;
}

/**
 *
 * @export
 * @interface SetVisibleConfigRequest
 */
export interface SetVisibleConfigRequest {
  /**
   *
   * @type {number}
   * @memberof SetVisibleConfigRequest
   */
  entityDetailConfigId?: number;
  /**
   *
   * @type {boolean}
   * @memberof SetVisibleConfigRequest
   */
  isVisible?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SexType = {
  Male: 1,
  Female: 2,
  DesexedMale: 3,
  Unknown: 4,
} as const;

export type SexType = (typeof SexType)[keyof typeof SexType];

/**
 *
 * @export
 * @interface SingleUploadDocumentRequest
 */
export interface SingleUploadDocumentRequest {
  /**
   *
   * @type {number}
   * @memberof SingleUploadDocumentRequest
   */
  documentId?: number | null;
  /**
   *
   * @type {string}
   * @memberof SingleUploadDocumentRequest
   */
  entityId?: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof SingleUploadDocumentRequest
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {DocumentTypeCode}
   * @memberof SingleUploadDocumentRequest
   */
  documentType?: DocumentTypeCode;
}

/**
 *
 * @export
 * @interface SortByRequest
 */
export interface SortByRequest {
  /**
   *
   * @type {string}
   * @memberof SortByRequest
   */
  sortBy?: string | null;
  /**
   *
   * @type {string}
   * @memberof SortByRequest
   */
  sortDirection?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const SortDirectionOrder = {
  Ascending: 0,
  Descending: 1,
} as const;

export type SortDirectionOrder =
  (typeof SortDirectionOrder)[keyof typeof SortDirectionOrder];

/**
 *
 * @export
 * @interface SubmitWorkOrdersRequest
 */
export interface SubmitWorkOrdersRequest {
  /**
   *
   * @type {number}
   * @memberof SubmitWorkOrdersRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof SubmitWorkOrdersRequest
   */
  workOrderIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface TestJsonRuleRequest
 */
export interface TestJsonRuleRequest {
  /**
   *
   * @type {string}
   * @memberof TestJsonRuleRequest
   */
  ruleJson?: string | null;
}
/**
 *
 * @export
 * @interface TestRuleDefinitionRequest
 */
export interface TestRuleDefinitionRequest {
  /**
   *
   * @type {RuleDefinition}
   * @memberof TestRuleDefinitionRequest
   */
  ruleDefinition: RuleDefinition;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof TestRuleDefinitionRequest
   */
  testData?: { [key: string]: any } | null;
  /**
   *
   * @type {number}
   * @memberof TestRuleDefinitionRequest
   */
  organizationId?: number | null;
}
/**
 *
 * @export
 * @interface TimelineDto
 */
export interface TimelineDto {
  /**
   *
   * @type {string}
   * @memberof TimelineDto
   */
  eventHeading?: string | null;
  /**
   *
   * @type {string}
   * @memberof TimelineDto
   */
  eventDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof TimelineDto
   */
  capturedByUserName?: string | null;
  /**
   *
   * @type {string}
   * @memberof TimelineDto
   */
  timelineDate?: string;
  /**
   *
   * @type {string}
   * @memberof TimelineDto
   */
  capturedByUserProfileEntityId?: string;
}
/**
 *
 * @export
 * @enum {string}
 */

export const TransferType = {
  Lease: 1,
  Sale: 2,
  Transfer: 3,
} as const;

export type TransferType = (typeof TransferType)[keyof typeof TransferType];

/**
 *
 * @export
 * @enum {string}
 */

export const TriggerType = {
  FieldChange: 0,
  EntityAction: 1,
} as const;

export type TriggerType = (typeof TriggerType)[keyof typeof TriggerType];

/**
 *
 * @export
 * @interface UpdateAddressRequest
 */
export interface UpdateAddressRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  addressEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  unitNumber?: string | null;
  /**
   *
   * @type {AddressType}
   * @memberof UpdateAddressRequest
   */
  addressType?: AddressType;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  streetAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  state?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  country?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  postCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  latitude?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateAddressRequest
   */
  longitude?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateAddressRequest
   */
  isAddressValid?: boolean;
}

/**
 *
 * @export
 * @interface UpdateCustomFieldRequest
 */
export interface UpdateCustomFieldRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateCustomFieldRequest
   */
  customFieldId: number;
  /**
   *
   * @type {string}
   * @memberof UpdateCustomFieldRequest
   */
  customFieldEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateCustomFieldRequest
   */
  organisationId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpdateCustomFieldRequest
   */
  fieldTypeId: number;
  /**
   *
   * @type {string}
   * @memberof UpdateCustomFieldRequest
   */
  labelText: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCustomFieldRequest
   */
  fieldName: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCustomFieldRequest
   */
  fieldDescription: string;
  /**
   *
   * @type {string}
   * @memberof UpdateCustomFieldRequest
   */
  placeholder?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateCustomFieldRequest
   */
  defaultValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateCustomFieldRequest
   */
  value?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateCustomFieldRequest
   */
  options?: Array<string> | null;
  /**
   *
   * @type {ValidationRequest}
   * @memberof UpdateCustomFieldRequest
   */
  validation?: ValidationRequest;
}
/**
 *
 * @export
 * @interface UpdateEnterpriseNotificationRequest
 */
export interface UpdateEnterpriseNotificationRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateEnterpriseNotificationRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateEnterpriseNotificationRequest
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UpdateEnterpriseNotificationRequest
   */
  isReceiveNotifications?: boolean;
}
/**
 *
 * @export
 * @interface UpdateMemberMembershipRequest
 */
export interface UpdateMemberMembershipRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateMemberMembershipRequest
   */
  entityId?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberMembershipRequest
   */
  membershipValue?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpdateMemberMembershipRequest
   */
  annualPrice?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberMembershipRequest
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMemberMembershipRequest
   */
  expiryDate?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateMemberMembershipRequest
   */
  isAutoRenewal?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpdateMemberMembershipRequest
   */
  isAppendWorkOrder?: boolean;
}
/**
 *
 * @export
 * @interface UpdateMembershipRequest
 */
export interface UpdateMembershipRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipRequest
   */
  membershipId?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipRequest
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipRequest
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UpdateMembershipRequest
   */
  isAutoRenewal?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateMembershipRequest
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateMembershipRequest
   */
  expiryDate?: string | null;
  /**
   *
   * @type {UpdateMembershipTypeDurationRequest}
   * @memberof UpdateMembershipRequest
   */
  membershipTypeDuration?: UpdateMembershipTypeDurationRequest;
}
/**
 *
 * @export
 * @interface UpdateMembershipTypeDurationRequest
 */
export interface UpdateMembershipTypeDurationRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipTypeDurationRequest
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipTypeDurationRequest
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipTypeDurationRequest
   */
  duration?: number;
  /**
   *
   * @type {number}
   * @memberof UpdateMembershipTypeDurationRequest
   */
  feeId?: number;
}
/**
 *
 * @export
 * @interface UpdateOrganisationRequest
 */
export interface UpdateOrganisationRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateOrganisationRequest
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateOrganisationRequest
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateOrganisationRequest
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateOrganisationRequest
   */
  currency?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateOrganisationRequest
   */
  country?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateOrganisationRequest
   */
  isFreeMembership?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateOrganisationRequest
   */
  constitutionUrl?: string | null;
  /**
   *
   * @type {Array<OrganisationServiceOption>}
   * @memberof UpdateOrganisationRequest
   */
  organisationServiceOptions?: Array<OrganisationServiceOption> | null;
}
/**
 *
 * @export
 * @interface UpdateRoleRequest
 */
export interface UpdateRoleRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateRoleRequest
   */
  roleId?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateRoleRequest
   */
  roleName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateRoleRequest
   */
  roleDescription?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateRoleRequest
   */
  isSystemRole?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpdateRoleRequest
   */
  isDefaultRole?: boolean;
}
/**
 *
 * @export
 * @interface UpdateRuleRequest
 */
export interface UpdateRuleRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateRuleRequest
   */
  ruleId: number;
  /**
   *
   * @type {string}
   * @memberof UpdateRuleRequest
   */
  ruleName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateRuleRequest
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateRuleRequest
   */
  ruleJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateRuleRequest
   */
  triggerConfigJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateRuleRequest
   */
  errorMessage?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpdateRuleRequest
   */
  ruleEntityType?: EntityTypeCode;
  /**
   *
   * @type {boolean}
   * @memberof UpdateRuleRequest
   */
  isEnabled?: boolean;
}

/**
 *
 * @export
 * @interface UpdateValidationRequest
 */
export interface UpdateValidationRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateValidationRequest
   */
  validationId?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateValidationRequest
   */
  validationEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateValidationRequest
   */
  validationName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateValidationRequest
   */
  validationDescription?: string | null;
  /**
   *
   * @type {ValidationType}
   * @memberof UpdateValidationRequest
   */
  validationType?: ValidationType;
  /**
   *
   * @type {ParentEntityType}
   * @memberof UpdateValidationRequest
   */
  parentEntityType?: ParentEntityType;
  /**
   *
   * @type {string}
   * @memberof UpdateValidationRequest
   */
  errorMessage?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateValidationRequest
   */
  isActive?: boolean;
}

/**
 *
 * @export
 * @interface UpsertAddressRequest
 */
export interface UpsertAddressRequest {
  /**
   *
   * @type {AddressType}
   * @memberof UpsertAddressRequest
   */
  addressType?: AddressType;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  streetAddress?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  state?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  country?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  postCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  latitude?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  longitude?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertAddressRequest
   */
  isAddressValid?: boolean;
  /**
   *
   * @type {number}
   * @memberof UpsertAddressRequest
   */
  addressId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  unitNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAddressRequest
   */
  entityId?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertAddressRequest
   */
  entityType?: EntityTypeCode;
}

/**
 *
 * @export
 * @interface UpsertAnimalSpecies
 */
export interface UpsertAnimalSpecies {
  /**
   *
   * @type {number}
   * @memberof UpsertAnimalSpecies
   */
  animalSpeciesId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertAnimalSpecies
   */
  animalSpeciesEntityId?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAnimalSpecies
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAnimalSpecies
   */
  description?: string | null;
}
/**
 *
 * @export
 * @interface UpsertAnimalSpeciesBreed
 */
export interface UpsertAnimalSpeciesBreed {
  /**
   *
   * @type {number}
   * @memberof UpsertAnimalSpeciesBreed
   */
  animalSpeciesBreedId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertAnimalSpeciesBreed
   */
  animalSpeciesBreedEntityId?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertAnimalSpeciesBreed
   */
  animalSpeciesId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertAnimalSpeciesBreed
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAnimalSpeciesBreed
   */
  description?: string | null;
}
/**
 *
 * @export
 * @interface UpsertAnimalSpeciesBreedRequest
 */
export interface UpsertAnimalSpeciesBreedRequest {
  /**
   *
   * @type {Array<UpsertAnimalSpeciesBreed>}
   * @memberof UpsertAnimalSpeciesBreedRequest
   */
  animalSpeciesBreeds?: Array<UpsertAnimalSpeciesBreed> | null;
}
/**
 *
 * @export
 * @interface UpsertAnimalSpeciesRequest
 */
export interface UpsertAnimalSpeciesRequest {
  /**
   *
   * @type {Array<UpsertAnimalSpecies>}
   * @memberof UpsertAnimalSpeciesRequest
   */
  animalSpecies?: Array<UpsertAnimalSpecies> | null;
}
/**
 *
 * @export
 * @interface UpsertAuthorisedRepresentativesRequest
 */
export interface UpsertAuthorisedRepresentativesRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertAuthorisedRepresentativesRequest
   */
  authorisedRepresentativeId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertAuthorisedRepresentativesRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertAuthorisedRepresentativesRequest
   */
  firstName: string;
  /**
   *
   * @type {string}
   * @memberof UpsertAuthorisedRepresentativesRequest
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertAuthorisedRepresentativesRequest
   */
  email: string;
}
/**
 *
 * @export
 * @interface UpsertContactDetailRequest
 */
export interface UpsertContactDetailRequest {
  /**
   *
   * @type {boolean}
   * @memberof UpsertContactDetailRequest
   */
  isPrimary?: boolean;
  /**
   *
   * @type {ContactType}
   * @memberof UpsertContactDetailRequest
   */
  contactType?: ContactType;
  /**
   *
   * @type {string}
   * @memberof UpsertContactDetailRequest
   */
  contactValue?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertContactDetailRequest
   */
  contactDetailId?: number | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertContactDetailRequest
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof UpsertContactDetailRequest
   */
  entityId?: string | null;
}

/**
 *
 * @export
 * @interface UpsertCustomFormField
 */
export interface UpsertCustomFormField {
  /**
   *
   * @type {number}
   * @memberof UpsertCustomFormField
   */
  customFieldId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormField
   */
  customFieldEntityId?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertCustomFormField
   */
  organisationId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertCustomFormField
   */
  fieldTypeId: number;
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormField
   */
  labelText: string;
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormField
   */
  fieldName: string;
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormField
   */
  fieldDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormField
   */
  placeholder?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormField
   */
  defaultValue?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof UpsertCustomFormField
   */
  options?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormField
   */
  value?: string | null;
  /**
   *
   * @type {ValidationRuleDto}
   * @memberof UpsertCustomFormField
   */
  validation?: ValidationRuleDto;
}
/**
 *
 * @export
 * @interface UpsertCustomFormFieldValuesRequest
 */
export interface UpsertCustomFormFieldValuesRequest {
  /**
   *
   * @type {string}
   * @memberof UpsertCustomFormFieldValuesRequest
   */
  customFormJson?: string | null;
}
/**
 *
 * @export
 * @interface UpsertCustomFormFieldsRequest
 */
export interface UpsertCustomFormFieldsRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertCustomFormFieldsRequest
   */
  customFormId?: number;
  /**
   *
   * @type {Array<UpsertCustomFormField>}
   * @memberof UpsertCustomFormFieldsRequest
   */
  fields?: Array<UpsertCustomFormField> | null;
}
/**
 *
 * @export
 * @interface UpsertDetailValuesRequest
 */
export interface UpsertDetailValuesRequest {
  /**
   *
   * @type {Array<UpsertEntityDetailValueFormData>}
   * @memberof UpsertDetailValuesRequest
   */
  detailValues?: Array<UpsertEntityDetailValueFormData> | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertDetailValuesRequest
   */
  isOverridePreviousValue?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpsertDetailValuesRequest
   */
  isCleanOldLinkEntityDetailId?: boolean;
}
/**
 *
 * @export
 * @interface UpsertEnterpriseActionRequest
 */
export interface UpsertEnterpriseActionRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseActionRequest
   */
  enterpriseActionId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseActionRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseActionRequest
   */
  actionTypeId?: number;
  /**
   *
   * @type {EnterpriseActionTypeStatusCode}
   * @memberof UpsertEnterpriseActionRequest
   */
  actionTypeStatus?: EnterpriseActionTypeStatusCode;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterpriseActionRequest
   */
  actionOnDate?: string;
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseActionRequest
   */
  actionByUserId?: number;
}

/**
 *
 * @export
 * @interface UpsertEnterprisePrefixes
 */
export interface UpsertEnterprisePrefixes {
  /**
   *
   * @type {number}
   * @memberof UpsertEnterprisePrefixes
   */
  enterprisePrefixId?: number | null;
  /**
   *
   * @type {PrefixType}
   * @memberof UpsertEnterprisePrefixes
   */
  prefixType?: PrefixType;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterprisePrefixes
   */
  prefix: string;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEnterprisePrefixes
   */
  activePrefix?: boolean;
}

/**
 *
 * @export
 * @interface UpsertEnterprisePrefixesRequest
 */
export interface UpsertEnterprisePrefixesRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEnterprisePrefixesRequest
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {Array<UpsertEnterprisePrefixes>}
   * @memberof UpsertEnterprisePrefixesRequest
   */
  enterprisePrefixes?: Array<UpsertEnterprisePrefixes> | null;
}
/**
 *
 * @export
 * @interface UpsertEnterpriseRequest
 */
export interface UpsertEnterpriseRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseRequest
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseRequest
   */
  organisationId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterpriseRequest
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterpriseRequest
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterpriseRequest
   */
  dateOfBirth?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEnterpriseRequest
   */
  isExistingMember?: boolean;
  /**
   *
   * @type {Array<UpsertAddressRequest>}
   * @memberof UpsertEnterpriseRequest
   */
  addresses?: Array<UpsertAddressRequest> | null;
  /**
   *
   * @type {Array<UpsertContactDetailRequest>}
   * @memberof UpsertEnterpriseRequest
   */
  contactDetails?: Array<UpsertContactDetailRequest> | null;
  /**
   *
   * @type {UpsertEnterpriseUsersRequest}
   * @memberof UpsertEnterpriseRequest
   */
  enterpriseUsers?: UpsertEnterpriseUsersRequest;
  /**
   *
   * @type {UpsertEnterprisePrefixesRequest}
   * @memberof UpsertEnterpriseRequest
   */
  enterprisePrefixes?: UpsertEnterprisePrefixesRequest;
  /**
   *
   * @type {UpsertMembershipRequest}
   * @memberof UpsertEnterpriseRequest
   */
  membership?: UpsertMembershipRequest;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterpriseRequest
   */
  enterpriseEntityId?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterpriseRequest
   */
  enterpriseIdent?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEnterpriseRequest
   */
  isStudbookOptedOut?: boolean | null;
}
/**
 *
 * @export
 * @interface UpsertEnterpriseUsers
 */
export interface UpsertEnterpriseUsers {
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseUsers
   */
  enterpriseUserId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseUsers
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEnterpriseUsers
   */
  isPrimary?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpsertEnterpriseUsers
   */
  dateOfBirth?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEnterpriseUsers
   */
  isReceiveNotifications?: boolean;
}
/**
 *
 * @export
 * @interface UpsertEnterpriseUsersRequest
 */
export interface UpsertEnterpriseUsersRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEnterpriseUsersRequest
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {Array<UpsertEnterpriseUsers>}
   * @memberof UpsertEnterpriseUsersRequest
   */
  enterpriseUsers?: Array<UpsertEnterpriseUsers> | null;
}
/**
 *
 * @export
 * @interface UpsertEntityDetailCategoryRequest
 */
export interface UpsertEntityDetailCategoryRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailCategoryRequest
   */
  entityDetailCategoryId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailCategoryRequest
   */
  entityDetailCategoryName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailCategoryRequest
   */
  entityDetailCategoryDescription?: string | null;
}
/**
 *
 * @export
 * @interface UpsertEntityDetailConfigRequest
 */
export interface UpsertEntityDetailConfigRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailConfigRequest
   */
  entityDetailConfigId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  entityDetailConfigEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailConfigRequest
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  category?: string | null;
  /**
   *
   * @type {EntityDetailUnitOfMeasurement}
   * @memberof UpsertEntityDetailConfigRequest
   */
  entityDetailUnitOfMeasurement?: EntityDetailUnitOfMeasurement;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailConfigRequest
   */
  entityDetailUnitOfMeasureScale?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  labelText: string;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  detailName: string;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  detailDescription: string;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  placeholder?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof UpsertEntityDetailConfigRequest
   */
  entityDetailType?: EntityDetailType;
  /**
   *
   * @type {Array<EntityDetailOption>}
   * @memberof UpsertEntityDetailConfigRequest
   */
  options?: Array<EntityDetailOption> | null;
  /**
   *
   * @type {ValidationRequest}
   * @memberof UpsertEntityDetailConfigRequest
   */
  validation?: ValidationRequest;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  defaultValue?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityDetailConfigRequest
   */
  isEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailConfigRequest
   */
  order?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityDetailConfigRequest
   */
  isDefault?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailConfigRequest
   */
  custom?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityDetailConfigRequest
   */
  isVisible?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityDetailConfigRequest
   */
  isAutoCalculatedEnabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityDetailConfigRequest
   */
  isDatabaseSearchEnable?: boolean;
}

/**
 *
 * @export
 * @interface UpsertEntityDetailEnhancerRequest
 */
export interface UpsertEntityDetailEnhancerRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailEnhancerRequest
   */
  entityDetailEnhancerId?: number | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertEntityDetailEnhancerRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailEnhancerRequest
   */
  name: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailEnhancerRequest
   */
  description: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailEnhancerRequest
   */
  configurationString: string | null;
}

/**
 *
 * @export
 * @interface UpsertEntityDetailRequest
 */
export interface UpsertEntityDetailRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailRequest
   */
  entityDetailId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailRequest
   */
  entityId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailRequest
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailRequest
   */
  entityDetailDescription?: string | null;
  /**
   *
   * @type {EntityDetailType}
   * @memberof UpsertEntityDetailRequest
   */
  entityDetailType?: EntityDetailType;
}

/**
 *
 * @export
 * @interface UpsertEntityDetailValue
 */
export interface UpsertEntityDetailValue {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValue
   */
  entityDetailValueId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValue
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailValue
   */
  value?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityDetailValue
   */
  isAppendNewRecord?: boolean;
}
/**
 *
 * @export
 * @interface UpsertEntityDetailValueFormData
 */
export interface UpsertEntityDetailValueFormData {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValueFormData
   */
  entityDetailValueId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValueFormData
   */
  entityDetailId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValueFormData
   */
  entityId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailValueFormData
   */
  value?: string | null;
}
/**
 *
 * @export
 * @interface UpsertEntityDetailValueFormRequest
 */
export interface UpsertEntityDetailValueFormRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValueFormRequest
   */
  entityDetailValueId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValueFormRequest
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailValueFormRequest
   */
  entityDetailName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityDetailValueFormRequest
   */
  value?: string | null;
}
/**
 *
 * @export
 * @interface UpsertEntityDetailValueRequest
 */
export interface UpsertEntityDetailValueRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValueRequest
   */
  entityId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityDetailValueRequest
   */
  organisationId?: number | null;
  /**
   *
   * @type {Array<UpsertEntityDetailValue>}
   * @memberof UpsertEntityDetailValueRequest
   */
  entityDetailValues?: Array<UpsertEntityDetailValue> | null;
}
/**
 *
 * @export
 * @interface UpsertEntityKeyRequest
 */
export interface UpsertEntityKeyRequest {
  /**
   *
   * @type {string}
   * @memberof UpsertEntityKeyRequest
   */
  entityKeyEntityId?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityKeyRequest
   */
  entityId: string;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertEntityKeyRequest
   */
  entityType: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityKeyRequest
   */
  externalKey?: string | null;
  /**
   *
   * @type {ExternalSourceType}
   * @memberof UpsertEntityKeyRequest
   */
  externalKeySource?: ExternalSourceType;
}

/**
 *
 * @export
 * @interface UpsertEntityRequest
 */
export interface UpsertEntityRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityRequest
   */
  entityId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityRequest
   */
  organisationId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertEntityRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {Array<UpsertEntityDetailValueFormRequest>}
   * @memberof UpsertEntityRequest
   */
  entityDetailValues?: Array<UpsertEntityDetailValueFormRequest> | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityRequest
   */
  isDraft?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityRequest
   */
  isConfirmed?: boolean;
}

/**
 *
 * @export
 * @interface UpsertEntityTransferRequest
 */
export interface UpsertEntityTransferRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityTransferRequest
   */
  entityTransferId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityTransferRequest
   */
  transferToEntityId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityTransferRequest
   * @deprecated
   */
  transferToEnterpriseId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityTransferRequest
   */
  transferFromDate?: string;
  /**
   *
   * @type {string}
   * @memberof UpsertEntityTransferRequest
   */
  transferToDate?: string | null;
  /**
   *
   * @type {TransferType}
   * @memberof UpsertEntityTransferRequest
   */
  transferType?: TransferType;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityTransferRequest
   */
  entityId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UpsertEntityTransferRequest
   */
  isBillable?: boolean;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityTransferRequest
   */
  transferPercent?: number;
}

/**
 *
 * @export
 * @interface UpsertEntityTransfersRequest
 */
export interface UpsertEntityTransfersRequest {
  /**
   *
   * @type {Array<UpsertEntityTransferRequest>}
   * @memberof UpsertEntityTransfersRequest
   */
  transfers: Array<UpsertEntityTransferRequest> | null;
}
/**
 *
 * @export
 * @interface UpsertEntityWithDetailRequest
 */
export interface UpsertEntityWithDetailRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertEntityWithDetailRequest
   */
  entityId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertEntityWithDetailRequest
   */
  organisationId?: number;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertEntityWithDetailRequest
   */
  entityTypeCode?: EntityTypeCode;
  /**
   *
   * @type {Array<UpsertEntityDetailValueFormRequest>}
   * @memberof UpsertEntityWithDetailRequest
   */
  entityDetailValues?: Array<UpsertEntityDetailValueFormRequest> | null;
}

/**
 *
 * @export
 * @interface UpsertFormActionAssociationRequest
 */
export interface UpsertFormActionAssociationRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertFormActionAssociationRequest
   */
  formId: number;
  /**
   *
   * @type {ActionType}
   * @memberof UpsertFormActionAssociationRequest
   */
  actionType: ActionType;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertFormActionAssociationRequest
   */
  entityTypeCode: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof UpsertFormActionAssociationRequest
   */
  organisationId: number;
}

/**
 *
 * @export
 * @interface UpsertFormRequest
 */
export interface UpsertFormRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertFormRequest
   */
  formId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertFormRequest
   */
  value?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertFormRequest
   */
  screenId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertFormRequest
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertFormRequest
   */
  formName?: string | null;
}
/**
 *
 * @export
 * @interface UpsertIdentGenerationRuleRequest
 */
export interface UpsertIdentGenerationRuleRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertIdentGenerationRuleRequest
   */
  id?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertIdentGenerationRuleRequest
   */
  organisationId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertIdentGenerationRuleRequest
   */
  format?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertIdentGenerationRuleRequest
   */
  requiredFieldsJson?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertIdentGenerationRuleRequest
   */
  gradeAbbreviationMapJson?: string | null;
}
/**
 *
 * @export
 * @interface UpsertImportBatchRequest
 */
export interface UpsertImportBatchRequest {
  /**
   *
   * @type {string}
   * @memberof UpsertImportBatchRequest
   */
  importBatchGuid?: string;
  /**
   *
   * @type {string}
   * @memberof UpsertImportBatchRequest
   */
  type?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertImportBatchRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertImportBatchRequest
   */
  numberOfRecords?: number;
  /**
   *
   * @type {ImportBatchStatus}
   * @memberof UpsertImportBatchRequest
   */
  status?: ImportBatchStatus;
  /**
   *
   * @type {string}
   * @memberof UpsertImportBatchRequest
   */
  documentId?: string | null;
}

/**
 *
 * @export
 * @interface UpsertItemCodeRequest
 */
export interface UpsertItemCodeRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertItemCodeRequest
   */
  itemCodeId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertItemCodeRequest
   */
  orgId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertItemCodeRequest
   */
  itemCodeValue?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertItemCodeRequest
   */
  externalId?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertItemCodeRequest
   */
  grossPrice?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertItemCodeRequest
   */
  defaultDescription?: string | null;
}
/**
 *
 * @export
 * @interface UpsertMembershipBenefitsRequest
 */
export interface UpsertMembershipBenefitsRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertMembershipBenefitsRequest
   */
  organisationId?: number;
  /**
   *
   * @type {Array<MembershipBenefitUpsert>}
   * @memberof UpsertMembershipBenefitsRequest
   */
  membershipBenefits?: Array<MembershipBenefitUpsert> | null;
}
/**
 *
 * @export
 * @interface UpsertMembershipRequest
 */
export interface UpsertMembershipRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertMembershipRequest
   */
  membershipId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertMembershipRequest
   */
  membershipEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof UpsertMembershipRequest
   */
  enterpriseId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertMembershipRequest
   */
  membershipTypeId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertMembershipRequest
   */
  membershipTypeDurationId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UpsertMembershipRequest
   */
  isAutoRenewal?: boolean;
  /**
   *
   * @type {MembershipStatusCode}
   * @memberof UpsertMembershipRequest
   */
  membershipStatus?: MembershipStatusCode;
  /**
   *
   * @type {string}
   * @memberof UpsertMembershipRequest
   */
  effectiveDate?: string;
  /**
   *
   * @type {string}
   * @memberof UpsertMembershipRequest
   */
  expiryDate?: string | null;
}

/**
 *
 * @export
 * @interface UpsertMembershipTypeDurationRequest
 */
export interface UpsertMembershipTypeDurationRequest {
  /**
   *
   * @type {Array<MembershipTypeDurationUpsert>}
   * @memberof UpsertMembershipTypeDurationRequest
   */
  membershipTypeDurations?: Array<MembershipTypeDurationUpsert> | null;
}
/**
 *
 * @export
 * @interface UpsertMembershipTypeRequest
 */
export interface UpsertMembershipTypeRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertMembershipTypeRequest
   */
  organisationId?: number;
  /**
   *
   * @type {Array<MembershipTypeUpsert>}
   * @memberof UpsertMembershipTypeRequest
   */
  membershipTypes?: Array<MembershipTypeUpsert> | null;
}
/**
 *
 * @export
 * @interface UpsertNoteRequest
 */
export interface UpsertNoteRequest {
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertNoteRequest
   */
  entityType?: EntityTypeCode;
  /**
   *
   * @type {string}
   * @memberof UpsertNoteRequest
   */
  noteEntityId?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpsertNoteRequest
   */
  isImportant?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpsertNoteRequest
   */
  entityId?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertNoteRequest
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof UpsertNoteRequest
   */
  body?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertNoteRequest
   */
  enterpriseId?: number;
}

/**
 *
 * @export
 * @interface UpsertOrgSettingFormRequest
 */
export interface UpsertOrgSettingFormRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertOrgSettingFormRequest
   */
  organisationId: number;
  /**
   *
   * @type {FormType}
   * @memberof UpsertOrgSettingFormRequest
   */
  type: FormType;
  /**
   *
   * @type {string}
   * @memberof UpsertOrgSettingFormRequest
   */
  value: string;
  /**
   *
   * @type {number}
   * @memberof UpsertOrgSettingFormRequest
   */
  organisationSettingId?: number | null;
}

/**
 *
 * @export
 * @interface UpsertOrganisationSettingsRequest
 */
export interface UpsertOrganisationSettingsRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertOrganisationSettingsRequest
   */
  organisationSettingId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertOrganisationSettingsRequest
   */
  organisationId: number;
  /**
   *
   * @type {OrganisationSettingTypeCode}
   * @memberof UpsertOrganisationSettingsRequest
   */
  settingTypeCode?: OrganisationSettingTypeCode;
  /**
   *
   * @type {OrganisationSettingDataType}
   * @memberof UpsertOrganisationSettingsRequest
   */
  dataType?: OrganisationSettingDataType;
  /**
   *
   * @type {string}
   * @memberof UpsertOrganisationSettingsRequest
   */
  value?: string | null;
  /**
   *
   * @type {number}
   * @memberof UpsertOrganisationSettingsRequest
   */
  order: number;
  /**
   *
   * @type {number}
   * @memberof UpsertOrganisationSettingsRequest
   */
  characterLimit?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertOrganisationSettingsRequest
   */
  requiredByDefault: boolean;
}

/**
 *
 * @export
 * @interface UpsertRolePermissionAssociationRequest
 */
export interface UpsertRolePermissionAssociationRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertRolePermissionAssociationRequest
   */
  roleId?: number;
  /**
   *
   * @type {Array<Permissions>}
   * @memberof UpsertRolePermissionAssociationRequest
   */
  rolePermissions: Array<Permissions> | null;
}
/**
 *
 * @export
 * @interface UpsertRoleUserOrgAssociationRequest
 */
export interface UpsertRoleUserOrgAssociationRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertRoleUserOrgAssociationRequest
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertRoleUserOrgAssociationRequest
   */
  organisationId?: number | null;
  /**
   *
   * @type {Array<number>}
   * @memberof UpsertRoleUserOrgAssociationRequest
   */
  roleIds?: Array<number> | null;
}
/**
 *
 * @export
 * @interface UpsertRuleConfigurationRequest
 */
export interface UpsertRuleConfigurationRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertRuleConfigurationRequest
   */
  ruleConfigurationId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertRuleConfigurationRequest
   */
  ruleId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertRuleConfigurationRequest
   */
  roleId?: number;
  /**
   *
   * @type {number}
   * @memberof UpsertRuleConfigurationRequest
   */
  organisationId?: number | null;
  /**
   *
   * @type {number}
   * @memberof UpsertRuleConfigurationRequest
   */
  entityDetailId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertRuleConfigurationRequest
   */
  entityDetailValue?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpsertRuleConfigurationRequest
   */
  enabled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UpsertRuleConfigurationRequest
   */
  canOverride?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpsertRuleConfigurationRequest
   */
  message?: string | null;
}
/**
 *
 * @export
 * @interface UpsertScreenRequest
 */
export interface UpsertScreenRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertScreenRequest
   */
  screenId?: number | null;
  /**
   *
   * @type {string}
   * @memberof UpsertScreenRequest
   */
  screenName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpsertScreenRequest
   */
  screenDescription?: string | null;
  /**
   *
   * @type {EntityTypeCode}
   * @memberof UpsertScreenRequest
   */
  type?: EntityTypeCode;
  /**
   *
   * @type {number}
   * @memberof UpsertScreenRequest
   */
  organisationId?: number | null;
  /**
   *
   * @type {Array<UpsertFormRequest>}
   * @memberof UpsertScreenRequest
   */
  forms?: Array<UpsertFormRequest> | null;
}

/**
 *
 * @export
 * @interface UpsertUserConfigRequest
 */
export interface UpsertUserConfigRequest {
  /**
   *
   * @type {number}
   * @memberof UpsertUserConfigRequest
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof UpsertUserConfigRequest
   */
  config?: string | null;
}
/**
 *
 * @export
 * @interface UserConfigDto
 */
export interface UserConfigDto {
  /**
   *
   * @type {number}
   * @memberof UserConfigDto
   */
  userConfigId?: number;
  /**
   *
   * @type {number}
   * @memberof UserConfigDto
   */
  userId?: number;
  /**
   *
   * @type {number}
   * @memberof UserConfigDto
   */
  enterpriseId?: number;
  /**
   *
   * @type {string}
   * @memberof UserConfigDto
   */
  config?: string | null;
}
/**
 *
 * @export
 * @interface UserProfileDto
 */
export interface UserProfileDto {
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  userProfileEntityId?: string;
  /**
   *
   * @type {number}
   * @memberof UserProfileDto
   */
  userId?: number;
  /**
   *
   * @type {boolean}
   * @memberof UserProfileDto
   */
  isEulaAccepted?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  eulaAcceptedDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  firstName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  lastName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  preferredName?: string | null;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  communicationPreferences?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UserProfileDto
   */
  isReceiveNotifications?: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  dateOfBirth?: string;
  /**
   *
   * @type {string}
   * @memberof UserProfileDto
   */
  displayName?: string | null;
}
/**
 *
 * @export
 * @interface UserProfileDtoPagedResult
 */
export interface UserProfileDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof UserProfileDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof UserProfileDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof UserProfileDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof UserProfileDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<UserProfileDto>}
   * @memberof UserProfileDtoPagedResult
   */
  results?: Array<UserProfileDto> | null;
}
/**
 *
 * @export
 * @interface ValidationDto
 */
export interface ValidationDto {
  /**
   *
   * @type {number}
   * @memberof ValidationDto
   */
  validationId?: number;
  /**
   *
   * @type {string}
   * @memberof ValidationDto
   */
  validationEntityId?: string;
  /**
   *
   * @type {string}
   * @memberof ValidationDto
   */
  validationName?: string | null;
  /**
   *
   * @type {string}
   * @memberof ValidationDto
   */
  validationDescription?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ValidationDto
   */
  isActive?: boolean;
  /**
   *
   * @type {Array<RuleConfigurationDto>}
   * @memberof ValidationDto
   */
  ruleConfigurations?: Array<RuleConfigurationDto> | null;
  /**
   *
   * @type {Array<RuleActionDto>}
   * @memberof ValidationDto
   */
  ruleActions?: Array<RuleActionDto> | null;
  /**
   *
   * @type {boolean}
   * @memberof ValidationDto
   */
  isValid?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ValidationDto
   */
  errorMessage?: string | null;
  /**
   *
   * @type {string}
   * @memberof ValidationDto
   */
  executionDetails?: string | null;
}
/**
 *
 * @export
 * @interface ValidationRequest
 */
export interface ValidationRequest {
  /**
   *
   * @type {boolean}
   * @memberof ValidationRequest
   */
  isRequired?: boolean;
  /**
   *
   * @type {number}
   * @memberof ValidationRequest
   */
  min?: number | null;
  /**
   *
   * @type {number}
   * @memberof ValidationRequest
   */
  max?: number | null;
  /**
   *
   * @type {string}
   * @memberof ValidationRequest
   */
  regex?: string | null;
  /**
   *
   * @type {string}
   * @memberof ValidationRequest
   */
  minDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ValidationRequest
   */
  maxDate?: string | null;
}
/**
 *
 * @export
 * @interface ValidationRuleDto
 */
export interface ValidationRuleDto {
  /**
   *
   * @type {boolean}
   * @memberof ValidationRuleDto
   */
  required?: boolean;
  /**
   *
   * @type {number}
   * @memberof ValidationRuleDto
   */
  min?: number | null;
  /**
   *
   * @type {number}
   * @memberof ValidationRuleDto
   */
  max?: number | null;
  /**
   *
   * @type {string}
   * @memberof ValidationRuleDto
   */
  minDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ValidationRuleDto
   */
  maxDate?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ValidationType = {
  Unknown: 0,
  AnimalDetailChecks: 1,
  DateChecks: 2,
  FormatCheck: 3,
  LookupChecks: 4,
  RequiredFields: 5,
  CalvingYearChecks: 6,
  DamChecks: 7,
  FosterDamChecks: 8,
  OwnerChecks: 9,
  RecipDamChecks: 10,
  SireChecks: 11,
  StatusChecks: 12,
  BreederChecks: 13,
  IdentChecks: 14,
  TraitChecks: 15,
} as const;

export type ValidationType =
  (typeof ValidationType)[keyof typeof ValidationType];

/**
 *
 * @export
 * @interface WorkOrder
 */
export interface WorkOrder {
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkOrder
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof WorkOrder
   */
  workOrderId?: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrder
   */
  enterpriseId?: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrder
   */
  billedEnterpriseId?: number | null;
  /**
   *
   * @type {number}
   * @memberof WorkOrder
   */
  organisationId: number;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  issueDate: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof WorkOrder
   */
  status: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  paymentDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  invoiceNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof WorkOrder
   */
  receiptNumber?: string | null;
  /**
   *
   * @type {Enterprise}
   * @memberof WorkOrder
   */
  enterprise?: Enterprise;
  /**
   *
   * @type {Enterprise}
   * @memberof WorkOrder
   */
  billedEnterprise?: Enterprise;
  /**
   *
   * @type {Organisation}
   * @memberof WorkOrder
   */
  organisation?: Organisation;
  /**
   *
   * @type {Array<WorkOrderItem>}
   * @memberof WorkOrder
   */
  items?: Array<WorkOrderItem> | null;
}

/**
 *
 * @export
 * @interface WorkOrderDto
 */
export interface WorkOrderDto {
  /**
   *
   * @type {number}
   * @memberof WorkOrderDto
   */
  workOrderId?: number;
  /**
   *
   * @type {string}
   * @memberof WorkOrderDto
   */
  organisationName?: string | null;
  /**
   *
   * @type {string}
   * @memberof WorkOrderDto
   */
  organisationEntityId?: string;
  /**
   *
   * @type {PaymentStatus}
   * @memberof WorkOrderDto
   */
  status?: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof WorkOrderDto
   */
  issueDate?: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrderDto
   */
  paymentDate?: string | null;
  /**
   *
   * @type {number}
   * @memberof WorkOrderDto
   */
  total?: number;
  /**
   *
   * @type {string}
   * @memberof WorkOrderDto
   */
  invoiceNumber?: string | null;
  /**
   *
   * @type {Array<WorkOrderItemDto>}
   * @memberof WorkOrderDto
   */
  items?: Array<WorkOrderItemDto> | null;
}

/**
 *
 * @export
 * @interface WorkOrderDtoPagedResult
 */
export interface WorkOrderDtoPagedResult {
  /**
   *
   * @type {number}
   * @memberof WorkOrderDtoPagedResult
   */
  currentPage: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrderDtoPagedResult
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrderDtoPagedResult
   */
  pageCount?: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrderDtoPagedResult
   */
  rowCount?: number;
  /**
   *
   * @type {Array<WorkOrderDto>}
   * @memberof WorkOrderDtoPagedResult
   */
  results?: Array<WorkOrderDto> | null;
}
/**
 *
 * @export
 * @interface WorkOrderFilter
 */
export interface WorkOrderFilter {
  /**
   *
   * @type {string}
   * @memberof WorkOrderFilter
   */
  organisationName?: string | null;
  /**
   *
   * @type {string}
   * @memberof WorkOrderFilter
   */
  type?: string | null;
  /**
   *
   * @type {PaymentStatus}
   * @memberof WorkOrderFilter
   */
  status?: PaymentStatus;
  /**
   *
   * @type {string}
   * @memberof WorkOrderFilter
   */
  issueDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof WorkOrderFilter
   */
  paymentDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof WorkOrderFilter
   */
  invoiceNumber?: string | null;
}

/**
 *
 * @export
 * @interface WorkOrderItem
 */
export interface WorkOrderItem {
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  createdByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  createdDate?: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  modifiedByProfileId?: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  modifiedDate?: string;
  /**
   *
   * @type {boolean}
   * @memberof WorkOrderItem
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  timeStamp?: string | null;
  /**
   *
   * @type {number}
   * @memberof WorkOrderItem
   */
  workOrderItemId?: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrderItem
   */
  workOrderId: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrderItem
   */
  feeId: number;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  itemDescription: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  itemEntityId: string;
  /**
   *
   * @type {FeeSection}
   * @memberof WorkOrderItem
   */
  itemType: FeeSection;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItem
   */
  itemTypeEntityId?: string | null;
  /**
   *
   * @type {number}
   * @memberof WorkOrderItem
   */
  quantity: number;
  /**
   *
   * @type {WorkOrder}
   * @memberof WorkOrderItem
   */
  workOrder?: WorkOrder;
  /**
   *
   * @type {Fee}
   * @memberof WorkOrderItem
   */
  fee?: Fee;
}

/**
 *
 * @export
 * @interface WorkOrderItemDto
 */
export interface WorkOrderItemDto {
  /**
   *
   * @type {number}
   * @memberof WorkOrderItemDto
   */
  workOrderItemId?: number;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItemDto
   */
  itemDescription: string;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItemDto
   */
  itemEntityId: string;
  /**
   *
   * @type {FeeSection}
   * @memberof WorkOrderItemDto
   */
  itemType: FeeSection;
  /**
   *
   * @type {string}
   * @memberof WorkOrderItemDto
   */
  itemTypeEntityId?: string | null;
  /**
   *
   * @type {number}
   * @memberof WorkOrderItemDto
   */
  quantity: number;
  /**
   *
   * @type {number}
   * @memberof WorkOrderItemDto
   */
  feeId: number;
  /**
   *
   * @type {FeeDto}
   * @memberof WorkOrderItemDto
   */
  fee?: FeeDto;
}

/**
 *
 * @export
 * @interface WorkOrderSearchSortFilterRequest
 */
export interface WorkOrderSearchSortFilterRequest {
  /**
   *
   * @type {number}
   * @memberof WorkOrderSearchSortFilterRequest
   */
  enterpriseId?: number;
  /**
   *
   * @type {string}
   * @memberof WorkOrderSearchSortFilterRequest
   */
  searchPhrase?: string | null;
  /**
   *
   * @type {SortByRequest}
   * @memberof WorkOrderSearchSortFilterRequest
   */
  sortBySettings?: SortByRequest;
  /**
   *
   * @type {WorkOrderFilter}
   * @memberof WorkOrderSearchSortFilterRequest
   */
  filter?: WorkOrderFilter;
  /**
   *
   * @type {PagedWorkOrderRequest}
   * @memberof WorkOrderSearchSortFilterRequest
   */
  pageSettings?: PagedWorkOrderRequest;
}

/**
 * AddressApi - axios parameter creator
 * @export
 */
export const AddressApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} [addressEntityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressDelete: async (
      addressEntityId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Address`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (addressEntityId !== undefined) {
        localVarQueryParameter['addressEntityId'] = addressEntityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressGet: async (
      entityId?: string,
      entityTypeCode?: EntityTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Address`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (entityTypeCode !== undefined) {
        localVarQueryParameter['entityTypeCode'] = entityTypeCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateAddressRequest} [updateAddressRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressPatch: async (
      updateAddressRequest?: UpdateAddressRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Address`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateAddressRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddAddressRequest} [addAddressRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressPost: async (
      addAddressRequest?: AddAddressRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Address`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addAddressRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AddressApi - functional programming interface
 * @export
 */
export const AddressApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AddressApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [addressEntityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAddressDelete(
      addressEntityId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAddressDelete(
          addressEntityId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AddressApi.apiAddressDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAddressGet(
      entityId?: string,
      entityTypeCode?: EntityTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiAddressGet(
        entityId,
        entityTypeCode,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AddressApi.apiAddressGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateAddressRequest} [updateAddressRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAddressPatch(
      updateAddressRequest?: UpdateAddressRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiAddressPatch(
        updateAddressRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AddressApi.apiAddressPatch']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AddAddressRequest} [addAddressRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAddressPost(
      addAddressRequest?: AddAddressRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiAddressPost(
        addAddressRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AddressApi.apiAddressPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AddressApi - factory interface
 * @export
 */
export const AddressApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AddressApiFp(configuration);
  return {
    /**
     *
     * @param {string} [addressEntityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressDelete(
      addressEntityId?: string,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiAddressDelete(addressEntityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressGet(
      entityId?: string,
      entityTypeCode?: EntityTypeCode,
      options?: any,
    ): AxiosPromise<AddressDto> {
      return localVarFp
        .apiAddressGet(entityId, entityTypeCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateAddressRequest} [updateAddressRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressPatch(
      updateAddressRequest?: UpdateAddressRequest,
      options?: any,
    ): AxiosPromise<AddressDto> {
      return localVarFp
        .apiAddressPatch(updateAddressRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddAddressRequest} [addAddressRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAddressPost(
      addAddressRequest?: AddAddressRequest,
      options?: any,
    ): AxiosPromise<AddressDto> {
      return localVarFp
        .apiAddressPost(addAddressRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
export class AddressApi extends BaseAPI {
  /**
   *
   * @param {string} [addressEntityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApi
   */
  public apiAddressDelete(
    addressEntityId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AddressApiFp(this.configuration)
      .apiAddressDelete(addressEntityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [entityId]
   * @param {EntityTypeCode} [entityTypeCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApi
   */
  public apiAddressGet(
    entityId?: string,
    entityTypeCode?: EntityTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return AddressApiFp(this.configuration)
      .apiAddressGet(entityId, entityTypeCode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateAddressRequest} [updateAddressRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApi
   */
  public apiAddressPatch(
    updateAddressRequest?: UpdateAddressRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AddressApiFp(this.configuration)
      .apiAddressPatch(updateAddressRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddAddressRequest} [addAddressRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AddressApi
   */
  public apiAddressPost(
    addAddressRequest?: AddAddressRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AddressApiFp(this.configuration)
      .apiAddressPost(addAddressRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AnimalSpeciesApi - axios parameter creator
 * @export
 */
export const AnimalSpeciesApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AnimalSpecies`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesPost: async (
      upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AnimalSpecies`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertAnimalSpeciesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AnimalSpeciesApi - functional programming interface
 * @export
 */
export const AnimalSpeciesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AnimalSpeciesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAnimalSpeciesGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AnimalSpeciesDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAnimalSpeciesGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AnimalSpeciesApi.apiAnimalSpeciesGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAnimalSpeciesPost(
      upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AnimalSpeciesDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAnimalSpeciesPost(
          upsertAnimalSpeciesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AnimalSpeciesApi.apiAnimalSpeciesPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AnimalSpeciesApi - factory interface
 * @export
 */
export const AnimalSpeciesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AnimalSpeciesApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesGet(options?: any): AxiosPromise<Array<AnimalSpeciesDto>> {
      return localVarFp
        .apiAnimalSpeciesGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesPost(
      upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest,
      options?: any,
    ): AxiosPromise<Array<AnimalSpeciesDto>> {
      return localVarFp
        .apiAnimalSpeciesPost(upsertAnimalSpeciesRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AnimalSpeciesApi - object-oriented interface
 * @export
 * @class AnimalSpeciesApi
 * @extends {BaseAPI}
 */
export class AnimalSpeciesApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnimalSpeciesApi
   */
  public apiAnimalSpeciesGet(options?: RawAxiosRequestConfig) {
    return AnimalSpeciesApiFp(this.configuration)
      .apiAnimalSpeciesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertAnimalSpeciesRequest} [upsertAnimalSpeciesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnimalSpeciesApi
   */
  public apiAnimalSpeciesPost(
    upsertAnimalSpeciesRequest?: UpsertAnimalSpeciesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AnimalSpeciesApiFp(this.configuration)
      .apiAnimalSpeciesPost(upsertAnimalSpeciesRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AnimalSpeciesBreedApi - axios parameter creator
 * @export
 */
export const AnimalSpeciesBreedApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesBreedGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AnimalSpeciesBreed`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesBreedPost: async (
      upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AnimalSpeciesBreed`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertAnimalSpeciesBreedRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AnimalSpeciesBreedApi - functional programming interface
 * @export
 */
export const AnimalSpeciesBreedApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    AnimalSpeciesBreedApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAnimalSpeciesBreedGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AnimalSpeciesBreedDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAnimalSpeciesBreedGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AnimalSpeciesBreedApi.apiAnimalSpeciesBreedGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAnimalSpeciesBreedPost(
      upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AnimalSpeciesBreedDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAnimalSpeciesBreedPost(
          upsertAnimalSpeciesBreedRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AnimalSpeciesBreedApi.apiAnimalSpeciesBreedPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AnimalSpeciesBreedApi - factory interface
 * @export
 */
export const AnimalSpeciesBreedApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AnimalSpeciesBreedApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesBreedGet(
      options?: any,
    ): AxiosPromise<Array<AnimalSpeciesBreedDto>> {
      return localVarFp
        .apiAnimalSpeciesBreedGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAnimalSpeciesBreedPost(
      upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest,
      options?: any,
    ): AxiosPromise<Array<AnimalSpeciesBreedDto>> {
      return localVarFp
        .apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AnimalSpeciesBreedApi - object-oriented interface
 * @export
 * @class AnimalSpeciesBreedApi
 * @extends {BaseAPI}
 */
export class AnimalSpeciesBreedApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnimalSpeciesBreedApi
   */
  public apiAnimalSpeciesBreedGet(options?: RawAxiosRequestConfig) {
    return AnimalSpeciesBreedApiFp(this.configuration)
      .apiAnimalSpeciesBreedGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertAnimalSpeciesBreedRequest} [upsertAnimalSpeciesBreedRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnimalSpeciesBreedApi
   */
  public apiAnimalSpeciesBreedPost(
    upsertAnimalSpeciesBreedRequest?: UpsertAnimalSpeciesBreedRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AnimalSpeciesBreedApiFp(this.configuration)
      .apiAnimalSpeciesBreedPost(upsertAnimalSpeciesBreedRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthCheckGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Auth/check`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthHealthGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Auth/health`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthPingGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Auth/ping`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthStatusGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Auth/status`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthCheckGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthCheckGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AuthApi.apiAuthCheckGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthHealthGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthHealthGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AuthApi.apiAuthHealthGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthPingGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthPingGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AuthApi.apiAuthPingGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthStatusGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthStatusGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['AuthApi.apiAuthStatusGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AuthApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthCheckGet(options?: any): AxiosPromise<boolean> {
      return localVarFp
        .apiAuthCheckGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthHealthGet(options?: any): AxiosPromise<void> {
      return localVarFp
        .apiAuthHealthGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthPingGet(options?: any): AxiosPromise<string> {
      return localVarFp
        .apiAuthPingGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthStatusGet(options?: any): AxiosPromise<void> {
      return localVarFp
        .apiAuthStatusGet(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public apiAuthCheckGet(options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .apiAuthCheckGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public apiAuthHealthGet(options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .apiAuthHealthGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public apiAuthPingGet(options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .apiAuthPingGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public apiAuthStatusGet(options?: RawAxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .apiAuthStatusGet(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AuthorisedRepresentativeApi - axios parameter creator
 * @export
 */
export const AuthorisedRepresentativeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeBulkDelete: async (
      requestBody?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AuthorisedRepresentative/Bulk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeBulkPost: async (
      upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AuthorisedRepresentative/Bulk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertAuthorisedRepresentativesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [authorisedRepresentativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeDelete: async (
      authorisedRepresentativeId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AuthorisedRepresentative`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (authorisedRepresentativeId !== undefined) {
        localVarQueryParameter['authorisedRepresentativeId'] =
          authorisedRepresentativeId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [authorisedRepresentativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeGet: async (
      authorisedRepresentativeId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AuthorisedRepresentative`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (authorisedRepresentativeId !== undefined) {
        localVarQueryParameter['authorisedRepresentativeId'] =
          authorisedRepresentativeId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet:
      async (
        enterpriseId?: number,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        const localVarPath = `/api/AuthorisedRepresentative/GetAuthorisedRepresentativesByEnterpriseId`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: 'GET',
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication X-Organisation-Id required
        await setApiKeyToObject(
          localVarHeaderParameter,
          'X-Organisation-Id',
          configuration,
        );

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          'Authorization',
          configuration,
        );

        if (enterpriseId !== undefined) {
          localVarQueryParameter['enterpriseId'] = enterpriseId;
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
  };
};

/**
 * AuthorisedRepresentativeApi - functional programming interface
 * @export
 */
export const AuthorisedRepresentativeApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    AuthorisedRepresentativeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthorisedRepresentativeBulkDelete(
      requestBody?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthorisedRepresentativeBulkDelete(
          requestBody,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AuthorisedRepresentativeApi.apiAuthorisedRepresentativeBulkDelete'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthorisedRepresentativeBulkPost(
      upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AuthorisedRepresentativeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthorisedRepresentativeBulkPost(
          upsertAuthorisedRepresentativesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AuthorisedRepresentativeApi.apiAuthorisedRepresentativeBulkPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [authorisedRepresentativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthorisedRepresentativeDelete(
      authorisedRepresentativeId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthorisedRepresentativeDelete(
          authorisedRepresentativeId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AuthorisedRepresentativeApi.apiAuthorisedRepresentativeDelete'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [authorisedRepresentativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthorisedRepresentativeGet(
      authorisedRepresentativeId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AuthorisedRepresentativeDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthorisedRepresentativeGet(
          authorisedRepresentativeId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AuthorisedRepresentativeApi.apiAuthorisedRepresentativeGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AuthorisedRepresentativeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AuthorisedRepresentativeApi.apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AuthorisedRepresentativeApi - factory interface
 * @export
 */
export const AuthorisedRepresentativeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AuthorisedRepresentativeApiFp(configuration);
  return {
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeBulkDelete(
      requestBody?: Array<number>,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiAuthorisedRepresentativeBulkDelete(requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeBulkPost(
      upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>,
      options?: any,
    ): AxiosPromise<Array<AuthorisedRepresentativeDto>> {
      return localVarFp
        .apiAuthorisedRepresentativeBulkPost(
          upsertAuthorisedRepresentativesRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [authorisedRepresentativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeDelete(
      authorisedRepresentativeId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiAuthorisedRepresentativeDelete(authorisedRepresentativeId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [authorisedRepresentativeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeGet(
      authorisedRepresentativeId?: number,
      options?: any,
    ): AxiosPromise<AuthorisedRepresentativeDto> {
      return localVarFp
        .apiAuthorisedRepresentativeGet(authorisedRepresentativeId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<Array<AuthorisedRepresentativeDto>> {
      return localVarFp
        .apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(
          enterpriseId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthorisedRepresentativeApi - object-oriented interface
 * @export
 * @class AuthorisedRepresentativeApi
 * @extends {BaseAPI}
 */
export class AuthorisedRepresentativeApi extends BaseAPI {
  /**
   *
   * @param {Array<number>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthorisedRepresentativeApi
   */
  public apiAuthorisedRepresentativeBulkDelete(
    requestBody?: Array<number>,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthorisedRepresentativeApiFp(this.configuration)
      .apiAuthorisedRepresentativeBulkDelete(requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<UpsertAuthorisedRepresentativesRequest>} [upsertAuthorisedRepresentativesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthorisedRepresentativeApi
   */
  public apiAuthorisedRepresentativeBulkPost(
    upsertAuthorisedRepresentativesRequest?: Array<UpsertAuthorisedRepresentativesRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthorisedRepresentativeApiFp(this.configuration)
      .apiAuthorisedRepresentativeBulkPost(
        upsertAuthorisedRepresentativesRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [authorisedRepresentativeId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthorisedRepresentativeApi
   */
  public apiAuthorisedRepresentativeDelete(
    authorisedRepresentativeId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthorisedRepresentativeApiFp(this.configuration)
      .apiAuthorisedRepresentativeDelete(authorisedRepresentativeId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [authorisedRepresentativeId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthorisedRepresentativeApi
   */
  public apiAuthorisedRepresentativeGet(
    authorisedRepresentativeId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthorisedRepresentativeApiFp(this.configuration)
      .apiAuthorisedRepresentativeGet(authorisedRepresentativeId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthorisedRepresentativeApi
   */
  public apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AuthorisedRepresentativeApiFp(this.configuration)
      .apiAuthorisedRepresentativeGetAuthorisedRepresentativesByEnterpriseIdGet(
        enterpriseId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AutoCalculateRuleApi - axios parameter creator
 * @export
 */
export const AutoCalculateRuleApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AutoCalculateRule} [autoCalculateRule]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiAutoCalculateRuleAddRulePost: async (
      autoCalculateRule?: AutoCalculateRule,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AutoCalculateRule/AddRule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        autoCalculateRule,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [autoCalculateRuleId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiAutoCalculateRuleDeleteRuleDelete: async (
      autoCalculateRuleId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AutoCalculateRule/DeleteRule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (autoCalculateRuleId !== undefined) {
        localVarQueryParameter['autoCalculateRuleId'] = autoCalculateRuleId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AutoCalcTriggerRequest} [autoCalcTriggerRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiAutoCalculateRuleEvaluateAutoCalcRulesPost: async (
      autoCalcTriggerRequest?: AutoCalcTriggerRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/AutoCalculateRule/EvaluateAutoCalcRules`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        autoCalcTriggerRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AutoCalculateRuleApi - functional programming interface
 * @export
 */
export const AutoCalculateRuleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    AutoCalculateRuleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AutoCalculateRule} [autoCalculateRule]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiAutoCalculateRuleAddRulePost(
      autoCalculateRule?: AutoCalculateRule,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAutoCalculateRuleAddRulePost(
          autoCalculateRule,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AutoCalculateRuleApi.apiAutoCalculateRuleAddRulePost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [autoCalculateRuleId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiAutoCalculateRuleDeleteRuleDelete(
      autoCalculateRuleId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAutoCalculateRuleDeleteRuleDelete(
          autoCalculateRuleId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AutoCalculateRuleApi.apiAutoCalculateRuleDeleteRuleDelete'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AutoCalcTriggerRequest} [autoCalcTriggerRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiAutoCalculateRuleEvaluateAutoCalcRulesPost(
      autoCalcTriggerRequest?: AutoCalcTriggerRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AutoCalcInstruction>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiAutoCalculateRuleEvaluateAutoCalcRulesPost(
          autoCalcTriggerRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'AutoCalculateRuleApi.apiAutoCalculateRuleEvaluateAutoCalcRulesPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * AutoCalculateRuleApi - factory interface
 * @export
 */
export const AutoCalculateRuleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AutoCalculateRuleApiFp(configuration);
  return {
    /**
     *
     * @param {AutoCalculateRule} [autoCalculateRule]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiAutoCalculateRuleAddRulePost(
      autoCalculateRule?: AutoCalculateRule,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiAutoCalculateRuleAddRulePost(autoCalculateRule, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [autoCalculateRuleId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiAutoCalculateRuleDeleteRuleDelete(
      autoCalculateRuleId?: number,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiAutoCalculateRuleDeleteRuleDelete(autoCalculateRuleId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AutoCalcTriggerRequest} [autoCalcTriggerRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiAutoCalculateRuleEvaluateAutoCalcRulesPost(
      autoCalcTriggerRequest?: AutoCalcTriggerRequest,
      options?: any,
    ): AxiosPromise<Array<AutoCalcInstruction>> {
      return localVarFp
        .apiAutoCalculateRuleEvaluateAutoCalcRulesPost(
          autoCalcTriggerRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AutoCalculateRuleApi - object-oriented interface
 * @export
 * @class AutoCalculateRuleApi
 * @extends {BaseAPI}
 */
export class AutoCalculateRuleApi extends BaseAPI {
  /**
   *
   * @param {AutoCalculateRule} [autoCalculateRule]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AutoCalculateRuleApi
   */
  public apiAutoCalculateRuleAddRulePost(
    autoCalculateRule?: AutoCalculateRule,
    options?: RawAxiosRequestConfig,
  ) {
    return AutoCalculateRuleApiFp(this.configuration)
      .apiAutoCalculateRuleAddRulePost(autoCalculateRule, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [autoCalculateRuleId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AutoCalculateRuleApi
   */
  public apiAutoCalculateRuleDeleteRuleDelete(
    autoCalculateRuleId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AutoCalculateRuleApiFp(this.configuration)
      .apiAutoCalculateRuleDeleteRuleDelete(autoCalculateRuleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AutoCalcTriggerRequest} [autoCalcTriggerRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof AutoCalculateRuleApi
   */
  public apiAutoCalculateRuleEvaluateAutoCalcRulesPost(
    autoCalcTriggerRequest?: AutoCalcTriggerRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AutoCalculateRuleApiFp(this.configuration)
      .apiAutoCalculateRuleEvaluateAutoCalcRulesPost(
        autoCalcTriggerRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BillableEventApi - axios parameter creator
 * @export
 */
export const BillableEventApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} entityId
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityEntityIdGet: async (
      entityId: number,
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityId' is not null or undefined
      assertParamExists('entityEntityIdGet', 'entityId', entityId);
      const localVarPath = `/entity/{entityId}`.replace(
        `{${'entityId'}}`,
        encodeURIComponent(String(entityId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitySearchPost: async (
      searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/entity/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchBillableEventsByEntityRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BillableEventApi - functional programming interface
 * @export
 */
export const BillableEventApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    BillableEventApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} entityId
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entityEntityIdGet(
      entityId: number,
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<BillableEventDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.entityEntityIdGet(
          entityId,
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BillableEventApi.entityEntityIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entitySearchPost(
      searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BillableEventDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.entitySearchPost(
          searchBillableEventsByEntityRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['BillableEventApi.entitySearchPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * BillableEventApi - factory interface
 * @export
 */
export const BillableEventApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BillableEventApiFp(configuration);
  return {
    /**
     *
     * @param {number} entityId
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entityEntityIdGet(
      entityId: number,
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<BillableEventDto>> {
      return localVarFp
        .entityEntityIdGet(entityId, organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitySearchPost(
      searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest,
      options?: any,
    ): AxiosPromise<BillableEventDtoPagedResult> {
      return localVarFp
        .entitySearchPost(searchBillableEventsByEntityRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * BillableEventApi - object-oriented interface
 * @export
 * @class BillableEventApi
 * @extends {BaseAPI}
 */
export class BillableEventApi extends BaseAPI {
  /**
   *
   * @param {number} entityId
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillableEventApi
   */
  public entityEntityIdGet(
    entityId: number,
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return BillableEventApiFp(this.configuration)
      .entityEntityIdGet(entityId, organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SearchBillableEventsByEntityRequest} [searchBillableEventsByEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BillableEventApi
   */
  public entitySearchPost(
    searchBillableEventsByEntityRequest?: SearchBillableEventsByEntityRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return BillableEventApiFp(this.configuration)
      .entitySearchPost(searchBillableEventsByEntityRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * CustomFieldApi - axios parameter creator
 * @export
 */
export const CustomFieldApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AddCustomFieldRequest} [addCustomFieldRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFieldAddCustomFieldPost: async (
      addCustomFieldRequest?: AddCustomFieldRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomField/AddCustomField`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addCustomFieldRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [customFieldGuid]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFieldDelete: async (
      customFieldGuid?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomField`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (customFieldGuid !== undefined) {
        localVarQueryParameter['customFieldGuid'] = customFieldGuid;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateCustomFieldRequest} [updateCustomFieldRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFieldUpdateCustomFieldPost: async (
      updateCustomFieldRequest?: UpdateCustomFieldRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomField/UpdateCustomField`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateCustomFieldRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CustomFieldApi - functional programming interface
 * @export
 */
export const CustomFieldApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    CustomFieldApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AddCustomFieldRequest} [addCustomFieldRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFieldAddCustomFieldPost(
      addCustomFieldRequest?: AddCustomFieldRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFieldAddCustomFieldPost(
          addCustomFieldRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['CustomFieldApi.apiCustomFieldAddCustomFieldPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [customFieldGuid]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFieldDelete(
      customFieldGuid?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFieldDelete(
          customFieldGuid,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['CustomFieldApi.apiCustomFieldDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateCustomFieldRequest} [updateCustomFieldRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFieldUpdateCustomFieldPost(
      updateCustomFieldRequest?: UpdateCustomFieldRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFieldUpdateCustomFieldPost(
          updateCustomFieldRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'CustomFieldApi.apiCustomFieldUpdateCustomFieldPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * CustomFieldApi - factory interface
 * @export
 */
export const CustomFieldApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CustomFieldApiFp(configuration);
  return {
    /**
     *
     * @param {AddCustomFieldRequest} [addCustomFieldRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFieldAddCustomFieldPost(
      addCustomFieldRequest?: AddCustomFieldRequest,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .apiCustomFieldAddCustomFieldPost(addCustomFieldRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [customFieldGuid]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFieldDelete(
      customFieldGuid?: string,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiCustomFieldDelete(customFieldGuid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateCustomFieldRequest} [updateCustomFieldRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFieldUpdateCustomFieldPost(
      updateCustomFieldRequest?: UpdateCustomFieldRequest,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .apiCustomFieldUpdateCustomFieldPost(updateCustomFieldRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CustomFieldApi - object-oriented interface
 * @export
 * @class CustomFieldApi
 * @extends {BaseAPI}
 */
export class CustomFieldApi extends BaseAPI {
  /**
   *
   * @param {AddCustomFieldRequest} [addCustomFieldRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFieldApi
   */
  public apiCustomFieldAddCustomFieldPost(
    addCustomFieldRequest?: AddCustomFieldRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFieldApiFp(this.configuration)
      .apiCustomFieldAddCustomFieldPost(addCustomFieldRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [customFieldGuid]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFieldApi
   */
  public apiCustomFieldDelete(
    customFieldGuid?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFieldApiFp(this.configuration)
      .apiCustomFieldDelete(customFieldGuid, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateCustomFieldRequest} [updateCustomFieldRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFieldApi
   */
  public apiCustomFieldUpdateCustomFieldPost(
    updateCustomFieldRequest?: UpdateCustomFieldRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFieldApiFp(this.configuration)
      .apiCustomFieldUpdateCustomFieldPost(updateCustomFieldRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * CustomFormApi - axios parameter creator
 * @export
 */
export const CustomFormApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {CreateCustomFormRequest} [createCustomFormRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormAddCustomFormPost: async (
      createCustomFormRequest?: CreateCustomFormRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomForm/AddCustomForm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createCustomFormRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ReadCustomFormFieldsJsonRequest} [readCustomFormFieldsJsonRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormReadCustomFormForEntityPost: async (
      readCustomFormFieldsJsonRequest?: ReadCustomFormFieldsJsonRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomForm/ReadCustomFormForEntity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        readCustomFormFieldsJsonRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SetCustomFormFieldsRequest} [setCustomFormFieldsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormSetCustomFormFieldsPost: async (
      setCustomFormFieldsRequest?: SetCustomFormFieldsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomForm/SetCustomFormFields`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        setCustomFormFieldsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertCustomFormFieldValuesRequest} [upsertCustomFormFieldValuesRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormUpsertCustomFormFieldValuesPatch: async (
      upsertCustomFormFieldValuesRequest?: UpsertCustomFormFieldValuesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomForm/UpsertCustomFormFieldValues`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertCustomFormFieldValuesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertCustomFormFieldsRequest} [upsertCustomFormFieldsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormUpsertCustomFormFieldsPost: async (
      upsertCustomFormFieldsRequest?: UpsertCustomFormFieldsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CustomForm/UpsertCustomFormFields`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertCustomFormFieldsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CustomFormApi - functional programming interface
 * @export
 */
export const CustomFormApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    CustomFormApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CreateCustomFormRequest} [createCustomFormRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFormAddCustomFormPost(
      createCustomFormRequest?: CreateCustomFormRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFormAddCustomFormPost(
          createCustomFormRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['CustomFormApi.apiCustomFormAddCustomFormPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {ReadCustomFormFieldsJsonRequest} [readCustomFormFieldsJsonRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFormReadCustomFormForEntityPost(
      readCustomFormFieldsJsonRequest?: ReadCustomFormFieldsJsonRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFormReadCustomFormForEntityPost(
          readCustomFormFieldsJsonRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'CustomFormApi.apiCustomFormReadCustomFormForEntityPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SetCustomFormFieldsRequest} [setCustomFormFieldsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFormSetCustomFormFieldsPost(
      setCustomFormFieldsRequest?: SetCustomFormFieldsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFormSetCustomFormFieldsPost(
          setCustomFormFieldsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'CustomFormApi.apiCustomFormSetCustomFormFieldsPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertCustomFormFieldValuesRequest} [upsertCustomFormFieldValuesRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFormUpsertCustomFormFieldValuesPatch(
      upsertCustomFormFieldValuesRequest?: UpsertCustomFormFieldValuesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFormUpsertCustomFormFieldValuesPatch(
          upsertCustomFormFieldValuesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'CustomFormApi.apiCustomFormUpsertCustomFormFieldValuesPatch'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertCustomFormFieldsRequest} [upsertCustomFormFieldsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiCustomFormUpsertCustomFormFieldsPost(
      upsertCustomFormFieldsRequest?: UpsertCustomFormFieldsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCustomFormUpsertCustomFormFieldsPost(
          upsertCustomFormFieldsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'CustomFormApi.apiCustomFormUpsertCustomFormFieldsPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * CustomFormApi - factory interface
 * @export
 */
export const CustomFormApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = CustomFormApiFp(configuration);
  return {
    /**
     *
     * @param {CreateCustomFormRequest} [createCustomFormRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormAddCustomFormPost(
      createCustomFormRequest?: CreateCustomFormRequest,
      options?: any,
    ): AxiosPromise<CustomFormDto> {
      return localVarFp
        .apiCustomFormAddCustomFormPost(createCustomFormRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReadCustomFormFieldsJsonRequest} [readCustomFormFieldsJsonRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormReadCustomFormForEntityPost(
      readCustomFormFieldsJsonRequest?: ReadCustomFormFieldsJsonRequest,
      options?: any,
    ): AxiosPromise<CustomFormDto> {
      return localVarFp
        .apiCustomFormReadCustomFormForEntityPost(
          readCustomFormFieldsJsonRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SetCustomFormFieldsRequest} [setCustomFormFieldsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormSetCustomFormFieldsPost(
      setCustomFormFieldsRequest?: SetCustomFormFieldsRequest,
      options?: any,
    ): AxiosPromise<CustomFormDto> {
      return localVarFp
        .apiCustomFormSetCustomFormFieldsPost(
          setCustomFormFieldsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertCustomFormFieldValuesRequest} [upsertCustomFormFieldValuesRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormUpsertCustomFormFieldValuesPatch(
      upsertCustomFormFieldValuesRequest?: UpsertCustomFormFieldValuesRequest,
      options?: any,
    ): AxiosPromise<CustomFormDto> {
      return localVarFp
        .apiCustomFormUpsertCustomFormFieldValuesPatch(
          upsertCustomFormFieldValuesRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertCustomFormFieldsRequest} [upsertCustomFormFieldsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiCustomFormUpsertCustomFormFieldsPost(
      upsertCustomFormFieldsRequest?: UpsertCustomFormFieldsRequest,
      options?: any,
    ): AxiosPromise<CustomFormDto> {
      return localVarFp
        .apiCustomFormUpsertCustomFormFieldsPost(
          upsertCustomFormFieldsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CustomFormApi - object-oriented interface
 * @export
 * @class CustomFormApi
 * @extends {BaseAPI}
 */
export class CustomFormApi extends BaseAPI {
  /**
   *
   * @param {CreateCustomFormRequest} [createCustomFormRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFormApi
   */
  public apiCustomFormAddCustomFormPost(
    createCustomFormRequest?: CreateCustomFormRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFormApiFp(this.configuration)
      .apiCustomFormAddCustomFormPost(createCustomFormRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReadCustomFormFieldsJsonRequest} [readCustomFormFieldsJsonRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFormApi
   */
  public apiCustomFormReadCustomFormForEntityPost(
    readCustomFormFieldsJsonRequest?: ReadCustomFormFieldsJsonRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFormApiFp(this.configuration)
      .apiCustomFormReadCustomFormForEntityPost(
        readCustomFormFieldsJsonRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SetCustomFormFieldsRequest} [setCustomFormFieldsRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFormApi
   */
  public apiCustomFormSetCustomFormFieldsPost(
    setCustomFormFieldsRequest?: SetCustomFormFieldsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFormApiFp(this.configuration)
      .apiCustomFormSetCustomFormFieldsPost(setCustomFormFieldsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertCustomFormFieldValuesRequest} [upsertCustomFormFieldValuesRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFormApi
   */
  public apiCustomFormUpsertCustomFormFieldValuesPatch(
    upsertCustomFormFieldValuesRequest?: UpsertCustomFormFieldValuesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFormApiFp(this.configuration)
      .apiCustomFormUpsertCustomFormFieldValuesPatch(
        upsertCustomFormFieldValuesRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertCustomFormFieldsRequest} [upsertCustomFormFieldsRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof CustomFormApi
   */
  public apiCustomFormUpsertCustomFormFieldsPost(
    upsertCustomFormFieldsRequest?: UpsertCustomFormFieldsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return CustomFormApiFp(this.configuration)
      .apiCustomFormUpsertCustomFormFieldsPost(
        upsertCustomFormFieldsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentBulkUploadPost: async (
      bulkUploadDocumentRequest?: BulkUploadDocumentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/bulk-upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bulkUploadDocumentRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [documentId]
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {DocumentTypeCode} [documentType]
     * @param {number} [x]
     * @param {number} [y]
     * @param {number} [width]
     * @param {number} [height]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentCroppedPost: async (
      documentId?: number,
      entityId?: string,
      entityType?: EntityTypeCode,
      documentType?: DocumentTypeCode,
      x?: number,
      y?: number,
      width?: number,
      height?: number,
      file?: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/cropped`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (documentId !== undefined) {
        localVarQueryParameter['DocumentId'] = documentId;
      }

      if (entityId !== undefined) {
        localVarQueryParameter['EntityId'] = entityId;
      }

      if (entityType !== undefined) {
        localVarQueryParameter['EntityType'] = entityType;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['DocumentType'] = documentType;
      }

      if (x !== undefined) {
        localVarQueryParameter['X'] = x;
      }

      if (y !== undefined) {
        localVarQueryParameter['Y'] = y;
      }

      if (width !== undefined) {
        localVarQueryParameter['Width'] = width;
      }

      if (height !== undefined) {
        localVarQueryParameter['Height'] = height;
      }

      if (file !== undefined) {
        localVarFormParams.append('File', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [documentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentDelete: async (
      documentId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (documentId !== undefined) {
        localVarQueryParameter['documentId'] = documentId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentDocumentIdSetPrimaryPut: async (
      documentId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        'apiDocumentDocumentIdSetPrimaryPut',
        'documentId',
        documentId,
      );
      const localVarPath = `/api/Document/{documentId}/set-primary`.replace(
        `{${'documentId'}}`,
        encodeURIComponent(String(documentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [documentEntityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGet: async (
      documentEntityId?: string,
      documentType?: DocumentTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (documentEntityId !== undefined) {
        localVarQueryParameter['documentEntityId'] = documentEntityId;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['documentType'] = documentType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetAllImagesForAnimalGet: async (
      entityId?: number,
      documentType?: DocumentTypeCode,
      size?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/GetAllImagesForAnimal`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['documentType'] = documentType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<number>} [entityIds]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {boolean} [isPrimary]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetAnimalImageByEntityIdGet: async (
      entityIds?: Array<number>,
      documentType?: DocumentTypeCode,
      size?: string,
      isPrimary?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/GetAnimalImageByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityIds) {
        localVarQueryParameter['entityIds'] = entityIds;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['documentType'] = documentType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (isPrimary !== undefined) {
        localVarQueryParameter['isPrimary'] = isPrimary;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetDocumentsByEntityIdGet: async (
      entityId?: string,
      documentType?: DocumentTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/GetDocumentsByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['documentType'] = documentType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImageByEntityIdGet: async (
      entityId?: string,
      documentType?: DocumentTypeCode,
      size?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/GetImageByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['documentType'] = documentType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [documentEntityId]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImageGet: async (
      documentEntityId?: string,
      size?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/GetImage`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (documentEntityId !== undefined) {
        localVarQueryParameter['documentEntityId'] = documentEntityId;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImagesByEntityIdGet: async (
      entityId?: string,
      documentType?: DocumentTypeCode,
      size?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/GetImagesByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['documentType'] = documentType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {boolean} [isPrimary]
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImagesByEntityIdsPost: async (
      documentType?: DocumentTypeCode,
      size?: string,
      isPrimary?: boolean,
      requestBody?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/GetImagesByEntityIds`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (documentType !== undefined) {
        localVarQueryParameter['documentType'] = documentType;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (isPrimary !== undefined) {
        localVarQueryParameter['isPrimary'] = isPrimary;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentMainUploadPost: async (
      singleUploadDocumentRequest?: SingleUploadDocumentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/main-upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        singleUploadDocumentRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [currentPage]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentPagedGet: async (
      currentPage?: number,
      pageSize?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/Paged`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (currentPage !== undefined) {
        localVarQueryParameter['CurrentPage'] = currentPage;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [documentId]
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {DocumentTypeCode} [documentType]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentPost: async (
      documentId?: number,
      entityId?: string,
      entityType?: EntityTypeCode,
      documentType?: DocumentTypeCode,
      file?: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (documentId !== undefined) {
        localVarQueryParameter['DocumentId'] = documentId;
      }

      if (entityId !== undefined) {
        localVarQueryParameter['EntityId'] = entityId;
      }

      if (entityType !== undefined) {
        localVarQueryParameter['EntityType'] = entityType;
      }

      if (documentType !== undefined) {
        localVarQueryParameter['DocumentType'] = documentType;
      }

      if (file !== undefined) {
        localVarFormParams.append('File', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DocumentTypeCode} [documentType]
     * @param {DocumentSourceType} [sourceType]
     * @param {string} [folderName]
     * @param {boolean} [shouldCheckSameNameExist]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentTemporaryUploadPost: async (
      documentType?: DocumentTypeCode,
      sourceType?: DocumentSourceType,
      folderName?: string,
      shouldCheckSameNameExist?: boolean,
      file?: File,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Document/temporary-upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (documentType !== undefined) {
        localVarQueryParameter['DocumentType'] = documentType;
      }

      if (sourceType !== undefined) {
        localVarQueryParameter['SourceType'] = sourceType;
      }

      if (folderName !== undefined) {
        localVarQueryParameter['FolderName'] = folderName;
      }

      if (shouldCheckSameNameExist !== undefined) {
        localVarQueryParameter['ShouldCheckSameNameExist'] =
          shouldCheckSameNameExist;
      }

      if (file !== undefined) {
        localVarFormParams.append('File', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentBulkUploadPost(
      bulkUploadDocumentRequest?: BulkUploadDocumentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentBulkUploadPost(
          bulkUploadDocumentRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentBulkUploadPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [documentId]
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {DocumentTypeCode} [documentType]
     * @param {number} [x]
     * @param {number} [y]
     * @param {number} [width]
     * @param {number} [height]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentCroppedPost(
      documentId?: number,
      entityId?: string,
      entityType?: EntityTypeCode,
      documentType?: DocumentTypeCode,
      x?: number,
      y?: number,
      width?: number,
      height?: number,
      file?: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentCroppedPost(
          documentId,
          entityId,
          entityType,
          documentType,
          x,
          y,
          width,
          height,
          file,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentCroppedPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [documentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentDelete(
      documentId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentDelete(documentId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentDocumentIdSetPrimaryPut(
      documentId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentDocumentIdSetPrimaryPut(
          documentId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentDocumentIdSetPrimaryPut']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [documentEntityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGet(
      documentEntityId?: string,
      documentType?: DocumentTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentGet(
        documentEntityId,
        documentType,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGetAllImagesForAnimalGet(
      entityId?: number,
      documentType?: DocumentTypeCode,
      size?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentGetAllImagesForAnimalGet(
          entityId,
          documentType,
          size,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentGetAllImagesForAnimalGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Array<number>} [entityIds]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {boolean} [isPrimary]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGetAnimalImageByEntityIdGet(
      entityIds?: Array<number>,
      documentType?: DocumentTypeCode,
      size?: string,
      isPrimary?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentGetAnimalImageByEntityIdGet(
          entityIds,
          documentType,
          size,
          isPrimary,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'DocumentApi.apiDocumentGetAnimalImageByEntityIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGetDocumentsByEntityIdGet(
      entityId?: string,
      documentType?: DocumentTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentGetDocumentsByEntityIdGet(
          entityId,
          documentType,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'DocumentApi.apiDocumentGetDocumentsByEntityIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGetImageByEntityIdGet(
      entityId?: string,
      documentType?: DocumentTypeCode,
      size?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentGetImageByEntityIdGet(
          entityId,
          documentType,
          size,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentGetImageByEntityIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [documentEntityId]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGetImageGet(
      documentEntityId?: string,
      size?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentGetImageGet(
          documentEntityId,
          size,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentGetImageGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGetImagesByEntityIdGet(
      entityId?: string,
      documentType?: DocumentTypeCode,
      size?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentGetImagesByEntityIdGet(
          entityId,
          documentType,
          size,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentGetImagesByEntityIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {boolean} [isPrimary]
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentGetImagesByEntityIdsPost(
      documentType?: DocumentTypeCode,
      size?: string,
      isPrimary?: boolean,
      requestBody?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentGetImagesByEntityIdsPost(
          documentType,
          size,
          isPrimary,
          requestBody,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentGetImagesByEntityIdsPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentMainUploadPost(
      singleUploadDocumentRequest?: SingleUploadDocumentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentMainUploadPost(
          singleUploadDocumentRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentMainUploadPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [currentPage]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentPagedGet(
      currentPage?: number,
      pageSize?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<DocumentPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentPagedGet(
          currentPage,
          pageSize,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentPagedGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [documentId]
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {DocumentTypeCode} [documentType]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentPost(
      documentId?: number,
      entityId?: string,
      entityType?: EntityTypeCode,
      documentType?: DocumentTypeCode,
      file?: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentPost(
        documentId,
        entityId,
        entityType,
        documentType,
        file,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {DocumentTypeCode} [documentType]
     * @param {DocumentSourceType} [sourceType]
     * @param {string} [folderName]
     * @param {boolean} [shouldCheckSameNameExist]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiDocumentTemporaryUploadPost(
      documentType?: DocumentTypeCode,
      sourceType?: DocumentSourceType,
      folderName?: string,
      shouldCheckSameNameExist?: boolean,
      file?: File,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiDocumentTemporaryUploadPost(
          documentType,
          sourceType,
          folderName,
          shouldCheckSameNameExist,
          file,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['DocumentApi.apiDocumentTemporaryUploadPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DocumentApiFp(configuration);
  return {
    /**
     *
     * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentBulkUploadPost(
      bulkUploadDocumentRequest?: BulkUploadDocumentRequest,
      options?: any,
    ): AxiosPromise<Array<DocumentDto>> {
      return localVarFp
        .apiDocumentBulkUploadPost(bulkUploadDocumentRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [documentId]
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {DocumentTypeCode} [documentType]
     * @param {number} [x]
     * @param {number} [y]
     * @param {number} [width]
     * @param {number} [height]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentCroppedPost(
      documentId?: number,
      entityId?: string,
      entityType?: EntityTypeCode,
      documentType?: DocumentTypeCode,
      x?: number,
      y?: number,
      width?: number,
      height?: number,
      file?: File,
      options?: any,
    ): AxiosPromise<DocumentDto> {
      return localVarFp
        .apiDocumentCroppedPost(
          documentId,
          entityId,
          entityType,
          documentType,
          x,
          y,
          width,
          height,
          file,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [documentId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentDelete(
      documentId?: number,
      options?: any,
    ): AxiosPromise<DocumentDto> {
      return localVarFp
        .apiDocumentDelete(documentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} documentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentDocumentIdSetPrimaryPut(
      documentId: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiDocumentDocumentIdSetPrimaryPut(documentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [documentEntityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGet(
      documentEntityId?: string,
      documentType?: DocumentTypeCode,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .apiDocumentGet(documentEntityId, documentType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetAllImagesForAnimalGet(
      entityId?: number,
      documentType?: DocumentTypeCode,
      size?: string,
      options?: any,
    ): AxiosPromise<Array<DocumentDto>> {
      return localVarFp
        .apiDocumentGetAllImagesForAnimalGet(
          entityId,
          documentType,
          size,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<number>} [entityIds]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {boolean} [isPrimary]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetAnimalImageByEntityIdGet(
      entityIds?: Array<number>,
      documentType?: DocumentTypeCode,
      size?: string,
      isPrimary?: boolean,
      options?: any,
    ): AxiosPromise<Array<DocumentDto>> {
      return localVarFp
        .apiDocumentGetAnimalImageByEntityIdGet(
          entityIds,
          documentType,
          size,
          isPrimary,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetDocumentsByEntityIdGet(
      entityId?: string,
      documentType?: DocumentTypeCode,
      options?: any,
    ): AxiosPromise<Array<DocumentDto>> {
      return localVarFp
        .apiDocumentGetDocumentsByEntityIdGet(entityId, documentType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImageByEntityIdGet(
      entityId?: string,
      documentType?: DocumentTypeCode,
      size?: string,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .apiDocumentGetImageByEntityIdGet(entityId, documentType, size, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [documentEntityId]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImageGet(
      documentEntityId?: string,
      size?: string,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .apiDocumentGetImageGet(documentEntityId, size, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [entityId]
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImagesByEntityIdGet(
      entityId?: string,
      documentType?: DocumentTypeCode,
      size?: string,
      options?: any,
    ): AxiosPromise<Array<DocumentDto>> {
      return localVarFp
        .apiDocumentGetImagesByEntityIdGet(
          entityId,
          documentType,
          size,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DocumentTypeCode} [documentType]
     * @param {string} [size]
     * @param {boolean} [isPrimary]
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentGetImagesByEntityIdsPost(
      documentType?: DocumentTypeCode,
      size?: string,
      isPrimary?: boolean,
      requestBody?: Array<string>,
      options?: any,
    ): AxiosPromise<Array<DocumentDto>> {
      return localVarFp
        .apiDocumentGetImagesByEntityIdsPost(
          documentType,
          size,
          isPrimary,
          requestBody,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentMainUploadPost(
      singleUploadDocumentRequest?: SingleUploadDocumentRequest,
      options?: any,
    ): AxiosPromise<DocumentDto> {
      return localVarFp
        .apiDocumentMainUploadPost(singleUploadDocumentRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [currentPage]
     * @param {number} [pageSize]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentPagedGet(
      currentPage?: number,
      pageSize?: number,
      options?: any,
    ): AxiosPromise<DocumentPagedResult> {
      return localVarFp
        .apiDocumentPagedGet(currentPage, pageSize, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [documentId]
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {DocumentTypeCode} [documentType]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentPost(
      documentId?: number,
      entityId?: string,
      entityType?: EntityTypeCode,
      documentType?: DocumentTypeCode,
      file?: File,
      options?: any,
    ): AxiosPromise<DocumentDto> {
      return localVarFp
        .apiDocumentPost(
          documentId,
          entityId,
          entityType,
          documentType,
          file,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DocumentTypeCode} [documentType]
     * @param {DocumentSourceType} [sourceType]
     * @param {string} [folderName]
     * @param {boolean} [shouldCheckSameNameExist]
     * @param {File} [file]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiDocumentTemporaryUploadPost(
      documentType?: DocumentTypeCode,
      sourceType?: DocumentSourceType,
      folderName?: string,
      shouldCheckSameNameExist?: boolean,
      file?: File,
      options?: any,
    ): AxiosPromise<DocumentDto> {
      return localVarFp
        .apiDocumentTemporaryUploadPost(
          documentType,
          sourceType,
          folderName,
          shouldCheckSameNameExist,
          file,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
  /**
   *
   * @param {BulkUploadDocumentRequest} [bulkUploadDocumentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentBulkUploadPost(
    bulkUploadDocumentRequest?: BulkUploadDocumentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentBulkUploadPost(bulkUploadDocumentRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [documentId]
   * @param {string} [entityId]
   * @param {EntityTypeCode} [entityType]
   * @param {DocumentTypeCode} [documentType]
   * @param {number} [x]
   * @param {number} [y]
   * @param {number} [width]
   * @param {number} [height]
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentCroppedPost(
    documentId?: number,
    entityId?: string,
    entityType?: EntityTypeCode,
    documentType?: DocumentTypeCode,
    x?: number,
    y?: number,
    width?: number,
    height?: number,
    file?: File,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentCroppedPost(
        documentId,
        entityId,
        entityType,
        documentType,
        x,
        y,
        width,
        height,
        file,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [documentId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentDelete(
    documentId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentDelete(documentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} documentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentDocumentIdSetPrimaryPut(
    documentId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentDocumentIdSetPrimaryPut(documentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [documentEntityId]
   * @param {DocumentTypeCode} [documentType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGet(
    documentEntityId?: string,
    documentType?: DocumentTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGet(documentEntityId, documentType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [entityId]
   * @param {DocumentTypeCode} [documentType]
   * @param {string} [size]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGetAllImagesForAnimalGet(
    entityId?: number,
    documentType?: DocumentTypeCode,
    size?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGetAllImagesForAnimalGet(
        entityId,
        documentType,
        size,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<number>} [entityIds]
   * @param {DocumentTypeCode} [documentType]
   * @param {string} [size]
   * @param {boolean} [isPrimary]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGetAnimalImageByEntityIdGet(
    entityIds?: Array<number>,
    documentType?: DocumentTypeCode,
    size?: string,
    isPrimary?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGetAnimalImageByEntityIdGet(
        entityIds,
        documentType,
        size,
        isPrimary,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [entityId]
   * @param {DocumentTypeCode} [documentType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGetDocumentsByEntityIdGet(
    entityId?: string,
    documentType?: DocumentTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGetDocumentsByEntityIdGet(entityId, documentType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [entityId]
   * @param {DocumentTypeCode} [documentType]
   * @param {string} [size]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGetImageByEntityIdGet(
    entityId?: string,
    documentType?: DocumentTypeCode,
    size?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGetImageByEntityIdGet(entityId, documentType, size, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [documentEntityId]
   * @param {string} [size]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGetImageGet(
    documentEntityId?: string,
    size?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGetImageGet(documentEntityId, size, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [entityId]
   * @param {DocumentTypeCode} [documentType]
   * @param {string} [size]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGetImagesByEntityIdGet(
    entityId?: string,
    documentType?: DocumentTypeCode,
    size?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGetImagesByEntityIdGet(entityId, documentType, size, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DocumentTypeCode} [documentType]
   * @param {string} [size]
   * @param {boolean} [isPrimary]
   * @param {Array<string>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentGetImagesByEntityIdsPost(
    documentType?: DocumentTypeCode,
    size?: string,
    isPrimary?: boolean,
    requestBody?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentGetImagesByEntityIdsPost(
        documentType,
        size,
        isPrimary,
        requestBody,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SingleUploadDocumentRequest} [singleUploadDocumentRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentMainUploadPost(
    singleUploadDocumentRequest?: SingleUploadDocumentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentMainUploadPost(singleUploadDocumentRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [currentPage]
   * @param {number} [pageSize]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentPagedGet(
    currentPage?: number,
    pageSize?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentPagedGet(currentPage, pageSize, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [documentId]
   * @param {string} [entityId]
   * @param {EntityTypeCode} [entityType]
   * @param {DocumentTypeCode} [documentType]
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentPost(
    documentId?: number,
    entityId?: string,
    entityType?: EntityTypeCode,
    documentType?: DocumentTypeCode,
    file?: File,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentPost(
        documentId,
        entityId,
        entityType,
        documentType,
        file,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DocumentTypeCode} [documentType]
   * @param {DocumentSourceType} [sourceType]
   * @param {string} [folderName]
   * @param {boolean} [shouldCheckSameNameExist]
   * @param {File} [file]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public apiDocumentTemporaryUploadPost(
    documentType?: DocumentTypeCode,
    sourceType?: DocumentSourceType,
    folderName?: string,
    shouldCheckSameNameExist?: boolean,
    file?: File,
    options?: RawAxiosRequestConfig,
  ) {
    return DocumentApiFp(this.configuration)
      .apiDocumentTemporaryUploadPost(
        documentType,
        sourceType,
        folderName,
        shouldCheckSameNameExist,
        file,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EnterpriseApi - axios parameter creator
 * @export
 */
export const EnterpriseApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [body]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseAcceptConstitutionPatch: async (
      body?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/AcceptConstitution`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BulkUpdateMembershipStatusCodeRequest} [bulkUpdateMembershipStatusCodeRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseBulkUpdateMembershipStatusCodePatch: async (
      bulkUpdateMembershipStatusCodeRequest?: BulkUpdateMembershipStatusCodeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/BulkUpdateMembershipStatusCode`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bulkUpdateMembershipStatusCodeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseCheckValidIdentForOrganisationPost: async (
      checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/CheckValidIdentForOrganisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkValidIdentForOrganisationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseDelete: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGet: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetByUserIdGet: async (
      userId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/GetByUserId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterpriseByGuidGet: async (
      id?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/GetEnterpriseByGuid`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterprisesByIdGet: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/GetEnterprisesById`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} paginationCurrentPage
     * @param {number} paginationPageSize
     * @param {number} [organisationId]
     * @param {MembershipStatusCode} [membershipStatus]
     * @param {string} [membershipType]
     * @param {string} [membershipSince]
     * @param {string} [keyword]
     * @param {boolean} [isStudBook]
     * @param {number} [sortInputEntityDetailId]
     * @param {string} [sortInputEntityDetailName]
     * @param {SortDirectionOrder} [sortInputSortDirection]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterprisesByOrganisationIdGet: async (
      paginationCurrentPage: number,
      paginationPageSize: number,
      organisationId?: number,
      membershipStatus?: MembershipStatusCode,
      membershipType?: string,
      membershipSince?: string,
      keyword?: string,
      isStudBook?: boolean,
      sortInputEntityDetailId?: number,
      sortInputEntityDetailName?: string,
      sortInputSortDirection?: SortDirectionOrder,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'paginationCurrentPage' is not null or undefined
      assertParamExists(
        'apiEnterpriseGetEnterprisesByOrganisationIdGet',
        'paginationCurrentPage',
        paginationCurrentPage,
      );
      // verify required parameter 'paginationPageSize' is not null or undefined
      assertParamExists(
        'apiEnterpriseGetEnterprisesByOrganisationIdGet',
        'paginationPageSize',
        paginationPageSize,
      );
      const localVarPath = `/api/Enterprise/GetEnterprisesByOrganisationId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      if (paginationCurrentPage !== undefined) {
        localVarQueryParameter['Pagination.CurrentPage'] =
          paginationCurrentPage;
      }

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['Pagination.PageSize'] = paginationPageSize;
      }

      if (membershipStatus !== undefined) {
        localVarQueryParameter['MembershipStatus'] = membershipStatus;
      }

      if (membershipType !== undefined) {
        localVarQueryParameter['MembershipType'] = membershipType;
      }

      if (membershipSince !== undefined) {
        localVarQueryParameter['MembershipSince'] = membershipSince;
      }

      if (keyword !== undefined) {
        localVarQueryParameter['Keyword'] = keyword;
      }

      if (isStudBook !== undefined) {
        localVarQueryParameter['IsStudBook'] = isStudBook;
      }

      if (sortInputEntityDetailId !== undefined) {
        localVarQueryParameter['SortInput.EntityDetailId'] =
          sortInputEntityDetailId;
      }

      if (sortInputEntityDetailName !== undefined) {
        localVarQueryParameter['SortInput.EntityDetailName'] =
          sortInputEntityDetailName;
      }

      if (sortInputSortDirection !== undefined) {
        localVarQueryParameter['SortInput.SortDirection'] =
          sortInputSortDirection;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterprisesPendingByUserIdGet: async (
      userId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/GetEnterprisesPendingByUserId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {string} [name]
     * @param {number} [orgId]
     * @param {number} [entityDetailId]
     * @param {string} [entityDetailName]
     * @param {SortDirectionOrder} [sortDirection]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseSearchEnterprisesGet: async (
      currentPage: number,
      pageSize: number,
      name?: string,
      orgId?: number,
      entityDetailId?: number,
      entityDetailName?: string,
      sortDirection?: SortDirectionOrder,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'currentPage' is not null or undefined
      assertParamExists(
        'apiEnterpriseSearchEnterprisesGet',
        'currentPage',
        currentPage,
      );
      // verify required parameter 'pageSize' is not null or undefined
      assertParamExists(
        'apiEnterpriseSearchEnterprisesGet',
        'pageSize',
        pageSize,
      );
      const localVarPath = `/api/Enterprise/SearchEnterprises`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (name !== undefined) {
        localVarQueryParameter['name'] = name;
      }

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (currentPage !== undefined) {
        localVarQueryParameter['CurrentPage'] = currentPage;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
      }

      if (entityDetailId !== undefined) {
        localVarQueryParameter['EntityDetailId'] = entityDetailId;
      }

      if (entityDetailName !== undefined) {
        localVarQueryParameter['EntityDetailName'] = entityDetailName;
      }

      if (sortDirection !== undefined) {
        localVarQueryParameter['SortDirection'] = sortDirection;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateEnterpriseNotificationRequest} [updateEnterpriseNotificationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseUpdateEnterpriseNotificationPatch: async (
      updateEnterpriseNotificationRequest?: UpdateEnterpriseNotificationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/UpdateEnterpriseNotification`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateEnterpriseNotificationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEnterpriseRequest} [upsertEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseUpsertEnterprisesPost: async (
      upsertEnterpriseRequest?: UpsertEnterpriseRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Enterprise/UpsertEnterprises`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEnterpriseRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EnterpriseApi - functional programming interface
 * @export
 */
export const EnterpriseApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EnterpriseApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [body]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseAcceptConstitutionPatch(
      body?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseAcceptConstitutionPatch(
          body,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseAcceptConstitutionPatch'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {BulkUpdateMembershipStatusCodeRequest} [bulkUpdateMembershipStatusCodeRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseBulkUpdateMembershipStatusCodePatch(
      bulkUpdateMembershipStatusCodeRequest?: BulkUpdateMembershipStatusCodeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EnterpriseDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseBulkUpdateMembershipStatusCodePatch(
          bulkUpdateMembershipStatusCodeRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseBulkUpdateMembershipStatusCodePatch'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseCheckValidIdentForOrganisationPost(
      checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseCheckValidIdentForOrganisationPost(
          checkValidIdentForOrganisationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseCheckValidIdentForOrganisationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseDelete(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseDelete(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EnterpriseApi.apiEnterpriseDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseGet(enterpriseId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EnterpriseApi.apiEnterpriseGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseGetByUserIdGet(
      userId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EnterpriseDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseGetByUserIdGet(
          userId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EnterpriseApi.apiEnterpriseGetByUserIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseGetEnterpriseByGuidGet(
      id?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EnterpriseDtoResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseGetEnterpriseByGuidGet(
          id,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseGetEnterpriseByGuidGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseGetEnterprisesByIdGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseGetEnterprisesByIdGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseGetEnterprisesByIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} paginationCurrentPage
     * @param {number} paginationPageSize
     * @param {number} [organisationId]
     * @param {MembershipStatusCode} [membershipStatus]
     * @param {string} [membershipType]
     * @param {string} [membershipSince]
     * @param {string} [keyword]
     * @param {boolean} [isStudBook]
     * @param {number} [sortInputEntityDetailId]
     * @param {string} [sortInputEntityDetailName]
     * @param {SortDirectionOrder} [sortInputSortDirection]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseGetEnterprisesByOrganisationIdGet(
      paginationCurrentPage: number,
      paginationPageSize: number,
      organisationId?: number,
      membershipStatus?: MembershipStatusCode,
      membershipType?: string,
      membershipSince?: string,
      keyword?: string,
      isStudBook?: boolean,
      sortInputEntityDetailId?: number,
      sortInputEntityDetailName?: string,
      sortInputSortDirection?: SortDirectionOrder,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EnterpriseDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseGetEnterprisesByOrganisationIdGet(
          paginationCurrentPage,
          paginationPageSize,
          organisationId,
          membershipStatus,
          membershipType,
          membershipSince,
          keyword,
          isStudBook,
          sortInputEntityDetailId,
          sortInputEntityDetailName,
          sortInputSortDirection,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseGetEnterprisesByOrganisationIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseGetEnterprisesPendingByUserIdGet(
      userId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EnterpriseDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseGetEnterprisesPendingByUserIdGet(
          userId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseGetEnterprisesPendingByUserIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {string} [name]
     * @param {number} [orgId]
     * @param {number} [entityDetailId]
     * @param {string} [entityDetailName]
     * @param {SortDirectionOrder} [sortDirection]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseSearchEnterprisesGet(
      currentPage: number,
      pageSize: number,
      name?: string,
      orgId?: number,
      entityDetailId?: number,
      entityDetailName?: string,
      sortDirection?: SortDirectionOrder,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EnterpriseDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseSearchEnterprisesGet(
          currentPage,
          pageSize,
          name,
          orgId,
          entityDetailId,
          entityDetailName,
          sortDirection,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EnterpriseApi.apiEnterpriseSearchEnterprisesGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateEnterpriseNotificationRequest} [updateEnterpriseNotificationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseUpdateEnterpriseNotificationPatch(
      updateEnterpriseNotificationRequest?: UpdateEnterpriseNotificationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseUpdateEnterpriseNotificationPatch(
          updateEnterpriseNotificationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseUpdateEnterpriseNotificationPatch'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEnterpriseRequest} [upsertEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseUpsertEnterprisesPost(
      upsertEnterpriseRequest?: UpsertEnterpriseRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EnterpriseDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseUpsertEnterprisesPost(
          upsertEnterpriseRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterpriseApi.apiEnterpriseUpsertEnterprisesPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EnterpriseApi - factory interface
 * @export
 */
export const EnterpriseApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EnterpriseApiFp(configuration);
  return {
    /**
     *
     * @param {number} [body]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseAcceptConstitutionPatch(
      body?: number,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiEnterpriseAcceptConstitutionPatch(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BulkUpdateMembershipStatusCodeRequest} [bulkUpdateMembershipStatusCodeRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseBulkUpdateMembershipStatusCodePatch(
      bulkUpdateMembershipStatusCodeRequest?: BulkUpdateMembershipStatusCodeRequest,
      options?: any,
    ): AxiosPromise<Array<EnterpriseDto>> {
      return localVarFp
        .apiEnterpriseBulkUpdateMembershipStatusCodePatch(
          bulkUpdateMembershipStatusCodeRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseCheckValidIdentForOrganisationPost(
      checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEnterpriseCheckValidIdentForOrganisationPost(
          checkValidIdentForOrganisationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseDelete(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiEnterpriseDelete(enterpriseId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<EnterpriseDto> {
      return localVarFp
        .apiEnterpriseGet(enterpriseId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetByUserIdGet(
      userId?: number,
      options?: any,
    ): AxiosPromise<Array<EnterpriseDto>> {
      return localVarFp
        .apiEnterpriseGetByUserIdGet(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterpriseByGuidGet(
      id?: string,
      options?: any,
    ): AxiosPromise<EnterpriseDtoResult> {
      return localVarFp
        .apiEnterpriseGetEnterpriseByGuidGet(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterprisesByIdGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<EnterpriseDto> {
      return localVarFp
        .apiEnterpriseGetEnterprisesByIdGet(enterpriseId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} paginationCurrentPage
     * @param {number} paginationPageSize
     * @param {number} [organisationId]
     * @param {MembershipStatusCode} [membershipStatus]
     * @param {string} [membershipType]
     * @param {string} [membershipSince]
     * @param {string} [keyword]
     * @param {boolean} [isStudBook]
     * @param {number} [sortInputEntityDetailId]
     * @param {string} [sortInputEntityDetailName]
     * @param {SortDirectionOrder} [sortInputSortDirection]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterprisesByOrganisationIdGet(
      paginationCurrentPage: number,
      paginationPageSize: number,
      organisationId?: number,
      membershipStatus?: MembershipStatusCode,
      membershipType?: string,
      membershipSince?: string,
      keyword?: string,
      isStudBook?: boolean,
      sortInputEntityDetailId?: number,
      sortInputEntityDetailName?: string,
      sortInputSortDirection?: SortDirectionOrder,
      options?: any,
    ): AxiosPromise<EnterpriseDtoPagedResult> {
      return localVarFp
        .apiEnterpriseGetEnterprisesByOrganisationIdGet(
          paginationCurrentPage,
          paginationPageSize,
          organisationId,
          membershipStatus,
          membershipType,
          membershipSince,
          keyword,
          isStudBook,
          sortInputEntityDetailId,
          sortInputEntityDetailName,
          sortInputSortDirection,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseGetEnterprisesPendingByUserIdGet(
      userId?: number,
      options?: any,
    ): AxiosPromise<Array<EnterpriseDto>> {
      return localVarFp
        .apiEnterpriseGetEnterprisesPendingByUserIdGet(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {string} [name]
     * @param {number} [orgId]
     * @param {number} [entityDetailId]
     * @param {string} [entityDetailName]
     * @param {SortDirectionOrder} [sortDirection]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseSearchEnterprisesGet(
      currentPage: number,
      pageSize: number,
      name?: string,
      orgId?: number,
      entityDetailId?: number,
      entityDetailName?: string,
      sortDirection?: SortDirectionOrder,
      options?: any,
    ): AxiosPromise<Array<EnterpriseDto>> {
      return localVarFp
        .apiEnterpriseSearchEnterprisesGet(
          currentPage,
          pageSize,
          name,
          orgId,
          entityDetailId,
          entityDetailName,
          sortDirection,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateEnterpriseNotificationRequest} [updateEnterpriseNotificationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseUpdateEnterpriseNotificationPatch(
      updateEnterpriseNotificationRequest?: UpdateEnterpriseNotificationRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiEnterpriseUpdateEnterpriseNotificationPatch(
          updateEnterpriseNotificationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEnterpriseRequest} [upsertEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseUpsertEnterprisesPost(
      upsertEnterpriseRequest?: UpsertEnterpriseRequest,
      options?: any,
    ): AxiosPromise<EnterpriseDto> {
      return localVarFp
        .apiEnterpriseUpsertEnterprisesPost(upsertEnterpriseRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EnterpriseApi - object-oriented interface
 * @export
 * @class EnterpriseApi
 * @extends {BaseAPI}
 */
export class EnterpriseApi extends BaseAPI {
  /**
   *
   * @param {number} [body]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseAcceptConstitutionPatch(
    body?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseAcceptConstitutionPatch(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BulkUpdateMembershipStatusCodeRequest} [bulkUpdateMembershipStatusCodeRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseBulkUpdateMembershipStatusCodePatch(
    bulkUpdateMembershipStatusCodeRequest?: BulkUpdateMembershipStatusCodeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseBulkUpdateMembershipStatusCodePatch(
        bulkUpdateMembershipStatusCodeRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseCheckValidIdentForOrganisationPost(
    checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseCheckValidIdentForOrganisationPost(
        checkValidIdentForOrganisationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseDelete(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseDelete(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseGet(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [userId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseGetByUserIdGet(
    userId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseGetByUserIdGet(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [id]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseGetEnterpriseByGuidGet(
    id?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseGetEnterpriseByGuidGet(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseGetEnterprisesByIdGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseGetEnterprisesByIdGet(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} paginationCurrentPage
   * @param {number} paginationPageSize
   * @param {number} [organisationId]
   * @param {MembershipStatusCode} [membershipStatus]
   * @param {string} [membershipType]
   * @param {string} [membershipSince]
   * @param {string} [keyword]
   * @param {boolean} [isStudBook]
   * @param {number} [sortInputEntityDetailId]
   * @param {string} [sortInputEntityDetailName]
   * @param {SortDirectionOrder} [sortInputSortDirection]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseGetEnterprisesByOrganisationIdGet(
    paginationCurrentPage: number,
    paginationPageSize: number,
    organisationId?: number,
    membershipStatus?: MembershipStatusCode,
    membershipType?: string,
    membershipSince?: string,
    keyword?: string,
    isStudBook?: boolean,
    sortInputEntityDetailId?: number,
    sortInputEntityDetailName?: string,
    sortInputSortDirection?: SortDirectionOrder,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseGetEnterprisesByOrganisationIdGet(
        paginationCurrentPage,
        paginationPageSize,
        organisationId,
        membershipStatus,
        membershipType,
        membershipSince,
        keyword,
        isStudBook,
        sortInputEntityDetailId,
        sortInputEntityDetailName,
        sortInputSortDirection,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [userId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseGetEnterprisesPendingByUserIdGet(
    userId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseGetEnterprisesPendingByUserIdGet(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} currentPage
   * @param {number} pageSize
   * @param {string} [name]
   * @param {number} [orgId]
   * @param {number} [entityDetailId]
   * @param {string} [entityDetailName]
   * @param {SortDirectionOrder} [sortDirection]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseSearchEnterprisesGet(
    currentPage: number,
    pageSize: number,
    name?: string,
    orgId?: number,
    entityDetailId?: number,
    entityDetailName?: string,
    sortDirection?: SortDirectionOrder,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseSearchEnterprisesGet(
        currentPage,
        pageSize,
        name,
        orgId,
        entityDetailId,
        entityDetailName,
        sortDirection,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateEnterpriseNotificationRequest} [updateEnterpriseNotificationRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseUpdateEnterpriseNotificationPatch(
    updateEnterpriseNotificationRequest?: UpdateEnterpriseNotificationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseUpdateEnterpriseNotificationPatch(
        updateEnterpriseNotificationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEnterpriseRequest} [upsertEnterpriseRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseApi
   */
  public apiEnterpriseUpsertEnterprisesPost(
    upsertEnterpriseRequest?: UpsertEnterpriseRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseApiFp(this.configuration)
      .apiEnterpriseUpsertEnterprisesPost(upsertEnterpriseRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EnterpriseActionApi - axios parameter creator
 * @export
 */
export const EnterpriseActionApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseActionGet: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EnterpriseAction`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEnterpriseActionRequest} [upsertEnterpriseActionRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseActionPost: async (
      upsertEnterpriseActionRequest?: UpsertEnterpriseActionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EnterpriseAction`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEnterpriseActionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EnterpriseActionApi - functional programming interface
 * @export
 */
export const EnterpriseActionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EnterpriseActionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseActionGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EnterpriseActionDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseActionGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EnterpriseActionApi.apiEnterpriseActionGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEnterpriseActionRequest} [upsertEnterpriseActionRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterpriseActionPost(
      upsertEnterpriseActionRequest?: UpsertEnterpriseActionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EnterpriseActionDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterpriseActionPost(
          upsertEnterpriseActionRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EnterpriseActionApi.apiEnterpriseActionPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EnterpriseActionApi - factory interface
 * @export
 */
export const EnterpriseActionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EnterpriseActionApiFp(configuration);
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseActionGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<Array<EnterpriseActionDto>> {
      return localVarFp
        .apiEnterpriseActionGet(enterpriseId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEnterpriseActionRequest} [upsertEnterpriseActionRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterpriseActionPost(
      upsertEnterpriseActionRequest?: UpsertEnterpriseActionRequest,
      options?: any,
    ): AxiosPromise<EnterpriseActionDto> {
      return localVarFp
        .apiEnterpriseActionPost(upsertEnterpriseActionRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EnterpriseActionApi - object-oriented interface
 * @export
 * @class EnterpriseActionApi
 * @extends {BaseAPI}
 */
export class EnterpriseActionApi extends BaseAPI {
  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseActionApi
   */
  public apiEnterpriseActionGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseActionApiFp(this.configuration)
      .apiEnterpriseActionGet(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEnterpriseActionRequest} [upsertEnterpriseActionRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterpriseActionApi
   */
  public apiEnterpriseActionPost(
    upsertEnterpriseActionRequest?: UpsertEnterpriseActionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterpriseActionApiFp(this.configuration)
      .apiEnterpriseActionPost(upsertEnterpriseActionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EnterprisePrefixApi - axios parameter creator
 * @export
 */
export const EnterprisePrefixApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {CheckPrefixExistsForEnterpriseRequest} [checkPrefixExistsForEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixCheckPrefixExistsForEnterprisePost: async (
      checkPrefixExistsForEnterpriseRequest?: CheckPrefixExistsForEnterpriseRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EnterprisePrefix/CheckPrefixExistsForEnterprise`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkPrefixExistsForEnterpriseRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixCheckValidPrefixForOrganisationPost: async (
      checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EnterprisePrefix/CheckValidPrefixForOrganisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkValidPrefixForOrganisationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixGet: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EnterprisePrefix`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SetEnterprisePrefixesRequest} [setEnterprisePrefixesRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixSetEnterprisePrefixesPost: async (
      setEnterprisePrefixesRequest?: SetEnterprisePrefixesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EnterprisePrefix/SetEnterprisePrefixes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        setEnterprisePrefixesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EnterprisePrefixApi - functional programming interface
 * @export
 */
export const EnterprisePrefixApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EnterprisePrefixApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {CheckPrefixExistsForEnterpriseRequest} [checkPrefixExistsForEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterprisePrefixCheckPrefixExistsForEnterprisePost(
      checkPrefixExistsForEnterpriseRequest?: CheckPrefixExistsForEnterpriseRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterprisePrefixCheckPrefixExistsForEnterprisePost(
          checkPrefixExistsForEnterpriseRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterprisePrefixApi.apiEnterprisePrefixCheckPrefixExistsForEnterprisePost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterprisePrefixCheckValidPrefixForOrganisationPost(
      checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterprisePrefixCheckValidPrefixForOrganisationPost(
          checkValidPrefixForOrganisationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterprisePrefixApi.apiEnterprisePrefixCheckValidPrefixForOrganisationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterprisePrefixGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EnterprisePrefixDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterprisePrefixGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EnterprisePrefixApi.apiEnterprisePrefixGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SetEnterprisePrefixesRequest} [setEnterprisePrefixesRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiEnterprisePrefixSetEnterprisePrefixesPost(
      setEnterprisePrefixesRequest?: SetEnterprisePrefixesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EnterprisePrefixDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEnterprisePrefixSetEnterprisePrefixesPost(
          setEnterprisePrefixesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EnterprisePrefixApi.apiEnterprisePrefixSetEnterprisePrefixesPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EnterprisePrefixApi - factory interface
 * @export
 */
export const EnterprisePrefixApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EnterprisePrefixApiFp(configuration);
  return {
    /**
     *
     * @param {CheckPrefixExistsForEnterpriseRequest} [checkPrefixExistsForEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixCheckPrefixExistsForEnterprisePost(
      checkPrefixExistsForEnterpriseRequest?: CheckPrefixExistsForEnterpriseRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEnterprisePrefixCheckPrefixExistsForEnterprisePost(
          checkPrefixExistsForEnterpriseRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixCheckValidPrefixForOrganisationPost(
      checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEnterprisePrefixCheckValidPrefixForOrganisationPost(
          checkValidPrefixForOrganisationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<Array<EnterprisePrefixDto>> {
      return localVarFp
        .apiEnterprisePrefixGet(enterpriseId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SetEnterprisePrefixesRequest} [setEnterprisePrefixesRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiEnterprisePrefixSetEnterprisePrefixesPost(
      setEnterprisePrefixesRequest?: SetEnterprisePrefixesRequest,
      options?: any,
    ): AxiosPromise<Array<EnterprisePrefixDto>> {
      return localVarFp
        .apiEnterprisePrefixSetEnterprisePrefixesPost(
          setEnterprisePrefixesRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EnterprisePrefixApi - object-oriented interface
 * @export
 * @class EnterprisePrefixApi
 * @extends {BaseAPI}
 */
export class EnterprisePrefixApi extends BaseAPI {
  /**
   *
   * @param {CheckPrefixExistsForEnterpriseRequest} [checkPrefixExistsForEnterpriseRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterprisePrefixApi
   */
  public apiEnterprisePrefixCheckPrefixExistsForEnterprisePost(
    checkPrefixExistsForEnterpriseRequest?: CheckPrefixExistsForEnterpriseRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterprisePrefixApiFp(this.configuration)
      .apiEnterprisePrefixCheckPrefixExistsForEnterprisePost(
        checkPrefixExistsForEnterpriseRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterprisePrefixApi
   */
  public apiEnterprisePrefixCheckValidPrefixForOrganisationPost(
    checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterprisePrefixApiFp(this.configuration)
      .apiEnterprisePrefixCheckValidPrefixForOrganisationPost(
        checkValidPrefixForOrganisationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterprisePrefixApi
   */
  public apiEnterprisePrefixGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterprisePrefixApiFp(this.configuration)
      .apiEnterprisePrefixGet(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SetEnterprisePrefixesRequest} [setEnterprisePrefixesRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof EnterprisePrefixApi
   */
  public apiEnterprisePrefixSetEnterprisePrefixesPost(
    setEnterprisePrefixesRequest?: SetEnterprisePrefixesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EnterprisePrefixApiFp(this.configuration)
      .apiEnterprisePrefixSetEnterprisePrefixesPost(
        setEnterprisePrefixesRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityApi - axios parameter creator
 * @export
 */
export const EntityApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityApprovePost: async (
      entityId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/Approve`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BulkDisposeRequest} [bulkDisposeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityBulkDisposeAnimalsPost: async (
      bulkDisposeRequest?: BulkDisposeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/BulkDisposeAnimals`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bulkDisposeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityCheckValidIdentForOrganisationPost: async (
      checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/CheckValidIdentForOrganisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkValidIdentForOrganisationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityCheckValidPrefixForOrganisationPost: async (
      checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/CheckValidPrefixForOrganisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkValidPrefixForOrganisationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityCleanEntityDetailValuesPost: async (
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/clean-entity-detail-values`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      if (entityTypeCode !== undefined) {
        localVarQueryParameter['entityTypeCode'] = entityTypeCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDelete: async (
      entityId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [orgId]
     * @param {string} [keyType]
     * @param {string} [uniqueKey]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityEntityResolverGet: async (
      orgId?: string,
      keyType?: string,
      uniqueKey?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/EntityResolver`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (keyType !== undefined) {
        localVarQueryParameter['keyType'] = keyType;
      }

      if (uniqueKey !== undefined) {
        localVarQueryParameter['uniqueKey'] = uniqueKey;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [entityId]
     * @param {number} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGenerateAnimalIdentGet: async (
      entityId?: number,
      orgId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/GenerateAnimalIdent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GenerateCertificateRequest} [generateCertificateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGenerateCertificatePost: async (
      generateCertificateRequest?: GenerateCertificateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/generate-certificate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateCertificateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetAllEntitiesWithPaginationGet: async (
      currentPage: number,
      pageSize: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'currentPage' is not null or undefined
      assertParamExists(
        'apiEntityGetAllEntitiesWithPaginationGet',
        'currentPage',
        currentPage,
      );
      // verify required parameter 'pageSize' is not null or undefined
      assertParamExists(
        'apiEntityGetAllEntitiesWithPaginationGet',
        'pageSize',
        pageSize,
      );
      const localVarPath = `/api/Entity/GetAllEntitiesWithPagination`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (currentPage !== undefined) {
        localVarQueryParameter['CurrentPage'] = currentPage;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetAnimalProgenyPost: async (
      getAnimalProgenyRequest?: GetAnimalProgenyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/GetAnimalProgeny`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getAnimalProgenyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetDetailsByEntityIdGet: async (
      entityId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/get-details-by-entity-id`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByEntityGuidsPost: async (
      requestBody?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/GetEntityByEntityGuids`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByEntityIdGet: async (
      entityId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/GetEntityByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByGuidGet: async (
      id?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/GetEntityByGuid`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByOrgIdGet: async (
      currentPage: number,
      pageSize: number,
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'currentPage' is not null or undefined
      assertParamExists(
        'apiEntityGetEntityByOrgIdGet',
        'currentPage',
        currentPage,
      );
      // verify required parameter 'pageSize' is not null or undefined
      assertParamExists('apiEntityGetEntityByOrgIdGet', 'pageSize', pageSize);
      const localVarPath = `/api/Entity/GetEntityByOrgId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (currentPage !== undefined) {
        localVarQueryParameter['CurrentPage'] = currentPage;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
      }

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      if (entityTypeCode !== undefined) {
        localVarQueryParameter['entityTypeCode'] = entityTypeCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityFilterByDetailPost: async (
      entityFilterByDetailRequest?: EntityFilterByDetailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/GetEntityFilterByDetail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        entityFilterByDetailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [entityGuidId]
     * @param {number} [maxGeneration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetPedigreeGet: async (
      entityGuidId?: string,
      maxGeneration?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/GetPedigree`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityGuidId !== undefined) {
        localVarQueryParameter['entityGuidId'] = entityGuidId;
      }

      if (maxGeneration !== undefined) {
        localVarQueryParameter['maxGeneration'] = maxGeneration;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityLinkOptionsByEntityDetailPost: async (
      linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/link-options-by-entity-detail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        linkOptionsByEntityDetailsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityMemberMembershipsPut: async (
      updateMemberMembershipRequest?: UpdateMemberMembershipRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/member/memberships`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMemberMembershipRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityRequest} [upsertEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityPost: async (
      upsertEntityRequest?: UpsertEntityRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {QuickSearchRequest} [quickSearchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityQuickSearchPost: async (
      quickSearchRequest?: QuickSearchRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/quick-search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        quickSearchRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SearchByOrgIdRequest} [searchByOrgIdRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntitySearchByOrgIdPost: async (
      searchByOrgIdRequest?: SearchByOrgIdRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/SearchByOrgId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchByOrgIdRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntitySearchEntityByDetailPost: async (
      searchEntityByDetailRequest?: SearchEntityByDetailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/SearchEntityByDetail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchEntityByDetailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {BulkSuspendEnterpriseRequest} [bulkSuspendEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntitySuspendEnterprisesPatch: async (
      bulkSuspendEnterpriseRequest?: BulkSuspendEnterpriseRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/SuspendEnterprises`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        bulkSuspendEnterpriseRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityUpsertDetailValuesPost: async (
      upsertDetailValuesRequest?: UpsertDetailValuesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/UpsertDetailValues`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertDetailValuesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityUpsertEntityWithDetailPost: async (
      upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Entity/UpsertEntityWithDetail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityWithDetailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityApi - functional programming interface
 * @export
 */
export const EntityApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EntityApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityApprovePost(
      entityId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityApprovePost(entityId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityApprovePost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {BulkDisposeRequest} [bulkDisposeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityBulkDisposeAnimalsPost(
      bulkDisposeRequest?: BulkDisposeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BulkDisposeResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityBulkDisposeAnimalsPost(
          bulkDisposeRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityBulkDisposeAnimalsPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityCheckValidIdentForOrganisationPost(
      checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityCheckValidIdentForOrganisationPost(
          checkValidIdentForOrganisationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityApi.apiEntityCheckValidIdentForOrganisationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityCheckValidPrefixForOrganisationPost(
      checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityCheckValidPrefixForOrganisationPost(
          checkValidPrefixForOrganisationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityApi.apiEntityCheckValidPrefixForOrganisationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityCleanEntityDetailValuesPost(
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityCleanEntityDetailValuesPost(
          organisationId,
          entityTypeCode,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityCleanEntityDetailValuesPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDelete(
      entityId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityDelete(
        entityId,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [orgId]
     * @param {string} [keyType]
     * @param {string} [uniqueKey]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityEntityResolverGet(
      orgId?: string,
      keyType?: string,
      uniqueKey?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityEntityResolverGet(
          orgId,
          keyType,
          uniqueKey,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityEntityResolverGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [entityId]
     * @param {number} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGenerateAnimalIdentGet(
      entityId?: number,
      orgId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGenerateAnimalIdentGet(
          entityId,
          orgId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGenerateAnimalIdentGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GenerateCertificateRequest} [generateCertificateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGenerateCertificatePost(
      generateCertificateRequest?: GenerateCertificateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGenerateCertificatePost(
          generateCertificateRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGenerateCertificatePost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetAllEntitiesWithPaginationGet(
      currentPage: number,
      pageSize: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetAllEntitiesWithPaginationGet(
          currentPage,
          pageSize,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityApi.apiEntityGetAllEntitiesWithPaginationGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetAnimalProgenyPost(
      getAnimalProgenyRequest?: GetAnimalProgenyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetAnimalProgenyPost(
          getAnimalProgenyRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetAnimalProgenyPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetDetailsByEntityIdGet(
      entityId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetDetailsByEntityIdGet(
          entityId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetDetailsByEntityIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetEntityByEntityGuidsPost(
      requestBody?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetEntityByEntityGuidsPost(
          requestBody,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetEntityByEntityGuidsPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetEntityByEntityIdGet(
      entityId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetEntityByEntityIdGet(
          entityId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetEntityByEntityIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetEntityByGuidGet(
      id?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetEntityByGuidGet(
          id,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetEntityByGuidGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetEntityByOrgIdGet(
      currentPage: number,
      pageSize: number,
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetEntityByOrgIdGet(
          currentPage,
          pageSize,
          organisationId,
          entityTypeCode,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetEntityByOrgIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetEntityFilterByDetailPost(
      entityFilterByDetailRequest?: EntityFilterByDetailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetEntityFilterByDetailPost(
          entityFilterByDetailRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetEntityFilterByDetailPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [entityGuidId]
     * @param {number} [maxGeneration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityGetPedigreeGet(
      entityGuidId?: string,
      maxGeneration?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PedigreeNodeDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityGetPedigreeGet(
          entityGuidId,
          maxGeneration,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityGetPedigreeGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityLinkOptionsByEntityDetailPost(
      linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<LinkOptionsByEntityDetailsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityLinkOptionsByEntityDetailPost(
          linkOptionsByEntityDetailsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityApi.apiEntityLinkOptionsByEntityDetailPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityMemberMembershipsPut(
      updateMemberMembershipRequest?: UpdateMemberMembershipRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityMemberMembershipsPut(
          updateMemberMembershipRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityMemberMembershipsPut']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityRequest} [upsertEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityPost(
      upsertEntityRequest?: UpsertEntityRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiEntityPost(
        upsertEntityRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {QuickSearchRequest} [quickSearchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityQuickSearchPost(
      quickSearchRequest?: QuickSearchRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityQuickSearchPost(
          quickSearchRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityQuickSearchPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SearchByOrgIdRequest} [searchByOrgIdRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntitySearchByOrgIdPost(
      searchByOrgIdRequest?: SearchByOrgIdRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntitySearchByOrgIdPost(
          searchByOrgIdRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntitySearchByOrgIdPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntitySearchEntityByDetailPost(
      searchEntityByDetailRequest?: SearchEntityByDetailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntitySearchEntityByDetailPost(
          searchEntityByDetailRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntitySearchEntityByDetailPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {BulkSuspendEnterpriseRequest} [bulkSuspendEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntitySuspendEnterprisesPatch(
      bulkSuspendEnterpriseRequest?: BulkSuspendEnterpriseRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntitySuspendEnterprisesPatch(
          bulkSuspendEnterpriseRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntitySuspendEnterprisesPatch']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityUpsertDetailValuesPost(
      upsertDetailValuesRequest?: UpsertDetailValuesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityUpsertDetailValuesPost(
          upsertDetailValuesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityUpsertDetailValuesPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityUpsertEntityWithDetailPost(
      upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityUpsertEntityWithDetailPost(
          upsertEntityWithDetailRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityApi.apiEntityUpsertEntityWithDetailPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityApi - factory interface
 * @export
 */
export const EntityApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityApiFp(configuration);
  return {
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityApprovePost(
      entityId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityApprovePost(entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BulkDisposeRequest} [bulkDisposeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityBulkDisposeAnimalsPost(
      bulkDisposeRequest?: BulkDisposeRequest,
      options?: any,
    ): AxiosPromise<BulkDisposeResultDto> {
      return localVarFp
        .apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityCheckValidIdentForOrganisationPost(
      checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityCheckValidIdentForOrganisationPost(
          checkValidIdentForOrganisationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityCheckValidPrefixForOrganisationPost(
      checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityCheckValidPrefixForOrganisationPost(
          checkValidPrefixForOrganisationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityCleanEntityDetailValuesPost(
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityCleanEntityDetailValuesPost(
          organisationId,
          entityTypeCode,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDelete(entityId?: number, options?: any): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityDelete(entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [orgId]
     * @param {string} [keyType]
     * @param {string} [uniqueKey]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityEntityResolverGet(
      orgId?: string,
      keyType?: string,
      uniqueKey?: string,
      options?: any,
    ): AxiosPromise<string> {
      return localVarFp
        .apiEntityEntityResolverGet(orgId, keyType, uniqueKey, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [entityId]
     * @param {number} [orgId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGenerateAnimalIdentGet(
      entityId?: number,
      orgId?: number,
      options?: any,
    ): AxiosPromise<EntityDto> {
      return localVarFp
        .apiEntityGenerateAnimalIdentGet(entityId, orgId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GenerateCertificateRequest} [generateCertificateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGenerateCertificatePost(
      generateCertificateRequest?: GenerateCertificateRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiEntityGenerateCertificatePost(generateCertificateRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetAllEntitiesWithPaginationGet(
      currentPage: number,
      pageSize: number,
      options?: any,
    ): AxiosPromise<EntityDtoPagedResult> {
      return localVarFp
        .apiEntityGetAllEntitiesWithPaginationGet(
          currentPage,
          pageSize,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetAnimalProgenyPost(
      getAnimalProgenyRequest?: GetAnimalProgenyRequest,
      options?: any,
    ): AxiosPromise<EntityDtoPagedResult> {
      return localVarFp
        .apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetDetailsByEntityIdGet(
      entityId?: number,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiEntityGetDetailsByEntityIdGet(entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<string>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByEntityGuidsPost(
      requestBody?: Array<string>,
      options?: any,
    ): AxiosPromise<Array<EntityDto>> {
      return localVarFp
        .apiEntityGetEntityByEntityGuidsPost(requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByEntityIdGet(
      entityId?: number,
      options?: any,
    ): AxiosPromise<EntityDto> {
      return localVarFp
        .apiEntityGetEntityByEntityIdGet(entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByGuidGet(
      id?: string,
      options?: any,
    ): AxiosPromise<EntityDto> {
      return localVarFp
        .apiEntityGetEntityByGuidGet(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityByOrgIdGet(
      currentPage: number,
      pageSize: number,
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      options?: any,
    ): AxiosPromise<EntityDtoPagedResult> {
      return localVarFp
        .apiEntityGetEntityByOrgIdGet(
          currentPage,
          pageSize,
          organisationId,
          entityTypeCode,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetEntityFilterByDetailPost(
      entityFilterByDetailRequest?: EntityFilterByDetailRequest,
      options?: any,
    ): AxiosPromise<EntityDtoPagedResult> {
      return localVarFp
        .apiEntityGetEntityFilterByDetailPost(
          entityFilterByDetailRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [entityGuidId]
     * @param {number} [maxGeneration]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityGetPedigreeGet(
      entityGuidId?: string,
      maxGeneration?: number,
      options?: any,
    ): AxiosPromise<PedigreeNodeDto> {
      return localVarFp
        .apiEntityGetPedigreeGet(entityGuidId, maxGeneration, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityLinkOptionsByEntityDetailPost(
      linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest,
      options?: any,
    ): AxiosPromise<LinkOptionsByEntityDetailsResponse> {
      return localVarFp
        .apiEntityLinkOptionsByEntityDetailPost(
          linkOptionsByEntityDetailsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityMemberMembershipsPut(
      updateMemberMembershipRequest?: UpdateMemberMembershipRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityMemberMembershipsPut(updateMemberMembershipRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityRequest} [upsertEntityRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityPost(
      upsertEntityRequest?: UpsertEntityRequest,
      options?: any,
    ): AxiosPromise<EntityDto> {
      return localVarFp
        .apiEntityPost(upsertEntityRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QuickSearchRequest} [quickSearchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityQuickSearchPost(
      quickSearchRequest?: QuickSearchRequest,
      options?: any,
    ): AxiosPromise<EntityDtoPagedResult> {
      return localVarFp
        .apiEntityQuickSearchPost(quickSearchRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SearchByOrgIdRequest} [searchByOrgIdRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntitySearchByOrgIdPost(
      searchByOrgIdRequest?: SearchByOrgIdRequest,
      options?: any,
    ): AxiosPromise<EntityDtoPagedResult> {
      return localVarFp
        .apiEntitySearchByOrgIdPost(searchByOrgIdRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntitySearchEntityByDetailPost(
      searchEntityByDetailRequest?: SearchEntityByDetailRequest,
      options?: any,
    ): AxiosPromise<EntityDtoPagedResult> {
      return localVarFp
        .apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {BulkSuspendEnterpriseRequest} [bulkSuspendEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntitySuspendEnterprisesPatch(
      bulkSuspendEnterpriseRequest?: BulkSuspendEnterpriseRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntitySuspendEnterprisesPatch(bulkSuspendEnterpriseRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityUpsertDetailValuesPost(
      upsertDetailValuesRequest?: UpsertDetailValuesRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityUpsertEntityWithDetailPost(
      upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest,
      options?: any,
    ): AxiosPromise<EntityDto> {
      return localVarFp
        .apiEntityUpsertEntityWithDetailPost(
          upsertEntityWithDetailRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityApi - object-oriented interface
 * @export
 * @class EntityApi
 * @extends {BaseAPI}
 */
export class EntityApi extends BaseAPI {
  /**
   *
   * @param {number} [entityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityApprovePost(
    entityId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityApprovePost(entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BulkDisposeRequest} [bulkDisposeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityBulkDisposeAnimalsPost(
    bulkDisposeRequest?: BulkDisposeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityBulkDisposeAnimalsPost(bulkDisposeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CheckValidIdentForOrganisationRequest} [checkValidIdentForOrganisationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityCheckValidIdentForOrganisationPost(
    checkValidIdentForOrganisationRequest?: CheckValidIdentForOrganisationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityCheckValidIdentForOrganisationPost(
        checkValidIdentForOrganisationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CheckValidPrefixForOrganisationRequest} [checkValidPrefixForOrganisationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityCheckValidPrefixForOrganisationPost(
    checkValidPrefixForOrganisationRequest?: CheckValidPrefixForOrganisationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityCheckValidPrefixForOrganisationPost(
        checkValidPrefixForOrganisationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {EntityTypeCode} [entityTypeCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityCleanEntityDetailValuesPost(
    organisationId?: number,
    entityTypeCode?: EntityTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityCleanEntityDetailValuesPost(
        organisationId,
        entityTypeCode,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [entityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityDelete(entityId?: number, options?: RawAxiosRequestConfig) {
    return EntityApiFp(this.configuration)
      .apiEntityDelete(entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [orgId]
   * @param {string} [keyType]
   * @param {string} [uniqueKey]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityEntityResolverGet(
    orgId?: string,
    keyType?: string,
    uniqueKey?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityEntityResolverGet(orgId, keyType, uniqueKey, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [entityId]
   * @param {number} [orgId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGenerateAnimalIdentGet(
    entityId?: number,
    orgId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGenerateAnimalIdentGet(entityId, orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GenerateCertificateRequest} [generateCertificateRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGenerateCertificatePost(
    generateCertificateRequest?: GenerateCertificateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGenerateCertificatePost(generateCertificateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} currentPage
   * @param {number} pageSize
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetAllEntitiesWithPaginationGet(
    currentPage: number,
    pageSize: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetAllEntitiesWithPaginationGet(currentPage, pageSize, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetAnimalProgenyRequest} [getAnimalProgenyRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetAnimalProgenyPost(
    getAnimalProgenyRequest?: GetAnimalProgenyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetAnimalProgenyPost(getAnimalProgenyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [entityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetDetailsByEntityIdGet(
    entityId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetDetailsByEntityIdGet(entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<string>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetEntityByEntityGuidsPost(
    requestBody?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetEntityByEntityGuidsPost(requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [entityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetEntityByEntityIdGet(
    entityId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetEntityByEntityIdGet(entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [id]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetEntityByGuidGet(
    id?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetEntityByGuidGet(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} currentPage
   * @param {number} pageSize
   * @param {number} [organisationId]
   * @param {EntityTypeCode} [entityTypeCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetEntityByOrgIdGet(
    currentPage: number,
    pageSize: number,
    organisationId?: number,
    entityTypeCode?: EntityTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetEntityByOrgIdGet(
        currentPage,
        pageSize,
        organisationId,
        entityTypeCode,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EntityFilterByDetailRequest} [entityFilterByDetailRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetEntityFilterByDetailPost(
    entityFilterByDetailRequest?: EntityFilterByDetailRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetEntityFilterByDetailPost(
        entityFilterByDetailRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [entityGuidId]
   * @param {number} [maxGeneration]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityGetPedigreeGet(
    entityGuidId?: string,
    maxGeneration?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityGetPedigreeGet(entityGuidId, maxGeneration, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {LinkOptionsByEntityDetailsRequest} [linkOptionsByEntityDetailsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityLinkOptionsByEntityDetailPost(
    linkOptionsByEntityDetailsRequest?: LinkOptionsByEntityDetailsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityLinkOptionsByEntityDetailPost(
        linkOptionsByEntityDetailsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateMemberMembershipRequest} [updateMemberMembershipRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityMemberMembershipsPut(
    updateMemberMembershipRequest?: UpdateMemberMembershipRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityMemberMembershipsPut(updateMemberMembershipRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityRequest} [upsertEntityRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityPost(
    upsertEntityRequest?: UpsertEntityRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityPost(upsertEntityRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QuickSearchRequest} [quickSearchRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityQuickSearchPost(
    quickSearchRequest?: QuickSearchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityQuickSearchPost(quickSearchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SearchByOrgIdRequest} [searchByOrgIdRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntitySearchByOrgIdPost(
    searchByOrgIdRequest?: SearchByOrgIdRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntitySearchByOrgIdPost(searchByOrgIdRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SearchEntityByDetailRequest} [searchEntityByDetailRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntitySearchEntityByDetailPost(
    searchEntityByDetailRequest?: SearchEntityByDetailRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntitySearchEntityByDetailPost(searchEntityByDetailRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {BulkSuspendEnterpriseRequest} [bulkSuspendEnterpriseRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntitySuspendEnterprisesPatch(
    bulkSuspendEnterpriseRequest?: BulkSuspendEnterpriseRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntitySuspendEnterprisesPatch(bulkSuspendEnterpriseRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertDetailValuesRequest} [upsertDetailValuesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityUpsertDetailValuesPost(
    upsertDetailValuesRequest?: UpsertDetailValuesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityUpsertDetailValuesPost(upsertDetailValuesRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityWithDetailRequest} [upsertEntityWithDetailRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityApi
   */
  public apiEntityUpsertEntityWithDetailPost(
    upsertEntityWithDetailRequest?: UpsertEntityWithDetailRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityApiFp(this.configuration)
      .apiEntityUpsertEntityWithDetailPost(
        upsertEntityWithDetailRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityDetailApi - axios parameter creator
 * @export
 */
export const EntityDetailApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailAllDefinitionsGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetail/all-definitions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {number} [entityId]
     * @param {number} [categoryId]
     * @param {EntityDetailType} [entityDetailType]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailGet: async (
      organisationId?: number,
      entityId?: number,
      categoryId?: number,
      entityDetailType?: EntityDetailType,
      entityTypeCode?: EntityTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (categoryId !== undefined) {
        localVarQueryParameter['categoryId'] = categoryId;
      }

      if (entityDetailType !== undefined) {
        localVarQueryParameter['entityDetailType'] = entityDetailType;
      }

      if (entityTypeCode !== undefined) {
        localVarQueryParameter['entityTypeCode'] = entityTypeCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailGetEntityDetailPaginationGet: async (
      currentPage: number,
      pageSize: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'currentPage' is not null or undefined
      assertParamExists(
        'apiEntityDetailGetEntityDetailPaginationGet',
        'currentPage',
        currentPage,
      );
      // verify required parameter 'pageSize' is not null or undefined
      assertParamExists(
        'apiEntityDetailGetEntityDetailPaginationGet',
        'pageSize',
        pageSize,
      );
      const localVarPath = `/api/EntityDetail/GetEntityDetailPagination`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (currentPage !== undefined) {
        localVarQueryParameter['CurrentPage'] = currentPage;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [categoryId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailGetEntityDetailssByCategoryIdGet: async (
      categoryId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetail/GetEntityDetailssByCategoryId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (categoryId !== undefined) {
        localVarQueryParameter['categoryId'] = categoryId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailPagedEntityDetailssByOrganisationIdPost: async (
      pagedEntityDetailsRequest?: PagedEntityDetailsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetail/PagedEntityDetailssByOrganisationId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pagedEntityDetailsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailPost: async (
      upsertEntityDetailRequest?: UpsertEntityDetailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityDetailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailSearchSortFilterPost: async (
      entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetail/SearchSortFilter`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        entityDetailsSearchSortFilterRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityDetailApi - functional programming interface
 * @export
 */
export const EntityDetailApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EntityDetailApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailAllDefinitionsGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailAllDefinitionsGet(
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailApi.apiEntityDetailAllDefinitionsGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {number} [entityId]
     * @param {number} [categoryId]
     * @param {EntityDetailType} [entityDetailType]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailGet(
      organisationId?: number,
      entityId?: number,
      categoryId?: number,
      entityDetailType?: EntityDetailType,
      entityTypeCode?: EntityTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailGet(
          organisationId,
          entityId,
          categoryId,
          entityDetailType,
          entityTypeCode,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityDetailApi.apiEntityDetailGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailGetEntityDetailPaginationGet(
      currentPage: number,
      pageSize: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailGetEntityDetailPaginationGet(
          currentPage,
          pageSize,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailApi.apiEntityDetailGetEntityDetailPaginationGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [categoryId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailGetEntityDetailssByCategoryIdGet(
      categoryId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailGetEntityDetailssByCategoryIdGet(
          categoryId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailApi.apiEntityDetailGetEntityDetailssByCategoryIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailPagedEntityDetailssByOrganisationIdPost(
      pagedEntityDetailsRequest?: PagedEntityDetailsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDetailDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailPagedEntityDetailssByOrganisationIdPost(
          pagedEntityDetailsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailApi.apiEntityDetailPagedEntityDetailssByOrganisationIdPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailPost(
      upsertEntityDetailRequest?: UpsertEntityDetailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailPost(
          upsertEntityDetailRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityDetailApi.apiEntityDetailPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailSearchSortFilterPost(
      entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDetailDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailSearchSortFilterPost(
          entityDetailsSearchSortFilterRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailApi.apiEntityDetailSearchSortFilterPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityDetailApi - factory interface
 * @export
 */
export const EntityDetailApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityDetailApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailAllDefinitionsGet(
      options?: any,
    ): AxiosPromise<Array<EntityDetailDto>> {
      return localVarFp
        .apiEntityDetailAllDefinitionsGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {number} [entityId]
     * @param {number} [categoryId]
     * @param {EntityDetailType} [entityDetailType]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailGet(
      organisationId?: number,
      entityId?: number,
      categoryId?: number,
      entityDetailType?: EntityDetailType,
      entityTypeCode?: EntityTypeCode,
      options?: any,
    ): AxiosPromise<Array<EntityDetailDto>> {
      return localVarFp
        .apiEntityDetailGet(
          organisationId,
          entityId,
          categoryId,
          entityDetailType,
          entityTypeCode,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} currentPage
     * @param {number} pageSize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailGetEntityDetailPaginationGet(
      currentPage: number,
      pageSize: number,
      options?: any,
    ): AxiosPromise<Array<EntityDetailDto>> {
      return localVarFp
        .apiEntityDetailGetEntityDetailPaginationGet(
          currentPage,
          pageSize,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [categoryId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailGetEntityDetailssByCategoryIdGet(
      categoryId?: number,
      options?: any,
    ): AxiosPromise<Array<EntityDetailDto>> {
      return localVarFp
        .apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailPagedEntityDetailssByOrganisationIdPost(
      pagedEntityDetailsRequest?: PagedEntityDetailsRequest,
      options?: any,
    ): AxiosPromise<EntityDetailDtoPagedResult> {
      return localVarFp
        .apiEntityDetailPagedEntityDetailssByOrganisationIdPost(
          pagedEntityDetailsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailPost(
      upsertEntityDetailRequest?: UpsertEntityDetailRequest,
      options?: any,
    ): AxiosPromise<Array<EntityDetailDto>> {
      return localVarFp
        .apiEntityDetailPost(upsertEntityDetailRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailSearchSortFilterPost(
      entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest,
      options?: any,
    ): AxiosPromise<EntityDetailDtoPagedResult> {
      return localVarFp
        .apiEntityDetailSearchSortFilterPost(
          entityDetailsSearchSortFilterRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityDetailApi - object-oriented interface
 * @export
 * @class EntityDetailApi
 * @extends {BaseAPI}
 */
export class EntityDetailApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailApi
   */
  public apiEntityDetailAllDefinitionsGet(options?: RawAxiosRequestConfig) {
    return EntityDetailApiFp(this.configuration)
      .apiEntityDetailAllDefinitionsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {number} [entityId]
   * @param {number} [categoryId]
   * @param {EntityDetailType} [entityDetailType]
   * @param {EntityTypeCode} [entityTypeCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailApi
   */
  public apiEntityDetailGet(
    organisationId?: number,
    entityId?: number,
    categoryId?: number,
    entityDetailType?: EntityDetailType,
    entityTypeCode?: EntityTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailApiFp(this.configuration)
      .apiEntityDetailGet(
        organisationId,
        entityId,
        categoryId,
        entityDetailType,
        entityTypeCode,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} currentPage
   * @param {number} pageSize
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailApi
   */
  public apiEntityDetailGetEntityDetailPaginationGet(
    currentPage: number,
    pageSize: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailApiFp(this.configuration)
      .apiEntityDetailGetEntityDetailPaginationGet(
        currentPage,
        pageSize,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [categoryId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailApi
   */
  public apiEntityDetailGetEntityDetailssByCategoryIdGet(
    categoryId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailApiFp(this.configuration)
      .apiEntityDetailGetEntityDetailssByCategoryIdGet(categoryId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PagedEntityDetailsRequest} [pagedEntityDetailsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailApi
   */
  public apiEntityDetailPagedEntityDetailssByOrganisationIdPost(
    pagedEntityDetailsRequest?: PagedEntityDetailsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailApiFp(this.configuration)
      .apiEntityDetailPagedEntityDetailssByOrganisationIdPost(
        pagedEntityDetailsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityDetailRequest} [upsertEntityDetailRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailApi
   */
  public apiEntityDetailPost(
    upsertEntityDetailRequest?: UpsertEntityDetailRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailApiFp(this.configuration)
      .apiEntityDetailPost(upsertEntityDetailRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EntityDetailsSearchSortFilterRequest} [entityDetailsSearchSortFilterRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailApi
   */
  public apiEntityDetailSearchSortFilterPost(
    entityDetailsSearchSortFilterRequest?: EntityDetailsSearchSortFilterRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailApiFp(this.configuration)
      .apiEntityDetailSearchSortFilterPost(
        entityDetailsSearchSortFilterRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityDetailCategoryApi - axios parameter creator
 * @export
 */
export const EntityDetailCategoryApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailCategoryGet: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailCategory`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailCategoryPost: async (
      upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailCategory`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityDetailCategoryRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityDetailCategoryApi - functional programming interface
 * @export
 */
export const EntityDetailCategoryApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EntityDetailCategoryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailCategoryGet(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailCategoryDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailCategoryGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailCategoryApi.apiEntityDetailCategoryGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailCategoryPost(
      upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDetailCategoryDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailCategoryPost(
          upsertEntityDetailCategoryRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailCategoryApi.apiEntityDetailCategoryPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityDetailCategoryApi - factory interface
 * @export
 */
export const EntityDetailCategoryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityDetailCategoryApiFp(configuration);
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailCategoryGet(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<EntityDetailCategoryDto>> {
      return localVarFp
        .apiEntityDetailCategoryGet(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailCategoryPost(
      upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest,
      options?: any,
    ): AxiosPromise<EntityDetailCategoryDto> {
      return localVarFp
        .apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityDetailCategoryApi - object-oriented interface
 * @export
 * @class EntityDetailCategoryApi
 * @extends {BaseAPI}
 */
export class EntityDetailCategoryApi extends BaseAPI {
  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailCategoryApi
   */
  public apiEntityDetailCategoryGet(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailCategoryApiFp(this.configuration)
      .apiEntityDetailCategoryGet(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityDetailCategoryRequest} [upsertEntityDetailCategoryRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailCategoryApi
   */
  public apiEntityDetailCategoryPost(
    upsertEntityDetailCategoryRequest?: UpsertEntityDetailCategoryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailCategoryApiFp(this.configuration)
      .apiEntityDetailCategoryPost(upsertEntityDetailCategoryRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityDetailCategoryAssociationApi - axios parameter creator
 * @export
 */
export const EntityDetailCategoryAssociationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailCategoryAssociationPost: async (
      mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailCategoryAssociation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mergeEntityDetailCategoryAssociationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityDetailCategoryAssociationApi - functional programming interface
 * @export
 */
export const EntityDetailCategoryAssociationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EntityDetailCategoryAssociationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailCategoryAssociationPost(
      mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDetailCategoryAssociationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailCategoryAssociationPost(
          mergeEntityDetailCategoryAssociationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailCategoryAssociationApi.apiEntityDetailCategoryAssociationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityDetailCategoryAssociationApi - factory interface
 * @export
 */
export const EntityDetailCategoryAssociationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityDetailCategoryAssociationApiFp(configuration);
  return {
    /**
     *
     * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailCategoryAssociationPost(
      mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest,
      options?: any,
    ): AxiosPromise<EntityDetailCategoryAssociationDto> {
      return localVarFp
        .apiEntityDetailCategoryAssociationPost(
          mergeEntityDetailCategoryAssociationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityDetailCategoryAssociationApi - object-oriented interface
 * @export
 * @class EntityDetailCategoryAssociationApi
 * @extends {BaseAPI}
 */
export class EntityDetailCategoryAssociationApi extends BaseAPI {
  /**
   *
   * @param {MergeEntityDetailCategoryAssociationRequest} [mergeEntityDetailCategoryAssociationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailCategoryAssociationApi
   */
  public apiEntityDetailCategoryAssociationPost(
    mergeEntityDetailCategoryAssociationRequest?: MergeEntityDetailCategoryAssociationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailCategoryAssociationApiFp(this.configuration)
      .apiEntityDetailCategoryAssociationPost(
        mergeEntityDetailCategoryAssociationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityDetailConfigApi - axios parameter creator
 * @export
 */
export const EntityDetailConfigApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigDefaultEntityDetailsGet: async (
      entityTypeCode?: EntityTypeCode,
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailConfig/default-entity-details`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityTypeCode !== undefined) {
        localVarQueryParameter['entityTypeCode'] = entityTypeCode;
      }

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} entityDetailConfigId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost: async (
      entityDetailConfigId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entityDetailConfigId' is not null or undefined
      assertParamExists(
        'apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost',
        'entityDetailConfigId',
        entityDetailConfigId,
      );
      const localVarPath =
        `/api/EntityDetailConfig/{entityDetailConfigId}/ResetDefaultValue`.replace(
          `{${'entityDetailConfigId'}}`,
          encodeURIComponent(String(entityDetailConfigId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigPost: async (
      upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityDetailConfigRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SetVisibleConfigRequest} [setVisibleConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigSetVisibleConfigPost: async (
      setVisibleConfigRequest?: SetVisibleConfigRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailConfig/SetVisibleConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        setVisibleConfigRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityDetailConfigApi - functional programming interface
 * @export
 */
export const EntityDetailConfigApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EntityDetailConfigApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailConfigDefaultEntityDetailsGet(
      entityTypeCode?: EntityTypeCode,
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailData>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailConfigDefaultEntityDetailsGet(
          entityTypeCode,
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailConfigApi.apiEntityDetailConfigDefaultEntityDetailsGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} entityDetailConfigId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(
      entityDetailConfigId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDetailConfigDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(
          entityDetailConfigId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailConfigApi.apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailConfigPost(
      upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDetailConfigDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailConfigPost(
          upsertEntityDetailConfigRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityDetailConfigApi.apiEntityDetailConfigPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SetVisibleConfigRequest} [setVisibleConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailConfigSetVisibleConfigPost(
      setVisibleConfigRequest?: SetVisibleConfigRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailConfigSetVisibleConfigPost(
          setVisibleConfigRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailConfigApi.apiEntityDetailConfigSetVisibleConfigPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityDetailConfigApi - factory interface
 * @export
 */
export const EntityDetailConfigApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityDetailConfigApiFp(configuration);
  return {
    /**
     *
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigDefaultEntityDetailsGet(
      entityTypeCode?: EntityTypeCode,
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<EntityDetailData>> {
      return localVarFp
        .apiEntityDetailConfigDefaultEntityDetailsGet(
          entityTypeCode,
          organisationId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} entityDetailConfigId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(
      entityDetailConfigId: number,
      options?: any,
    ): AxiosPromise<EntityDetailConfigDto> {
      return localVarFp
        .apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(
          entityDetailConfigId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigPost(
      upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest,
      options?: any,
    ): AxiosPromise<EntityDetailConfigDto> {
      return localVarFp
        .apiEntityDetailConfigPost(upsertEntityDetailConfigRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SetVisibleConfigRequest} [setVisibleConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailConfigSetVisibleConfigPost(
      setVisibleConfigRequest?: SetVisibleConfigRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiEntityDetailConfigSetVisibleConfigPost(
          setVisibleConfigRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityDetailConfigApi - object-oriented interface
 * @export
 * @class EntityDetailConfigApi
 * @extends {BaseAPI}
 */
export class EntityDetailConfigApi extends BaseAPI {
  /**
   *
   * @param {EntityTypeCode} [entityTypeCode]
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailConfigApi
   */
  public apiEntityDetailConfigDefaultEntityDetailsGet(
    entityTypeCode?: EntityTypeCode,
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailConfigApiFp(this.configuration)
      .apiEntityDetailConfigDefaultEntityDetailsGet(
        entityTypeCode,
        organisationId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} entityDetailConfigId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailConfigApi
   */
  public apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(
    entityDetailConfigId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailConfigApiFp(this.configuration)
      .apiEntityDetailConfigEntityDetailConfigIdResetDefaultValuePost(
        entityDetailConfigId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityDetailConfigRequest} [upsertEntityDetailConfigRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailConfigApi
   */
  public apiEntityDetailConfigPost(
    upsertEntityDetailConfigRequest?: UpsertEntityDetailConfigRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailConfigApiFp(this.configuration)
      .apiEntityDetailConfigPost(upsertEntityDetailConfigRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SetVisibleConfigRequest} [setVisibleConfigRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailConfigApi
   */
  public apiEntityDetailConfigSetVisibleConfigPost(
    setVisibleConfigRequest?: SetVisibleConfigRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailConfigApiFp(this.configuration)
      .apiEntityDetailConfigSetVisibleConfigPost(
        setVisibleConfigRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityDetailEnhancerApi - axios parameter creator
 * @export
 */
export const EntityDetailEnhancerApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [entityDetailEnhancerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet: async (
      entityDetailEnhancerId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailEnhancer/GetEntityDetailValueByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityDetailEnhancerId !== undefined) {
        localVarQueryParameter['entityDetailEnhancerId'] =
          entityDetailEnhancerId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailEnhancerPost: async (
      upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailEnhancer`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityDetailEnhancerRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailEnhancerPreviewValuePost: async (
      previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailEnhancer/PreviewValue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        previewValueEntityDetailEnhancerRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityDetailEnhancerApi - functional programming interface
 * @export
 */
export const EntityDetailEnhancerApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EntityDetailEnhancerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [entityDetailEnhancerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(
      entityDetailEnhancerId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityEnhancerDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(
          entityDetailEnhancerId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailEnhancerApi.apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailEnhancerPost(
      upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityEnhancerDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailEnhancerPost(
          upsertEntityDetailEnhancerRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailEnhancerApi.apiEntityDetailEnhancerPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailEnhancerPreviewValuePost(
      previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityDetailEnhancerDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailEnhancerPreviewValuePost(
          previewValueEntityDetailEnhancerRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailEnhancerApi.apiEntityDetailEnhancerPreviewValuePost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityDetailEnhancerApi - factory interface
 * @export
 */
export const EntityDetailEnhancerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityDetailEnhancerApiFp(configuration);
  return {
    /**
     *
     * @param {number} [entityDetailEnhancerId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(
      entityDetailEnhancerId?: number,
      options?: any,
    ): AxiosPromise<EntityEnhancerDto> {
      return localVarFp
        .apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(
          entityDetailEnhancerId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailEnhancerPost(
      upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest,
      options?: any,
    ): AxiosPromise<EntityEnhancerDto> {
      return localVarFp
        .apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailEnhancerPreviewValuePost(
      previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest,
      options?: any,
    ): AxiosPromise<EntityDetailEnhancerDto> {
      return localVarFp
        .apiEntityDetailEnhancerPreviewValuePost(
          previewValueEntityDetailEnhancerRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityDetailEnhancerApi - object-oriented interface
 * @export
 * @class EntityDetailEnhancerApi
 * @extends {BaseAPI}
 */
export class EntityDetailEnhancerApi extends BaseAPI {
  /**
   *
   * @param {number} [entityDetailEnhancerId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailEnhancerApi
   */
  public apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(
    entityDetailEnhancerId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailEnhancerApiFp(this.configuration)
      .apiEntityDetailEnhancerGetEntityDetailValueByEntityIdGet(
        entityDetailEnhancerId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityDetailEnhancerRequest} [upsertEntityDetailEnhancerRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailEnhancerApi
   */
  public apiEntityDetailEnhancerPost(
    upsertEntityDetailEnhancerRequest?: UpsertEntityDetailEnhancerRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailEnhancerApiFp(this.configuration)
      .apiEntityDetailEnhancerPost(upsertEntityDetailEnhancerRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PreviewValueEntityDetailEnhancerRequest} [previewValueEntityDetailEnhancerRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailEnhancerApi
   */
  public apiEntityDetailEnhancerPreviewValuePost(
    previewValueEntityDetailEnhancerRequest?: PreviewValueEntityDetailEnhancerRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailEnhancerApiFp(this.configuration)
      .apiEntityDetailEnhancerPreviewValuePost(
        previewValueEntityDetailEnhancerRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityDetailValueApi - axios parameter creator
 * @export
 */
export const EntityDetailValueApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailValueGetEntityDetailValueByEntityIdGet: async (
      entityId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailValue/GetEntityDetailValueByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['EntityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailValuePost: async (
      upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityDetailValue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityDetailValueRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityDetailValueApi - functional programming interface
 * @export
 */
export const EntityDetailValueApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EntityDetailValueApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailValueGetEntityDetailValueByEntityIdGet(
      entityId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailValueDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailValueGetEntityDetailValueByEntityIdGet(
          entityId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityDetailValueApi.apiEntityDetailValueGetEntityDetailValueByEntityIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityDetailValuePost(
      upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityDetailValueDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityDetailValuePost(
          upsertEntityDetailValueRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityDetailValueApi.apiEntityDetailValuePost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityDetailValueApi - factory interface
 * @export
 */
export const EntityDetailValueApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityDetailValueApiFp(configuration);
  return {
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailValueGetEntityDetailValueByEntityIdGet(
      entityId?: number,
      options?: any,
    ): AxiosPromise<Array<EntityDetailValueDto>> {
      return localVarFp
        .apiEntityDetailValueGetEntityDetailValueByEntityIdGet(
          entityId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityDetailValuePost(
      upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest,
      options?: any,
    ): AxiosPromise<Array<EntityDetailValueDto>> {
      return localVarFp
        .apiEntityDetailValuePost(upsertEntityDetailValueRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityDetailValueApi - object-oriented interface
 * @export
 * @class EntityDetailValueApi
 * @extends {BaseAPI}
 */
export class EntityDetailValueApi extends BaseAPI {
  /**
   *
   * @param {number} [entityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailValueApi
   */
  public apiEntityDetailValueGetEntityDetailValueByEntityIdGet(
    entityId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailValueApiFp(this.configuration)
      .apiEntityDetailValueGetEntityDetailValueByEntityIdGet(entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityDetailValueRequest} [upsertEntityDetailValueRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityDetailValueApi
   */
  public apiEntityDetailValuePost(
    upsertEntityDetailValueRequest?: UpsertEntityDetailValueRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityDetailValueApiFp(this.configuration)
      .apiEntityDetailValuePost(upsertEntityDetailValueRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityKeyApi - axios parameter creator
 * @export
 */
export const EntityKeyApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityKeyDeleteEntityKeyDelete: async (
      body?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityKey/DeleteEntityKey`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityKeyUpsertEntityKeyPost: async (
      upsertEntityKeyRequest?: UpsertEntityKeyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityKey/UpsertEntityKey`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityKeyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityKeyApi - functional programming interface
 * @export
 */
export const EntityKeyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EntityKeyApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityKeyDeleteEntityKeyDelete(
      body?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityKeyDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityKeyDeleteEntityKeyDelete(
          body,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityKeyApi.apiEntityKeyDeleteEntityKeyDelete']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityKeyUpsertEntityKeyPost(
      upsertEntityKeyRequest?: UpsertEntityKeyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntityKeyDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityKeyUpsertEntityKeyPost(
          upsertEntityKeyRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityKeyApi.apiEntityKeyUpsertEntityKeyPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityKeyApi - factory interface
 * @export
 */
export const EntityKeyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityKeyApiFp(configuration);
  return {
    /**
     *
     * @param {number} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityKeyDeleteEntityKeyDelete(
      body?: number,
      options?: any,
    ): AxiosPromise<EntityKeyDto> {
      return localVarFp
        .apiEntityKeyDeleteEntityKeyDelete(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityKeyUpsertEntityKeyPost(
      upsertEntityKeyRequest?: UpsertEntityKeyRequest,
      options?: any,
    ): AxiosPromise<EntityKeyDto> {
      return localVarFp
        .apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityKeyApi - object-oriented interface
 * @export
 * @class EntityKeyApi
 * @extends {BaseAPI}
 */
export class EntityKeyApi extends BaseAPI {
  /**
   *
   * @param {number} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityKeyApi
   */
  public apiEntityKeyDeleteEntityKeyDelete(
    body?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityKeyApiFp(this.configuration)
      .apiEntityKeyDeleteEntityKeyDelete(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityKeyRequest} [upsertEntityKeyRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityKeyApi
   */
  public apiEntityKeyUpsertEntityKeyPost(
    upsertEntityKeyRequest?: UpsertEntityKeyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityKeyApiFp(this.configuration)
      .apiEntityKeyUpsertEntityKeyPost(upsertEntityKeyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EntityTransferApi - axios parameter creator
 * @export
 */
export const EntityTransferApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [entityTransferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferDelete: async (
      entityTransferId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityTransfer`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityTransferId !== undefined) {
        localVarQueryParameter['entityTransferId'] = entityTransferId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [entityTransferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferGet: async (
      entityTransferId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityTransfer`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityTransferId !== undefined) {
        localVarQueryParameter['entityTransferId'] = entityTransferId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [transferFromEnterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferGetEntityTransferByFromEntityIdGet: async (
      transferFromEnterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityTransfer/GetEntityTransferByFromEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (transferFromEnterpriseId !== undefined) {
        localVarQueryParameter['transferFromEnterpriseId'] =
          transferFromEnterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [transferToEnterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferGetEntityTransferByToEntityIdGet: async (
      transferToEnterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityTransfer/GetEntityTransferByToEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (transferToEnterpriseId !== undefined) {
        localVarQueryParameter['transferToEnterpriseId'] =
          transferToEnterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferPost: async (
      upsertEntityTransfersRequest?: UpsertEntityTransfersRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityTransfer`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertEntityTransfersRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EntityTransferSearchRequest} [entityTransferSearchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferSearchPost: async (
      entityTransferSearchRequest?: EntityTransferSearchRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/EntityTransfer/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        entityTransferSearchRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EntityTransferApi - functional programming interface
 * @export
 */
export const EntityTransferApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    EntityTransferApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [entityTransferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityTransferDelete(
      entityTransferId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityTransferDelete(
          entityTransferId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityTransferApi.apiEntityTransferDelete']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [entityTransferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityTransferGet(
      entityTransferId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityTransferDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityTransferGet(
          entityTransferId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityTransferApi.apiEntityTransferGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [transferFromEnterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityTransferGetEntityTransferByFromEntityIdGet(
      transferFromEnterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityTransferDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityTransferGetEntityTransferByFromEntityIdGet(
          transferFromEnterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityTransferApi.apiEntityTransferGetEntityTransferByFromEntityIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [transferToEnterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityTransferGetEntityTransferByToEntityIdGet(
      transferToEnterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EntityTransferDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityTransferGetEntityTransferByToEntityIdGet(
          transferToEnterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'EntityTransferApi.apiEntityTransferGetEntityTransferByToEntityIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityTransferPost(
      upsertEntityTransfersRequest?: UpsertEntityTransfersRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityTransferDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityTransferPost(
          upsertEntityTransfersRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityTransferApi.apiEntityTransferPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {EntityTransferSearchRequest} [entityTransferSearchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiEntityTransferSearchPost(
      entityTransferSearchRequest?: EntityTransferSearchRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EntityTransferDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiEntityTransferSearchPost(
          entityTransferSearchRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['EntityTransferApi.apiEntityTransferSearchPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * EntityTransferApi - factory interface
 * @export
 */
export const EntityTransferApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EntityTransferApiFp(configuration);
  return {
    /**
     *
     * @param {number} [entityTransferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferDelete(
      entityTransferId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiEntityTransferDelete(entityTransferId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [entityTransferId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferGet(
      entityTransferId?: number,
      options?: any,
    ): AxiosPromise<EntityTransferDto> {
      return localVarFp
        .apiEntityTransferGet(entityTransferId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [transferFromEnterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferGetEntityTransferByFromEntityIdGet(
      transferFromEnterpriseId?: number,
      options?: any,
    ): AxiosPromise<Array<EntityTransferDto>> {
      return localVarFp
        .apiEntityTransferGetEntityTransferByFromEntityIdGet(
          transferFromEnterpriseId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [transferToEnterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferGetEntityTransferByToEntityIdGet(
      transferToEnterpriseId?: number,
      options?: any,
    ): AxiosPromise<Array<EntityTransferDto>> {
      return localVarFp
        .apiEntityTransferGetEntityTransferByToEntityIdGet(
          transferToEnterpriseId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferPost(
      upsertEntityTransfersRequest?: UpsertEntityTransfersRequest,
      options?: any,
    ): AxiosPromise<EntityTransferDto> {
      return localVarFp
        .apiEntityTransferPost(upsertEntityTransfersRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EntityTransferSearchRequest} [entityTransferSearchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiEntityTransferSearchPost(
      entityTransferSearchRequest?: EntityTransferSearchRequest,
      options?: any,
    ): AxiosPromise<EntityTransferDtoPagedResult> {
      return localVarFp
        .apiEntityTransferSearchPost(entityTransferSearchRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EntityTransferApi - object-oriented interface
 * @export
 * @class EntityTransferApi
 * @extends {BaseAPI}
 */
export class EntityTransferApi extends BaseAPI {
  /**
   *
   * @param {number} [entityTransferId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityTransferApi
   */
  public apiEntityTransferDelete(
    entityTransferId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityTransferApiFp(this.configuration)
      .apiEntityTransferDelete(entityTransferId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [entityTransferId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityTransferApi
   */
  public apiEntityTransferGet(
    entityTransferId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityTransferApiFp(this.configuration)
      .apiEntityTransferGet(entityTransferId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [transferFromEnterpriseId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityTransferApi
   */
  public apiEntityTransferGetEntityTransferByFromEntityIdGet(
    transferFromEnterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityTransferApiFp(this.configuration)
      .apiEntityTransferGetEntityTransferByFromEntityIdGet(
        transferFromEnterpriseId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [transferToEnterpriseId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityTransferApi
   */
  public apiEntityTransferGetEntityTransferByToEntityIdGet(
    transferToEnterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityTransferApiFp(this.configuration)
      .apiEntityTransferGetEntityTransferByToEntityIdGet(
        transferToEnterpriseId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertEntityTransfersRequest} [upsertEntityTransfersRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityTransferApi
   */
  public apiEntityTransferPost(
    upsertEntityTransfersRequest?: UpsertEntityTransfersRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityTransferApiFp(this.configuration)
      .apiEntityTransferPost(upsertEntityTransfersRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EntityTransferSearchRequest} [entityTransferSearchRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EntityTransferApi
   */
  public apiEntityTransferSearchPost(
    entityTransferSearchRequest?: EntityTransferSearchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return EntityTransferApiFp(this.configuration)
      .apiEntityTransferSearchPost(entityTransferSearchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FeatureFlagTestApi - axios parameter creator
 * @export
 */
export const FeatureFlagTestApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} userKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeatureFlagTestUserKeyGet: async (
      userKey: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userKey' is not null or undefined
      assertParamExists('apiFeatureFlagTestUserKeyGet', 'userKey', userKey);
      const localVarPath = `/api/FeatureFlagTest/{userKey}`.replace(
        `{${'userKey'}}`,
        encodeURIComponent(String(userKey)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FeatureFlagTestApi - functional programming interface
 * @export
 */
export const FeatureFlagTestApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    FeatureFlagTestApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} userKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFeatureFlagTestUserKeyGet(
      userKey: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFeatureFlagTestUserKeyGet(
          userKey,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FeatureFlagTestApi.apiFeatureFlagTestUserKeyGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * FeatureFlagTestApi - factory interface
 * @export
 */
export const FeatureFlagTestApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FeatureFlagTestApiFp(configuration);
  return {
    /**
     *
     * @param {string} userKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeatureFlagTestUserKeyGet(
      userKey: string,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiFeatureFlagTestUserKeyGet(userKey, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FeatureFlagTestApi - object-oriented interface
 * @export
 * @class FeatureFlagTestApi
 * @extends {BaseAPI}
 */
export class FeatureFlagTestApi extends BaseAPI {
  /**
   *
   * @param {string} userKey
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeatureFlagTestApi
   */
  public apiFeatureFlagTestUserKeyGet(
    userKey: string,
    options?: RawAxiosRequestConfig,
  ) {
    return FeatureFlagTestApiFp(this.configuration)
      .apiFeatureFlagTestUserKeyGet(userKey, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FeeApi - axios parameter creator
 * @export
 */
export const FeeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AddFeesRequest} [addFeesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeeAddFeesPost: async (
      addFeesRequest?: AddFeesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Fee/AddFees`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addFeesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteFeesRequest} [deleteFeesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeeDeleteFeesPost: async (
      deleteFeesRequest?: DeleteFeesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Fee/DeleteFees`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteFeesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeeGetFeeByOrganisationIdGet: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Fee/GetFeeByOrganisationId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FeeApi - functional programming interface
 * @export
 */
export const FeeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FeeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AddFeesRequest} [addFeesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFeeAddFeesPost(
      addFeesRequest?: AddFeesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFeeAddFeesPost(
          addFeesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FeeApi.apiFeeAddFeesPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {DeleteFeesRequest} [deleteFeesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFeeDeleteFeesPost(
      deleteFeesRequest?: DeleteFeesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFeeDeleteFeesPost(
          deleteFeesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FeeApi.apiFeeDeleteFeesPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFeeGetFeeByOrganisationIdGet(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFeeGetFeeByOrganisationIdGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FeeApi.apiFeeGetFeeByOrganisationIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * FeeApi - factory interface
 * @export
 */
export const FeeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FeeApiFp(configuration);
  return {
    /**
     *
     * @param {AddFeesRequest} [addFeesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeeAddFeesPost(
      addFeesRequest?: AddFeesRequest,
      options?: any,
    ): AxiosPromise<Array<FeeDto>> {
      return localVarFp
        .apiFeeAddFeesPost(addFeesRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteFeesRequest} [deleteFeesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeeDeleteFeesPost(
      deleteFeesRequest?: DeleteFeesRequest,
      options?: any,
    ): AxiosPromise<Array<FeeDto>> {
      return localVarFp
        .apiFeeDeleteFeesPost(deleteFeesRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFeeGetFeeByOrganisationIdGet(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<FeeDto>> {
      return localVarFp
        .apiFeeGetFeeByOrganisationIdGet(organisationId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FeeApi - object-oriented interface
 * @export
 * @class FeeApi
 * @extends {BaseAPI}
 */
export class FeeApi extends BaseAPI {
  /**
   *
   * @param {AddFeesRequest} [addFeesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeeApi
   */
  public apiFeeAddFeesPost(
    addFeesRequest?: AddFeesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FeeApiFp(this.configuration)
      .apiFeeAddFeesPost(addFeesRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteFeesRequest} [deleteFeesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeeApi
   */
  public apiFeeDeleteFeesPost(
    deleteFeesRequest?: DeleteFeesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FeeApiFp(this.configuration)
      .apiFeeDeleteFeesPost(deleteFeesRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FeeApi
   */
  public apiFeeGetFeeByOrganisationIdGet(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return FeeApiFp(this.configuration)
      .apiFeeGetFeeByOrganisationIdGet(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FormApi - axios parameter creator
 * @export
 */
export const FormApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [formId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormDelete: async (
      formId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Form`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (formId !== undefined) {
        localVarQueryParameter['formId'] = formId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DuplicateFormRequest} [duplicateFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormDuplicatePost: async (
      duplicateFormRequest?: DuplicateFormRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Form/duplicate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        duplicateFormRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormGetFormsByIdFormIdGet: async (
      formId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'formId' is not null or undefined
      assertParamExists('apiFormGetFormsByIdFormIdGet', 'formId', formId);
      const localVarPath = `/api/Form/GetFormsById/{formId}`.replace(
        `{${'formId'}}`,
        encodeURIComponent(String(formId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormGetFormsByOrgGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Form/GetFormsByOrg`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} orgId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiFormGetFormsByOrgOrgIdGet: async (
      orgId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('apiFormGetFormsByOrgOrgIdGet', 'orgId', orgId);
      const localVarPath = `/api/Form/GetFormsByOrg/{orgId}`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertFormRequest} [upsertFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormPost: async (
      upsertFormRequest?: UpsertFormRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Form`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertFormRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} screenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormScreenIdGet: async (
      screenId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'screenId' is not null or undefined
      assertParamExists('apiFormScreenIdGet', 'screenId', screenId);
      const localVarPath = `/api/Form/{screenId}`.replace(
        `{${'screenId'}}`,
        encodeURIComponent(String(screenId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FormApi - functional programming interface
 * @export
 */
export const FormApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = FormApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [formId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormDelete(
      formId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormDelete(
        formId,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FormApi.apiFormDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {DuplicateFormRequest} [duplicateFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormDuplicatePost(
      duplicateFormRequest?: DuplicateFormRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormDuplicatePost(
          duplicateFormRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FormApi.apiFormDuplicatePost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormGetFormsByIdFormIdGet(
      formId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormGetFormsByIdFormIdGet(
          formId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FormApi.apiFormGetFormsByIdFormIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormGetFormsByOrgGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormGetFormsByOrgGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FormApi.apiFormGetFormsByOrgGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} orgId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiFormGetFormsByOrgOrgIdGet(
      orgId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormGetFormsByOrgOrgIdGet(
          orgId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FormApi.apiFormGetFormsByOrgOrgIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertFormRequest} [upsertFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormPost(
      upsertFormRequest?: UpsertFormRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<FormDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiFormPost(
        upsertFormRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FormApi.apiFormPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} screenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormScreenIdGet(
      screenId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FormDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormScreenIdGet(screenId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['FormApi.apiFormScreenIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * FormApi - factory interface
 * @export
 */
export const FormApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FormApiFp(configuration);
  return {
    /**
     *
     * @param {number} [formId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormDelete(formId?: number, options?: any): AxiosPromise<boolean> {
      return localVarFp
        .apiFormDelete(formId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DuplicateFormRequest} [duplicateFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormDuplicatePost(
      duplicateFormRequest?: DuplicateFormRequest,
      options?: any,
    ): AxiosPromise<FormDto> {
      return localVarFp
        .apiFormDuplicatePost(duplicateFormRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} formId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormGetFormsByIdFormIdGet(
      formId: number,
      options?: any,
    ): AxiosPromise<Array<FormDto>> {
      return localVarFp
        .apiFormGetFormsByIdFormIdGet(formId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormGetFormsByOrgGet(options?: any): AxiosPromise<Array<FormDto>> {
      return localVarFp
        .apiFormGetFormsByOrgGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} orgId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiFormGetFormsByOrgOrgIdGet(
      orgId: number,
      options?: any,
    ): AxiosPromise<Array<FormDto>> {
      return localVarFp
        .apiFormGetFormsByOrgOrgIdGet(orgId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertFormRequest} [upsertFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormPost(
      upsertFormRequest?: UpsertFormRequest,
      options?: any,
    ): AxiosPromise<FormDto> {
      return localVarFp
        .apiFormPost(upsertFormRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} screenId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormScreenIdGet(
      screenId: number,
      options?: any,
    ): AxiosPromise<Array<FormDto>> {
      return localVarFp
        .apiFormScreenIdGet(screenId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FormApi - object-oriented interface
 * @export
 * @class FormApi
 * @extends {BaseAPI}
 */
export class FormApi extends BaseAPI {
  /**
   *
   * @param {number} [formId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormApi
   */
  public apiFormDelete(formId?: number, options?: RawAxiosRequestConfig) {
    return FormApiFp(this.configuration)
      .apiFormDelete(formId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DuplicateFormRequest} [duplicateFormRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormApi
   */
  public apiFormDuplicatePost(
    duplicateFormRequest?: DuplicateFormRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FormApiFp(this.configuration)
      .apiFormDuplicatePost(duplicateFormRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} formId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormApi
   */
  public apiFormGetFormsByIdFormIdGet(
    formId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return FormApiFp(this.configuration)
      .apiFormGetFormsByIdFormIdGet(formId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormApi
   */
  public apiFormGetFormsByOrgGet(options?: RawAxiosRequestConfig) {
    return FormApiFp(this.configuration)
      .apiFormGetFormsByOrgGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} orgId
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof FormApi
   */
  public apiFormGetFormsByOrgOrgIdGet(
    orgId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return FormApiFp(this.configuration)
      .apiFormGetFormsByOrgOrgIdGet(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertFormRequest} [upsertFormRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormApi
   */
  public apiFormPost(
    upsertFormRequest?: UpsertFormRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FormApiFp(this.configuration)
      .apiFormPost(upsertFormRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} screenId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormApi
   */
  public apiFormScreenIdGet(screenId: number, options?: RawAxiosRequestConfig) {
    return FormApiFp(this.configuration)
      .apiFormScreenIdGet(screenId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * FormActionAssociationApi - axios parameter creator
 * @export
 */
export const FormActionAssociationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormActionAssociationByOrgGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/FormActionAssociation/ByOrg`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [orgId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiFormActionAssociationByOrgIdGet: async (
      orgId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/FormActionAssociation/ByOrgId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [formId]
     * @param {ActionType} [actionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormActionAssociationGet: async (
      formId?: number,
      actionType?: ActionType,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/FormActionAssociation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (formId !== undefined) {
        localVarQueryParameter['formId'] = formId;
      }

      if (actionType !== undefined) {
        localVarQueryParameter['actionType'] = actionType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormActionAssociationUpsertFormActionAssociationPost: async (
      upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/FormActionAssociation/UpsertFormActionAssociation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertFormActionAssociationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * FormActionAssociationApi - functional programming interface
 * @export
 */
export const FormActionAssociationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    FormActionAssociationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormActionAssociationByOrgGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<FormActionAssociationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormActionAssociationByOrgGet(
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'FormActionAssociationApi.apiFormActionAssociationByOrgGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [orgId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiFormActionAssociationByOrgIdGet(
      orgId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<FormActionAssociationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormActionAssociationByOrgIdGet(
          orgId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'FormActionAssociationApi.apiFormActionAssociationByOrgIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [formId]
     * @param {ActionType} [actionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormActionAssociationGet(
      formId?: number,
      actionType?: ActionType,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<FormActionAssociationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormActionAssociationGet(
          formId,
          actionType,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'FormActionAssociationApi.apiFormActionAssociationGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiFormActionAssociationUpsertFormActionAssociationPost(
      upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<FormActionAssociationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiFormActionAssociationUpsertFormActionAssociationPost(
          upsertFormActionAssociationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'FormActionAssociationApi.apiFormActionAssociationUpsertFormActionAssociationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * FormActionAssociationApi - factory interface
 * @export
 */
export const FormActionAssociationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = FormActionAssociationApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormActionAssociationByOrgGet(
      options?: any,
    ): AxiosPromise<Array<FormActionAssociationDto>> {
      return localVarFp
        .apiFormActionAssociationByOrgGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [orgId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiFormActionAssociationByOrgIdGet(
      orgId?: number,
      options?: any,
    ): AxiosPromise<Array<FormActionAssociationDto>> {
      return localVarFp
        .apiFormActionAssociationByOrgIdGet(orgId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [formId]
     * @param {ActionType} [actionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormActionAssociationGet(
      formId?: number,
      actionType?: ActionType,
      options?: any,
    ): AxiosPromise<FormActionAssociationDto> {
      return localVarFp
        .apiFormActionAssociationGet(formId, actionType, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiFormActionAssociationUpsertFormActionAssociationPost(
      upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest,
      options?: any,
    ): AxiosPromise<FormActionAssociationDto> {
      return localVarFp
        .apiFormActionAssociationUpsertFormActionAssociationPost(
          upsertFormActionAssociationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * FormActionAssociationApi - object-oriented interface
 * @export
 * @class FormActionAssociationApi
 * @extends {BaseAPI}
 */
export class FormActionAssociationApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormActionAssociationApi
   */
  public apiFormActionAssociationByOrgGet(options?: RawAxiosRequestConfig) {
    return FormActionAssociationApiFp(this.configuration)
      .apiFormActionAssociationByOrgGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [orgId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof FormActionAssociationApi
   */
  public apiFormActionAssociationByOrgIdGet(
    orgId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return FormActionAssociationApiFp(this.configuration)
      .apiFormActionAssociationByOrgIdGet(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [formId]
   * @param {ActionType} [actionType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormActionAssociationApi
   */
  public apiFormActionAssociationGet(
    formId?: number,
    actionType?: ActionType,
    options?: RawAxiosRequestConfig,
  ) {
    return FormActionAssociationApiFp(this.configuration)
      .apiFormActionAssociationGet(formId, actionType, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertFormActionAssociationRequest} [upsertFormActionAssociationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FormActionAssociationApi
   */
  public apiFormActionAssociationUpsertFormActionAssociationPost(
    upsertFormActionAssociationRequest?: UpsertFormActionAssociationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return FormActionAssociationApiFp(this.configuration)
      .apiFormActionAssociationUpsertFormActionAssociationPost(
        upsertFormActionAssociationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * IdentGenerationRuleApi - axios parameter creator
 * @export
 */
export const IdentGenerationRuleApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiIdentGenerationRuleByOrganisationGet: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/IdentGenerationRule/by-organisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiIdentGenerationRuleDelete: async (
      id?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/IdentGenerationRule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (id !== undefined) {
        localVarQueryParameter['id'] = id;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiIdentGenerationRuleUpsertPost: async (
      upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/IdentGenerationRule/upsert`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertIdentGenerationRuleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * IdentGenerationRuleApi - functional programming interface
 * @export
 */
export const IdentGenerationRuleApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    IdentGenerationRuleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiIdentGenerationRuleByOrganisationGet(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<IdentGenerationRuleDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiIdentGenerationRuleByOrganisationGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'IdentGenerationRuleApi.apiIdentGenerationRuleByOrganisationGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiIdentGenerationRuleDelete(
      id?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiIdentGenerationRuleDelete(
          id,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'IdentGenerationRuleApi.apiIdentGenerationRuleDelete'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiIdentGenerationRuleUpsertPost(
      upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<IdentGenerationRuleDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiIdentGenerationRuleUpsertPost(
          upsertIdentGenerationRuleRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'IdentGenerationRuleApi.apiIdentGenerationRuleUpsertPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * IdentGenerationRuleApi - factory interface
 * @export
 */
export const IdentGenerationRuleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = IdentGenerationRuleApiFp(configuration);
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiIdentGenerationRuleByOrganisationGet(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<IdentGenerationRuleDto> {
      return localVarFp
        .apiIdentGenerationRuleByOrganisationGet(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiIdentGenerationRuleDelete(
      id?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiIdentGenerationRuleDelete(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiIdentGenerationRuleUpsertPost(
      upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest,
      options?: any,
    ): AxiosPromise<IdentGenerationRuleDto> {
      return localVarFp
        .apiIdentGenerationRuleUpsertPost(
          upsertIdentGenerationRuleRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * IdentGenerationRuleApi - object-oriented interface
 * @export
 * @class IdentGenerationRuleApi
 * @extends {BaseAPI}
 */
export class IdentGenerationRuleApi extends BaseAPI {
  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IdentGenerationRuleApi
   */
  public apiIdentGenerationRuleByOrganisationGet(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return IdentGenerationRuleApiFp(this.configuration)
      .apiIdentGenerationRuleByOrganisationGet(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [id]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IdentGenerationRuleApi
   */
  public apiIdentGenerationRuleDelete(
    id?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return IdentGenerationRuleApiFp(this.configuration)
      .apiIdentGenerationRuleDelete(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertIdentGenerationRuleRequest} [upsertIdentGenerationRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof IdentGenerationRuleApi
   */
  public apiIdentGenerationRuleUpsertPost(
    upsertIdentGenerationRuleRequest?: UpsertIdentGenerationRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return IdentGenerationRuleApiFp(this.configuration)
      .apiIdentGenerationRuleUpsertPost(
        upsertIdentGenerationRuleRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ImportBatchApi - axios parameter creator
 * @export
 */
export const ImportBatchApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {File} [file]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchCreateWithDocumentPost: async (
      enterpriseId?: number,
      file?: File,
      documentType?: DocumentTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/ImportBatch/create-with-document`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarFormParams.append('EnterpriseId', enterpriseId as any);
      }

      if (file !== undefined) {
        localVarFormParams.append('File', file as any);
      }

      if (documentType !== undefined) {
        localVarFormParams.append('DocumentType', documentType as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} paginationCurrentPage
     * @param {number} paginationPageSize
     * @param {string} [search]
     * @param {boolean} [includeCompleted]
     * @param {string} [sortBy]
     * @param {SortDirectionOrder} [sortDirection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchGet: async (
      paginationCurrentPage: number,
      paginationPageSize: number,
      search?: string,
      includeCompleted?: boolean,
      sortBy?: string,
      sortDirection?: SortDirectionOrder,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'paginationCurrentPage' is not null or undefined
      assertParamExists(
        'apiImportBatchGet',
        'paginationCurrentPage',
        paginationCurrentPage,
      );
      // verify required parameter 'paginationPageSize' is not null or undefined
      assertParamExists(
        'apiImportBatchGet',
        'paginationPageSize',
        paginationPageSize,
      );
      const localVarPath = `/api/ImportBatch`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (search !== undefined) {
        localVarQueryParameter['Search'] = search;
      }

      if (includeCompleted !== undefined) {
        localVarQueryParameter['IncludeCompleted'] = includeCompleted;
      }

      if (sortBy !== undefined) {
        localVarQueryParameter['SortBy'] = sortBy;
      }

      if (sortDirection !== undefined) {
        localVarQueryParameter['SortDirection'] = sortDirection;
      }

      if (paginationCurrentPage !== undefined) {
        localVarQueryParameter['Pagination.CurrentPage'] =
          paginationCurrentPage;
      }

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['Pagination.PageSize'] = paginationPageSize;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} importBatchGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchImportBatchGuidDelete: async (
      importBatchGuid: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'importBatchGuid' is not null or undefined
      assertParamExists(
        'apiImportBatchImportBatchGuidDelete',
        'importBatchGuid',
        importBatchGuid,
      );
      const localVarPath = `/api/ImportBatch/{importBatchGuid}`.replace(
        `{${'importBatchGuid'}}`,
        encodeURIComponent(String(importBatchGuid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} importBatchGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchImportBatchGuidGet: async (
      importBatchGuid: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'importBatchGuid' is not null or undefined
      assertParamExists(
        'apiImportBatchImportBatchGuidGet',
        'importBatchGuid',
        importBatchGuid,
      );
      const localVarPath = `/api/ImportBatch/{importBatchGuid}`.replace(
        `{${'importBatchGuid'}}`,
        encodeURIComponent(String(importBatchGuid)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} importBatchId
     * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchImportBatchIdFinalisePost: async (
      importBatchId: number,
      finaliseImportBatchRequest?: FinaliseImportBatchRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'importBatchId' is not null or undefined
      assertParamExists(
        'apiImportBatchImportBatchIdFinalisePost',
        'importBatchId',
        importBatchId,
      );
      const localVarPath = `/api/ImportBatch/{importBatchId}/finalise`.replace(
        `{${'importBatchId'}}`,
        encodeURIComponent(String(importBatchId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        finaliseImportBatchRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertImportBatchRequest} [upsertImportBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchUpsertPost: async (
      upsertImportBatchRequest?: UpsertImportBatchRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/ImportBatch/upsert`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertImportBatchRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ImportBatchApi - functional programming interface
 * @export
 */
export const ImportBatchApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ImportBatchApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {File} [file]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiImportBatchCreateWithDocumentPost(
      enterpriseId?: number,
      file?: File,
      documentType?: DocumentTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiImportBatchCreateWithDocumentPost(
          enterpriseId,
          file,
          documentType,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'ImportBatchApi.apiImportBatchCreateWithDocumentPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} paginationCurrentPage
     * @param {number} paginationPageSize
     * @param {string} [search]
     * @param {boolean} [includeCompleted]
     * @param {string} [sortBy]
     * @param {SortDirectionOrder} [sortDirection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiImportBatchGet(
      paginationCurrentPage: number,
      paginationPageSize: number,
      search?: string,
      includeCompleted?: boolean,
      sortBy?: string,
      sortDirection?: SortDirectionOrder,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ImportBatchDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiImportBatchGet(
          paginationCurrentPage,
          paginationPageSize,
          search,
          includeCompleted,
          sortBy,
          sortDirection,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ImportBatchApi.apiImportBatchGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} importBatchGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiImportBatchImportBatchGuidDelete(
      importBatchGuid: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiImportBatchImportBatchGuidDelete(
          importBatchGuid,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'ImportBatchApi.apiImportBatchImportBatchGuidDelete'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} importBatchGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiImportBatchImportBatchGuidGet(
      importBatchGuid: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiImportBatchImportBatchGuidGet(
          importBatchGuid,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ImportBatchApi.apiImportBatchImportBatchGuidGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} importBatchId
     * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiImportBatchImportBatchIdFinalisePost(
      importBatchId: number,
      finaliseImportBatchRequest?: FinaliseImportBatchRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ImportBatchDtoResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiImportBatchImportBatchIdFinalisePost(
          importBatchId,
          finaliseImportBatchRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'ImportBatchApi.apiImportBatchImportBatchIdFinalisePost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertImportBatchRequest} [upsertImportBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiImportBatchUpsertPost(
      upsertImportBatchRequest?: UpsertImportBatchRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportBatchDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiImportBatchUpsertPost(
          upsertImportBatchRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ImportBatchApi.apiImportBatchUpsertPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * ImportBatchApi - factory interface
 * @export
 */
export const ImportBatchApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ImportBatchApiFp(configuration);
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {File} [file]
     * @param {DocumentTypeCode} [documentType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchCreateWithDocumentPost(
      enterpriseId?: number,
      file?: File,
      documentType?: DocumentTypeCode,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiImportBatchCreateWithDocumentPost(
          enterpriseId,
          file,
          documentType,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} paginationCurrentPage
     * @param {number} paginationPageSize
     * @param {string} [search]
     * @param {boolean} [includeCompleted]
     * @param {string} [sortBy]
     * @param {SortDirectionOrder} [sortDirection]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchGet(
      paginationCurrentPage: number,
      paginationPageSize: number,
      search?: string,
      includeCompleted?: boolean,
      sortBy?: string,
      sortDirection?: SortDirectionOrder,
      options?: any,
    ): AxiosPromise<ImportBatchDtoPagedResult> {
      return localVarFp
        .apiImportBatchGet(
          paginationCurrentPage,
          paginationPageSize,
          search,
          includeCompleted,
          sortBy,
          sortDirection,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} importBatchGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchImportBatchGuidDelete(
      importBatchGuid: string,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiImportBatchImportBatchGuidDelete(importBatchGuid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} importBatchGuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchImportBatchGuidGet(
      importBatchGuid: string,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .apiImportBatchImportBatchGuidGet(importBatchGuid, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} importBatchId
     * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchImportBatchIdFinalisePost(
      importBatchId: number,
      finaliseImportBatchRequest?: FinaliseImportBatchRequest,
      options?: any,
    ): AxiosPromise<ImportBatchDtoResult> {
      return localVarFp
        .apiImportBatchImportBatchIdFinalisePost(
          importBatchId,
          finaliseImportBatchRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertImportBatchRequest} [upsertImportBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiImportBatchUpsertPost(
      upsertImportBatchRequest?: UpsertImportBatchRequest,
      options?: any,
    ): AxiosPromise<ImportBatchDto> {
      return localVarFp
        .apiImportBatchUpsertPost(upsertImportBatchRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ImportBatchApi - object-oriented interface
 * @export
 * @class ImportBatchApi
 * @extends {BaseAPI}
 */
export class ImportBatchApi extends BaseAPI {
  /**
   *
   * @param {number} [enterpriseId]
   * @param {File} [file]
   * @param {DocumentTypeCode} [documentType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportBatchApi
   */
  public apiImportBatchCreateWithDocumentPost(
    enterpriseId?: number,
    file?: File,
    documentType?: DocumentTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return ImportBatchApiFp(this.configuration)
      .apiImportBatchCreateWithDocumentPost(
        enterpriseId,
        file,
        documentType,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} paginationCurrentPage
   * @param {number} paginationPageSize
   * @param {string} [search]
   * @param {boolean} [includeCompleted]
   * @param {string} [sortBy]
   * @param {SortDirectionOrder} [sortDirection]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportBatchApi
   */
  public apiImportBatchGet(
    paginationCurrentPage: number,
    paginationPageSize: number,
    search?: string,
    includeCompleted?: boolean,
    sortBy?: string,
    sortDirection?: SortDirectionOrder,
    options?: RawAxiosRequestConfig,
  ) {
    return ImportBatchApiFp(this.configuration)
      .apiImportBatchGet(
        paginationCurrentPage,
        paginationPageSize,
        search,
        includeCompleted,
        sortBy,
        sortDirection,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} importBatchGuid
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportBatchApi
   */
  public apiImportBatchImportBatchGuidDelete(
    importBatchGuid: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ImportBatchApiFp(this.configuration)
      .apiImportBatchImportBatchGuidDelete(importBatchGuid, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} importBatchGuid
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportBatchApi
   */
  public apiImportBatchImportBatchGuidGet(
    importBatchGuid: string,
    options?: RawAxiosRequestConfig,
  ) {
    return ImportBatchApiFp(this.configuration)
      .apiImportBatchImportBatchGuidGet(importBatchGuid, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} importBatchId
   * @param {FinaliseImportBatchRequest} [finaliseImportBatchRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportBatchApi
   */
  public apiImportBatchImportBatchIdFinalisePost(
    importBatchId: number,
    finaliseImportBatchRequest?: FinaliseImportBatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ImportBatchApiFp(this.configuration)
      .apiImportBatchImportBatchIdFinalisePost(
        importBatchId,
        finaliseImportBatchRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertImportBatchRequest} [upsertImportBatchRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ImportBatchApi
   */
  public apiImportBatchUpsertPost(
    upsertImportBatchRequest?: UpsertImportBatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ImportBatchApiFp(this.configuration)
      .apiImportBatchUpsertPost(upsertImportBatchRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InvitationApi - axios parameter creator
 * @export
 */
export const InvitationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {ProcessInvitationRequest} [processInvitationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvitationProcessInvitationPost: async (
      processInvitationRequest?: ProcessInvitationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invitation/ProcessInvitation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        processInvitationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvitationSendSocietyInvitationEmailPost: async (
      sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Invitation/SendSocietyInvitationEmail`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendSocietyInvitationEmailRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InvitationApi - functional programming interface
 * @export
 */
export const InvitationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    InvitationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {ProcessInvitationRequest} [processInvitationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvitationProcessInvitationPost(
      processInvitationRequest?: ProcessInvitationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvitationProcessInvitationPost(
          processInvitationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'InvitationApi.apiInvitationProcessInvitationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiInvitationSendSocietyInvitationEmailPost(
      sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiInvitationSendSocietyInvitationEmailPost(
          sendSocietyInvitationEmailRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'InvitationApi.apiInvitationSendSocietyInvitationEmailPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * InvitationApi - factory interface
 * @export
 */
export const InvitationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = InvitationApiFp(configuration);
  return {
    /**
     *
     * @param {ProcessInvitationRequest} [processInvitationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvitationProcessInvitationPost(
      processInvitationRequest?: ProcessInvitationRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiInvitationProcessInvitationPost(processInvitationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiInvitationSendSocietyInvitationEmailPost(
      sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiInvitationSendSocietyInvitationEmailPost(
          sendSocietyInvitationEmailRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * InvitationApi - object-oriented interface
 * @export
 * @class InvitationApi
 * @extends {BaseAPI}
 */
export class InvitationApi extends BaseAPI {
  /**
   *
   * @param {ProcessInvitationRequest} [processInvitationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationApi
   */
  public apiInvitationProcessInvitationPost(
    processInvitationRequest?: ProcessInvitationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return InvitationApiFp(this.configuration)
      .apiInvitationProcessInvitationPost(processInvitationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SendSocietyInvitationEmailRequest} [sendSocietyInvitationEmailRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InvitationApi
   */
  public apiInvitationSendSocietyInvitationEmailPost(
    sendSocietyInvitationEmailRequest?: SendSocietyInvitationEmailRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return InvitationApiFp(this.configuration)
      .apiInvitationSendSocietyInvitationEmailPost(
        sendSocietyInvitationEmailRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ItemCodeApi - axios parameter creator
 * @export
 */
export const ItemCodeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} itemCodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodeItemCodeIdDelete: async (
      itemCodeId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'itemCodeId' is not null or undefined
      assertParamExists(
        'apiItemCodeItemCodeIdDelete',
        'itemCodeId',
        itemCodeId,
      );
      const localVarPath = `/api/ItemCode/{itemCodeId}`.replace(
        `{${'itemCodeId'}}`,
        encodeURIComponent(String(itemCodeId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} itemCodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodeItemCodeIdGet: async (
      itemCodeId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'itemCodeId' is not null or undefined
      assertParamExists('apiItemCodeItemCodeIdGet', 'itemCodeId', itemCodeId);
      const localVarPath = `/api/ItemCode/{itemCodeId}`.replace(
        `{${'itemCodeId'}}`,
        encodeURIComponent(String(itemCodeId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodeOrgOrgIdGet: async (
      orgId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'orgId' is not null or undefined
      assertParamExists('apiItemCodeOrgOrgIdGet', 'orgId', orgId);
      const localVarPath = `/api/ItemCode/Org/{orgId}`.replace(
        `{${'orgId'}}`,
        encodeURIComponent(String(orgId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertItemCodeRequest} [upsertItemCodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodePost: async (
      upsertItemCodeRequest?: UpsertItemCodeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/ItemCode`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertItemCodeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ItemCodeApi - functional programming interface
 * @export
 */
export const ItemCodeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ItemCodeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} itemCodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiItemCodeItemCodeIdDelete(
      itemCodeId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiItemCodeItemCodeIdDelete(
          itemCodeId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ItemCodeApi.apiItemCodeItemCodeIdDelete']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} itemCodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiItemCodeItemCodeIdGet(
      itemCodeId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemCodeDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiItemCodeItemCodeIdGet(
          itemCodeId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ItemCodeApi.apiItemCodeItemCodeIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiItemCodeOrgOrgIdGet(
      orgId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ItemCodeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiItemCodeOrgOrgIdGet(orgId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ItemCodeApi.apiItemCodeOrgOrgIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertItemCodeRequest} [upsertItemCodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiItemCodePost(
      upsertItemCodeRequest?: UpsertItemCodeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ItemCodeDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiItemCodePost(
        upsertItemCodeRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ItemCodeApi.apiItemCodePost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * ItemCodeApi - factory interface
 * @export
 */
export const ItemCodeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ItemCodeApiFp(configuration);
  return {
    /**
     *
     * @param {number} itemCodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodeItemCodeIdDelete(
      itemCodeId: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiItemCodeItemCodeIdDelete(itemCodeId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} itemCodeId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodeItemCodeIdGet(
      itemCodeId: number,
      options?: any,
    ): AxiosPromise<ItemCodeDto> {
      return localVarFp
        .apiItemCodeItemCodeIdGet(itemCodeId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} orgId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodeOrgOrgIdGet(
      orgId: number,
      options?: any,
    ): AxiosPromise<Array<ItemCodeDto>> {
      return localVarFp
        .apiItemCodeOrgOrgIdGet(orgId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertItemCodeRequest} [upsertItemCodeRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiItemCodePost(
      upsertItemCodeRequest?: UpsertItemCodeRequest,
      options?: any,
    ): AxiosPromise<ItemCodeDto> {
      return localVarFp
        .apiItemCodePost(upsertItemCodeRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ItemCodeApi - object-oriented interface
 * @export
 * @class ItemCodeApi
 * @extends {BaseAPI}
 */
export class ItemCodeApi extends BaseAPI {
  /**
   *
   * @param {number} itemCodeId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemCodeApi
   */
  public apiItemCodeItemCodeIdDelete(
    itemCodeId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ItemCodeApiFp(this.configuration)
      .apiItemCodeItemCodeIdDelete(itemCodeId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} itemCodeId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemCodeApi
   */
  public apiItemCodeItemCodeIdGet(
    itemCodeId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ItemCodeApiFp(this.configuration)
      .apiItemCodeItemCodeIdGet(itemCodeId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} orgId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemCodeApi
   */
  public apiItemCodeOrgOrgIdGet(
    orgId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ItemCodeApiFp(this.configuration)
      .apiItemCodeOrgOrgIdGet(orgId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertItemCodeRequest} [upsertItemCodeRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ItemCodeApi
   */
  public apiItemCodePost(
    upsertItemCodeRequest?: UpsertItemCodeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ItemCodeApiFp(this.configuration)
      .apiItemCodePost(upsertItemCodeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MembershipApi - axios parameter creator
 * @export
 */
export const MembershipApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} membershipId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipApproveMembershipIdPatch: async (
      membershipId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'membershipId' is not null or undefined
      assertParamExists(
        'apiMembershipApproveMembershipIdPatch',
        'membershipId',
        membershipId,
      );
      const localVarPath = `/api/Membership/Approve/{membershipId}`.replace(
        `{${'membershipId'}}`,
        encodeURIComponent(String(membershipId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [membershipId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipDelete: async (
      membershipId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Membership`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (membershipId !== undefined) {
        localVarQueryParameter['membershipId'] = membershipId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [membershipId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGet: async (
      membershipId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Membership`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (membershipId !== undefined) {
        localVarQueryParameter['membershipId'] = membershipId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} enterpriseId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet: async (
      enterpriseId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'enterpriseId' is not null or undefined
      assertParamExists(
        'apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet',
        'enterpriseId',
        enterpriseId,
      );
      const localVarPath =
        `/api/Membership/GetMembershipsByEnterpriseId/{enterpriseId}`.replace(
          `{${'enterpriseId'}}`,
          encodeURIComponent(String(enterpriseId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGetMembershipsByUserIdUserIdGet: async (
      userId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists(
        'apiMembershipGetMembershipsByUserIdUserIdGet',
        'userId',
        userId,
      );
      const localVarPath =
        `/api/Membership/GetMembershipsByUserId/{userId}`.replace(
          `{${'userId'}}`,
          encodeURIComponent(String(userId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGetRenewalConfigGet: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Membership/GetRenewalConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddMembershipRequest} [addMembershipRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipPost: async (
      addMembershipRequest?: AddMembershipRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Membership`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addMembershipRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateMembershipRequest} [updateMembershipRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipPut: async (
      updateMembershipRequest?: UpdateMembershipRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Membership`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMembershipRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MembershipApi - functional programming interface
 * @export
 */
export const MembershipApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MembershipApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} membershipId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipApproveMembershipIdPatch(
      membershipId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipApproveMembershipIdPatch(
          membershipId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipApi.apiMembershipApproveMembershipIdPatch'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [membershipId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipDelete(
      membershipId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipDelete(
          membershipId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipApi.apiMembershipDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [membershipId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipGet(
      membershipId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MembershipReturnDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipGet(membershipId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipApi.apiMembershipGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} enterpriseId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet(
      enterpriseId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipApi.apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipGetMembershipsByUserIdUserIdGet(
      userId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipGetMembershipsByUserIdUserIdGet(
          userId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipApi.apiMembershipGetMembershipsByUserIdUserIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipGetRenewalConfigGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipGetRenewalConfigGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipApi.apiMembershipGetRenewalConfigGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AddMembershipRequest} [addMembershipRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipPost(
      addMembershipRequest?: AddMembershipRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipPost(
          addMembershipRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipApi.apiMembershipPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateMembershipRequest} [updateMembershipRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipPut(
      updateMembershipRequest?: UpdateMembershipRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MembershipDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipPut(
          updateMembershipRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipApi.apiMembershipPut']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * MembershipApi - factory interface
 * @export
 */
export const MembershipApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MembershipApiFp(configuration);
  return {
    /**
     *
     * @param {number} membershipId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipApproveMembershipIdPatch(
      membershipId: number,
      options?: any,
    ): AxiosPromise<MembershipDto> {
      return localVarFp
        .apiMembershipApproveMembershipIdPatch(membershipId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [membershipId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipDelete(
      membershipId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiMembershipDelete(membershipId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [membershipId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGet(
      membershipId?: number,
      options?: any,
    ): AxiosPromise<MembershipReturnDto> {
      return localVarFp
        .apiMembershipGet(membershipId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} enterpriseId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet(
      enterpriseId: number,
      options?: any,
    ): AxiosPromise<Array<MembershipDto>> {
      return localVarFp
        .apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet(
          enterpriseId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGetMembershipsByUserIdUserIdGet(
      userId: number,
      options?: any,
    ): AxiosPromise<Array<MembershipDto>> {
      return localVarFp
        .apiMembershipGetMembershipsByUserIdUserIdGet(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipGetRenewalConfigGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<MembershipDto> {
      return localVarFp
        .apiMembershipGetRenewalConfigGet(enterpriseId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddMembershipRequest} [addMembershipRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipPost(
      addMembershipRequest?: AddMembershipRequest,
      options?: any,
    ): AxiosPromise<MembershipDto> {
      return localVarFp
        .apiMembershipPost(addMembershipRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateMembershipRequest} [updateMembershipRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipPut(
      updateMembershipRequest?: UpdateMembershipRequest,
      options?: any,
    ): AxiosPromise<MembershipDto> {
      return localVarFp
        .apiMembershipPut(updateMembershipRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MembershipApi - object-oriented interface
 * @export
 * @class MembershipApi
 * @extends {BaseAPI}
 */
export class MembershipApi extends BaseAPI {
  /**
   *
   * @param {number} membershipId
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipApproveMembershipIdPatch(
    membershipId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipApproveMembershipIdPatch(membershipId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [membershipId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipDelete(
    membershipId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipDelete(membershipId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [membershipId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipGet(
    membershipId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipGet(membershipId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} enterpriseId
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet(
    enterpriseId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipGetMembershipsByEnterpriseIdEnterpriseIdGet(
        enterpriseId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipGetMembershipsByUserIdUserIdGet(
    userId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipGetMembershipsByUserIdUserIdGet(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipGetRenewalConfigGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipGetRenewalConfigGet(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddMembershipRequest} [addMembershipRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipPost(
    addMembershipRequest?: AddMembershipRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipPost(addMembershipRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateMembershipRequest} [updateMembershipRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipApi
   */
  public apiMembershipPut(
    updateMembershipRequest?: UpdateMembershipRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipApiFp(this.configuration)
      .apiMembershipPut(updateMembershipRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MembershipBenefitApi - axios parameter creator
 * @export
 */
export const MembershipBenefitApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UpsertMembershipBenefitsRequest} [upsertMembershipBenefitsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipBenefitBulkPost: async (
      upsertMembershipBenefitsRequest?: UpsertMembershipBenefitsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipBenefit/Bulk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertMembershipBenefitsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [memberBenefitId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipBenefitDelete: async (
      memberBenefitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipBenefit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (memberBenefitId !== undefined) {
        localVarQueryParameter['memberBenefitId'] = memberBenefitId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipBenefitGet: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipBenefit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MembershipBenefitApi - functional programming interface
 * @export
 */
export const MembershipBenefitApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MembershipBenefitApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UpsertMembershipBenefitsRequest} [upsertMembershipBenefitsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipBenefitBulkPost(
      upsertMembershipBenefitsRequest?: UpsertMembershipBenefitsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipBenefitDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipBenefitBulkPost(
          upsertMembershipBenefitsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipBenefitApi.apiMembershipBenefitBulkPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [memberBenefitId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipBenefitDelete(
      memberBenefitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipBenefitDelete(
          memberBenefitId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipBenefitApi.apiMembershipBenefitDelete']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipBenefitGet(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipBenefitDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipBenefitGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipBenefitApi.apiMembershipBenefitGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * MembershipBenefitApi - factory interface
 * @export
 */
export const MembershipBenefitApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MembershipBenefitApiFp(configuration);
  return {
    /**
     *
     * @param {UpsertMembershipBenefitsRequest} [upsertMembershipBenefitsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipBenefitBulkPost(
      upsertMembershipBenefitsRequest?: UpsertMembershipBenefitsRequest,
      options?: any,
    ): AxiosPromise<Array<MembershipBenefitDto>> {
      return localVarFp
        .apiMembershipBenefitBulkPost(upsertMembershipBenefitsRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [memberBenefitId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipBenefitDelete(
      memberBenefitId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiMembershipBenefitDelete(memberBenefitId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipBenefitGet(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<MembershipBenefitDto>> {
      return localVarFp
        .apiMembershipBenefitGet(organisationId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MembershipBenefitApi - object-oriented interface
 * @export
 * @class MembershipBenefitApi
 * @extends {BaseAPI}
 */
export class MembershipBenefitApi extends BaseAPI {
  /**
   *
   * @param {UpsertMembershipBenefitsRequest} [upsertMembershipBenefitsRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipBenefitApi
   */
  public apiMembershipBenefitBulkPost(
    upsertMembershipBenefitsRequest?: UpsertMembershipBenefitsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipBenefitApiFp(this.configuration)
      .apiMembershipBenefitBulkPost(upsertMembershipBenefitsRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [memberBenefitId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipBenefitApi
   */
  public apiMembershipBenefitDelete(
    memberBenefitId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipBenefitApiFp(this.configuration)
      .apiMembershipBenefitDelete(memberBenefitId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipBenefitApi
   */
  public apiMembershipBenefitGet(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipBenefitApiFp(this.configuration)
      .apiMembershipBenefitGet(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MembershipTypeApi - axios parameter creator
 * @export
 */
export const MembershipTypeApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UpsertMembershipTypeRequest} [upsertMembershipTypeRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeBulkPost: async (
      upsertMembershipTypeRequest?: UpsertMembershipTypeRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipType/Bulk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertMembershipTypeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeDelete: async (
      requestBody?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipType`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [membershipTypeId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeGet: async (
      membershipTypeId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipType`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (membershipTypeId !== undefined) {
        localVarQueryParameter['membershipTypeId'] = membershipTypeId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} enterpriseId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet: async (
      enterpriseId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'enterpriseId' is not null or undefined
      assertParamExists(
        'apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet',
        'enterpriseId',
        enterpriseId,
      );
      const localVarPath =
        `/api/MembershipType/GetMembershipTypesByEnterpriseId/{EnterpriseId}`.replace(
          `{${'EnterpriseId'}}`,
          encodeURIComponent(String(enterpriseId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} organisationId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet:
      async (
        organisationId: number,
        options: RawAxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'organisationId' is not null or undefined
        assertParamExists(
          'apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet',
          'organisationId',
          organisationId,
        );
        const localVarPath =
          `/api/MembershipType/GetMembershipTypesByOrganisationId/{organisationId}`.replace(
            `{${'organisationId'}}`,
            encodeURIComponent(String(organisationId)),
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: 'GET',
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication X-Organisation-Id required
        await setApiKeyToObject(
          localVarHeaderParameter,
          'X-Organisation-Id',
          configuration,
        );

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          'Authorization',
          configuration,
        );

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     *
     * @param {SetMembershipTypeStatusRequest} [setMembershipTypeStatusRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeSetMembershipTypeStatusPost: async (
      setMembershipTypeStatusRequest?: SetMembershipTypeStatusRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipType/SetMembershipTypeStatus`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        setMembershipTypeStatusRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MembershipTypeApi - functional programming interface
 * @export
 */
export const MembershipTypeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MembershipTypeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UpsertMembershipTypeRequest} [upsertMembershipTypeRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeBulkPost(
      upsertMembershipTypeRequest?: UpsertMembershipTypeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipTypeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeBulkPost(
          upsertMembershipTypeRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipTypeApi.apiMembershipTypeBulkPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeDelete(
      requestBody?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeDelete(
          requestBody,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipTypeApi.apiMembershipTypeDelete']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [membershipTypeId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeGet(
      membershipTypeId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MembershipTypeDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeGet(
          membershipTypeId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['MembershipTypeApi.apiMembershipTypeGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} enterpriseId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet(
      enterpriseId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipTypeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipTypeApi.apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} organisationId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet(
      organisationId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipTypeDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipTypeApi.apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SetMembershipTypeStatusRequest} [setMembershipTypeStatusRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeSetMembershipTypeStatusPost(
      setMembershipTypeStatusRequest?: SetMembershipTypeStatusRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MembershipTypeDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeSetMembershipTypeStatusPost(
          setMembershipTypeStatusRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipTypeApi.apiMembershipTypeSetMembershipTypeStatusPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * MembershipTypeApi - factory interface
 * @export
 */
export const MembershipTypeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MembershipTypeApiFp(configuration);
  return {
    /**
     *
     * @param {UpsertMembershipTypeRequest} [upsertMembershipTypeRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeBulkPost(
      upsertMembershipTypeRequest?: UpsertMembershipTypeRequest,
      options?: any,
    ): AxiosPromise<Array<MembershipTypeDto>> {
      return localVarFp
        .apiMembershipTypeBulkPost(upsertMembershipTypeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeDelete(
      requestBody?: Array<number>,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiMembershipTypeDelete(requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [membershipTypeId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeGet(
      membershipTypeId?: number,
      options?: any,
    ): AxiosPromise<MembershipTypeDto> {
      return localVarFp
        .apiMembershipTypeGet(membershipTypeId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} enterpriseId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet(
      enterpriseId: number,
      options?: any,
    ): AxiosPromise<Array<MembershipTypeDto>> {
      return localVarFp
        .apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet(
          enterpriseId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} organisationId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet(
      organisationId: number,
      options?: any,
    ): AxiosPromise<Array<MembershipTypeDto>> {
      return localVarFp
        .apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet(
          organisationId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SetMembershipTypeStatusRequest} [setMembershipTypeStatusRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeSetMembershipTypeStatusPost(
      setMembershipTypeStatusRequest?: SetMembershipTypeStatusRequest,
      options?: any,
    ): AxiosPromise<MembershipTypeDto> {
      return localVarFp
        .apiMembershipTypeSetMembershipTypeStatusPost(
          setMembershipTypeStatusRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MembershipTypeApi - object-oriented interface
 * @export
 * @class MembershipTypeApi
 * @extends {BaseAPI}
 */
export class MembershipTypeApi extends BaseAPI {
  /**
   *
   * @param {UpsertMembershipTypeRequest} [upsertMembershipTypeRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeApi
   */
  public apiMembershipTypeBulkPost(
    upsertMembershipTypeRequest?: UpsertMembershipTypeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeApiFp(this.configuration)
      .apiMembershipTypeBulkPost(upsertMembershipTypeRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<number>} [requestBody]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeApi
   */
  public apiMembershipTypeDelete(
    requestBody?: Array<number>,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeApiFp(this.configuration)
      .apiMembershipTypeDelete(requestBody, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [membershipTypeId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeApi
   */
  public apiMembershipTypeGet(
    membershipTypeId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeApiFp(this.configuration)
      .apiMembershipTypeGet(membershipTypeId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} enterpriseId
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeApi
   */
  public apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet(
    enterpriseId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeApiFp(this.configuration)
      .apiMembershipTypeGetMembershipTypesByEnterpriseIdEnterpriseIdGet(
        enterpriseId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} organisationId
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeApi
   */
  public apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet(
    organisationId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeApiFp(this.configuration)
      .apiMembershipTypeGetMembershipTypesByOrganisationIdOrganisationIdGet(
        organisationId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SetMembershipTypeStatusRequest} [setMembershipTypeStatusRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeApi
   */
  public apiMembershipTypeSetMembershipTypeStatusPost(
    setMembershipTypeStatusRequest?: SetMembershipTypeStatusRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeApiFp(this.configuration)
      .apiMembershipTypeSetMembershipTypeStatusPost(
        setMembershipTypeStatusRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MembershipTypeBenefitAsscApi - axios parameter creator
 * @export
 */
export const MembershipTypeBenefitAsscApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeBenefitAsscGet: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipTypeBenefitAssc`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<MergeMembershipTypeBenefitsAsscsRequest>} [mergeMembershipTypeBenefitsAsscsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeBenefitAsscMergePost: async (
      mergeMembershipTypeBenefitsAsscsRequest?: Array<MergeMembershipTypeBenefitsAsscsRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipTypeBenefitAssc/Merge`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mergeMembershipTypeBenefitsAsscsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MembershipTypeBenefitAsscApi - functional programming interface
 * @export
 */
export const MembershipTypeBenefitAsscApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    MembershipTypeBenefitAsscApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeBenefitAsscGet(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipTypeBenefitAsscDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeBenefitAsscGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipTypeBenefitAsscApi.apiMembershipTypeBenefitAsscGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Array<MergeMembershipTypeBenefitsAsscsRequest>} [mergeMembershipTypeBenefitsAsscsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeBenefitAsscMergePost(
      mergeMembershipTypeBenefitsAsscsRequest?: Array<MergeMembershipTypeBenefitsAsscsRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipTypeBenefitAsscDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeBenefitAsscMergePost(
          mergeMembershipTypeBenefitsAsscsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipTypeBenefitAsscApi.apiMembershipTypeBenefitAsscMergePost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * MembershipTypeBenefitAsscApi - factory interface
 * @export
 */
export const MembershipTypeBenefitAsscApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MembershipTypeBenefitAsscApiFp(configuration);
  return {
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeBenefitAsscGet(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<MembershipTypeBenefitAsscDto>> {
      return localVarFp
        .apiMembershipTypeBenefitAsscGet(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<MergeMembershipTypeBenefitsAsscsRequest>} [mergeMembershipTypeBenefitsAsscsRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeBenefitAsscMergePost(
      mergeMembershipTypeBenefitsAsscsRequest?: Array<MergeMembershipTypeBenefitsAsscsRequest>,
      options?: any,
    ): AxiosPromise<Array<MembershipTypeBenefitAsscDto>> {
      return localVarFp
        .apiMembershipTypeBenefitAsscMergePost(
          mergeMembershipTypeBenefitsAsscsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MembershipTypeBenefitAsscApi - object-oriented interface
 * @export
 * @class MembershipTypeBenefitAsscApi
 * @extends {BaseAPI}
 */
export class MembershipTypeBenefitAsscApi extends BaseAPI {
  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeBenefitAsscApi
   */
  public apiMembershipTypeBenefitAsscGet(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeBenefitAsscApiFp(this.configuration)
      .apiMembershipTypeBenefitAsscGet(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<MergeMembershipTypeBenefitsAsscsRequest>} [mergeMembershipTypeBenefitsAsscsRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeBenefitAsscApi
   */
  public apiMembershipTypeBenefitAsscMergePost(
    mergeMembershipTypeBenefitsAsscsRequest?: Array<MergeMembershipTypeBenefitsAsscsRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeBenefitAsscApiFp(this.configuration)
      .apiMembershipTypeBenefitAsscMergePost(
        mergeMembershipTypeBenefitsAsscsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MembershipTypeDurationApi - axios parameter creator
 * @export
 */
export const MembershipTypeDurationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UpsertMembershipTypeDurationRequest} [upsertMembershipTypeDurationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeDurationBulkPost: async (
      upsertMembershipTypeDurationRequest?: UpsertMembershipTypeDurationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipTypeDuration/Bulk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertMembershipTypeDurationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [membershipTypeDurationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeDurationDelete: async (
      membershipTypeDurationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/MembershipTypeDuration`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (membershipTypeDurationId !== undefined) {
        localVarQueryParameter['membershipTypeDurationId'] =
          membershipTypeDurationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MembershipTypeDurationApi - functional programming interface
 * @export
 */
export const MembershipTypeDurationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    MembershipTypeDurationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UpsertMembershipTypeDurationRequest} [upsertMembershipTypeDurationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeDurationBulkPost(
      upsertMembershipTypeDurationRequest?: UpsertMembershipTypeDurationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<MembershipTypeDurationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeDurationBulkPost(
          upsertMembershipTypeDurationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipTypeDurationApi.apiMembershipTypeDurationBulkPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [membershipTypeDurationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async apiMembershipTypeDurationDelete(
      membershipTypeDurationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiMembershipTypeDurationDelete(
          membershipTypeDurationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'MembershipTypeDurationApi.apiMembershipTypeDurationDelete'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * MembershipTypeDurationApi - factory interface
 * @export
 */
export const MembershipTypeDurationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MembershipTypeDurationApiFp(configuration);
  return {
    /**
     *
     * @param {UpsertMembershipTypeDurationRequest} [upsertMembershipTypeDurationRequest]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeDurationBulkPost(
      upsertMembershipTypeDurationRequest?: UpsertMembershipTypeDurationRequest,
      options?: any,
    ): AxiosPromise<Array<MembershipTypeDurationDto>> {
      return localVarFp
        .apiMembershipTypeDurationBulkPost(
          upsertMembershipTypeDurationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [membershipTypeDurationId]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    apiMembershipTypeDurationDelete(
      membershipTypeDurationId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiMembershipTypeDurationDelete(membershipTypeDurationId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * MembershipTypeDurationApi - object-oriented interface
 * @export
 * @class MembershipTypeDurationApi
 * @extends {BaseAPI}
 */
export class MembershipTypeDurationApi extends BaseAPI {
  /**
   *
   * @param {UpsertMembershipTypeDurationRequest} [upsertMembershipTypeDurationRequest]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeDurationApi
   */
  public apiMembershipTypeDurationBulkPost(
    upsertMembershipTypeDurationRequest?: UpsertMembershipTypeDurationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeDurationApiFp(this.configuration)
      .apiMembershipTypeDurationBulkPost(
        upsertMembershipTypeDurationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [membershipTypeDurationId]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MembershipTypeDurationApi
   */
  public apiMembershipTypeDurationDelete(
    membershipTypeDurationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return MembershipTypeDurationApiFp(this.configuration)
      .apiMembershipTypeDurationDelete(membershipTypeDurationId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * NoteApi - axios parameter creator
 * @export
 */
export const NoteApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [noteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteDelete: async (
      noteId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Note`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (noteId !== undefined) {
        localVarQueryParameter['noteId'] = noteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [noteEntityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteGetNoteByEntityIdGet: async (
      noteEntityId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Note/GetNoteByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (noteEntityId !== undefined) {
        localVarQueryParameter['noteEntityId'] = noteEntityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [noteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteGetNoteByIdGet: async (
      noteId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Note/GetNoteById`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (noteId !== undefined) {
        localVarQueryParameter['noteId'] = noteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertNoteRequest} [upsertNoteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotePost: async (
      upsertNoteRequest?: UpsertNoteRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Note`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertNoteRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {NoteSearchSortRequest} [noteSearchSortRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteSearchSortFilterNotePost: async (
      noteSearchSortRequest?: NoteSearchSortRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Note/SearchSortFilterNote`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        noteSearchSortRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * NoteApi - functional programming interface
 * @export
 */
export const NoteApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NoteApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [noteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiNoteDelete(
      noteId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiNoteDelete(
        noteId,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['NoteApi.apiNoteDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [noteEntityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiNoteGetNoteByEntityIdGet(
      noteEntityId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiNoteGetNoteByEntityIdGet(
          noteEntityId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['NoteApi.apiNoteGetNoteByEntityIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [noteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiNoteGetNoteByIdGet(
      noteId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiNoteGetNoteByIdGet(noteId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['NoteApi.apiNoteGetNoteByIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertNoteRequest} [upsertNoteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiNotePost(
      upsertNoteRequest?: UpsertNoteRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<NoteDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotePost(
        upsertNoteRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['NoteApi.apiNotePost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {NoteSearchSortRequest} [noteSearchSortRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiNoteSearchSortFilterNotePost(
      noteSearchSortRequest?: NoteSearchSortRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<NoteDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiNoteSearchSortFilterNotePost(
          noteSearchSortRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['NoteApi.apiNoteSearchSortFilterNotePost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * NoteApi - factory interface
 * @export
 */
export const NoteApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = NoteApiFp(configuration);
  return {
    /**
     *
     * @param {number} [noteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteDelete(noteId?: number, options?: any): AxiosPromise<boolean> {
      return localVarFp
        .apiNoteDelete(noteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [noteEntityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteGetNoteByEntityIdGet(
      noteEntityId?: string,
      options?: any,
    ): AxiosPromise<NoteDto> {
      return localVarFp
        .apiNoteGetNoteByEntityIdGet(noteEntityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [noteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteGetNoteByIdGet(
      noteId?: number,
      options?: any,
    ): AxiosPromise<NoteDto> {
      return localVarFp
        .apiNoteGetNoteByIdGet(noteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertNoteRequest} [upsertNoteRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNotePost(
      upsertNoteRequest?: UpsertNoteRequest,
      options?: any,
    ): AxiosPromise<NoteDto> {
      return localVarFp
        .apiNotePost(upsertNoteRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {NoteSearchSortRequest} [noteSearchSortRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiNoteSearchSortFilterNotePost(
      noteSearchSortRequest?: NoteSearchSortRequest,
      options?: any,
    ): AxiosPromise<NoteDtoPagedResult> {
      return localVarFp
        .apiNoteSearchSortFilterNotePost(noteSearchSortRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * NoteApi - object-oriented interface
 * @export
 * @class NoteApi
 * @extends {BaseAPI}
 */
export class NoteApi extends BaseAPI {
  /**
   *
   * @param {number} [noteId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NoteApi
   */
  public apiNoteDelete(noteId?: number, options?: RawAxiosRequestConfig) {
    return NoteApiFp(this.configuration)
      .apiNoteDelete(noteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [noteEntityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NoteApi
   */
  public apiNoteGetNoteByEntityIdGet(
    noteEntityId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return NoteApiFp(this.configuration)
      .apiNoteGetNoteByEntityIdGet(noteEntityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [noteId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NoteApi
   */
  public apiNoteGetNoteByIdGet(
    noteId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return NoteApiFp(this.configuration)
      .apiNoteGetNoteByIdGet(noteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertNoteRequest} [upsertNoteRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NoteApi
   */
  public apiNotePost(
    upsertNoteRequest?: UpsertNoteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoteApiFp(this.configuration)
      .apiNotePost(upsertNoteRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {NoteSearchSortRequest} [noteSearchSortRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NoteApi
   */
  public apiNoteSearchSortFilterNotePost(
    noteSearchSortRequest?: NoteSearchSortRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return NoteApiFp(this.configuration)
      .apiNoteSearchSortFilterNotePost(noteSearchSortRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * OrganisationApi - axios parameter creator
 * @export
 */
export const OrganisationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationByEnterpriseIdGet: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Organisation/ByEnterpriseId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationByEntityIdGet: async (
      entityId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Organisation/ByEntityId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Organisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationGetOrganisationByIdGet: async (
      entityId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Organisation/GetOrganisationById`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateOrganisationRequest} [updateOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationPatch: async (
      updateOrganisationRequest?: UpdateOrganisationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Organisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateOrganisationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddOrganisationRequest} [addOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationPost: async (
      addOrganisationRequest?: AddOrganisationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Organisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addOrganisationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrganisationApi - functional programming interface
 * @export
 */
export const OrganisationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    OrganisationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationByEnterpriseIdGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationByEnterpriseIdGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationApi.apiOrganisationByEnterpriseIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationByEntityIdGet(
      entityId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationByEntityIdGet(
          entityId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['OrganisationApi.apiOrganisationByEntityIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganisationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['OrganisationApi.apiOrganisationGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationGetOrganisationByIdGet(
      entityId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationGetOrganisationByIdGet(
          entityId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationApi.apiOrganisationGetOrganisationByIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateOrganisationRequest} [updateOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationPatch(
      updateOrganisationRequest?: UpdateOrganisationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationPatch(
          updateOrganisationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['OrganisationApi.apiOrganisationPatch']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AddOrganisationRequest} [addOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationPost(
      addOrganisationRequest?: AddOrganisationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationPost(
          addOrganisationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['OrganisationApi.apiOrganisationPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * OrganisationApi - factory interface
 * @export
 */
export const OrganisationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OrganisationApiFp(configuration);
  return {
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationByEnterpriseIdGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<OrganisationDto> {
      return localVarFp
        .apiOrganisationByEnterpriseIdGet(enterpriseId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationByEntityIdGet(
      entityId?: string,
      options?: any,
    ): AxiosPromise<OrganisationDto> {
      return localVarFp
        .apiOrganisationByEntityIdGet(entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationGet(options?: any): AxiosPromise<Array<OrganisationDto>> {
      return localVarFp
        .apiOrganisationGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationGetOrganisationByIdGet(
      entityId?: number,
      options?: any,
    ): AxiosPromise<OrganisationDto> {
      return localVarFp
        .apiOrganisationGetOrganisationByIdGet(entityId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateOrganisationRequest} [updateOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationPatch(
      updateOrganisationRequest?: UpdateOrganisationRequest,
      options?: any,
    ): AxiosPromise<OrganisationDto> {
      return localVarFp
        .apiOrganisationPatch(updateOrganisationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddOrganisationRequest} [addOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationPost(
      addOrganisationRequest?: AddOrganisationRequest,
      options?: any,
    ): AxiosPromise<OrganisationDto> {
      return localVarFp
        .apiOrganisationPost(addOrganisationRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * OrganisationApi - object-oriented interface
 * @export
 * @class OrganisationApi
 * @extends {BaseAPI}
 */
export class OrganisationApi extends BaseAPI {
  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationApi
   */
  public apiOrganisationByEnterpriseIdGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationApiFp(this.configuration)
      .apiOrganisationByEnterpriseIdGet(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [entityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationApi
   */
  public apiOrganisationByEntityIdGet(
    entityId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationApiFp(this.configuration)
      .apiOrganisationByEntityIdGet(entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationApi
   */
  public apiOrganisationGet(options?: RawAxiosRequestConfig) {
    return OrganisationApiFp(this.configuration)
      .apiOrganisationGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [entityId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationApi
   */
  public apiOrganisationGetOrganisationByIdGet(
    entityId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationApiFp(this.configuration)
      .apiOrganisationGetOrganisationByIdGet(entityId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateOrganisationRequest} [updateOrganisationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationApi
   */
  public apiOrganisationPatch(
    updateOrganisationRequest?: UpdateOrganisationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationApiFp(this.configuration)
      .apiOrganisationPatch(updateOrganisationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddOrganisationRequest} [addOrganisationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationApi
   */
  public apiOrganisationPost(
    addOrganisationRequest?: AddOrganisationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationApiFp(this.configuration)
      .apiOrganisationPost(addOrganisationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * OrganisationSettingApi - axios parameter creator
 * @export
 */
export const OrganisationSettingApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingBulkPost: async (
      upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/Bulk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertOrganisationSettingsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGet: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost: async (
      organisationId?: number,
      requestBody?: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/GetByOrganisationIdAndSettingIds`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost: async (
      getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/GetByOrganisationIdAndSettingTypes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        getSettingsByOrganisationAndSettingTypesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [orgId]
     * @param {FormType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetOrgSettingFormFieldsGet: async (
      orgId?: number,
      type?: FormType,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/GetOrgSettingFormFields`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [orgId]
     * @param {FormType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetOrgSettingFormGet: async (
      orgId?: number,
      type?: FormType,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/GetOrgSettingForm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (orgId !== undefined) {
        localVarQueryParameter['orgId'] = orgId;
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetStudbookOptInSettingsGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/GetStudbookOptInSettings`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingUpsertOrgSettingFormFieldsPost: async (
      upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/UpsertOrgSettingFormFields`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertOrgSettingFormRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingUpsertOrgSettingFormPost: async (
      upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/UpsertOrgSettingForm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertOrgSettingFormRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<UpsertOrgSettingFormRequest>} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingUpsertOrgSettingFormsPost: async (
      upsertOrgSettingFormRequest?: Array<UpsertOrgSettingFormRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/OrganisationSetting/UpsertOrgSettingForms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertOrgSettingFormRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * OrganisationSettingApi - functional programming interface
 * @export
 */
export const OrganisationSettingApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    OrganisationSettingApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingBulkPost(
      upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganisationSettingDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingBulkPost(
          upsertOrganisationSettingsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingBulkPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingGet(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganisationSettingDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(
      organisationId?: number,
      requestBody?: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganisationSettingDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(
          organisationId,
          requestBody,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(
      getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganisationSettingDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(
          getSettingsByOrganisationAndSettingTypesRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [orgId]
     * @param {FormType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingGetOrgSettingFormFieldsGet(
      orgId?: number,
      type?: FormType,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationSettingsFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingGetOrgSettingFormFieldsGet(
          orgId,
          type,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingGetOrgSettingFormFieldsGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [orgId]
     * @param {FormType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingGetOrgSettingFormGet(
      orgId?: number,
      type?: FormType,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationSettingsFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingGetOrgSettingFormGet(
          orgId,
          type,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingGetOrgSettingFormGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingGetStudbookOptInSettingsGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrgsOptInSetting>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingGetStudbookOptInSettingsGet(
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingGetStudbookOptInSettingsGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingUpsertOrgSettingFormFieldsPost(
      upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationSettingsFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingUpsertOrgSettingFormFieldsPost(
          upsertOrgSettingFormRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingUpsertOrgSettingFormFieldsPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingUpsertOrgSettingFormPost(
      upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationSettingsFormDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingUpsertOrgSettingFormPost(
          upsertOrgSettingFormRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingUpsertOrgSettingFormPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Array<UpsertOrgSettingFormRequest>} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiOrganisationSettingUpsertOrgSettingFormsPost(
      upsertOrgSettingFormRequest?: Array<UpsertOrgSettingFormRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganisationSettingDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiOrganisationSettingUpsertOrgSettingFormsPost(
          upsertOrgSettingFormRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'OrganisationSettingApi.apiOrganisationSettingUpsertOrgSettingFormsPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * OrganisationSettingApi - factory interface
 * @export
 */
export const OrganisationSettingApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = OrganisationSettingApiFp(configuration);
  return {
    /**
     *
     * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingBulkPost(
      upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>,
      options?: any,
    ): AxiosPromise<Array<OrganisationSettingDto>> {
      return localVarFp
        .apiOrganisationSettingBulkPost(
          upsertOrganisationSettingsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGet(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<OrganisationSettingDto>> {
      return localVarFp
        .apiOrganisationSettingGet(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {Array<number>} [requestBody]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(
      organisationId?: number,
      requestBody?: Array<number>,
      options?: any,
    ): AxiosPromise<Array<OrganisationSettingDto>> {
      return localVarFp
        .apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(
          organisationId,
          requestBody,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(
      getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest,
      options?: any,
    ): AxiosPromise<Array<OrganisationSettingDto>> {
      return localVarFp
        .apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(
          getSettingsByOrganisationAndSettingTypesRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [orgId]
     * @param {FormType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetOrgSettingFormFieldsGet(
      orgId?: number,
      type?: FormType,
      options?: any,
    ): AxiosPromise<OrganisationSettingsFormDto> {
      return localVarFp
        .apiOrganisationSettingGetOrgSettingFormFieldsGet(orgId, type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [orgId]
     * @param {FormType} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetOrgSettingFormGet(
      orgId?: number,
      type?: FormType,
      options?: any,
    ): AxiosPromise<OrganisationSettingsFormDto> {
      return localVarFp
        .apiOrganisationSettingGetOrgSettingFormGet(orgId, type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingGetStudbookOptInSettingsGet(
      options?: any,
    ): AxiosPromise<Array<OrgsOptInSetting>> {
      return localVarFp
        .apiOrganisationSettingGetStudbookOptInSettingsGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingUpsertOrgSettingFormFieldsPost(
      upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
      options?: any,
    ): AxiosPromise<OrganisationSettingsFormDto> {
      return localVarFp
        .apiOrganisationSettingUpsertOrgSettingFormFieldsPost(
          upsertOrgSettingFormRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingUpsertOrgSettingFormPost(
      upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
      options?: any,
    ): AxiosPromise<OrganisationSettingsFormDto> {
      return localVarFp
        .apiOrganisationSettingUpsertOrgSettingFormPost(
          upsertOrgSettingFormRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<UpsertOrgSettingFormRequest>} [upsertOrgSettingFormRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiOrganisationSettingUpsertOrgSettingFormsPost(
      upsertOrgSettingFormRequest?: Array<UpsertOrgSettingFormRequest>,
      options?: any,
    ): AxiosPromise<Array<OrganisationSettingDto>> {
      return localVarFp
        .apiOrganisationSettingUpsertOrgSettingFormsPost(
          upsertOrgSettingFormRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * OrganisationSettingApi - object-oriented interface
 * @export
 * @class OrganisationSettingApi
 * @extends {BaseAPI}
 */
export class OrganisationSettingApi extends BaseAPI {
  /**
   *
   * @param {Array<UpsertOrganisationSettingsRequest>} [upsertOrganisationSettingsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingBulkPost(
    upsertOrganisationSettingsRequest?: Array<UpsertOrganisationSettingsRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingBulkPost(
        upsertOrganisationSettingsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingGet(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingGet(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {Array<number>} [requestBody]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(
    organisationId?: number,
    requestBody?: Array<number>,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingGetByOrganisationIdAndSettingIdsPost(
        organisationId,
        requestBody,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GetSettingsByOrganisationAndSettingTypesRequest} [getSettingsByOrganisationAndSettingTypesRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(
    getSettingsByOrganisationAndSettingTypesRequest?: GetSettingsByOrganisationAndSettingTypesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingGetByOrganisationIdAndSettingTypesPost(
        getSettingsByOrganisationAndSettingTypesRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [orgId]
   * @param {FormType} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingGetOrgSettingFormFieldsGet(
    orgId?: number,
    type?: FormType,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingGetOrgSettingFormFieldsGet(orgId, type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [orgId]
   * @param {FormType} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingGetOrgSettingFormGet(
    orgId?: number,
    type?: FormType,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingGetOrgSettingFormGet(orgId, type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingGetStudbookOptInSettingsGet(
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingGetStudbookOptInSettingsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingUpsertOrgSettingFormFieldsPost(
    upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingUpsertOrgSettingFormFieldsPost(
        upsertOrgSettingFormRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertOrgSettingFormRequest} [upsertOrgSettingFormRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingUpsertOrgSettingFormPost(
    upsertOrgSettingFormRequest?: UpsertOrgSettingFormRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingUpsertOrgSettingFormPost(
        upsertOrgSettingFormRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<UpsertOrgSettingFormRequest>} [upsertOrgSettingFormRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof OrganisationSettingApi
   */
  public apiOrganisationSettingUpsertOrgSettingFormsPost(
    upsertOrgSettingFormRequest?: Array<UpsertOrgSettingFormRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return OrganisationSettingApiFp(this.configuration)
      .apiOrganisationSettingUpsertOrgSettingFormsPost(
        upsertOrgSettingFormRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [roleId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleDelete: async (
      roleId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Role`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (roleId !== undefined) {
        localVarQueryParameter['roleId'] = roleId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Role`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [roleId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleGetByIdGet: async (
      roleId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Role/GetById`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (roleId !== undefined) {
        localVarQueryParameter['roleId'] = roleId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateRoleRequest} [updateRoleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePatch: async (
      updateRoleRequest?: UpdateRoleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Role`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddRoleRequest} [addRoleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePost: async (
      addRoleRequest?: AddRoleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Role`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [roleId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRoleDelete(
      roleId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiRoleDelete(
        roleId,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['RoleApi.apiRoleDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRoleGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRoleGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['RoleApi.apiRoleGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [roleId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRoleGetByIdGet(
      roleId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRoleGetByIdGet(roleId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['RoleApi.apiRoleGetByIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateRoleRequest} [updateRoleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRolePatch(
      updateRoleRequest?: UpdateRoleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolePatch(
        updateRoleRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['RoleApi.apiRolePatch']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AddRoleRequest} [addRoleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRolePost(
      addRoleRequest?: AddRoleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiRolePost(
        addRoleRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['RoleApi.apiRolePost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RoleApiFp(configuration);
  return {
    /**
     *
     * @param {number} [roleId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleDelete(roleId?: number, options?: any): AxiosPromise<RoleDto> {
      return localVarFp
        .apiRoleDelete(roleId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleGet(options?: any): AxiosPromise<Array<RoleDto>> {
      return localVarFp
        .apiRoleGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [roleId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleGetByIdGet(roleId?: number, options?: any): AxiosPromise<RoleDto> {
      return localVarFp
        .apiRoleGetByIdGet(roleId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateRoleRequest} [updateRoleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePatch(
      updateRoleRequest?: UpdateRoleRequest,
      options?: any,
    ): AxiosPromise<RoleDto> {
      return localVarFp
        .apiRolePatch(updateRoleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddRoleRequest} [addRoleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePost(
      addRoleRequest?: AddRoleRequest,
      options?: any,
    ): AxiosPromise<RoleDto> {
      return localVarFp
        .apiRolePost(addRoleRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
  /**
   *
   * @param {number} [roleId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleApi
   */
  public apiRoleDelete(roleId?: number, options?: RawAxiosRequestConfig) {
    return RoleApiFp(this.configuration)
      .apiRoleDelete(roleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleApi
   */
  public apiRoleGet(options?: RawAxiosRequestConfig) {
    return RoleApiFp(this.configuration)
      .apiRoleGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [roleId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleApi
   */
  public apiRoleGetByIdGet(roleId?: number, options?: RawAxiosRequestConfig) {
    return RoleApiFp(this.configuration)
      .apiRoleGetByIdGet(roleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateRoleRequest} [updateRoleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleApi
   */
  public apiRolePatch(
    updateRoleRequest?: UpdateRoleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoleApiFp(this.configuration)
      .apiRolePatch(updateRoleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddRoleRequest} [addRoleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleApi
   */
  public apiRolePost(
    addRoleRequest?: AddRoleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoleApiFp(this.configuration)
      .apiRolePost(addRoleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RolePermissionAssociationApi - axios parameter creator
 * @export
 */
export const RolePermissionAssociationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePermissionAssociationPost: async (
      upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/RolePermissionAssociation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertRolePermissionAssociationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePermissionAssociationRoleIdGet: async (
      roleId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'roleId' is not null or undefined
      assertParamExists(
        'apiRolePermissionAssociationRoleIdGet',
        'roleId',
        roleId,
      );
      const localVarPath = `/api/RolePermissionAssociation/{roleId}`.replace(
        `{${'roleId'}}`,
        encodeURIComponent(String(roleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RolePermissionAssociationApi - functional programming interface
 * @export
 */
export const RolePermissionAssociationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    RolePermissionAssociationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRolePermissionAssociationPost(
      upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<RolePermissionAssociationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRolePermissionAssociationPost(
          upsertRolePermissionAssociationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RolePermissionAssociationApi.apiRolePermissionAssociationPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRolePermissionAssociationRoleIdGet(
      roleId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<RolePermissionAssociationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRolePermissionAssociationRoleIdGet(
          roleId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RolePermissionAssociationApi.apiRolePermissionAssociationRoleIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * RolePermissionAssociationApi - factory interface
 * @export
 */
export const RolePermissionAssociationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RolePermissionAssociationApiFp(configuration);
  return {
    /**
     *
     * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePermissionAssociationPost(
      upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest,
      options?: any,
    ): AxiosPromise<Array<RolePermissionAssociationDto>> {
      return localVarFp
        .apiRolePermissionAssociationPost(
          upsertRolePermissionAssociationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} roleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRolePermissionAssociationRoleIdGet(
      roleId: number,
      options?: any,
    ): AxiosPromise<Array<RolePermissionAssociationDto>> {
      return localVarFp
        .apiRolePermissionAssociationRoleIdGet(roleId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RolePermissionAssociationApi - object-oriented interface
 * @export
 * @class RolePermissionAssociationApi
 * @extends {BaseAPI}
 */
export class RolePermissionAssociationApi extends BaseAPI {
  /**
   *
   * @param {UpsertRolePermissionAssociationRequest} [upsertRolePermissionAssociationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolePermissionAssociationApi
   */
  public apiRolePermissionAssociationPost(
    upsertRolePermissionAssociationRequest?: UpsertRolePermissionAssociationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RolePermissionAssociationApiFp(this.configuration)
      .apiRolePermissionAssociationPost(
        upsertRolePermissionAssociationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} roleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RolePermissionAssociationApi
   */
  public apiRolePermissionAssociationRoleIdGet(
    roleId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return RolePermissionAssociationApiFp(this.configuration)
      .apiRolePermissionAssociationRoleIdGet(roleId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RoleUserOrgAssociationApi - axios parameter creator
 * @export
 */
export const RoleUserOrgAssociationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleUserOrgAssociationBulkPost: async (
      upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/RoleUserOrgAssociation/Bulk`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertRoleUserOrgAssociationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [userId]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleUserOrgAssociationGetByUserOrgIdGet: async (
      userId?: number,
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/RoleUserOrgAssociation/GetByUserOrgId`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RoleUserOrgAssociationApi - functional programming interface
 * @export
 */
export const RoleUserOrgAssociationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    RoleUserOrgAssociationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRoleUserOrgAssociationBulkPost(
      upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<RoleUserOrgAssociationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRoleUserOrgAssociationBulkPost(
          upsertRoleUserOrgAssociationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RoleUserOrgAssociationApi.apiRoleUserOrgAssociationBulkPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [userId]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRoleUserOrgAssociationGetByUserOrgIdGet(
      userId?: number,
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<RoleUserOrgAssociationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRoleUserOrgAssociationGetByUserOrgIdGet(
          userId,
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RoleUserOrgAssociationApi.apiRoleUserOrgAssociationGetByUserOrgIdGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * RoleUserOrgAssociationApi - factory interface
 * @export
 */
export const RoleUserOrgAssociationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RoleUserOrgAssociationApiFp(configuration);
  return {
    /**
     *
     * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleUserOrgAssociationBulkPost(
      upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest,
      options?: any,
    ): AxiosPromise<Array<RoleUserOrgAssociationDto>> {
      return localVarFp
        .apiRoleUserOrgAssociationBulkPost(
          upsertRoleUserOrgAssociationRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [userId]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRoleUserOrgAssociationGetByUserOrgIdGet(
      userId?: number,
      organisationId?: number,
      options?: any,
    ): AxiosPromise<Array<RoleUserOrgAssociationDto>> {
      return localVarFp
        .apiRoleUserOrgAssociationGetByUserOrgIdGet(
          userId,
          organisationId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RoleUserOrgAssociationApi - object-oriented interface
 * @export
 * @class RoleUserOrgAssociationApi
 * @extends {BaseAPI}
 */
export class RoleUserOrgAssociationApi extends BaseAPI {
  /**
   *
   * @param {UpsertRoleUserOrgAssociationRequest} [upsertRoleUserOrgAssociationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleUserOrgAssociationApi
   */
  public apiRoleUserOrgAssociationBulkPost(
    upsertRoleUserOrgAssociationRequest?: UpsertRoleUserOrgAssociationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RoleUserOrgAssociationApiFp(this.configuration)
      .apiRoleUserOrgAssociationBulkPost(
        upsertRoleUserOrgAssociationRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [userId]
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoleUserOrgAssociationApi
   */
  public apiRoleUserOrgAssociationGetByUserOrgIdGet(
    userId?: number,
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return RoleUserOrgAssociationApiFp(this.configuration)
      .apiRoleUserOrgAssociationGetByUserOrgIdGet(
        userId,
        organisationId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RuleConfigurationApi - axios parameter creator
 * @export
 */
export const RuleConfigurationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationIdDelete: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('apiRuleConfigurationIdDelete', 'id', id);
      const localVarPath = `/api/RuleConfiguration/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationIdGet: async (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('apiRuleConfigurationIdGet', 'id', id);
      const localVarPath = `/api/RuleConfiguration/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [ruleId]
     * @param {number} [roleId]
     * @param {number} [entityDetailId]
     * @param {string} [entityDetailValue]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationMatchGet: async (
      ruleId?: number,
      roleId?: number,
      entityDetailId?: number,
      entityDetailValue?: string,
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/RuleConfiguration/match`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (ruleId !== undefined) {
        localVarQueryParameter['ruleId'] = ruleId;
      }

      if (roleId !== undefined) {
        localVarQueryParameter['roleId'] = roleId;
      }

      if (entityDetailId !== undefined) {
        localVarQueryParameter['entityDetailId'] = entityDetailId;
      }

      if (entityDetailValue !== undefined) {
        localVarQueryParameter['entityDetailValue'] = entityDetailValue;
      }

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationOrganisationGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/RuleConfiguration/organisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationUpsertPost: async (
      upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/RuleConfiguration/upsert`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertRuleConfigurationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RuleConfigurationApi - functional programming interface
 * @export
 */
export const RuleConfigurationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RuleConfigurationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRuleConfigurationIdDelete(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRuleConfigurationIdDelete(
          id,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RuleConfigurationApi.apiRuleConfigurationIdDelete'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRuleConfigurationIdGet(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RuleConfigurationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRuleConfigurationIdGet(id, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['RuleConfigurationApi.apiRuleConfigurationIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [ruleId]
     * @param {number} [roleId]
     * @param {number} [entityDetailId]
     * @param {string} [entityDetailValue]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRuleConfigurationMatchGet(
      ruleId?: number,
      roleId?: number,
      entityDetailId?: number,
      entityDetailValue?: string,
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RuleConfigurationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRuleConfigurationMatchGet(
          ruleId,
          roleId,
          entityDetailId,
          entityDetailValue,
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RuleConfigurationApi.apiRuleConfigurationMatchGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRuleConfigurationOrganisationGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<RuleConfigurationDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRuleConfigurationOrganisationGet(
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RuleConfigurationApi.apiRuleConfigurationOrganisationGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiRuleConfigurationUpsertPost(
      upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RuleConfigurationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiRuleConfigurationUpsertPost(
          upsertRuleConfigurationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'RuleConfigurationApi.apiRuleConfigurationUpsertPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * RuleConfigurationApi - factory interface
 * @export
 */
export const RuleConfigurationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RuleConfigurationApiFp(configuration);
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationIdDelete(
      id: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiRuleConfigurationIdDelete(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationIdGet(
      id: number,
      options?: any,
    ): AxiosPromise<RuleConfigurationDto> {
      return localVarFp
        .apiRuleConfigurationIdGet(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [ruleId]
     * @param {number} [roleId]
     * @param {number} [entityDetailId]
     * @param {string} [entityDetailValue]
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationMatchGet(
      ruleId?: number,
      roleId?: number,
      entityDetailId?: number,
      entityDetailValue?: string,
      organisationId?: number,
      options?: any,
    ): AxiosPromise<RuleConfigurationDto> {
      return localVarFp
        .apiRuleConfigurationMatchGet(
          ruleId,
          roleId,
          entityDetailId,
          entityDetailValue,
          organisationId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationOrganisationGet(
      options?: any,
    ): AxiosPromise<Array<RuleConfigurationDto>> {
      return localVarFp
        .apiRuleConfigurationOrganisationGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiRuleConfigurationUpsertPost(
      upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest,
      options?: any,
    ): AxiosPromise<RuleConfigurationDto> {
      return localVarFp
        .apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RuleConfigurationApi - object-oriented interface
 * @export
 * @class RuleConfigurationApi
 * @extends {BaseAPI}
 */
export class RuleConfigurationApi extends BaseAPI {
  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationApi
   */
  public apiRuleConfigurationIdDelete(
    id: number,
    options?: RawAxiosRequestConfig,
  ) {
    return RuleConfigurationApiFp(this.configuration)
      .apiRuleConfigurationIdDelete(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationApi
   */
  public apiRuleConfigurationIdGet(
    id: number,
    options?: RawAxiosRequestConfig,
  ) {
    return RuleConfigurationApiFp(this.configuration)
      .apiRuleConfigurationIdGet(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [ruleId]
   * @param {number} [roleId]
   * @param {number} [entityDetailId]
   * @param {string} [entityDetailValue]
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationApi
   */
  public apiRuleConfigurationMatchGet(
    ruleId?: number,
    roleId?: number,
    entityDetailId?: number,
    entityDetailValue?: string,
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return RuleConfigurationApiFp(this.configuration)
      .apiRuleConfigurationMatchGet(
        ruleId,
        roleId,
        entityDetailId,
        entityDetailValue,
        organisationId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationApi
   */
  public apiRuleConfigurationOrganisationGet(options?: RawAxiosRequestConfig) {
    return RuleConfigurationApiFp(this.configuration)
      .apiRuleConfigurationOrganisationGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpsertRuleConfigurationRequest} [upsertRuleConfigurationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RuleConfigurationApi
   */
  public apiRuleConfigurationUpsertPost(
    upsertRuleConfigurationRequest?: UpsertRuleConfigurationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return RuleConfigurationApiFp(this.configuration)
      .apiRuleConfigurationUpsertPost(upsertRuleConfigurationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ScreenApi - axios parameter creator
 * @export
 */
export const ScreenApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {number} [screenId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenDelete: async (
      screenId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Screen`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (screenId !== undefined) {
        localVarQueryParameter['screenId'] = screenId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [screenId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenGetScreenByIdGet: async (
      screenId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Screen/GetScreenById`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (screenId !== undefined) {
        localVarQueryParameter['screenId'] = screenId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenOrganisationIdGet: async (
      organisationId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'organisationId' is not null or undefined
      assertParamExists(
        'apiScreenOrganisationIdGet',
        'organisationId',
        organisationId,
      );
      const localVarPath = `/api/Screen/{organisationId}`.replace(
        `{${'organisationId'}}`,
        encodeURIComponent(String(organisationId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {Array<UpsertScreenRequest>} [upsertScreenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenPost: async (
      upsertScreenRequest?: Array<UpsertScreenRequest>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Screen`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertScreenRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ScreenApi - functional programming interface
 * @export
 */
export const ScreenApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ScreenApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {number} [screenId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiScreenDelete(
      screenId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiScreenDelete(
        screenId,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ScreenApi.apiScreenDelete']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [screenId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiScreenGetScreenByIdGet(
      screenId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScreenDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiScreenGetScreenByIdGet(
          screenId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ScreenApi.apiScreenGetScreenByIdGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiScreenOrganisationIdGet(
      organisationId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ScreenDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiScreenOrganisationIdGet(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ScreenApi.apiScreenOrganisationIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {Array<UpsertScreenRequest>} [upsertScreenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiScreenPost(
      upsertScreenRequest?: Array<UpsertScreenRequest>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<ScreenDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiScreenPost(
        upsertScreenRequest,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ScreenApi.apiScreenPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * ScreenApi - factory interface
 * @export
 */
export const ScreenApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ScreenApiFp(configuration);
  return {
    /**
     *
     * @param {number} [screenId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenDelete(screenId?: number, options?: any): AxiosPromise<boolean> {
      return localVarFp
        .apiScreenDelete(screenId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [screenId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenGetScreenByIdGet(
      screenId?: number,
      options?: any,
    ): AxiosPromise<ScreenDto> {
      return localVarFp
        .apiScreenGetScreenByIdGet(screenId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} organisationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenOrganisationIdGet(
      organisationId: number,
      options?: any,
    ): AxiosPromise<Array<ScreenDto>> {
      return localVarFp
        .apiScreenOrganisationIdGet(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {Array<UpsertScreenRequest>} [upsertScreenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiScreenPost(
      upsertScreenRequest?: Array<UpsertScreenRequest>,
      options?: any,
    ): AxiosPromise<Array<ScreenDto>> {
      return localVarFp
        .apiScreenPost(upsertScreenRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ScreenApi - object-oriented interface
 * @export
 * @class ScreenApi
 * @extends {BaseAPI}
 */
export class ScreenApi extends BaseAPI {
  /**
   *
   * @param {number} [screenId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */
  public apiScreenDelete(screenId?: number, options?: RawAxiosRequestConfig) {
    return ScreenApiFp(this.configuration)
      .apiScreenDelete(screenId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [screenId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */
  public apiScreenGetScreenByIdGet(
    screenId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ScreenApiFp(this.configuration)
      .apiScreenGetScreenByIdGet(screenId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} organisationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */
  public apiScreenOrganisationIdGet(
    organisationId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ScreenApiFp(this.configuration)
      .apiScreenOrganisationIdGet(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {Array<UpsertScreenRequest>} [upsertScreenRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ScreenApi
   */
  public apiScreenPost(
    upsertScreenRequest?: Array<UpsertScreenRequest>,
    options?: RawAxiosRequestConfig,
  ) {
    return ScreenApiFp(this.configuration)
      .apiScreenPost(upsertScreenRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * SystemApi - axios parameter creator
 * @export
 */
export const SystemApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemApplyMigrationsPost: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/apply-migrations`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemAuthCheckGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/auth-check`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemCreateDefaultScreenPost: async (
      entityTypeCode?: EntityTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/Create-Default-Screen`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityTypeCode !== undefined) {
        localVarQueryParameter['entityTypeCode'] = entityTypeCode;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddOrganisationRequest} [addOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemCreateEmptyOrganisationPost: async (
      addOrganisationRequest?: AddOrganisationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/create-empty-organisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addOrganisationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GenerateAnimalRequest} [generateAnimalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemGenerateAnimalsPost: async (
      generateAnimalRequest?: GenerateAnimalRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/generate-animals`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateAnimalRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GenerateEnterpriseRequest} [generateEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemGenerateEnterprisesPost: async (
      generateEnterpriseRequest?: GenerateEnterpriseRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/generate-enterprises`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateEnterpriseRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {GenerateRequest} [generateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemGeneratePost: async (
      generateRequest?: GenerateRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/generate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        generateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemLinkBreederPost: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/link-breeder`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemMigrateEnterprisePost: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/migrate-enterprise`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemMigrateSyndicatePost: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/migrate-syndicate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetAllEntitiesPost: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/reset-all-entities`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetConfigurationPost: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/reset-configuration`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {boolean} [addOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetEntityDetailsPost: async (
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      addOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/reset-entity-details`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      if (entityTypeCode !== undefined) {
        localVarQueryParameter['entityTypeCode'] = entityTypeCode;
      }

      if (addOnly !== undefined) {
        localVarQueryParameter['addOnly'] = addOnly;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetItemCodesPost: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/reset-item-codes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemSeedBillingRulesPost: async (
      organisationId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/seed-billing-rules`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (organisationId !== undefined) {
        localVarQueryParameter['organisationId'] = organisationId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemTestAuthPost: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/System/test-auth`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SystemApi - functional programming interface
 * @export
 */
export const SystemApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemApplyMigrationsPost(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemApplyMigrationsPost(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemApplyMigrationsPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemAuthCheckGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemAuthCheckGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemAuthCheckGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemCreateDefaultScreenPost(
      entityTypeCode?: EntityTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemCreateDefaultScreenPost(
          entityTypeCode,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemCreateDefaultScreenPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AddOrganisationRequest} [addOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemCreateEmptyOrganisationPost(
      addOrganisationRequest?: AddOrganisationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<OrganisationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemCreateEmptyOrganisationPost(
          addOrganisationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemCreateEmptyOrganisationPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GenerateAnimalRequest} [generateAnimalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemGenerateAnimalsPost(
      generateAnimalRequest?: GenerateAnimalRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemGenerateAnimalsPost(
          generateAnimalRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemGenerateAnimalsPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GenerateEnterpriseRequest} [generateEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemGenerateEnterprisesPost(
      generateEnterpriseRequest?: GenerateEnterpriseRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemGenerateEnterprisesPost(
          generateEnterpriseRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemGenerateEnterprisesPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {GenerateRequest} [generateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemGeneratePost(
      generateRequest?: GenerateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemGeneratePost(
          generateRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemGeneratePost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemLinkBreederPost(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemLinkBreederPost(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemLinkBreederPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemMigrateEnterprisePost(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemMigrateEnterprisePost(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemMigrateEnterprisePost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemMigrateSyndicatePost(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemMigrateSyndicatePost(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemMigrateSyndicatePost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemResetAllEntitiesPost(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemResetAllEntitiesPost(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemResetAllEntitiesPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemResetConfigurationPost(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemResetConfigurationPost(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemResetConfigurationPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {boolean} [addOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemResetEntityDetailsPost(
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      addOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemResetEntityDetailsPost(
          organisationId,
          entityTypeCode,
          addOnly,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemResetEntityDetailsPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemResetItemCodesPost(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemResetItemCodesPost(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemResetItemCodesPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemSeedBillingRulesPost(
      organisationId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemSeedBillingRulesPost(
          organisationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemSeedBillingRulesPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiSystemTestAuthPost(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiSystemTestAuthPost(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['SystemApi.apiSystemTestAuthPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * SystemApi - factory interface
 * @export
 */
export const SystemApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SystemApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemApplyMigrationsPost(options?: any): AxiosPromise<void> {
      return localVarFp
        .apiSystemApplyMigrationsPost(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemAuthCheckGet(options?: any): AxiosPromise<void> {
      return localVarFp
        .apiSystemAuthCheckGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemCreateDefaultScreenPost(
      entityTypeCode?: EntityTypeCode,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemCreateDefaultScreenPost(entityTypeCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddOrganisationRequest} [addOrganisationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemCreateEmptyOrganisationPost(
      addOrganisationRequest?: AddOrganisationRequest,
      options?: any,
    ): AxiosPromise<OrganisationDto> {
      return localVarFp
        .apiSystemCreateEmptyOrganisationPost(addOrganisationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GenerateAnimalRequest} [generateAnimalRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemGenerateAnimalsPost(
      generateAnimalRequest?: GenerateAnimalRequest,
      options?: any,
    ): AxiosPromise<number> {
      return localVarFp
        .apiSystemGenerateAnimalsPost(generateAnimalRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GenerateEnterpriseRequest} [generateEnterpriseRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemGenerateEnterprisesPost(
      generateEnterpriseRequest?: GenerateEnterpriseRequest,
      options?: any,
    ): AxiosPromise<number> {
      return localVarFp
        .apiSystemGenerateEnterprisesPost(generateEnterpriseRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {GenerateRequest} [generateRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemGeneratePost(
      generateRequest?: GenerateRequest,
      options?: any,
    ): AxiosPromise<number> {
      return localVarFp
        .apiSystemGeneratePost(generateRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemLinkBreederPost(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemLinkBreederPost(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemMigrateEnterprisePost(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemMigrateEnterprisePost(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemMigrateSyndicatePost(options?: any): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemMigrateSyndicatePost(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetAllEntitiesPost(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemResetAllEntitiesPost(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetConfigurationPost(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemResetConfigurationPost(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {EntityTypeCode} [entityTypeCode]
     * @param {boolean} [addOnly]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetEntityDetailsPost(
      organisationId?: number,
      entityTypeCode?: EntityTypeCode,
      addOnly?: boolean,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemResetEntityDetailsPost(
          organisationId,
          entityTypeCode,
          addOnly,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemResetItemCodesPost(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemResetItemCodesPost(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [organisationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemSeedBillingRulesPost(
      organisationId?: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemSeedBillingRulesPost(organisationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiSystemTestAuthPost(options?: any): AxiosPromise<boolean> {
      return localVarFp
        .apiSystemTestAuthPost(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
export class SystemApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemApplyMigrationsPost(options?: RawAxiosRequestConfig) {
    return SystemApiFp(this.configuration)
      .apiSystemApplyMigrationsPost(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemAuthCheckGet(options?: RawAxiosRequestConfig) {
    return SystemApiFp(this.configuration)
      .apiSystemAuthCheckGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {EntityTypeCode} [entityTypeCode]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemCreateDefaultScreenPost(
    entityTypeCode?: EntityTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemCreateDefaultScreenPost(entityTypeCode, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddOrganisationRequest} [addOrganisationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemCreateEmptyOrganisationPost(
    addOrganisationRequest?: AddOrganisationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemCreateEmptyOrganisationPost(addOrganisationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GenerateAnimalRequest} [generateAnimalRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemGenerateAnimalsPost(
    generateAnimalRequest?: GenerateAnimalRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemGenerateAnimalsPost(generateAnimalRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GenerateEnterpriseRequest} [generateEnterpriseRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemGenerateEnterprisesPost(
    generateEnterpriseRequest?: GenerateEnterpriseRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemGenerateEnterprisesPost(generateEnterpriseRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {GenerateRequest} [generateRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemGeneratePost(
    generateRequest?: GenerateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemGeneratePost(generateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemLinkBreederPost(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemLinkBreederPost(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemMigrateEnterprisePost(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemMigrateEnterprisePost(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemMigrateSyndicatePost(options?: RawAxiosRequestConfig) {
    return SystemApiFp(this.configuration)
      .apiSystemMigrateSyndicatePost(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemResetAllEntitiesPost(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemResetAllEntitiesPost(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemResetConfigurationPost(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemResetConfigurationPost(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {EntityTypeCode} [entityTypeCode]
   * @param {boolean} [addOnly]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemResetEntityDetailsPost(
    organisationId?: number,
    entityTypeCode?: EntityTypeCode,
    addOnly?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemResetEntityDetailsPost(
        organisationId,
        entityTypeCode,
        addOnly,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemResetItemCodesPost(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemResetItemCodesPost(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [organisationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemSeedBillingRulesPost(
    organisationId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SystemApiFp(this.configuration)
      .apiSystemSeedBillingRulesPost(organisationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SystemApi
   */
  public apiSystemTestAuthPost(options?: RawAxiosRequestConfig) {
    return SystemApiFp(this.configuration)
      .apiSystemTestAuthPost(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TimelineApi - axios parameter creator
 * @export
 */
export const TimelineApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTimelineGet: async (
      entityId?: string,
      entityType?: EntityTypeCode,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Timeline`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (entityId !== undefined) {
        localVarQueryParameter['entityId'] = entityId;
      }

      if (entityType !== undefined) {
        localVarQueryParameter['entityType'] = entityType;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TimelineApi - functional programming interface
 * @export
 */
export const TimelineApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TimelineApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiTimelineGet(
      entityId?: string,
      entityType?: EntityTypeCode,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<TimelineDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.apiTimelineGet(
        entityId,
        entityType,
        options,
      );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['TimelineApi.apiTimelineGet']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * TimelineApi - factory interface
 * @export
 */
export const TimelineApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = TimelineApiFp(configuration);
  return {
    /**
     *
     * @param {string} [entityId]
     * @param {EntityTypeCode} [entityType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiTimelineGet(
      entityId?: string,
      entityType?: EntityTypeCode,
      options?: any,
    ): AxiosPromise<Array<TimelineDto>> {
      return localVarFp
        .apiTimelineGet(entityId, entityType, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TimelineApi - object-oriented interface
 * @export
 * @class TimelineApi
 * @extends {BaseAPI}
 */
export class TimelineApi extends BaseAPI {
  /**
   *
   * @param {string} [entityId]
   * @param {EntityTypeCode} [entityType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TimelineApi
   */
  public apiTimelineGet(
    entityId?: string,
    entityType?: EntityTypeCode,
    options?: RawAxiosRequestConfig,
  ) {
    return TimelineApiFp(this.configuration)
      .apiTimelineGet(entityId, entityType, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserConfigApi - axios parameter creator
 * @export
 */
export const UserConfigApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {UpsertUserConfigRequest} [upsertUserConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserConfigPost: async (
      upsertUserConfigRequest?: UpsertUserConfigRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserConfig`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        upsertUserConfigRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserConfigUserIdDelete: async (
      userId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiUserConfigUserIdDelete', 'userId', userId);
      const localVarPath = `/api/UserConfig/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserConfigUserIdGet: async (
      userId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('apiUserConfigUserIdGet', 'userId', userId);
      const localVarPath = `/api/UserConfig/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserConfigApi - functional programming interface
 * @export
 */
export const UserConfigApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    UserConfigApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {UpsertUserConfigRequest} [upsertUserConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserConfigPost(
      upsertUserConfigRequest?: UpsertUserConfigRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserConfigPost(
          upsertUserConfigRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['UserConfigApi.apiUserConfigPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserConfigUserIdDelete(
      userId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserConfigUserIdDelete(
          userId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['UserConfigApi.apiUserConfigUserIdDelete']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserConfigUserIdGet(
      userId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConfigDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserConfigUserIdGet(userId, options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['UserConfigApi.apiUserConfigUserIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * UserConfigApi - factory interface
 * @export
 */
export const UserConfigApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserConfigApiFp(configuration);
  return {
    /**
     *
     * @param {UpsertUserConfigRequest} [upsertUserConfigRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserConfigPost(
      upsertUserConfigRequest?: UpsertUserConfigRequest,
      options?: any,
    ): AxiosPromise<UserConfigDto> {
      return localVarFp
        .apiUserConfigPost(upsertUserConfigRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserConfigUserIdDelete(
      userId: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiUserConfigUserIdDelete(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserConfigUserIdGet(
      userId: number,
      options?: any,
    ): AxiosPromise<UserConfigDto> {
      return localVarFp
        .apiUserConfigUserIdGet(userId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserConfigApi - object-oriented interface
 * @export
 * @class UserConfigApi
 * @extends {BaseAPI}
 */
export class UserConfigApi extends BaseAPI {
  /**
   *
   * @param {UpsertUserConfigRequest} [upsertUserConfigRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserConfigApi
   */
  public apiUserConfigPost(
    upsertUserConfigRequest?: UpsertUserConfigRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return UserConfigApiFp(this.configuration)
      .apiUserConfigPost(upsertUserConfigRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserConfigApi
   */
  public apiUserConfigUserIdDelete(
    userId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return UserConfigApiFp(this.configuration)
      .apiUserConfigUserIdDelete(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserConfigApi
   */
  public apiUserConfigUserIdGet(
    userId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return UserConfigApiFp(this.configuration)
      .apiUserConfigUserIdGet(userId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UserRoleApi - axios parameter creator
 * @export
 */
export const UserRoleApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserRolePost: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/UserRole`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserRoleApi - functional programming interface
 * @export
 */
export const UserRoleApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserRoleApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiUserRolePost(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserProfileDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiUserRolePost(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['UserRoleApi.apiUserRolePost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * UserRoleApi - factory interface
 * @export
 */
export const UserRoleApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = UserRoleApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiUserRolePost(options?: any): AxiosPromise<UserProfileDtoPagedResult> {
      return localVarFp
        .apiUserRolePost(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UserRoleApi - object-oriented interface
 * @export
 * @class UserRoleApi
 * @extends {BaseAPI}
 */
export class UserRoleApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserRoleApi
   */
  public apiUserRolePost(options?: RawAxiosRequestConfig) {
    return UserRoleApiFp(this.configuration)
      .apiUserRolePost(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ValidationApi - axios parameter creator
 * @export
 */
export const ValidationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationEvaluateJsonRulePost: async (
      evaluateJsonRuleRequest?: EvaluateJsonRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation/evaluate-json-rule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        evaluateJsonRuleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddValidationRequest} [addValidationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationPost: async (
      addValidationRequest?: AddValidationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addValidationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {UpdateValidationRequest} [updateValidationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationPut: async (
      updateValidationRequest?: UpdateValidationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateValidationRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRuleExamplesGet: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation/rule-examples`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddRuleRequest} [addRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesPost: async (
      addRuleRequest?: AddRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation/rules`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        addRuleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [count]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRecentGet: async (
      count?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation/rules/recent`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (count !== undefined) {
        localVarQueryParameter['count'] = count;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRuleIdDelete: async (
      ruleId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('apiValidationRulesRuleIdDelete', 'ruleId', ruleId);
      const localVarPath = `/api/Validation/rules/{ruleId}`.replace(
        `{${'ruleId'}}`,
        encodeURIComponent(String(ruleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRuleIdGet: async (
      ruleId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('apiValidationRulesRuleIdGet', 'ruleId', ruleId);
      const localVarPath = `/api/Validation/rules/{ruleId}`.replace(
        `{${'ruleId'}}`,
        encodeURIComponent(String(ruleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} ruleId
     * @param {UpdateRuleRequest} [updateRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRuleIdPut: async (
      ruleId: number,
      updateRuleRequest?: UpdateRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ruleId' is not null or undefined
      assertParamExists('apiValidationRulesRuleIdPut', 'ruleId', ruleId);
      const localVarPath = `/api/Validation/rules/{ruleId}`.replace(
        `{${'ruleId'}}`,
        encodeURIComponent(String(ruleId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRuleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SearchRuleRequest} [searchRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesSearchPost: async (
      searchRuleRequest?: SearchRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation/rules/search`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        searchRuleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {TestJsonRuleRequest} [testJsonRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationTestJsonRulePost: async (
      testJsonRuleRequest?: TestJsonRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation/test-json-rule`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        testJsonRuleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationTestPost: async (
      testRuleDefinitionRequest?: TestRuleDefinitionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/Validation/test`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        testRuleDefinitionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} validationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationValidationIdDelete: async (
      validationId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'validationId' is not null or undefined
      assertParamExists(
        'apiValidationValidationIdDelete',
        'validationId',
        validationId,
      );
      const localVarPath = `/api/Validation/{validationId}`.replace(
        `{${'validationId'}}`,
        encodeURIComponent(String(validationId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} validationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationValidationIdGet: async (
      validationId: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'validationId' is not null or undefined
      assertParamExists(
        'apiValidationValidationIdGet',
        'validationId',
        validationId,
      );
      const localVarPath = `/api/Validation/{validationId}`.replace(
        `{${'validationId'}}`,
        encodeURIComponent(String(validationId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ValidationApi - functional programming interface
 * @export
 */
export const ValidationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ValidationApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationEvaluateJsonRulePost(
      evaluateJsonRuleRequest?: EvaluateJsonRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RuleEvaluationResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationEvaluateJsonRulePost(
          evaluateJsonRuleRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationEvaluateJsonRulePost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AddValidationRequest} [addValidationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationPost(
      addValidationRequest?: AddValidationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationPost(
          addValidationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {UpdateValidationRequest} [updateValidationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationPut(
      updateValidationRequest?: UpdateValidationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationPut(
          updateValidationRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationPut']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationRuleExamplesGet(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RuleExamplesDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationRuleExamplesGet(options);
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationRuleExamplesGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {AddRuleRequest} [addRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationRulesPost(
      addRuleRequest?: AddRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationRulesPost(
          addRuleRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationRulesPost']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [count]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationRulesRecentGet(
      count?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RuleDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationRulesRecentGet(
          count,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationRulesRecentGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationRulesRuleIdDelete(
      ruleId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationRulesRuleIdDelete(
          ruleId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationRulesRuleIdDelete']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationRulesRuleIdGet(
      ruleId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationRulesRuleIdGet(
          ruleId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationRulesRuleIdGet']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} ruleId
     * @param {UpdateRuleRequest} [updateRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationRulesRuleIdPut(
      ruleId: number,
      updateRuleRequest?: UpdateRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RuleDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationRulesRuleIdPut(
          ruleId,
          updateRuleRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationRulesRuleIdPut']?.[index]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SearchRuleRequest} [searchRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationRulesSearchPost(
      searchRuleRequest?: SearchRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RuleDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationRulesSearchPost(
          searchRuleRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationRulesSearchPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {TestJsonRuleRequest} [testJsonRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationTestJsonRulePost(
      testJsonRuleRequest?: TestJsonRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RuleTestResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationTestJsonRulePost(
          testJsonRuleRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationTestJsonRulePost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationTestPost(
      testRuleDefinitionRequest?: TestRuleDefinitionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<RuleTestResultDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationTestPost(
          testRuleDefinitionRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationTestPost']?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} validationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationValidationIdDelete(
      validationId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationValidationIdDelete(
          validationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationValidationIdDelete']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} validationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiValidationValidationIdGet(
      validationId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiValidationValidationIdGet(
          validationId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['ValidationApi.apiValidationValidationIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * ValidationApi - factory interface
 * @export
 */
export const ValidationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ValidationApiFp(configuration);
  return {
    /**
     *
     * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationEvaluateJsonRulePost(
      evaluateJsonRuleRequest?: EvaluateJsonRuleRequest,
      options?: any,
    ): AxiosPromise<RuleEvaluationResultDto> {
      return localVarFp
        .apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddValidationRequest} [addValidationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationPost(
      addValidationRequest?: AddValidationRequest,
      options?: any,
    ): AxiosPromise<ValidationDto> {
      return localVarFp
        .apiValidationPost(addValidationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {UpdateValidationRequest} [updateValidationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationPut(
      updateValidationRequest?: UpdateValidationRequest,
      options?: any,
    ): AxiosPromise<ValidationDto> {
      return localVarFp
        .apiValidationPut(updateValidationRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRuleExamplesGet(options?: any): AxiosPromise<RuleExamplesDto> {
      return localVarFp
        .apiValidationRuleExamplesGet(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {AddRuleRequest} [addRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesPost(
      addRuleRequest?: AddRuleRequest,
      options?: any,
    ): AxiosPromise<RuleDto> {
      return localVarFp
        .apiValidationRulesPost(addRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [count]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRecentGet(
      count?: number,
      options?: any,
    ): AxiosPromise<Array<RuleDto>> {
      return localVarFp
        .apiValidationRulesRecentGet(count, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRuleIdDelete(
      ruleId: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiValidationRulesRuleIdDelete(ruleId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} ruleId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRuleIdGet(
      ruleId: number,
      options?: any,
    ): AxiosPromise<RuleDto> {
      return localVarFp
        .apiValidationRulesRuleIdGet(ruleId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} ruleId
     * @param {UpdateRuleRequest} [updateRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesRuleIdPut(
      ruleId: number,
      updateRuleRequest?: UpdateRuleRequest,
      options?: any,
    ): AxiosPromise<RuleDto> {
      return localVarFp
        .apiValidationRulesRuleIdPut(ruleId, updateRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SearchRuleRequest} [searchRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationRulesSearchPost(
      searchRuleRequest?: SearchRuleRequest,
      options?: any,
    ): AxiosPromise<Array<RuleDto>> {
      return localVarFp
        .apiValidationRulesSearchPost(searchRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {TestJsonRuleRequest} [testJsonRuleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationTestJsonRulePost(
      testJsonRuleRequest?: TestJsonRuleRequest,
      options?: any,
    ): AxiosPromise<RuleTestResultDto> {
      return localVarFp
        .apiValidationTestJsonRulePost(testJsonRuleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationTestPost(
      testRuleDefinitionRequest?: TestRuleDefinitionRequest,
      options?: any,
    ): AxiosPromise<RuleTestResultDto> {
      return localVarFp
        .apiValidationTestPost(testRuleDefinitionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} validationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationValidationIdDelete(
      validationId: number,
      options?: any,
    ): AxiosPromise<boolean> {
      return localVarFp
        .apiValidationValidationIdDelete(validationId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} validationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiValidationValidationIdGet(
      validationId: number,
      options?: any,
    ): AxiosPromise<ValidationDto> {
      return localVarFp
        .apiValidationValidationIdGet(validationId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ValidationApi - object-oriented interface
 * @export
 * @class ValidationApi
 * @extends {BaseAPI}
 */
export class ValidationApi extends BaseAPI {
  /**
   *
   * @param {EvaluateJsonRuleRequest} [evaluateJsonRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationEvaluateJsonRulePost(
    evaluateJsonRuleRequest?: EvaluateJsonRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationEvaluateJsonRulePost(evaluateJsonRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddValidationRequest} [addValidationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationPost(
    addValidationRequest?: AddValidationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationPost(addValidationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {UpdateValidationRequest} [updateValidationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationPut(
    updateValidationRequest?: UpdateValidationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationPut(updateValidationRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationRuleExamplesGet(options?: RawAxiosRequestConfig) {
    return ValidationApiFp(this.configuration)
      .apiValidationRuleExamplesGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {AddRuleRequest} [addRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationRulesPost(
    addRuleRequest?: AddRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationRulesPost(addRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [count]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationRulesRecentGet(
    count?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationRulesRecentGet(count, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} ruleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationRulesRuleIdDelete(
    ruleId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationRulesRuleIdDelete(ruleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} ruleId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationRulesRuleIdGet(
    ruleId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationRulesRuleIdGet(ruleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} ruleId
   * @param {UpdateRuleRequest} [updateRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationRulesRuleIdPut(
    ruleId: number,
    updateRuleRequest?: UpdateRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationRulesRuleIdPut(ruleId, updateRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SearchRuleRequest} [searchRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationRulesSearchPost(
    searchRuleRequest?: SearchRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationRulesSearchPost(searchRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {TestJsonRuleRequest} [testJsonRuleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationTestJsonRulePost(
    testJsonRuleRequest?: TestJsonRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationTestJsonRulePost(testJsonRuleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {TestRuleDefinitionRequest} [testRuleDefinitionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationTestPost(
    testRuleDefinitionRequest?: TestRuleDefinitionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationTestPost(testRuleDefinitionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} validationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationValidationIdDelete(
    validationId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationValidationIdDelete(validationId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} validationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ValidationApi
   */
  public apiValidationValidationIdGet(
    validationId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return ValidationApiFp(this.configuration)
      .apiValidationValidationIdGet(validationId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * WorkOrderApi - axios parameter creator
 * @export
 */
export const WorkOrderApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     *
     * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderAppendWorkOrderItemsPost: async (
      appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/WorkOrder/AppendWorkOrderItems`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        appendWorkOrderItemsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderDeleteWorkOrderItemsPost: async (
      deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/WorkOrder/DeleteWorkOrderItems`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteWorkOrderItemsRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [workOrderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderGetWorkOrderByIdGet: async (
      workOrderId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/WorkOrder/GetWorkOrderById`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (workOrderId !== undefined) {
        localVarQueryParameter['workOrderId'] = workOrderId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderGetWorkOrdersGroupedByOrganisationGet: async (
      enterpriseId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/WorkOrder/GetWorkOrdersGroupedByOrganisation`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      if (enterpriseId !== undefined) {
        localVarQueryParameter['enterpriseId'] = enterpriseId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderPagedWorkOrdersByEnterprisePost: async (
      pagedWorkOrderRequest?: PagedWorkOrderRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/WorkOrder/PagedWorkOrdersByEnterprise`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pagedWorkOrderRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderSearchSortFilterPost: async (
      workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/WorkOrder/SearchSortFilter`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        workOrderSearchSortFilterRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderSubmitWorkOrdersPost: async (
      submitWorkOrdersRequest?: SubmitWorkOrdersRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/WorkOrder/SubmitWorkOrders`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication X-Organisation-Id required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'X-Organisation-Id',
        configuration,
      );

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration,
      );

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        submitWorkOrdersRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * WorkOrderApi - functional programming interface
 * @export
 */
export const WorkOrderApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    WorkOrderApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiWorkOrderAppendWorkOrderItemsPost(
      appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiWorkOrderAppendWorkOrderItemsPost(
          appendWorkOrderItemsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'WorkOrderApi.apiWorkOrderAppendWorkOrderItemsPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiWorkOrderDeleteWorkOrderItemsPost(
      deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiWorkOrderDeleteWorkOrderItemsPost(
          deleteWorkOrderItemsRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'WorkOrderApi.apiWorkOrderDeleteWorkOrderItemsPost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [workOrderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiWorkOrderGetWorkOrderByIdGet(
      workOrderId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDto>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiWorkOrderGetWorkOrderByIdGet(
          workOrderId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['WorkOrderApi.apiWorkOrderGetWorkOrderByIdGet']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(
      enterpriseId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<OrganisationGroupedWorkOrders>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(
          enterpriseId,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'WorkOrderApi.apiWorkOrderGetWorkOrdersGroupedByOrganisationGet'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiWorkOrderPagedWorkOrdersByEnterprisePost(
      pagedWorkOrderRequest?: PagedWorkOrderRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WorkOrderDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiWorkOrderPagedWorkOrdersByEnterprisePost(
          pagedWorkOrderRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          'WorkOrderApi.apiWorkOrderPagedWorkOrdersByEnterprisePost'
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiWorkOrderSearchSortFilterPost(
      workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<WorkOrderDtoPagedResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiWorkOrderSearchSortFilterPost(
          workOrderSearchSortFilterRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['WorkOrderApi.apiWorkOrderSearchSortFilterPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
    /**
     *
     * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiWorkOrderSubmitWorkOrdersPost(
      submitWorkOrdersRequest?: SubmitWorkOrdersRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<WorkOrderDto>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiWorkOrderSubmitWorkOrdersPost(
          submitWorkOrdersRequest,
          options,
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap['WorkOrderApi.apiWorkOrderSubmitWorkOrdersPost']?.[
          index
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * WorkOrderApi - factory interface
 * @export
 */
export const WorkOrderApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = WorkOrderApiFp(configuration);
  return {
    /**
     *
     * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderAppendWorkOrderItemsPost(
      appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest,
      options?: any,
    ): AxiosPromise<WorkOrderDto> {
      return localVarFp
        .apiWorkOrderAppendWorkOrderItemsPost(
          appendWorkOrderItemsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderDeleteWorkOrderItemsPost(
      deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest,
      options?: any,
    ): AxiosPromise<WorkOrderDto> {
      return localVarFp
        .apiWorkOrderDeleteWorkOrderItemsPost(
          deleteWorkOrderItemsRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [workOrderId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderGetWorkOrderByIdGet(
      workOrderId?: number,
      options?: any,
    ): AxiosPromise<WorkOrderDto> {
      return localVarFp
        .apiWorkOrderGetWorkOrderByIdGet(workOrderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [enterpriseId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(
      enterpriseId?: number,
      options?: any,
    ): AxiosPromise<Array<OrganisationGroupedWorkOrders>> {
      return localVarFp
        .apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(
          enterpriseId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderPagedWorkOrdersByEnterprisePost(
      pagedWorkOrderRequest?: PagedWorkOrderRequest,
      options?: any,
    ): AxiosPromise<WorkOrderDtoPagedResult> {
      return localVarFp
        .apiWorkOrderPagedWorkOrdersByEnterprisePost(
          pagedWorkOrderRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderSearchSortFilterPost(
      workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest,
      options?: any,
    ): AxiosPromise<WorkOrderDtoPagedResult> {
      return localVarFp
        .apiWorkOrderSearchSortFilterPost(
          workOrderSearchSortFilterRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiWorkOrderSubmitWorkOrdersPost(
      submitWorkOrdersRequest?: SubmitWorkOrdersRequest,
      options?: any,
    ): AxiosPromise<Array<WorkOrderDto>> {
      return localVarFp
        .apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * WorkOrderApi - object-oriented interface
 * @export
 * @class WorkOrderApi
 * @extends {BaseAPI}
 */
export class WorkOrderApi extends BaseAPI {
  /**
   *
   * @param {AppendWorkOrderItemsRequest} [appendWorkOrderItemsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkOrderApi
   */
  public apiWorkOrderAppendWorkOrderItemsPost(
    appendWorkOrderItemsRequest?: AppendWorkOrderItemsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkOrderApiFp(this.configuration)
      .apiWorkOrderAppendWorkOrderItemsPost(
        appendWorkOrderItemsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {DeleteWorkOrderItemsRequest} [deleteWorkOrderItemsRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkOrderApi
   */
  public apiWorkOrderDeleteWorkOrderItemsPost(
    deleteWorkOrderItemsRequest?: DeleteWorkOrderItemsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkOrderApiFp(this.configuration)
      .apiWorkOrderDeleteWorkOrderItemsPost(
        deleteWorkOrderItemsRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [workOrderId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkOrderApi
   */
  public apiWorkOrderGetWorkOrderByIdGet(
    workOrderId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkOrderApiFp(this.configuration)
      .apiWorkOrderGetWorkOrderByIdGet(workOrderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [enterpriseId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkOrderApi
   */
  public apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(
    enterpriseId?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkOrderApiFp(this.configuration)
      .apiWorkOrderGetWorkOrdersGroupedByOrganisationGet(enterpriseId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {PagedWorkOrderRequest} [pagedWorkOrderRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkOrderApi
   */
  public apiWorkOrderPagedWorkOrdersByEnterprisePost(
    pagedWorkOrderRequest?: PagedWorkOrderRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkOrderApiFp(this.configuration)
      .apiWorkOrderPagedWorkOrdersByEnterprisePost(
        pagedWorkOrderRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {WorkOrderSearchSortFilterRequest} [workOrderSearchSortFilterRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkOrderApi
   */
  public apiWorkOrderSearchSortFilterPost(
    workOrderSearchSortFilterRequest?: WorkOrderSearchSortFilterRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkOrderApiFp(this.configuration)
      .apiWorkOrderSearchSortFilterPost(
        workOrderSearchSortFilterRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SubmitWorkOrdersRequest} [submitWorkOrdersRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof WorkOrderApi
   */
  public apiWorkOrderSubmitWorkOrdersPost(
    submitWorkOrdersRequest?: SubmitWorkOrdersRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return WorkOrderApiFp(this.configuration)
      .apiWorkOrderSubmitWorkOrdersPost(submitWorkOrdersRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
